(function(root) {
  "use strict";

  if (!root || !root.customElements || root.customElements.get("dyof-configurator")) {
    return;
  }

  // Translations (assets/dyof-i18n.js, non-English stores only). The English
  // stays here and is used as is when no language pack is loaded.
  function dyofInterpolate(text, params) {
    return params ? String(text).replace(/\{([A-Za-z0-9_]+)\}/g, function(match, name) {
      return Object.prototype.hasOwnProperty.call(params, name) && params[name] != null ? String(params[name]) : match;
    }) : text;
  }

  function dyofT(key, english, params) {
    var i18n = root.DYOFI18n;
    return i18n ? i18n.t(key, english, params) : dyofInterpolate(english, params);
  }

  function dyofPlural(key, count, english, params) {
    var i18n = root.DYOFI18n;
    var values = Object.assign({ count: count }, params || {});
    return i18n ? i18n.plural(key, count, english, params) : dyofInterpolate(Number(count) === 1 ? english.one : english.other, values);
  }

  var dyofCustomerMessages = new Set();

  function dyofCustomerMessage(message) {
    if (root.DYOFI18n) {
      dyofCustomerMessages.add(message);
      if (dyofCustomerMessages.size > 64) {
        dyofCustomerMessages.delete(dyofCustomerMessages.values().next().value);
      }
    }
    return message;
  }

  function dyofCustomerError(message) {
    var error = new Error(dyofCustomerMessage(message));
    error.dyofTranslated = true;
    return error;
  }

  // Network/browser errors and unknown backend text have no catalogue entry.
  // Keep the original UK message; elsewhere use the translated caller fallback.
  function dyofServiceMessage(code, service, status) {
    var photoMessage = photoStorageRefusalMessage(code);
    if (photoMessage) { return photoMessage; }
    switch (code) {
      case "DYOF_UNPRINTABLE_TEXT":
        return dyofT("cfg.interaction.service_unprintable_text", "Some text in this design can't be printed. Check the first page, personal dates and cover text, then try again.");
      case "DYOF_PHOTO_RESOLUTION_TOO_LOW":
        return dyofT("cfg.interaction.service_photo_resolution", "A photo is too low-resolution to print sharply at its current size. Zoom out, make it smaller or upload a larger photo, then try again.");
      case "DYOF_STOREFRONT_MISMATCH":
        return dyofT("cfg.interaction.service_storefront_mismatch", "This design belongs to a different Filofax store");
      case "DYOF_CONFIGURATION_TOO_LARGE":
        return dyofT("cfg.interaction.service_configuration_too_large", "This design is too large to save. Remove a photo or simplify the design, then try again.");
      case "DYOF_CART_MEDIA_INVALID":
        return dyofT("cfg.interaction.service_cart_media_invalid", "Your cart preview could not be accepted. Refresh the preview, then try again.");
      case "DYOF_CART_MEDIA_TOO_LARGE":
        return dyofT("cfg.interaction.service_cart_media_too_large", "Your cart preview is too large. Refresh the preview, then try again.");
      case "DYOF_CART_MEDIA_NOT_FOUND":
        return dyofT("cfg.interaction.service_cart_media_not_found", "Your saved cart preview could not be found. Save your design again, then try again.");
      case "DYOF_CART_MEDIA_CONFLICT":
        return dyofT("cfg.interaction.service_cart_media_conflict", "Your cart preview no longer matches this design. Refresh the preview, then try again.");
      case "DYOF_STORAGE_DISABLED":
      case "DYOF_CONFIGURATION_UNAVAILABLE":
      case "DYOF_CONFIGURATION_COMMIT_UNAVAILABLE":
      case "DYOF_CART_MEDIA_UNAVAILABLE":
      case "DYOF_CART_MEDIA_OPERATION_FAILED":
      case "DYOF_STORAGE_OPERATION_FAILED":
        return dyofT("cfg.interaction.service_unavailable", "The {service} is temporarily unavailable. Please try again shortly.", { service: service });
      default:
        return status === 503
          ? dyofT("cfg.interaction.service_unavailable", "The {service} is temporarily unavailable. Please try again shortly.", { service: service })
          : dyofT("cfg.interaction.service_failed", "The {service} could not complete this request. Please try again.", { service: service });
    }
  }

  function dyofErrorMessage(error, fallback) {
    if (error && error.message && (!root.DYOFI18n || error.dyofTranslated || dyofCustomerMessages.has(error.message))) {
      return error.message;
    }
    if (root.DYOFI18n && error && error.code) {
      return dyofServiceMessage(error.code, dyofT("cfg.interaction.configuration_service", "configuration service"), error.status || 400);
    }
    return error && error.message && (!root.DYOFI18n || error.dyofTranslated)
      ? error.message
      : fallback || (root.DYOFI18n ? dyofT("cfg.error.generic", "Something went wrong. Please try again.") : fallback);
  }

  function dyofDisplayMoney(element, amount, currency) {
    return root.DYOFI18n
      ? Number.isFinite(Number(amount)) ? root.DYOFI18n.money(amount, currency) : null
      : element.commerce.displayMoney(amount, currency);
  }

  function dyofVariantPrice(element, variant) {
    if (!root.DYOFI18n) { return element.commerce.displayPrice(variant); }
    if (!variant) { return null; }
    var catalogs = element.commerceCatalogs || {};
    var candidates = [element.productCatalog, catalogs.clipbook, catalogs.planner, catalogs.undated, catalogs.newColourful];
    var priceVariant = variant;
    candidates.some(function(catalog) {
      var match = (catalog && catalog.variants || []).find(function(candidate) {
        return String(candidate.id) === String(variant.id);
      });
      if (match) { priceVariant = match; }
      return Boolean(match);
    });
    return dyofDisplayMoney(element, priceVariant.price, catalogs.currency || "GBP");
  }

  // Preview quotes are full catalogue prices; cart metadata and basket events
  // continue to use the separate promotional purchase-price calculation.
  function dyofPreviewOfferPrice(offer) {
    return offer && (offer.previewPrice || offer.price);
  }

  function dyofPreviewVariantPrice(element, variant) {
    var currency = element.commerceCatalogs && element.commerceCatalogs.currency;
    return variant && String(currency || "").trim().toUpperCase() === "GBP"
      ? dyofDisplayMoney(element, Number(variant.price), currency)
      : dyofVariantPrice(element, variant);
  }

  function dyofFallbackPrice(element, state, gbpMinor) {
    if (!root.DYOFI18n) {
      return gbpMinor === 1200
        ? dyofT("cfg.price.fallback_refill", "Price £12")
        : dyofT("cfg.price.fallback_covered", "Price £22");
    }
    var offer = typeof element.resolvePriceOffer === "function" ? element.resolvePriceOffer(state) : null;
    if (!offer && typeof element.datedPlannerPriceOffer === "function") {
      offer = element.datedPlannerPriceOffer(state, false);
    }
    var previewPrice = dyofPreviewOfferPrice(offer);
    if (previewPrice && previewPrice.mode !== "none") {
      var amount = dyofDisplayMoney(element, previewPrice.amount, previewPrice.currency);
      return previewPrice.mode === "from"
        ? dyofT("cfg.price.from_amount", "From {amount}", { amount: amount })
        : dyofT("cfg.price.price_amount", "Price {amount}", { amount: amount });
    }
    var purchase = typeof element.resolveCartVariant === "function" ? element.resolveCartVariant(state) : null;
    var price = purchase && dyofVariantPrice(element, purchase.variant);
    return price
      ? dyofT("cfg.price.price_amount", "Price {amount}", { amount: price })
      : dyofT("cfg.price.unavailable", "Price unavailable");
  }

  var NATIVE_NEWSLETTER_POPUP_SELECTOR = '.cc-popup[data-section-type="newsletter-popup"]';
  var SHOPIFY_FORMS_POPUP_SELECTOR = 'shopify-forms-embed[id^="app-embed-container-"]';
  var PUSHOWL_MARKETING_POPUP_SELECTOR = [
    ".pushowl-optin",
    ".js-custom-prompt-2",
    ".pushowl-widget-node",
    '[id^="pushowl-popup-campaign-"]',
    ".pushowl-ios-install-prompt",
    ".po-hint-screen-widget-container"
  ].join(", ");
  var GROW_MARKETING_POPUP_SELECTOR = [
    "#grow-consent-modal.grow_modal",
    "iframe#gw-stock-fulfilled-iframe.gw-modal",
    "iframe#gw-price-drop-iframe.gw-modal"
  ].join(", ");
  var MARKETING_POPUP_SELECTOR = [
    NATIVE_NEWSLETTER_POPUP_SELECTOR,
    SHOPIFY_FORMS_POPUP_SELECTOR,
    PUSHOWL_MARKETING_POPUP_SELECTOR,
    GROW_MARKETING_POPUP_SELECTOR
  ].join(", ");
  var FREEZING_POPUP_SELECTOR = '.cc-popup.cc-popup--visible[data-freeze-scroll="true"]';
  var CONFIGURATION_RESTORE_TIMEOUT_MS = 12000;
  var CONTENT_CHECK_TIMEOUT_MS = 8000;
  var CONTENT_CHECK_DEBOUNCE_MS = 300;
  var CONTENT_CHECK_PATH = "/v1/modern/content-check";
  var PRIVATE_RESTORE_ASSET_MAX_BYTES = 10 * 1024 * 1024;
  var EDITOR_RESUME_SCHEMA_VERSION = 1;
  var RELOAD_RESUME_SCHEMA_VERSION = 1;
  var RELOAD_RESUME_HISTORY_KEY = "__dyofReloadResume";
  var RELOAD_RESUME_TYPING_DELAY_MS = 600;
  var COVER_SCREENS_WITHOUT_REFILL_CHOICES = {
    "cover-selection": true,
    "front-cover": true,
    "back-cover": true
  };
  var PDF_PREVIEW_MAX_PIXELS = 4 * 1024 * 1024;
  var PDF_PREVIEW_MAX_EDGE = 4096;
  var PREVIEW_FONT_MAX_ENTRIES = 32;
  var PREVIEW_FONT_MAX_FACE_BYTES = 2 * 1024 * 1024;
  var PREVIEW_FONT_MAX_CACHE_BYTES = 8 * 1024 * 1024;
  var PREVIEW_FONT_MAX_PAGE_BYTES = 8 * 1024 * 1024;
  var PREVIEW_FONT_MAX_TOTAL_PAGE_BYTES = 32 * 1024 * 1024;
  var PREVIEW_FONT_ID = /^[a-f0-9]{64}$/;
  // Same families and grammar as the backend's OWNED_FAMILIES/FONT_FACE (Czech
  // artwork adds MontserratPrelim300-500); tests/c20-preview-font-family-parity
  // reads this line. A face it rejects turns font transport off for the session.
  var PREVIEW_FONT_FACE = /^@font-face\s*\{\s*font-family:\s*"(?:MontserratLight|Montserrat|MontserratDailyText|MontserratDailyLabel|RockwellDyof|BumperSixNews|Myriad Pro|Meritocracy|DYOFSourceOwner|DYOFSourceSupport|DYOFSourceWeekday|DYOFSourceDigits|MontserratPrelim300|MontserratPrelim400|MontserratPrelim500)";\s*src:\s*url\("data:font\/(?:ttf|otf);base64,[A-Za-z0-9+/]+={0,2}"\)\s*format\("(?:truetype|opentype)"\);\s*font-style:\s*normal;\s*font-weight:\s*[1-9]00;\s*\}$/;
  // Phone typing (CSS "Mobile typing"). A keyboard shrinks the visual
  // viewport by 250px or more; browser bars change it by under 100px.
  var PHONE_TYPING_QUERY = "(max-width: 720px)";
  var PHONE_TYPING_TEXT_TYPES = ["text", "search", "email", "tel", "url", "number", "password"];
  var PHONE_KEYBOARD_MIN_PX = 150;
  var PHONE_TYPING_GAP_PX = 16;
  var PHONE_TYPING_REVEAL_MS = 120;
  var PHONE_TYPING_REVEAL_FALLBACK_MS = 400;
  var PHONE_TYPING_SETTLE_MS = 150;
  // About 2s of re-checks after a blur, far longer than a keyboard takes to close.
  var PHONE_TYPING_SETTLE_CHECKS = 6;
  var PREDEFINED_LAYOUT_RENDERER_VERSION = "modern-layout-preview-2026-09-25.2";
  // Updated only with a reviewed renderer/artwork release, never from active.json.
  var PREDEFINED_LAYOUT_SOURCE_IDENTITY = "a6160b4a782438b3a14ccf69622cf76f4ce954eead6f34b08dabf95517f40bb6";
  // The Czech (cs) stored-Layout pack follows the same rule. Empty keeps Czech
  // stored previews off: the Czech store then fetches no index at all.
  var PREDEFINED_LAYOUT_CS_RENDERER_VERSION = "modern-layout-preview-2026-09-29.2";
  var PREDEFINED_LAYOUT_CS_SOURCE_IDENTITY = "712c02669006672a394a1687da58d8bac3ecee5570b8f081f1e625575d73f653";
  var PREDEFINED_LAYOUT_PROFILE = "modern-main-chrome-artwork-screen-rules-lossless-v2";
  var PREDEFINED_LAYOUT_STYLES = ["gradient", "waves", "blocks", "soft-stripes", "essential", "everyday"];
  // One reviewed pack per refill language, each behind its own active index in
  // Shopify Files. The UK (no store profile) uses "en". The English Monthly
  // previews predate the bold Monthly dates of 2026-09-29; the Czech pack was
  // rendered after them, so only it keeps its stored Monthly previews.
  var PREDEFINED_LAYOUT_PINS = {
    en: { rendererVersion: PREDEFINED_LAYOUT_RENDERER_VERSION, sourceIdentity: PREDEFINED_LAYOUT_SOURCE_IDENTITY,
      activeFileName: "dyof-layout-preview-active.json", storedMonthly: false },
    cs: { rendererVersion: PREDEFINED_LAYOUT_CS_RENDERER_VERSION, sourceIdentity: PREDEFINED_LAYOUT_CS_SOURCE_IDENTITY,
      activeFileName: "dyof-layout-preview-active-cs.json", storedMonthly: true }
  };
  var RESTORE_CAPABILITY_PATTERN = /^dyof_[a-f0-9]{24}$/;
  // The old refill builder's own link (snippets/stepTracker.liquid
  // DYORLegacyUrl, snippets/saving.liquid savingID). A refill it printed holds
  // one as the QR code on its Saving System page (refill-js.liquid qrClassic:
  // the page's window.location.href when the PDF was made), and an old order's
  // "Reorder" link is the same. Forms: "?=savingID=<id>?=format=a5?=type=
  // luxury?=layout=24?=day=monday?=month=January%202026", later the hash
  // "#savingID=<id>&format=a5&type=luxury&...", and "?=format=a5&type=...".
  var OLD_BUILDER_LINK_KEYS = [
    "savingID", "size", "coverSize", "coverDiv", "FFshape", "shapeColor", "range", "coverInput1",
    "coverInput2", "coverInput3", "covFont", "textColor", "interiorColor", "letter", "format", "type",
    "frontLine1", "frontLine2", "frontLine3", "itemsund", "undatedNotebook", "layout", "day", "month",
    "timezoneoffset", "holidays", "input1", "input2", "input3", "typeBirthday", "typeEvent"
  ];
  var OLD_BUILDER_PROJECT_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  // The old builder's parameters in a page address: { key: value } for its
  // own keys only (query, hash and "?=" segments, later values winning).
  function oldBuilderLinkParams(href) {
    var parts = String(href || "").split("?=");
    var params = {};
    var parsed;
    function keep(key, value) {
      if (OLD_BUILDER_LINK_KEYS.indexOf(key) !== -1) {
        params[key] = value;
      }
    }
    try {
      parsed = new URL(parts.shift() || "");
    } catch (error) {
      return params;
    }
    parsed.searchParams.forEach(function(value, key) { keep(key, value); });
    new URLSearchParams(String(parsed.hash || "").replace(/^#\??/, "")).forEach(function(value, key) {
      keep(key, value);
    });
    parts.forEach(function(part) {
      // "?=format=a5&type=classic": another parameter starts at "&<old key>=";
      // any other "&" belongs to the value (a first-page line "Tom & Jerry").
      var pieces = [];
      var start = 0;
      part.replace(/&([A-Za-z][A-Za-z0-9]*)=/g, function(match, key, index) {
        if (OLD_BUILDER_LINK_KEYS.indexOf(key) !== -1) {
          pieces.push(part.slice(start, index));
          start = index + 1;
        }
        return match;
      });
      pieces.push(part.slice(start));
      pieces.forEach(function(piece) {
        var index = piece.indexOf("=");
        var raw = index > 0 ? piece.slice(index + 1) : "";
        var value;
        if (index <= 0) {
          return;
        }
        try {
          value = decodeURIComponent(raw.replace(/\+/g, " "));
        } catch (error) {
          value = raw;
        }
        keep(piece.slice(0, index), value);
      });
    });
    return params;
  }

  // The same page address without the old builder's state: the query before
  // its first "?=" minus the old keys, and no fragment.
  function withoutOldBuilderLink(href) {
    var parsed = new URL(String(href || "").split("?=")[0]);
    OLD_BUILDER_LINK_KEYS.forEach(function(key) {
      parsed.searchParams.delete(key);
    });
    parsed.hash = "";
    return parsed.toString();
  }
  var UPLOAD_AGAIN_MESSAGE = dyofT("cfg.photos.upload_again", "Your uploaded photo needs to be uploaded again. Go back to the cover, replace the photo with the same file, then try again.");
  // The configuration service refuses these with a bare code when the photos
  // it would store can no longer be claimed or kept. Only uploading them
  // again fixes that, so they are refusals to explain, not outages.
  var PHOTO_STORAGE_REFUSAL_MESSAGES = {
    DYOF_UPLOAD_CLAIM_MISMATCH: UPLOAD_AGAIN_MESSAGE,
    DYOF_UPLOAD_NOT_READY: UPLOAD_AGAIN_MESSAGE,
    DYOF_UPLOAD_UNAUTHORIZED: UPLOAD_AGAIN_MESSAGE,
    DYOF_UPLOAD_CLAIM_CONFLICT: UPLOAD_AGAIN_MESSAGE,
    DYOF_UPLOAD_DUPLICATE_CLAIM: UPLOAD_AGAIN_MESSAGE,
    DYOF_UPLOAD_INVALID: UPLOAD_AGAIN_MESSAGE,
    DYOF_PRIVATE_ASSET_RETENTION_UNAVAILABLE: dyofT("cfg.photos.expired", "The photos in this saved design are no longer stored. Go back to the cover, upload them again, then try again."),
    DYOF_LEGACY_ASSET_MIGRATION_REQUIRED: dyofT("cfg.photos.legacy_version", "This design uses a photo from an older version of the editor. Go back to the cover, upload it again, then try again.")
  };
  var EDITOR_RESUME_SCREENS = [
    "cover-selection",
    "front-cover",
    "back-cover",
    "refill-type",
    "dated-layout",
    "undated-layout",
    "planner-details",
    "personal-dates",
    "review"
  ];
  var EDITOR_RESUME_DATED_FIELDS = [
    "size:size",
    "style:style",
    "legacy-layout:layout",
    "legacy-design:lineStyle",
    "legacy-design:calendar",
    "legacy-design:notes",
    "legacy-design:appointmentTimes",
    "colour-mode:colourMode",
    "colour-mode:singleColour",
    "paper:paperColour",
    "layout:layout",
    "view:layoutView",
    "date-position:datePosition",
    "day-design:dayDesign",
    "header:headerTheme"
  ];

  // The refusals whose body lists the photos concerned (error.assetIds).
  var PHOTO_UPLOAD_AGAIN_CODES = [
    "DYOF_UPLOAD_CLAIM_MISMATCH",
    "DYOF_UPLOAD_NOT_READY",
    "DYOF_UPLOAD_UNAUTHORIZED"
  ];

  function photoStorageRefusalMessage(code) {
    return typeof code === "string"
      && Object.prototype.hasOwnProperty.call(PHOTO_STORAGE_REFUSAL_MESSAGES, code)
      ? PHOTO_STORAGE_REFUSAL_MESSAGES[code]
      : "";
  }

  // The back logo a DYOF_BACK_LOGO_INVALID refusal says the service accepts:
  // { version: 1, colour } or null for none; undefined for any other answer.
  function refusedBackLogo(payload) {
    if (!payload || typeof payload !== "object" || payload.code !== "DYOF_BACK_LOGO_INVALID"
      || !Object.prototype.hasOwnProperty.call(payload, "backLogo")) {
      return undefined;
    }
    var backLogo = payload.backLogo;
    if (backLogo === null) { return null; }
    return backLogo && backLogo.version === 1 && /^#[0-9A-F]{6}$/.test(String(backLogo.colour))
      ? { version: 1, colour: backLogo.colour }
      : undefined;
  }

  // The save body with the cover's back logo set (or, for null, removed) in
  // the production intent and the resume snapshot alike.
  function withSavedBackLogo(body, backLogo) {
    var withLogo = function(cover) {
      var next = Object.assign({}, cover);
      if (backLogo) { next.backLogo = backLogo; } else { delete next.backLogo; }
      return next;
    };
    var resume = body.resume;
    if (resume && resume.snapshot && resume.snapshot.cover) {
      resume = Object.assign({}, resume, {
        snapshot: Object.assign({}, resume.snapshot, { cover: withLogo(resume.snapshot.cover) })
      });
    }
    return Object.assign({}, body, {
      intent: Object.assign({}, body.intent, { cover: withLogo(body.intent.cover) }),
      resume: resume
    });
  }

  // The quoted names the design gives these uploaded photos, where it has one.
  function uploadedPhotoNames(state, ids) {
    var cover = state && state.cover || {};
    return (ids || []).map(function(id) {
      if (cover.background && cover.background.assetId === id) {
        return cover.background.title;
      }
      var objects = ["front", "back"].reduce(function(found, side) {
        return found.concat(cover[side] && cover[side].objects || []);
      }, []);
      var object = objects.filter(function(candidate) {
        return candidate && candidate.type === "image" && candidate.assetId === id;
      })[0];
      return object && object.name;
    }).filter(Boolean).map(function(name) {
      return "\"" + name + "\"";
    });
  }

  // True when a manifest entry carries the canonical fields of a photo this
  // browser uploaded to private storage. A record without them that is still
  // on the design came from a saved-link restore: the base holds that photo.
  function hasPrivateStorageFields(asset) {
    return Boolean(
      asset
      && asset.storageKey
      && asset.sha256
      && Number.isSafeInteger(asset.sizeBytes)
      && asset.sizeBytes > 0
    );
  }

  // Names selected uploaded photos whose production records are missing,
  // with the same upload-again step as the service refusal.
  function missingUploadedPhotoMessage(state, assetIds, manifest) {
    var present = new Set((manifest || []).map(function(asset) { return asset && asset.id; }));
    var missing = (assetIds || []).filter(function(id) { return !present.has(id); });
    if (!missing.length) { return ""; }
    var names = uploadedPhotoNames(state, missing);
    var listed = root.DYOFI18n ? root.DYOFI18n.list(names) : names.join(", ");
    return dyofCustomerMessage(names.length
      ? dyofPlural("cfg.photos.upload_again_named", missing.length, {
          one: "Your uploaded photo {names} needs to be uploaded again. Go back to the cover, replace the photo with the same file, then try again.",
          other: "Your uploaded photos {names} need to be uploaded again. Go back to the cover, replace the photos with the same files, then try again."
        }, { names: missing.length === 1 ? names[0] : listed })
      : dyofPlural("cfg.photos.upload_again_unnamed", missing.length, {
          one: "Your uploaded photo needs to be uploaded again. Go back to the cover, replace the photo with the same file, then try again.",
          other: "Your uploaded photos need to be uploaded again. Go back to the cover, replace the photos with the same files, then try again."
        }));
  }

  function scrubRestoreCapabilities(value, seenInput) {
    if (typeof value === "string") {
      return RESTORE_CAPABILITY_PATTERN.test(value) ? null : value;
    }
    if (!value || typeof value !== "object") {
      return value;
    }
    var seen = seenInput || new WeakMap();
    if (seen.has(value)) {
      return seen.get(value);
    }
    if (Array.isArray(value)) {
      var arrayCopy = [];
      seen.set(value, arrayCopy);
      value.forEach(function(entry) {
        arrayCopy.push(scrubRestoreCapabilities(entry, seen));
      });
      return arrayCopy;
    }
    if (Object.prototype.toString.call(value) !== "[object Object]") {
      return value;
    }
    var objectCopy = {};
    seen.set(value, objectCopy);
    return Object.keys(value).reduce(function(copy, key) {
      copy[key] = scrubRestoreCapabilities(value[key], seen);
      return copy;
    }, objectCopy);
  }

  var CONTROL_LABELS = {
    colourMode: {
      "signature-multicolour": dyofT("cfg.controls.signature_multicolour", "Signature Multicolour"),
      "single-colour": dyofT("cfg.controls.single_colour", "Single Colour")
    },
    paperColour: {
      white: dyofT("cfg.controls.white_paper", "White Paper"),
      cream: dyofT("cfg.controls.cream_paper", "Cream Paper")
    },
    datePosition: {
      "left-aligned": dyofT("cfg.controls.left_aligned", "Left Aligned"),
      outer: dyofT("cfg.controls.outer", "Outer")
    },
    startDay: {
      monday: dyofT("cfg.controls.monday", "Monday"),
      sunday: dyofT("cfg.controls.sunday", "Sunday")
    },
    language: {
      en: dyofT("cfg.controls.english", "English"),
      de: dyofT("cfg.controls.german", "German"),
      es: dyofT("cfg.controls.spanish", "Spanish"),
      fr: dyofT("cfg.controls.french", "French"),
      cs: dyofT("cfg.controls.czech", "Czech")
    }
  };
  var FIRST_PAGE_COPY = {
    en: {
      titleLine1: "YOUR PLANS.",
      titleLine2: "YOUR PACE.",
      tagline: "Your Way.",
      ownerLabel: "This belongs to:"
    },
    de: {
      titleLine1: "DEINE PLÄNE.",
      titleLine2: "DEIN TEMPO.",
      tagline: "Dein Weg.",
      ownerLabel: "Gehört:"
    },
    es: {
      titleLine1: "TUS PLANES.",
      titleLine2: "TU RITMO.",
      tagline: "A tu manera.",
      ownerLabel: "Pertenece a:"
    },
    fr: {
      titleLine1: "VOS PLANS.",
      titleLine2: "VOTRE RYTHME.",
      tagline: "À votre façon.",
      ownerLabel: "Appartient à :"
    }
  };
  var A4_ORGANISER_PAGE = {
    leftX: 211.3208,
    rightX: 813.9332,
    top: 390.7112,
    width: 579.3904,
    height: 818.5776
  };
  // Review cream stock is the Layout overlay rgba(247, 240, 223, .68) flattened
  // over white, so multiplying a white print page onto it reproduces Layout.
  var REVIEW_CREAM_PAPER_STOCK = "#faf5e9";
  var REVIEW_ORGANISER_OUTLINES = {
    a5: {
      classic: {
        crop: [103, 417, 1434, 763],
        clip: "polygon(1.185% 0.000%,95.188% 0.000%,96.374% 2.097%,96.374% 45.347%,97.141% 44.299%,99.791% 44.299%,100.000% 45.347%,100.000% 52.949%,99.651% 54.784%,98.326% 55.701%,97.141% 55.832%,96.374% 54.784%,96.374% 97.903%,95.188% 100.000%,1.185% 100.000%,0.000% 97.903%,0.000% 2.359%)"
      },
      modern: {
        crop: [103, 417, 1437, 763],
        clip: "polygon(1.183% 0.000%,94.990% 0.000%,96.173% 2.097%,96.173% 45.609%,97.008% 44.823%,99.722% 44.823%,100.000% 45.609%,100.000% 54.260%,99.652% 54.915%,97.008% 54.784%,96.173% 53.866%,96.173% 97.903%,94.990% 100.000%,1.183% 100.000%,0.000% 97.903%,0.000% 2.359%)"
      },
      neutral: {
        crop: [103, 417, 1430, 763],
        clip: "polygon(1.189% 0.000%,95.455% 0.000%,96.643% 2.097%,96.643% 46.003%,97.343% 45.347%,99.790% 45.216%,100.000% 46.003%,100.000% 54.128%,99.650% 55.046%,97.413% 55.308%,96.643% 54.522%,96.643% 97.903%,95.455% 100.000%,1.189% 100.000%,0.000% 97.903%,0.000% 2.359%)"
      },
      playful: {
        crop: [103, 417, 1441, 763],
        clip: "polygon(1.180% 0.000%,94.726% 0.000%,95.906% 2.097%,95.906% 43.250%,99.653% 43.512%,100.000% 44.168%,100.000% 55.963%,99.653% 56.356%,95.906% 56.225%,95.906% 97.903%,94.726% 100.000%,1.180% 100.000%,0.000% 97.903%,0.000% 2.359%)"
      }
    },
    a4: {
      crop: [132, 359, 1409, 888],
      clip: "polygon(0.923% 0.338%,45.280% 0.338%,45.706% 0%,48.261% 0%,49.042% 0.338%,93.896% 0.338%,94.748% 1.689%,94.748% 44.482%,95.884% 44.707%,96.026% 46.284%,99.645% 46.284%,100% 47.297%,100% 52.140%,99.716% 52.815%,96.026% 53.491%,95.884% 55.405%,94.748% 55.631%,94.748% 98.086%,94.038% 99.324%,48.616% 99.324%,48.048% 100%,46.487% 100%,45.848% 99.324%,0.923% 99.324%,0.142% 98.086%,0.142% 56.081%,0% 55.405%,0% 45.158%,0.142% 44.482%,0.142% 1.689%)"
    },
    personal: {
      classic: {
        crop: [232, 424, 1172, 737],
        clip: "polygon(1.536% 0%,39.932% 0%,48.464% 0.136%,91.980% 0%,93.345% 0.814%,94.027% 2.714%,94.027% 44.098%,96.246% 44.098%,100% 45.047%,100% 55.360%,98.805% 56.988%,94.027% 58.073%,94.027% 97.558%,93.259% 99.186%,91.980% 100%,1.621% 100%,0.512% 99.322%,0% 97.558%,0% 2.849%,0.427% 1.085%)"
      },
      modern: {
        crop: [234, 422, 1189, 745],
        clip: "polygon(2.019% 0.268%,30.446% 0%,43.230% 1.074%,51.808% 1.342%,56.182% 0.537%,90.412% 0.268%,91.842% 1.611%,92.431% 3.490%,92.431% 42.148%,95.542% 42.148%,99.748% 42.550%,100% 43.758%,100% 54.631%,98.066% 55.302%,92.431% 55.973%,92.431% 97.181%,91.590% 99.060%,90.496% 100%,2.019% 100%,0.505% 98.389%,0% 96.510%,0% 3.624%,0.505% 1.477%)"
      },
      neutral: {
        crop: [236, 419, 1175, 750],
        clip: "polygon(1.872% 0.533%,38.638% 0.667%,52.340% 0.667%,92.085% 0%,93.447% 0.933%,94.298% 2.800%,94.298% 43.600%,99.660% 44%,100% 45.733%,100% 55.067%,99.489% 56.533%,94.298% 57.333%,94.298% 96.933%,93.447% 99.200%,92% 100%,1.957% 100%,0.426% 98.400%,0% 96.533%,0% 3.600%,0.511% 1.600%)"
      },
      playful: {
        crop: [215, 419, 1218, 749],
        clip: "polygon(2.463% 0.134%,30.952% 0%,44.828% 0.801%,52.135% 0.935%,63.218% 0.267%,91.379% 0.134%,92.775% 1.068%,93.596% 3.204%,93.596% 42.056%,99.672% 42.056%,100% 42.857%,100% 57.009%,99.589% 57.410%,93.596% 57.410%,93.596% 96.796%,92.693% 99.065%,91.461% 100%,2.135% 100%,0.657% 98.131%,0.082% 96.262%,0% 4.005%,0.493% 1.869%)"
      }
    }
  };
  var A4_ORGANISER_SCENES = {
    classic: {
      openDataset: "a4OrganiserOpenClassic",
      frontSheetDataset: "a4OrganiserFrontSheetClassic"
    },
    modern: {
      openDataset: "a4OrganiserOpenModern",
      frontSheetDataset: "a4OrganiserFrontSheetModern"
    },
    neutral: {
      openDataset: "a4OrganiserOpenNeutral",
      frontSheetDataset: "a4OrganiserFrontSheetNeutral"
    },
    playful: {
      openDataset: "a4OrganiserOpenPlayful",
      frontSheetDataset: "a4OrganiserFrontSheetPlayful"
    }
  };
  var PERSONAL_CLIPBOOK_SCENES = {
    classic: {
      openDataset: "personalClipbookOpenClassic",
      frontSheetDataset: "personalClipbookFrontSheetClassic"
    },
    modern: {
      openDataset: "personalClipbookOpenModern",
      frontSheetDataset: "personalClipbookFrontSheetModern"
    },
    neutral: {
      openDataset: "personalClipbookOpenNeutral",
      frontSheetDataset: "personalClipbookFrontSheetNeutral"
    }
  };
  var PERSONAL_ORGANISER_SCENES = {
    classic: {
      openDataset: "personalOrganiserOpenClassic",
      frontSheetDataset: "personalOrganiserFrontSheetClassic"
    },
    modern: {
      openDataset: "personalOrganiserOpenModern",
      frontSheetDataset: "personalOrganiserFrontSheetModern"
    },
    neutral: {
      openDataset: "personalOrganiserOpenNeutral",
      frontSheetDataset: "personalOrganiserFrontSheetNeutral"
    },
    playful: {
      openDataset: "personalOrganiserOpenPlayful",
      frontSheetDataset: "personalOrganiserFrontSheetPlayful"
    }
  };
  var A5_OPEN_SCENES = {
    refill: {
      classic: "a5OrganiserOpenClassic",
      modern: "a5OrganiserOpenModern",
      neutral: "a5OrganiserOpenNeutral",
      playful: "a5OrganiserOpenPlayful"
    },
    clipbook: {
      classic: "a5ClipbookOpenClassic",
      modern: "a5ClipbookOpenModern",
      neutral: "a5ClipbookOpenNeutral",
      playful: "a5ClipbookOpenPlayful"
    },
    planner: {
      classic: "a5NotebookOpenClassic",
      modern: "a5NotebookOpenModern",
      neutral: "a5NotebookOpenNeutral",
      playful: "a5NotebookOpenPlayful"
    }
  };
  var A5_FRONT_SHEET_SCENES = {
    refill: {
      classic: "a5OrganiserFrontSheetClassic",
      modern: "a5OrganiserFrontSheetModern",
      neutral: "a5OrganiserFrontSheetNeutral",
      playful: "a5OrganiserFrontSheetPlayful"
    },
    clipbook: {
      classic: "a5ClipbookFrontSheetClassic",
      modern: "a5ClipbookFrontSheetModern",
      neutral: "a5ClipbookFrontSheetNeutral",
      playful: "a5ClipbookFrontSheetPlayful"
    },
    planner: {
      classic: "a5NotebookFrontSheetClassic",
      modern: "a5NotebookFrontSheetModern",
      neutral: "a5NotebookFrontSheetNeutral",
      playful: "a5NotebookFrontSheetPlayful"
    }
  };
  var PERSONAL_FIRST_PAGE_STYLES = {
    classic: {
      baseDataset: "personalFirstPageClassicBase",
      layout: {
        x: 28.6967,
        y: 134.045,
        width: 225.4909,
        height: 13.373,
        color: "#231F20",
        fontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
        fontSize: 12,
        fontWeight: "400"
      },
      lines: [
        { x: 67.7196, y: 236.901, width: 150, height: 14.726 },
        { x: 67.8317, y: 252.715, width: 150, height: 14.726 },
        { x: 67.9296, y: 268.884, width: 150, height: 14.726 }
      ],
      lineFontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
      lineFontWeight: "400"
    },
    minimal: {
      baseDataset: "personalFirstPageMinimalBase",
      layout: {
        x: 25.1299,
        y: 135.906,
        width: 231.4917,
        height: 13.203,
        color: "#58595B",
        fontFamily: "'DYOF Legacy Gotham Light', Arial, sans-serif",
        fontSize: 8,
        fontWeight: "400"
      },
      lines: [
        { x: 68.058, y: 231.319, width: 149.9996, height: 12.019 },
        { x: 68.3392, y: 246.963, width: 150.0004, height: 12.019 },
        { x: 68.2679, y: 263.133, width: 149.9997, height: 12.018 }
      ],
      lineFontFamily: "'DYOF Legacy Gotham Medium', Arial, sans-serif",
      lineFontWeight: "500"
    },
    luxury: {
      baseDataset: "personalFirstPageLuxuryBase",
      layout: {
        x: 33.1856,
        y: 136.825,
        width: 217.017,
        height: 11.537,
        color: "#80571B",
        fontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
        fontSize: 8,
        fontWeight: "400"
      },
      lines: [
        { x: 65.687, y: 238.309, width: 157.2596, height: 13.091 },
        { x: 65.687, y: 253.885, width: 157.2596, height: 13.091 },
        { x: 65.687, y: 270.301, width: 157.2596, height: 13.091 }
      ],
      lineFontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
      lineFontWeight: "400"
    }
  };
  var LEGACY_FIRST_PAGE_FORMATS = {
    a4: {
      trim: { width: 595.5176, height: 841.9034 },
      styles: {
        classic: {
          baseDataset: "a4FirstPageClassicBase",
          layout: { x: 133.0396, y: 218.817, width: 357.18, height: 22 },
          lines: [
            { x: 185.4296, y: 415.792, width: 252.4, height: 22 },
            { x: 185.4296, y: 443.234, width: 252.4, height: 22 },
            { x: 185.4296, y: 472.161, width: 252.4, height: 22 }
          ],
          layoutColor: "#000000",
          layoutFontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
          layoutFontSize: 14,
          lineFontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
          lineFontSize: 14,
          fontWeight: "400"
        },
        minimal: {
          baseDataset: "a4FirstPageMinimalBase",
          layout: { x: 200.7076, y: 216.436, width: 218.039, height: 22 },
          lines: [
            { x: 184.7176, y: 415.451, width: 252.4, height: 22 },
            { x: 184.3916, y: 443.914, width: 252.399, height: 22 },
            { x: 184.7426, y: 471.141, width: 252.399, height: 22 }
          ],
          layoutColor: "#58595B",
          layoutFontFamily: "'DYOF Legacy Gotham Light', Arial, sans-serif",
          layoutFontSize: 14,
          lineFontFamily: "'DYOF Legacy Gotham Medium', Arial, sans-serif",
          lineFontSize: 14,
          fontWeight: "400"
        },
        luxury: {
          baseDataset: "a4FirstPageLuxuryBase",
          layout: { x: 210.5726, y: 217.456, width: 197.968, height: 22 },
          lines: [
            { x: 177.9276, y: 415.338, width: 271.45, height: 22 },
            { x: 177.9276, y: 443.914, width: 271.45, height: 22 },
            { x: 177.9276, y: 471.47, width: 271.45, height: 22 }
          ],
          layoutColor: "#80571B",
          layoutFontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
          layoutFontSize: 14,
          lineFontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
          lineFontSize: 14,
          fontWeight: "400"
        }
      }
    },
    a5: {
      trim: { width: 419.6522, height: 595.2669 },
      styles: {
        classic: {
          baseDataset: "a5FirstPageClassicBase",
          layout: { x: 135.5362, y: 139.648, width: 180.286, height: 22 },
          lines: [
            { x: 99.1092, y: 287.628, width: 252.399, height: 17.529 },
            { x: 99.1092, y: 308.992, width: 252.399, height: 17.528 },
            { x: 99.4792, y: 330.528, width: 252.4, height: 17.529 }
          ],
          layoutColor: "#000000",
          layoutFontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
          layoutFontSize: 10,
          lineFontFamily: "'DYOF Legacy Avenir', Arial, sans-serif",
          lineFontSize: 10,
          fontWeight: "400"
        },
        minimal: {
          baseDataset: "a5FirstPageMinimalBase",
          layout: { x: 102.4702, y: 141.882, width: 237.971, height: 15.79 },
          lines: [
            { x: 150.2892, y: 287.947, width: 150, height: 17.777 },
            { x: 150.3082, y: 308.619, width: 150, height: 17.777 },
            { x: 150.4102, y: 330.829, width: 150, height: 17.777 }
          ],
          layoutColor: "#58595B",
          layoutFontFamily: "'DYOF Legacy Gotham Light', Arial, sans-serif",
          layoutFontSize: 10,
          lineFontFamily: "'DYOF Legacy Gotham Medium', Arial, sans-serif",
          lineFontSize: 10,
          fontWeight: "400"
        },
        luxury: {
          baseDataset: "a5FirstPageLuxuryBase",
          layout: { x: 128.7662, y: 143.266, width: 197.968, height: 14.582 },
          lines: [
            { x: 90.0122, y: 288.566, width: 271.45, height: 16.982 },
            { x: 90.0122, y: 309.724, width: 271.45, height: 16.982 },
            { x: 90.0122, y: 329.862, width: 271.45, height: 16.982 }
          ],
          layoutColor: "#80571B",
          layoutFontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
          layoutFontSize: 10,
          lineFontFamily: "'DYOF Legacy Stone Sans', Arial, sans-serif",
          lineFontSize: 14,
          fontWeight: "400"
        }
      }
    }
  };
  var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
  var firstPageHardwareClipSequence = 0;
  var PERSONAL_DATE_MONTHS = [
    dyofT("cfg.months.january", "January"), dyofT("cfg.months.february", "February"), dyofT("cfg.months.march", "March"), dyofT("cfg.months.april", "April"), dyofT("cfg.months.may", "May"), dyofT("cfg.months.june", "June"), dyofT("cfg.months.july", "July"), dyofT("cfg.months.august", "August"), dyofT("cfg.months.september", "September"), dyofT("cfg.months.october", "October"), dyofT("cfg.months.november", "November"), dyofT("cfg.months.december", "December")
  ];
  var TIMEZONE_LOCATIONS = {
    "-720": dyofT("cfg.timezones.international_date_line_west", "International Date Line West"),
    "-660": dyofT("cfg.timezones.midway_island_samoa", "Midway Island, Samoa"),
    "-600": dyofT("cfg.timezones.hawaii", "Hawaii"),
    "-540": dyofT("cfg.timezones.alaska", "Alaska"),
    "-480": dyofT("cfg.timezones.pacific_time_us_canada", "Pacific Time (US & Canada)"),
    "-420": dyofT("cfg.timezones.mountain_time_us_canada", "Mountain Time (US & Canada)"),
    "-360": dyofT("cfg.timezones.central_time_us_canada_mexico_city", "Central Time (US & Canada), Mexico City"),
    "-300": dyofT("cfg.timezones.eastern_time_us_canada_bogota_lima", "Eastern Time (US & Canada), Bogota, Lima"),
    "-270": dyofT("cfg.timezones.venezuela", "Venezuela"),
    "-240": dyofT("cfg.timezones.atlantic_time_canada_caracas", "Atlantic Time (Canada), Caracas"),
    "-180": dyofT("cfg.timezones.brasilia_buenos_aires_greenland", "Brasilia, Buenos Aires, Greenland"),
    "-120": dyofT("cfg.timezones.mid_atlantic", "Mid-Atlantic"),
    "-60": dyofT("cfg.timezones.azores_cape_verde_islands", "Azores, Cape Verde Islands"),
    "0": dyofT("cfg.timezones.london_dublin_lisbon", "London, Dublin, Lisbon"),
    "60": dyofT("cfg.timezones.amsterdam_berlin_paris_rome", "Amsterdam, Berlin, Paris, Rome"),
    "120": dyofT("cfg.timezones.athens_cairo_helsinki", "Athens, Cairo, Helsinki"),
    "180": dyofT("cfg.timezones.moscow_nairobi_riyadh", "Moscow, Nairobi, Riyadh"),
    "210": dyofT("cfg.timezones.tehran", "Tehran"),
    "240": dyofT("cfg.timezones.abu_dhabi_baku_tbilisi", "Abu Dhabi, Baku, Tbilisi"),
    "270": dyofT("cfg.timezones.kabul", "Kabul"),
    "300": dyofT("cfg.timezones.islamabad_karachi", "Islamabad, Karachi"),
    "330": dyofT("cfg.timezones.mumbai_new_delhi", "Mumbai, New Delhi"),
    "345": dyofT("cfg.timezones.kathmandu", "Kathmandu"),
    "360": dyofT("cfg.timezones.almaty_dhaka", "Almaty, Dhaka"),
    "390": dyofT("cfg.timezones.yangon", "Yangon"),
    "420": dyofT("cfg.timezones.bangkok_hanoi_jakarta", "Bangkok, Hanoi, Jakarta"),
    "480": dyofT("cfg.timezones.beijing_hong_kong_singapore", "Beijing, Hong Kong, Singapore"),
    "540": dyofT("cfg.timezones.osaka_seoul_tokyo", "Osaka, Seoul, Tokyo"),
    "570": dyofT("cfg.timezones.darwin_adelaide", "Darwin, Adelaide"),
    "600": dyofT("cfg.timezones.brisbane_sydney_melbourne", "Brisbane, Sydney, Melbourne"),
    "660": dyofT("cfg.timezones.magadan_solomon_islands", "Magadan, Solomon Islands"),
    "720": dyofT("cfg.timezones.auckland_fiji", "Auckland, Fiji"),
    "780": dyofT("cfg.timezones.nuku_alofa", "Nuku'alofa"),
    "840": dyofT("cfg.timezones.kiritimati", "Kiritimati")
  };

  // Only display labels pass through this lookup; catalogue/state keys stay intact.
  function dyofDisplayLabel(value) {
    var label = String(value == null ? "" : value);
    var colour = /^Colour (\d+)$/.exec(label);
    if (colour) {
      return dyofT("cfg.labels.colour_number", "Colour {number}", { number: colour[1] });
    }
    switch (label) {
      case "Minimal": return dyofT("cfg.labels.minimal", "Minimal");
      case "Classic": return dyofT("cfg.labels.classic", "Classic");
      case "Luxury": return dyofT("cfg.labels.luxury", "Luxury");
      case "Gradient": return dyofT("cfg.labels.gradient", "Gradient");
      case "Waves": return dyofT("cfg.labels.waves", "Waves");
      case "Blocks": return dyofT("cfg.labels.blocks", "Blocks");
      case "Soft Stripes": return dyofT("cfg.labels.soft_stripes", "Soft Stripes");
      case "Essential": return dyofT("cfg.labels.essential", "Essential");
      case "Everyday": return dyofT("cfg.labels.everyday", "Everyday");
      case "Daily": return dyofT("cfg.labels.daily", "Daily");
      case "Weekly": return dyofT("cfg.labels.weekly", "Weekly");
      case "Horizontal week to view": return dyofT("cfg.labels.horizontal_week_to_view", "Horizontal week to view");
      case "Two weeks to view": return dyofT("cfg.labels.two_weeks_to_view", "Two weeks to view");
      case "Vertical": return dyofT("cfg.labels.vertical", "Vertical");
      case "Monthly": return dyofT("cfg.labels.monthly", "Monthly");
      case "Standard": return dyofT("cfg.labels.standard", "Standard");
      case "Compact Weekend": return dyofT("cfg.labels.compact_weekend", "Compact Weekend");
      case "Tasks & Priorities": return dyofT("cfg.labels.tasks_priorities", "Tasks & Priorities");
      case "Ideas & Notes": return dyofT("cfg.labels.ideas_notes", "Ideas & Notes");
      case "Vertical Weekly": return dyofT("cfg.labels.vertical_weekly", "Vertical Weekly");
      case "Mix (Ruled, Dotted, Plain & Squared)": return dyofT("cfg.labels.mix_ruled_dotted_plain_squared", "Mix (Ruled, Dotted, Plain & Squared)");
      case "Ruled": return dyofT("cfg.labels.ruled", "Ruled");
      case "Dotted": return dyofT("cfg.labels.dotted", "Dotted");
      case "Plain": return dyofT("cfg.labels.plain", "Plain");
      case "Squared": return dyofT("cfg.labels.squared", "Squared");
      case "Dotted & Ruled": return dyofT("cfg.labels.dotted_ruled", "Dotted & Ruled");
      case "To do": return dyofT("cfg.labels.to_do", "To do");
      case "Work/Life Balance": return dyofT("cfg.labels.work_life_balance", "Work/Life Balance");
      case "Self-Care": return dyofT("cfg.labels.self_care", "Self-Care");
      case "Baby Journal": return dyofT("cfg.labels.baby_journal", "Baby Journal");
      case "A guided journal to preserve every milestone, memory and first. What's inside: Welcome Baby, Growing Together, First Moments, Family & Keepsakes, Letters & Reflections": return dyofT("cfg.labels.a_guided_journal_to_preserve_every_milestone_memory_and_description", "A guided journal to preserve every milestone, memory and first. What's inside: Welcome Baby, Growing Together, First Moments, Family & Keepsakes, Letters & Reflections");
      case "Wedding Journal": return dyofT("cfg.labels.wedding_journal", "Wedding Journal");
      case "A guided journal to plan every detail of your wedding and preserve the memories along the way. What's inside: Our Story, Budget & Suppliers, The Countdown, Guests, The Big Day, Memories": return dyofT("cfg.labels.a_guided_journal_to_plan_every_detail_of_your_wedding_a_description", "A guided journal to plan every detail of your wedding and preserve the memories along the way. What's inside: Our Story, Budget & Suppliers, The Countdown, Guests, The Big Day, Memories");
      case "Gardening Journal": return dyofT("cfg.labels.gardening_journal", "Gardening Journal");
      case "A guided journal to plan, nurture and keep track of your garden through every season. What's inside: Getting Started, Planning & Organisation, Garden Records, Garden Care, Seasonal Sections, Year Reflection": return dyofT("cfg.labels.a_guided_journal_to_plan_nurture_and_keep_track_of_your_description", "A guided journal to plan, nurture and keep track of your garden through every season. What's inside: Getting Started, Planning & Organisation, Garden Records, Garden Care, Seasonal Sections, Year Reflection");
      case "Life Essentials": return dyofT("cfg.labels.life_essentials", "Life Essentials");
      case "A guided journal to keep life's important information secure and organised. What's inside: Getting Started, Important Information, Accounts A–Z, Email & Devices, Software & Subscriptions, Looking Ahead": return dyofT("cfg.labels.a_guided_journal_to_keep_life_s_important_information_s_description", "A guided journal to keep life's important information secure and organised. What's inside: Getting Started, Important Information, Accounts A–Z, Email & Devices, Software & Subscriptions, Looking Ahead");
      case "Cookbook Journal": return dyofT("cfg.labels.cookbook_journal", "Cookbook Journal");
      case "A guided journal to collect favourite recipes, flavours and kitchen inspiration. What's inside: Getting Started, Kitchen Essentials, Recipe Collection, Recipe Records, Future Recipes": return dyofT("cfg.labels.a_guided_journal_to_collect_favourite_recipes_flavours_description", "A guided journal to collect favourite recipes, flavours and kitchen inspiration. What's inside: Getting Started, Kitchen Essentials, Recipe Collection, Recipe Records, Future Recipes");
      case "Pet Journal": return dyofT("cfg.labels.pet_journal", "Pet Journal");
      case "A guided journal to care for your pet and preserve the moments you share together. What's inside: Getting Started, Daily Life, Health & Care, Training & Growth, Pet Sitting, Memories": return dyofT("cfg.labels.a_guided_journal_to_care_for_your_pet_and_preserve_the_description", "A guided journal to care for your pet and preserve the moments you share together. What's inside: Getting Started, Daily Life, Health & Care, Training & Growth, Pet Sitting, Memories");
      case "Undated Planner - Week to view": return dyofT("cfg.labels.undated_planner_week_to_view", "Undated Planner - Week to view");
      case "Undated Planner - Vertical week to view": return dyofT("cfg.labels.undated_planner_vertical_week_to_view", "Undated Planner - Vertical week to view");
      case "Colour ": return dyofT("cfg.labels.colour", "Colour ");
      case "Australia": return dyofT("cfg.labels.australia", "Australia");
      case "Austria": return dyofT("cfg.labels.austria", "Austria");
      case "Belgium": return dyofT("cfg.labels.belgium", "Belgium");
      case "Canada": return dyofT("cfg.labels.canada", "Canada");
      case "China": return dyofT("cfg.labels.china", "China");
      case "Denmark": return dyofT("cfg.labels.denmark", "Denmark");
      case "Finland": return dyofT("cfg.labels.finland", "Finland");
      case "France": return dyofT("cfg.labels.france", "France");
      case "Germany": return dyofT("cfg.labels.germany", "Germany");
      case "Greece": return dyofT("cfg.labels.greece", "Greece");
      case "Iceland": return dyofT("cfg.labels.iceland", "Iceland");
      case "India": return dyofT("cfg.labels.india", "India");
      case "Indonesia": return dyofT("cfg.labels.indonesia", "Indonesia");
      case "Ireland": return dyofT("cfg.labels.ireland", "Ireland");
      case "Italy": return dyofT("cfg.labels.italy", "Italy");
      case "Japan": return dyofT("cfg.labels.japan", "Japan");
      case "Korea": return dyofT("cfg.labels.korea", "Korea");
      case "Malaysia": return dyofT("cfg.labels.malaysia", "Malaysia");
      case "Mexico": return dyofT("cfg.labels.mexico", "Mexico");
      case "Netherlands": return dyofT("cfg.labels.netherlands", "Netherlands");
      case "New Zealand": return dyofT("cfg.labels.new_zealand", "New Zealand");
      case "Norway": return dyofT("cfg.labels.norway", "Norway");
      case "Philippines": return dyofT("cfg.labels.philippines", "Philippines");
      case "Portugal": return dyofT("cfg.labels.portugal", "Portugal");
      case "Singapore": return dyofT("cfg.labels.singapore", "Singapore");
      case "Spain": return dyofT("cfg.labels.spain", "Spain");
      case "Sweden": return dyofT("cfg.labels.sweden", "Sweden");
      case "Switzerland": return dyofT("cfg.labels.switzerland", "Switzerland");
      case "Taiwan": return dyofT("cfg.labels.taiwan", "Taiwan");
      case "Ukraine": return dyofT("cfg.labels.ukraine", "Ukraine");
      case "United Kingdom": return dyofT("cfg.labels.united_kingdom", "United Kingdom");
      case "United States": return dyofT("cfg.labels.united_states", "United States");
      case "Chinese": return dyofT("cfg.labels.chinese", "Chinese");
      case "Christian": return dyofT("cfg.labels.christian", "Christian");
      case "Christian Orthodox": return dyofT("cfg.labels.christian_orthodox", "Christian Orthodox");
      case "Hindu": return dyofT("cfg.labels.hindu", "Hindu");
      case "Jewish": return dyofT("cfg.labels.jewish", "Jewish");
      case "Muslim": return dyofT("cfg.labels.muslim", "Muslim");
      case "White": return dyofT("cfg.labels.white", "White");
      case "Cream": return dyofT("cfg.labels.cream", "Cream");
      case "Black": return dyofT("cfg.labels.black", "Black");
      case "Red": return dyofT("cfg.labels.red", "Red");
      case "Blue": return dyofT("cfg.labels.blue", "Blue");
      case "Green": return dyofT("cfg.labels.green", "Green");
      case "Pink": return dyofT("cfg.labels.pink", "Pink");
      case "Purple": return dyofT("cfg.labels.purple", "Purple");
      case "Grey": return dyofT("cfg.labels.grey", "Grey");
      case "Gray": return dyofT("cfg.labels.gray", "Gray");
      case "Yellow": return dyofT("cfg.labels.yellow", "Yellow");
      case "Silver": return dyofT("cfg.labels.silver", "Silver");
      case "Gold": return dyofT("cfg.labels.gold", "Gold");
      case "Navy": return dyofT("cfg.labels.navy", "Navy");
      case "Tan": return dyofT("cfg.labels.tan", "Tan");
      case "Notes": return dyofT("cfg.labels.notes", "Notes");
      case "Wellness": return dyofT("cfg.labels.wellness", "Wellness");
      case "Productivity": return dyofT("cfg.labels.productivity", "Productivity");
      case "Mindful": return dyofT("cfg.labels.mindful", "Mindful");
      case "One Time": return dyofT("cfg.labels.one_time", "One Time");
      case "To Dos": return dyofT("cfg.labels.to_dos", "To Dos");
      case "Ruled And To Dos": return dyofT("cfg.labels.ruled_and_to_dos", "Ruled And To Dos");
      case "Month Days List": return dyofT("cfg.labels.month_days_list", "Month Days List");
      case "Month On One Page": return dyofT("cfg.labels.month_on_one_page", "Month On One Page");
      case "Half Page": return dyofT("cfg.labels.half_page", "Half Page");
      case "On": return dyofT("cfg.labels.on", "On");
      case "Off": return dyofT("cfg.labels.off", "Off");
      case "Dated": return dyofT("cfg.labels.dated", "Dated");
      case "Undated": return dyofT("cfg.labels.undated", "Undated");
      case "Czech": return dyofT("cfg.labels.czech", "Czech");
      case "Czech Republic": return dyofT("cfg.labels.czech_republic", "Czech Republic");
      case "Czechia": return dyofT("cfg.labels.czechia", "Czechia");
      case "Christianity": return dyofT("cfg.labels.christianity", "Christianity");
      case "Judaism": return dyofT("cfg.labels.judaism", "Judaism");
      case "UK": return dyofT("cfg.labels.uk", "UK");
      case "Not added": return dyofT("cfg.labels.not_added", "Not added");
      case "Upload Your Own Cover": return dyofT("cfg.labels.upload_your_own_cover", "Upload Your Own Cover");
      case "Journals": return dyofT("cfg.labels.journals_fallback", "Journals");
      case "Tasks Priorities": return dyofT("cfg.labels.tasks_priorities_fallback", "Tasks Priorities");
      case "Ideas Notes": return dyofT("cfg.labels.ideas_notes_fallback", "Ideas Notes");
      case "Self Care": return dyofT("cfg.labels.self_care_fallback", "Self Care");
      case "Design": return dyofT("cfg.labels.design_fallback", "Design");
      case "Layout": return dyofT("cfg.labels.layout_fallback", "Layout");
      case "Setup": return dyofT("cfg.labels.setup_fallback", "Setup");
      case "Personalise": return dyofT("cfg.labels.personalise_fallback", "Personalise");
      case "Review": return dyofT("cfg.labels.review_fallback", "Review");
      case "Personal": return dyofT("cfg.labels.personal_fallback", "Personal");
      case "Review sizes": return dyofT("cfg.labels.review_sizes_fallback", "Review sizes");
      case "Front cover preview": return dyofT("cfg.labels.front_cover_preview_fallback", "Front cover preview");
      case "Back cover preview": return dyofT("cfg.labels.back_cover_preview_fallback", "Back cover preview");
      case "Refill design": return dyofT("cfg.labels.refill_design_fallback", "Refill design");
      case "Live page preview": return dyofT("cfg.labels.live_page_preview_fallback", "Live page preview");
      case "Undated refill preview": return dyofT("cfg.labels.undated_refill_preview_fallback", "Undated refill preview");
      case "Instant first-page preview": return dyofT("cfg.labels.instant_first_page_preview_fallback", "Instant first-page preview");
      case "Personal dates preview": return dyofT("cfg.labels.personal_dates_preview_fallback", "Personal dates preview");
      case "Your planner review": return dyofT("cfg.labels.your_planner_review_fallback", "Your planner review");
      case "A5 Planner cover": return dyofT("cfg.labels.a5_planner_cover_fallback", "A5 Planner cover");
      case "Work Life Balance": return dyofT("cfg.labels.work_life_balance_fallback", "Work Life Balance");
      case "Undated Weekly": return dyofT("cfg.labels.undated_weekly_fallback", "Undated Weekly");
      case "Undated Vertical Weekly": return dyofT("cfg.labels.undated_vertical_weekly_fallback", "Undated Vertical Weekly");
      case "Dotted Ruled": return dyofT("cfg.labels.dotted_ruled_fallback", "Dotted Ruled");
      case "To Do": return dyofT("cfg.labels.to_do_fallback", "To Do");
      default: return value;
    }
  }

  function titleCase(value) {
    return dyofDisplayLabel(String(value || "")
      .replace(/-/g, " ")
      .replace(/\b\w/g, function(character) {
        return character.toUpperCase();
      }));
  }

  // Review hides the "Elastic closure" row while the option is hidden at the
  // owner's request (2026-09-29). The one switch is ELASTIC_CLOSURE_OFFERED in
  // dyof-cover-contract.js; set it to true to show the row again.
  function elasticClosureOffered() {
    return Boolean(root.DYOFCoverContract && root.DYOFCoverContract.ELASTIC_CLOSURE_OFFERED);
  }

  function elasticClosureLabel(elastic) {
    if (!elastic || !elastic.enabled) {
      return dyofT("cfg.labels.not_added", "Not added");
    }
    var labels = {
      navy: dyofT("cfg.labels.blue_marine", "Blue Marine"),
      tan: dyofT("cfg.labels.beige", "Beige"),
      pink: dyofT("cfg.labels.fuchsia", "Fuchsia"),
      "golden-yellow": dyofT("cfg.labels.yellow", "Yellow"),
      black: dyofT("cfg.labels.black", "Black"),
      "grey-green": dyofT("cfg.labels.nato_green", "NATO Green"),
      purple: dyofT("cfg.labels.violet", "Violet"),
      red: dyofT("cfg.labels.red", "Red"),
      "silver-metallic": dyofT("cfg.labels.silver", "Silver"),
      "gold-metallic": dyofT("cfg.labels.gold", "Gold")
    };
    return labels[elastic.colourId] || titleCase(elastic.colourId);
  }

  function headerLabel(value) {
    return value === "to-dos" ? dyofT("cfg.labels.to_do_s", "To-Dos") : titleCase(value);
  }

  function designLabel(value) {
    var labels = {
      "to-dos": dyofT("cfg.labels.to_do_s", "To-Dos"),
      "ruled-and-to-dos": dyofT("cfg.labels.ruled_to_do_s", "Ruled & To-Dos"),
      "month-days-list": dyofT("cfg.labels.month_days_list", "Month Days List"),
      "month-on-one-page": dyofT("cfg.labels.month_on_one_page_caption", "Month on One Page"),
      "half-page": dyofT("cfg.labels.half_page", "Half Page")
    };
    return labels[value] || titleCase(value);
  }

  function controlLabel(field, value) {
    return CONTROL_LABELS[field] && CONTROL_LABELS[field][value]
      ? CONTROL_LABELS[field][value]
      : titleCase(value);
  }

  function sizeLabel(value) {
    if (value === "a4") return "A4";
    if (value === "personal") return "Personal";
    return "A5";
  }

  function refillPreviewTemplate(state, merchandising) {
    if (
      root.DYOFCoverEditor
      && typeof root.DYOFCoverEditor.resolveRefillPreviewTemplate === "function"
    ) {
      return root.DYOFCoverEditor.resolveRefillPreviewTemplate(merchandising, state);
    }
    var lifestyle = state && state.journey && state.journey.lifestyle;
    return ["classic", "modern", "neutral", "playful"].indexOf(lifestyle) !== -1
      ? lifestyle
      : "classic";
  }

  function a4OrganiserLifestyle(state, merchandising) {
    var template = refillPreviewTemplate(state, merchandising);
    return A4_ORGANISER_SCENES[template] ? template : "classic";
  }

  function personalClipbookLifestyle(state, merchandising) {
    var template = refillPreviewTemplate(state, merchandising);
    return PERSONAL_CLIPBOOK_SCENES[template] ? template : "classic";
  }

  function effectivePaperColour(state) {
    if (state.selection.engine === "legacy") {
      return state.selection.style === "luxury" ? "cream" : "white";
    }
    // Only modern Dated refills offer a paper choice. Undated fills have none,
    // so an earlier Dated Cream choice still in the selection must not tint them.
    if (state.selection.engine !== "modern"
      || (state.journey && state.journey.refillType === "undated")) {
      return "white";
    }
    return state.selection.paperColour === "cream" ? "cream" : "white";
  }

  function swatchBackground(swatches) {
    var values = swatches || [];
    var step;

    if (values.length < 2) {
      return values[0] || "#fff";
    }

    step = 100 / values.length;
    return "conic-gradient(" + values.map(function(value, index) {
      return value + " " + (index * step) + "% " + ((index + 1) * step) + "%";
    }).join(", ") + ")";
  }

  function splitSwatchBackground(swatches) {
    var values = swatches || [];

    if (values.length < 2) {
      return values[0] || "#fff";
    }

    return "linear-gradient(90deg, " + values[0] + " 0 50%, " + values[1] + " 50% 100%)";
  }

  // Building an Intl.DateTimeFormat is slow (notably in Safari) and these
  // labels are redrawn on every render, so each formatter is built once.
  var dateFormatters = {};

  function cachedDateFormat(locale, options) {
    var key = locale + "\u0000" + JSON.stringify(options);
    if (!dateFormatters[key]) {
      dateFormatters[key] = new Intl.DateTimeFormat(locale, options);
    }
    return dateFormatters[key];
  }

  function monthLabel(value, locale) {
    var match = /^(\d{4})-(\d{2})$/.exec(String(value || ""));
    var date;

    if (!match) {
      return "";
    }

    date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
    if (root.DYOFI18n) {
      return root.DYOFI18n.date(date, { month: "long", year: "numeric", timeZone: "UTC" });
    }
    return cachedDateFormat(locale || "en-GB", {
      month: "long",
      year: "numeric",
      timeZone: "UTC"
    }).format(date);
  }

  function endMonthValue(startMonth, duration) {
    var match = /^(\d{4})-(\d{2})$/.exec(String(startMonth || ""));
    var date;

    if (!match) {
      return "";
    }

    date = new Date(Date.UTC(
      Number(match[1]),
      Number(match[2]) - 1 + Math.max(1, Number(duration) || 12) - 1,
      1
    ));
    return date.getUTCFullYear() + "-" + String(date.getUTCMonth() + 1).padStart(2, "0");
  }

  function timezoneLabel(offset) {
    var minutes = Number(offset) || 0;
    var absolute = Math.abs(minutes);
    var hours = Math.floor(absolute / 60);
    var remainder = absolute % 60;
    var prefix = minutes === 0
      ? dyofT("cfg.timezones.gmt", "GMT")
      : dyofT("cfg.timezones.gmt", "GMT") + (minutes > 0 ? "+" : "-") + hours +
        (remainder ? ":" + String(remainder).padStart(2, "0") : "");
    var location = TIMEZONE_LOCATIONS[String(minutes)];
    return location ? prefix + " (" + location + ")" : prefix;
  }

  function shiftMonthValue(value, amount) {
    var match = /^(\d{4})-(\d{2})$/.exec(String(value || ""));
    var date;
    if (!match) {
      return "";
    }
    date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1 + Number(amount || 0), 1));
    return date.getUTCFullYear() + "-" + String(date.getUTCMonth() + 1).padStart(2, "0");
  }

  function plannerPeriodLabel(startMonth, duration) {
    var endMonth = endMonthValue(startMonth, duration);
    var format = cachedDateFormat("en-GB", {
      month: "long",
      year: "2-digit",
      timeZone: "UTC"
    });
    var startMatch = /^(\d{4})-(\d{2})$/.exec(String(startMonth || ""));
    var endMatch = /^(\d{4})-(\d{2})$/.exec(String(endMonth || ""));
    if (!startMatch || !endMatch) {
      return dyofT("cfg.period.select", "Select the period");
    }
    if (root.DYOFI18n) {
      var options = { month: "long", year: "2-digit", timeZone: "UTC" };
      return dyofT("cfg.period.range", "{start} - {end}", {
        start: root.DYOFI18n.date(new Date(Date.UTC(Number(startMatch[1]), Number(startMatch[2]) - 1, 1)), options),
        end: root.DYOFI18n.date(new Date(Date.UTC(Number(endMatch[1]), Number(endMatch[2]) - 1, 1)), options)
      });
    }
    return format.format(new Date(Date.UTC(Number(startMatch[1]), Number(startMatch[2]) - 1, 1))) +
      " - " +
      format.format(new Date(Date.UTC(Number(endMatch[1]), Number(endMatch[2]) - 1, 1)));
  }

  function holidayDisplayLabel(feature, value) {
    var labels = {
      "countryHolidays:United Kingdom": dyofT("cfg.labels.uk", "UK"),
      "religiousHolidays:Jewish": dyofT("cfg.labels.judaism", "Judaism"),
      "religiousHolidays:Christian": dyofT("cfg.labels.christianity", "Christianity")
    };
    return dyofDisplayLabel(labels[feature + ":" + value] || value);
  }

  function createSvgElement(name, attributes, textContent) {
    var element = document.createElementNS(SVG_NAMESPACE, name);
    Object.keys(attributes || {}).forEach(function(key) {
      element.setAttribute(key, attributes[key]);
    });
    if (textContent !== undefined) {
      element.textContent = textContent;
    }
    return element;
  }

  function clearChildren(node) {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  // Makes the mounted node `current` equal to the new, unmounted node `next`
  // (the same elements, attributes and text) when both have the same element
  // structure, keeping the mounted nodes. Returns false, changing nothing,
  // when the structures differ.
  function morphPreviewTree(current, next) {
    var changes = [];
    if (!collectPreviewTreeChanges(current, next, changes)) {
      return false;
    }
    changes.forEach(function(change) { change(); });
    return true;
  }

  function onlyTextChildren(node) {
    return Array.prototype.every.call(node.childNodes, function(child) {
      return child.nodeType === 3;
    });
  }

  function collectPreviewTreeChanges(current, next, changes) {
    if (
      !current || !next
      || current.nodeType !== next.nodeType
      || current.nodeName !== next.nodeName
      || current.namespaceURI !== next.namespaceURI
    ) {
      return false;
    }
    if (current.nodeType === 3) {
      if (current.data !== next.data) {
        changes.push(function() { current.data = next.data; });
      }
      return true;
    }
    if (current.nodeType !== 1 || !current.attributes || !next.attributes || !current.childNodes || !next.childNodes) {
      return false;
    }
    Array.prototype.forEach.call(next.attributes, function(attribute) {
      if (current.getAttributeNS(attribute.namespaceURI, attribute.localName) !== attribute.value) {
        changes.push(function() {
          current.setAttributeNS(attribute.namespaceURI, attribute.name, attribute.value);
        });
      }
    });
    Array.prototype.forEach.call(current.attributes, function(attribute) {
      if (!next.hasAttributeNS(attribute.namespaceURI, attribute.localName)) {
        changes.push(function() {
          current.removeAttributeNS(attribute.namespaceURI, attribute.localName);
        });
      }
    });
    if (onlyTextChildren(current) && onlyTextChildren(next)) {
      if (current.textContent !== next.textContent) {
        changes.push(function() { current.textContent = next.textContent; });
      }
      return true;
    }
    if (current.childNodes.length !== next.childNodes.length) {
      return false;
    }
    return Array.prototype.every.call(next.childNodes, function(child, index) {
      return collectPreviewTreeChanges(current.childNodes[index], child, changes);
    });
  }

  function holidayValidationMessages(element) {
    var data = element.dataset || {};
    var coverEditor = element.coverEditor;
    return {
      countryHolidaysRequired: data.countryHolidaysRequired,
      religiousHolidaysRequired: data.religiousHolidaysRequired,
      // Known upload pixels let every cover gate apply the photo-resolution stop.
      coverAssets: coverEditor && typeof coverEditor.printResolutionAssets === "function"
        ? coverEditor.printResolutionAssets()
        : null
    };
  }

  // Only a well-formed answer from the backend can stop the customer. Anything
  // else means the check is unavailable, which must never block checkout.
  function normalizeContentCheckResponse(body) {
    var issues;
    if (!body || typeof body !== "object" || typeof body.ok !== "boolean" || !Array.isArray(body.issues)) {
      return null;
    }
    if (body.ok) {
      return { status: "ok", issues: [] };
    }
    issues = body.issues.filter(function(issue) {
      return issue
        && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(String(issue.isoDate || ""))
        && Number.isFinite(Number(issue.count))
        && Number.isFinite(Number(issue.maximum));
    }).map(function(issue) {
      var normalized = {
        isoDate: String(issue.isoDate),
        contentType: issue.contentType === "holidays" ? "holidays" : "personal dates",
        count: Number(issue.count),
        maximum: Number(issue.maximum),
        message: String(issue.message || "")
      };
      // A Monthly personal date too long to print even in smaller type names itself.
      if (normalized.contentType === "personal dates" && issue.reason === "too-long"
        && typeof issue.label === "string" && issue.label.trim()) {
        normalized.reason = "too-long";
        normalized.label = issue.label.trim();
      }
      // Classic layouts' holiday list and holiday data limits are not about one day.
      if (normalized.contentType === "holidays"
        && (issue.reason === "holiday-list" || issue.reason === "holiday-coverage")) {
        normalized.reason = issue.reason;
      }
      return normalized;
    }).sort(function(left, right) {
      return left.isoDate < right.isoDate ? -1 : left.isoDate > right.isoDate ? 1 : 0;
    });
    return issues.length ? { status: "issues", issues: issues } : null;
  }

  // Whether a personal date (with its weekly/monthly repeats) lands on isoDate.
  function personalDateOccursOn(entry, isoDate) {
    var origin = Date.parse(String(entry && entry.date || "") + "T00:00:00Z");
    var target = Date.parse(String(isoDate || "") + "T00:00:00Z");
    if (!Number.isFinite(origin) || !Number.isFinite(target) || target < origin) {
      return false;
    }
    if (entry.frequency === "weekly") {
      return Math.round((target - origin) / 86400000) % 7 === 0;
    }
    if (entry.frequency === "monthly") {
      return isoDate.slice(8) === entry.date.slice(8);
    }
    return isoDate === entry.date;
  }

  function contentCheckDateLabel(isoDate, withYear) {
    var parts = String(isoDate || "").split("-").map(Number);
    if (root.DYOFI18n) {
      return root.DYOFI18n.date(new Date(Date.UTC(parts[0], parts[1] - 1, parts[2])), {
        day: "numeric", month: "long", year: withYear ? "numeric" : undefined, timeZone: "UTC"
      });
    }
    return parts[2] + " " + PERSONAL_DATE_MONTHS[parts[1] - 1] + (withYear ? " " + parts[0] : "");
  }

  // Only a personal-date issue carries a template count limit. A holiday issue
  // can also mean the names do not fit (alone or beside personal dates), where
  // its maximum is how many would fit, so it is described without numbers. A
  // personal date too long for its space is named instead.
  function contentCheckIssueSummary(issue) {
    if (issue.contentType === "holidays") {
      return dyofT("cfg.content.holidays_dont_fit", "holiday names don't fit");
    }
    if (issue.reason === "too-long") {
      return dyofT("cfg.content.label_too_long", "\"{label}\" is too long", { label: issue.label });
    }
    return dyofPlural("cfg.content.personal_date_count", issue.count, {
      one: "{count} personal date, up to {maximum}", other: "{count} personal dates, up to {maximum}"
    }, { maximum: issue.maximum });
  }

  // Add date's stop for a personal date whose name is too long for that day's
  // space even in smaller print: usually the new entry, else one it squeezes.
  function personalDateTooLongMessage(issue, added) {
    var day = contentCheckDateLabel(issue.isoDate, false);
    if (String(added && added.label || "").trim() === issue.label) {
      return dyofT("cfg.content.added_too_long", "\"{label}\" is too long to fit on {day} on this layout, even in smaller print. Please shorten it.", { label: issue.label, day: day });
    }
    return dyofT("cfg.content.existing_too_long", "\"{label}\" on {day} no longer fits beside this entry on this layout, even in smaller print. Shorten that entry (remove it and add it again) or choose another date.", { label: issue.label, day: day });
  }

  function contentCheckMessage(issues) {
    var holidayList = issues.filter(function(issue) { return issue.reason === "holiday-list"; })[0];
    if (holidayList) {
      return dyofT("cfg.content.holiday_page_full", "This layout's holiday list has room for {maximum} holidays and your holiday groups have {count}. Choose fewer holiday groups to continue.", {
        maximum: holidayList.maximum, count: holidayList.count
      });
    }
    if (issues.some(function(issue) { return issue.reason === "holiday-coverage"; })) {
      return dyofT("cfg.content.holidays_unavailable", "Holidays aren't available for every month of this diary. Choose another start month or turn off holidays to continue.");
    }
    var listed = issues.slice(0, 5).map(function(issue) {
      return dyofT("cfg.content.issue_date", "{date} ({summary})", {
        date: contentCheckDateLabel(issue.isoDate, true), summary: contentCheckIssueSummary(issue)
      });
    });
    var more = issues.length - listed.length;
    var moreLabel = more ? dyofPlural("cfg.content.more_days", more, { one: "{count} more day", other: "{count} more days" }) : "";
    var days = root.DYOFI18n ? root.DYOFI18n.list(more ? listed.concat(moreLabel) : listed)
      : listed.length > 1 && !more
        ? listed.slice(0, -1).join(", ") + " and " + listed[listed.length - 1]
        : listed.join(", ") + (more ? " and " + moreLabel : "");
    var holidays = issues.some(function(issue) { return issue.contentType === "holidays"; });
    var tooLong = issues.some(function(issue) { return issue.reason === "too-long"; });
    if (tooLong && holidays) {
      return dyofPlural("cfg.content.shorten_holidays", issues.length, {
      one: "There's no room for every entry on this layout on {days}. Shorten or remove an entry or a holiday group on that day or choose a roomier layout to continue.",
      other: "There's no room for every entry on this layout on {days}. Shorten or remove an entry or a holiday group on those days or choose a roomier layout to continue."
    }, { days: days });
    }
    if (tooLong) {
      return dyofPlural("cfg.content.shorten", issues.length, {
      one: "There's no room for every entry on this layout on {days}. Shorten or remove an entry on that day or choose a roomier layout to continue.",
      other: "There's no room for every entry on this layout on {days}. Shorten or remove an entry on those days or choose a roomier layout to continue."
    }, { days: days });
    }
    if (holidays) {
      return dyofPlural("cfg.content.remove_holidays", issues.length, {
      one: "There's no room for every entry on this layout on {days}. Remove an entry or a holiday group on that day or choose a roomier layout to continue.",
      other: "There's no room for every entry on this layout on {days}. Remove an entry or a holiday group on those days or choose a roomier layout to continue."
    }, { days: days });
    }
    return dyofPlural("cfg.content.remove", issues.length, {
      one: "There's no room for every entry on this layout on {days}. Remove an entry on that day or choose a roomier layout to continue.",
      other: "There's no room for every entry on this layout on {days}. Remove an entry on those days or choose a roomier layout to continue."
    }, { days: days });
  }

  function withTimeout(promise, timeoutMs, onTimeout) {
    return new Promise(function(resolve, reject) {
      var settled = false;
      var timer = setTimeout(function() {
        if (settled) { return; }
        settled = true;
        if (typeof onTimeout === "function") {
          onTimeout();
        }
        reject(dyofCustomerError(dyofT("cfg.save.timeout", "The saved configuration request timed out.")));
      }, timeoutMs);
      Promise.resolve(promise).then(function(value) {
        if (settled) { return; }
        settled = true;
        clearTimeout(timer);
        resolve(value);
      }, function(error) {
        if (settled) { return; }
        settled = true;
        clearTimeout(timer);
        reject(error);
      });
    });
  }

  function decodeBase64(value) {
    var binary = root.atob(String(value || ""));
    var bytes = new Uint8Array(binary.length);
    for (var index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return bytes;
  }

  function createChoice(field, value, label, disabled, suffix) {
    var button = document.createElement("button");
    var text = document.createElement("span");
    button.type = "button";
    button.dataset.dyofField = field;
    button.dataset.dyofValue = value;
    button.disabled = Boolean(disabled);
    if (field === "layout") {
      var icon = document.createElement("i");
      icon.className = "dyof__layout-icon";
      icon.setAttribute("aria-hidden", "true");
      button.classList.add("dyof__layout-choice");
      button.appendChild(icon);
    }
    text.textContent = dyofDisplayLabel(label);
    button.appendChild(text);

    if (suffix) {
      var status = document.createElement("small");
      status.textContent = suffix;
      button.appendChild(status);
    }

    return button;
  }

  // ?size=&source_product_id= from an organiser page's DESIGN YOUR OWN REFILL
  // button (openDyorForOrganiser in sections/main-product.liquid).
  function organiserEntryParams(search) {
    var params = new URLSearchParams(String(search || ""));
    var productId = String(params.get("source_product_id") || "");
    var size = String(params.get("size") || "");
    return /^\d{1,20}$/.test(productId) && ["personal", "a5", "a4"].indexOf(size) !== -1
      ? { productId: productId, size: size }
      : null;
  }

  function readInitialState(element) {
    var script = element.querySelector("[data-dyof-initial-state]");
    var state = {};
    if (!script) {
      return state;
    }

    try {
      state = JSON.parse(script.textContent || "{}");
    } catch (error) {
      state = {};
    }

    if (root.location) {
      var searchParams = new URLSearchParams(root.location.search);
      // An organiser opens the refill journey at its own size; whether the
      // organiser bundle applies is decided by loadOrganiserContext.
      var organiserEntry = organiserEntryParams(root.location.search);
      if (organiserEntry) {
        state.journey = state.journey || {};
        state.journey.productType = "refill";
        state.selection = state.selection || {};
        state.selection.size = organiserEntry.size;
      }
      var productOverride = searchParams.get("dyof_product");
      if (["refill", "clipbook", "planner"].indexOf(productOverride) !== -1) {
        state.journey = state.journey || {};
        state.journey.productType = productOverride;
      }
      var lifestyleOverride = searchParams.get("dyof_lifestyle");
      if (["classic", "modern", "neutral", "playful"].indexOf(lifestyleOverride) !== -1) {
        state.journey = state.journey || {};
        state.journey.lifestyle = lifestyleOverride;
      }
      // Station links can open the Undated branch, optionally with a fill.
      var refillOverride = searchParams.get("dyof_refill");
      if (refillOverride === "dated" || refillOverride === "undated") {
        state.journey = state.journey || {};
        state.journey.refillType = refillOverride;
        var fillOverride = searchParams.get("dyof_fill");
        if (refillOverride === "undated" && /^[a-z0-9-]{2,40}$/.test(String(fillOverride || ""))) {
          state.journey.undatedFill = fillOverride;
        }
      }
    }

    return state;
  }

  function readJsonData(element, selector, fallback) {
    var script = element.querySelector(selector)
      || (root.document && root.document.querySelector(selector));
    if (!script) {
      return fallback;
    }

    try {
      return JSON.parse(script.textContent || "");
    } catch (error) {
      return fallback;
    }
  }

  function stablePreviewValue(value) {
    if (Array.isArray(value)) {
      return value.map(stablePreviewValue);
    }
    if (value && typeof value === "object") {
      return Object.keys(value).sort().reduce(function(result, key) {
        result[key] = stablePreviewValue(value[key]);
        return result;
      }, {});
    }
    return value;
  }

  function orderTwoPageSpreadBySide(pages) {
    var ordered = Array.isArray(pages) ? pages.slice() : [];
    if (ordered.length !== 2) {
      return ordered;
    }
    var leftPages = ordered.filter(function(page) {
      return page && page.side === "left";
    });
    var rightPages = ordered.filter(function(page) {
      return page && page.side === "right";
    });
    return leftPages.length === 1 && rightPages.length === 1
      ? [leftPages[0], rightPages[0]]
      : ordered;
  }

  function previewRequestKey(state, payload) {
    return JSON.stringify(stablePreviewValue({
      screen: state && state.screen,
      journey: state && state.journey,
      payload: payload
    }));
  }

  function previewAbortError() {
    var error = new Error("Preview rendering was superseded by a newer selection.");
    error.name = "AbortError";
    return error;
  }

  function throwIfPreviewAborted(signal) {
    if (signal && signal.aborted) {
      throw previewAbortError();
    }
  }

  function loadImageSource(image, source, signal) {
    try {
      throwIfPreviewAborted(signal);
    } catch (error) {
      return Promise.reject(error);
    }

    return new Promise(function(resolve, reject) {
      var settled = false;
      var decodeStarted = false;

      function cleanup() {
        image.removeEventListener("load", onLoad);
        image.removeEventListener("error", onError);
        if (signal) {
          signal.removeEventListener("abort", onAbort);
        }
      }

      function finish(error) {
        if (settled) {
          return;
        }
        settled = true;
        cleanup();
        if (error) {
          reject(error);
        } else {
          resolve(image);
        }
      }

      function decodeLoadedImage() {
        var decodePromise;
        if (decodeStarted || settled) {
          return;
        }
        decodeStarted = true;
        if (signal && signal.aborted) {
          finish(previewAbortError());
          return;
        }
        if (typeof image.decode !== "function") {
          finish();
          return;
        }
        try {
          decodePromise = image.decode();
        } catch (error) {
          finish(error);
          return;
        }
        Promise.resolve(decodePromise).then(function() {
          finish();
        }, function(error) {
          if (signal && signal.aborted) {
            finish(previewAbortError());
          } else if (image.complete && Number(image.naturalWidth) > 0) {
            // Safari can reject decode() for an otherwise complete image.
            finish();
          } else {
            finish(error || dyofCustomerError(dyofT("cfg.preview.image_decode", "A preview image could not be decoded.")));
          }
        });
      }

      function onLoad() {
        decodeLoadedImage();
      }

      function onError() {
        finish(dyofCustomerError(dyofT("cfg.preview.image_load", "A preview image could not be loaded.")));
      }

      function onAbort() {
        finish(previewAbortError());
      }

      image.addEventListener("load", onLoad);
      image.addEventListener("error", onError);
      if (signal) {
        signal.addEventListener("abort", onAbort);
      }
      image.src = source;

      if (image.complete) {
        if (Number(image.naturalWidth) > 0) {
          decodeLoadedImage();
        } else {
          Promise.resolve().then(function() {
            if (!settled && image.complete && Number(image.naturalWidth) === 0) {
              onError();
            }
          });
        }
      }
    });
  }

  class DYOFConfigurator extends HTMLElement {
    constructor() {
      super();
      this.store = null;
      this.abortController = null;
      this.previewTimer = null;
      this.previewUrls = [];
      this.restoredAssetObjectUrls = [];
      this.cartThumbnailCache = {};
      this.cartRefillPreview = null;
      this.layoutPreviewCacheEntries = new Map();
      this.layoutPreviewCacheQueue = [];
      this.layoutPreviewCacheActive = 0;
      this.predefinedLayoutEntries = new Map();
      this.predefinedLayoutQueue = [];
      this.predefinedLayoutActive = 0;
      this.predefinedLayoutManifests = new Map();
      this.predefinedLayoutBootstrap = null;
      this.currentPredefinedLayoutKey = "";
      this.layoutPreviewDirectManifestStateByEngine = {
        legacy: { index: null, promise: null, controller: null, retryAt: 0 },
        modern: { index: null, promise: null, controller: null, retryAt: 0 }
      };
      this.lastCommittedLayoutPreviewCacheKey = null;
      this.currentLayoutVisualKey = null;
      this.retainedLayoutPreview = null;
      this.lastPreviewRevision = null;
      this.activePreviewMode = null;
      this.reviewRevision = null;
      this.reviewKey = null;
      this.reviewMountedIdentity = null;
      this.pendingReloadReviewDestination = null;
      this.reloadReviewDestinationRestoring = false;
      this.reloadResumeTimer = 0;
      this.reloadResumePendingState = null;
      this.reviewLoadedThrough = 0;
      this.reviewTotalPages = 0;
      this.reviewCanLoadPages = false;
      this.reviewAbortController = null;
      this.reviewCurrentIndex = 0;
      this.reviewPendingBackCover = null;
      this.reviewUrls = [];
      this.reviewLoadedPageNumbers = new Set();
      this.reviewPersonalDatePageNumbers = [];
      this.reviewNavigationBusy = false;
      this.reviewNavigationGeneration = 0;
      this.reviewPreload = null;
      this.reviewNextSpread = null;
      this.reviewRendererVersion = "";
      this.reviewPreloadNavigationPending = false;
      this.reviewCoverPreload = null;
      this.reviewCoverGeneration = 0;
      this.reviewConfirmations = { details: false, policy: false };
      this.reviewConfirmationRevision = null;
      this.personalDateColour = "";
      this.personalDateDay = "";
      this.personalDateMonth = "";
      this.personalDateFrequency = "";
      this.baseConfigurationId = null;
      this.pendingEditorResumeState = null;
      this.restoringConfiguration = false;
      this.openRefillMenu = null;
      this.openPlannerMenu = null;
      this.periodAnchorMonth = null;
      this.contentCheck = null;
      this.personalDateAddCheck = null;
      this.didChooseRefillType = false;
      this.didChooseUndatedFill = false;
      this.undatedPreviewKey = null;
      this.undatedPreviewIdentity = null;
      this.undatedPreviewPendingKey = null;
      this.undatedPreviewPendingIdentity = null;
      this.undatedPreviewAbortController = null;
      this.undatedPreviewPrefetchLinks = [];
      this.undatedPreviewPrefetchSize = "";
      this.a5ShellPrefetchLinks = [];
      this.datedFlowExplicitFields = new Set();
      this.datedFlowVisibleThrough = 0;
      this.datedFlowPendingIndex = null;
      this.datedFlowComplete = false;
      this.datedFlowWaiting = false;
      this.organiserContext = null;
      this.pageTopScrollFrame = 0;
      this.toolbarResizeObserver = null;
      this.marketingPopupObserver = null;
      this.marketingPopupMayOwnBodyLock = false;
      this.marketingPopupMayOwnInlineBodyLock = false;
      this.marketingPopupInitialBodyOverflow = "";
      this.marketingPopupInitialBodyOverflowPriority = "";
      this.wp2MetricSequence = 0;
      this.wp2Metrics = [];
      this.wp2PendingPaintInteraction = null;
      this.wp2ActivePreviewInteraction = null;
      this.boundClick = this.onClick.bind(this);
      this.boundChange = this.onChange.bind(this);
      this.boundInput = this.onInput.bind(this);
      this.boundKeyDown = this.onKeyDown.bind(this);
      this.boundDailyNoticeClose = this.onDailyNoticeClose.bind(this);
      this.boundPageHide = this.onPageHide.bind(this);
      this.boundViewportResize = this.onViewportResize.bind(this);
      this.boundReviewVisibilityChange = this.onReviewVisibilityChange.bind(this);
      this.boundPreviewPointerEnter = this.onPreviewPointerEnter.bind(this);
      this.boundPreviewPointerMove = this.onPreviewPointerMove.bind(this);
      this.boundPreviewPointerLeave = this.onPreviewPointerLeave.bind(this);
      this.phoneTyping = null;
      this.boundPhoneTypingFocusIn = this.onPhoneTypingFocusIn.bind(this);
      this.boundPhoneTypingFocusOut = this.onPhoneTypingFocusOut.bind(this);
      this.boundPhoneTypingClick = this.onPhoneTypingClick.bind(this);
      this.boundPhoneTypingViewport = this.onPhoneTypingViewport.bind(this);
    }

    connectedCallback() {
      this.startMarketingPopupSuppression();

      if (this.store) {
        return;
      }

      if (!root.DYOFLaunchContract || !root.DYOFCommerce || !root.DYOFCoverContract || !root.DYOFCoverEditor || !root.DYOFState) {
        this.showDependencyError();
        return;
      }

      this.contract = root.DYOFLaunchContract;
      this.commerce = root.DYOFCommerce;
      this.commerceCatalogs = readJsonData(this, "[data-dyof-product-catalog]", {
        currency: "GBP",
        refill: { options: [], variants: [] },
        clipbook: { options: [], variants: [] },
        planner: { options: [], variants: [] },
        undated: { variants: [] },
        newColourful: { options: [], variants: [] }
      });
      this.applyStoreProfile(readJsonData(this, "[data-dyof-store-profile]", null));
      this.productCatalog = this.commerceCatalogs.refill || this.commerceCatalogs;
      this.merchandising = readJsonData(this, "[data-dyof-cover-merchandising]", {});
      this.undatedPreviews = readJsonData(this, "[data-dyof-undated-previews]", {});
      this.datedEntryPreview = readJsonData(this, "[data-dyof-dated-entry-preview]", null);
      this.stateApi = root.DYOFState;
      if (root.pdfjsLib && this.dataset.pdfWorker) {
        root.pdfjsLib.GlobalWorkerOptions.workerSrc = this.dataset.pdfWorker;
      }
      this.store = this.stateApi.createStore(readInitialState(this));
      this.preselectOrganiserSize(this.store.getState());
      this.cacheElements();
      this.setupDesktopStickyOffset();
      this.setupPdfPreviewSizing();
      this.coverEditor = new root.DYOFCoverEditor.Controller(this, this.store, {
        setStatus: this.setPreviewStatus.bind(this)
      });
      var savedConfigurationId = this.savedConfigurationId();
      var restoredReloadResume = this.restoreReloadResumeState();
      if (restoredReloadResume) {
        // Started before the first render, which then waits for those photos.
        this.restoreMissingAssetPreviews();
      }
      this.restoringConfiguration = Boolean(savedConfigurationId && !restoredReloadResume);
      // A printed refill's QR code (or an old "Reorder" link) from the old
      // builder opens as a new saved design, then restores like a saved link.
      var oldBuilderLink = savedConfigurationId || restoredReloadResume ? null : this.oldBuilderLink();
      if (oldBuilderLink) {
        this.restoringConfiguration = true;
      }
      this.addEventListener("click", this.boundClick);
      this.addEventListener("change", this.boundChange);
      this.addEventListener("input", this.boundInput);
      this.addEventListener("compositionend", this.boundInput);
      this.addEventListener("focusin", this.boundPhoneTypingFocusIn);
      this.addEventListener("focusout", this.boundPhoneTypingFocusOut);
      this.addEventListener("click", this.boundPhoneTypingClick, true);
      document.addEventListener("keydown", this.boundKeyDown);
      if (this.elements.dailyNotice) {
        this.elements.dailyNotice.addEventListener("close", this.boundDailyNoticeClose);
      }
      document.addEventListener("visibilitychange", this.boundReviewVisibilityChange);
      if (this.elements.previewStage) {
        this.elements.previewStage.addEventListener("pointerenter", this.boundPreviewPointerEnter);
        this.elements.previewStage.addEventListener("pointermove", this.boundPreviewPointerMove);
        this.elements.previewStage.addEventListener("pointerleave", this.boundPreviewPointerLeave);
      }
      if (typeof root.addEventListener === "function") {
        root.addEventListener("pagehide", this.boundPageHide);
        if (this.boundViewportResize) {
          root.addEventListener("resize", this.boundViewportResize);
          this.viewportWidthTracked = true;
          this.cachedViewportWidth = 0;
        }
      }
      this.unsubscribe = this.store.subscribe(this.onStateChange.bind(this));
      if (this.restoringConfiguration) {
        this.renderRestoringConfiguration();
      } else {
        this.render(this.store.getState());
        this.preloadPredefinedLayoutChoices(this.store.getState());
        this.prewarmPreviewPaths(this.store.getState());
        this.scheduleContentCheck(this.store.getState());
      }
      if (oldBuilderLink) {
        this.importOldBuilderLink(oldBuilderLink);
      } else if (!restoredReloadResume) {
        this.restoreConfigurationFromUrl();
      }
      if (
        !this.restoringConfiguration
        && this.shouldRequestPreview(this.store.getState())
      ) {
        this.schedulePreview(this.store.getState(), true);
      }
      this.loadOrganiserContext();
    }

    disconnectedCallback() {
      this.clearCartThumbnailCache();
      this.previewFontCache = null;
      this.previewFontTransportDisabledEndpoint = null;
      this.stopPdfPreviewSizing();
      this.stopMarketingPopupSuppression();
      this.flushReloadResumeState();
      this.removeEventListener("click", this.boundClick);
      this.removeEventListener("change", this.boundChange);
      this.removeEventListener("input", this.boundInput);
      this.removeEventListener("compositionend", this.boundInput);
      this.removeEventListener("focusin", this.boundPhoneTypingFocusIn);
      this.removeEventListener("focusout", this.boundPhoneTypingFocusOut);
      this.removeEventListener("click", this.boundPhoneTypingClick, true);
      this.endPhoneTyping(false);
      document.removeEventListener("keydown", this.boundKeyDown);
      if (this.elements && this.elements.dailyNotice) {
        this.elements.dailyNotice.removeEventListener("close", this.boundDailyNoticeClose);
      }
      document.removeEventListener("visibilitychange", this.boundReviewVisibilityChange);
      if (this.elements && this.elements.previewStage) {
        this.elements.previewStage.removeEventListener("pointerenter", this.boundPreviewPointerEnter);
        this.elements.previewStage.removeEventListener("pointermove", this.boundPreviewPointerMove);
        this.elements.previewStage.removeEventListener("pointerleave", this.boundPreviewPointerLeave);
      }
      if (typeof root.removeEventListener === "function") {
        root.removeEventListener("pagehide", this.boundPageHide);
        if (this.boundViewportResize) {
          root.removeEventListener("resize", this.boundViewportResize);
        }
      }
      this.viewportWidthTracked = false;
      this.closePreviewFullscreen(false);
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      if (this.abortController) {
        this.abortController.abort();
      }
      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
      }
      this.cancelContentCheck();
      this.cancelPersonalDateAddCheck();
      if (this.undatedPreviewAbortController) {
        this.undatedPreviewAbortController.abort();
        this.undatedPreviewAbortController = null;
      }
      (this.undatedPreviewPrefetchLinks || []).forEach(function(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      this.undatedPreviewPrefetchLinks = [];
      (this.a5ShellPrefetchLinks || []).forEach(function(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      this.a5ShellPrefetchLinks = [];
      Object.keys(this.layoutPreviewDirectManifestStateByEngine || {}).forEach(function(engine) {
        var manifestState = this.layoutPreviewDirectManifestStateByEngine[engine];
        if (manifestState && manifestState.controller) {
          manifestState.controller.abort();
          manifestState.controller = null;
        }
      }, this);
      this.discardReviewPreload();
      this.discardReviewCoverPreload();
      if (this.coverEditor) {
        this.coverEditor.destroy();
      }
      clearTimeout(this.previewTimer);
      this.releaseLayoutPreviewCacheEntries();
      this.discardRetainedLayoutPreview();
      if (this.pageTopScrollFrame) {
        root.cancelAnimationFrame(this.pageTopScrollFrame);
        this.pageTopScrollFrame = 0;
      }
      if (this.toolbarResizeObserver) {
        this.toolbarResizeObserver.disconnect();
        this.toolbarResizeObserver = null;
      }
      this.releasePreviewUrls();
      this.releaseReviewUrls();
      this.revokeRestoredAssetUrls(this.restoredAssetObjectUrls);
      this.restoredAssetObjectUrls = [];
      this.reviewMountedIdentity = null;
    }

    startMarketingPopupSuppression() {
      if (!this.marketingPopupObserver && document.body && document.body.style) {
        this.marketingPopupInitialBodyOverflow = document.body.style.getPropertyValue
          ? document.body.style.getPropertyValue("overflow")
          : "";
        this.marketingPopupInitialBodyOverflowPriority = document.body.style.getPropertyPriority
          ? document.body.style.getPropertyPriority("overflow")
          : "";
      }
      this.suppressMarketingPopup();
      if (this.marketingPopupObserver || !root.MutationObserver || !document.body) {
        return;
      }

      this.marketingPopupObserver = new root.MutationObserver(function(mutations) {
        var shouldSuppress = mutations.some(function(mutation) {
          if (mutation.type === "attributes") {
            return mutation.target === document.body || (
              mutation.target.matches
              && mutation.target.matches(MARKETING_POPUP_SELECTOR)
            );
          }
          return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
            if (!node || (node.nodeType !== 1 && node.nodeType !== 11)) {
              return false;
            }
            return Boolean(
              (node.matches && node.matches(MARKETING_POPUP_SELECTOR))
              || (node.querySelector && node.querySelector(MARKETING_POPUP_SELECTOR))
            );
          });
        });
        if (shouldSuppress) {
          this.suppressMarketingPopup();
        }
      }.bind(this));
      this.marketingPopupObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    stopMarketingPopupSuppression() {
      if (this.marketingPopupObserver) {
        this.marketingPopupObserver.disconnect();
        this.marketingPopupObserver = null;
      }
      this.releaseMarketingPopupScrollLock();
      this.marketingPopupMayOwnBodyLock = false;
      this.marketingPopupMayOwnInlineBodyLock = false;
    }

    suppressMarketingPopup() {
      if (!document.querySelectorAll) {
        return;
      }
      var popups = Array.prototype.slice.call(
        document.querySelectorAll(MARKETING_POPUP_SELECTOR)
      );
      var bodyStyle = document.body && document.body.style;
      var bodyHasInlineLock = Boolean(
        popups.length
        && bodyStyle
        && bodyStyle.getPropertyValue
        && bodyStyle.getPropertyValue("overflow") === "hidden"
      );
      if (bodyHasInlineLock) {
        this.marketingPopupMayOwnInlineBodyLock = true;
        var htmlHasDyofPreview = Boolean(
          document.documentElement
          && document.documentElement.classList
          && document.documentElement.classList.contains("dyof-preview-open")
        );
        var themeNavigationIsOpen = Boolean(
          document.body.classList
          && (
            document.body.classList.contains("reveal-mobile-nav")
            || document.body.classList.contains("show-search")
          )
        );
        if (
          this.marketingPopupInitialBodyOverflow === "hidden"
          && !htmlHasDyofPreview
          && !themeNavigationIsOpen
        ) {
          this.marketingPopupInitialBodyOverflow = "";
          this.marketingPopupInitialBodyOverflowPriority = "";
        }
      }
      Array.prototype.forEach.call(
        popups,
        function(popup) {
          if (popup.getAttribute("data-freeze-scroll") === "true") {
            this.marketingPopupMayOwnBodyLock = true;
          }
          popup.classList.remove("cc-popup--visible");
          popup.setAttribute("aria-hidden", "true");
          popup.hidden = true;
          if (popup.parentNode) {
            popup.parentNode.removeChild(popup);
          }
        }.bind(this)
      );
      this.releaseMarketingPopupScrollLock();
    }

    releaseMarketingPopupScrollLock() {
      if (
        (!this.marketingPopupMayOwnBodyLock && !this.marketingPopupMayOwnInlineBodyLock)
        || !document.body
        || !document.querySelectorAll
      ) {
        return;
      }
      var anotherFreezingPopupIsVisible = Array.prototype.some.call(
        document.querySelectorAll(FREEZING_POPUP_SELECTOR),
        function(popup) {
          return !popup.matches(NATIVE_NEWSLETTER_POPUP_SELECTOR);
        }
      );
      if (anotherFreezingPopupIsVisible) {
        return;
      }
      var htmlHasDyofPreview = Boolean(
        document.documentElement
        && document.documentElement.classList
        && document.documentElement.classList.contains("dyof-preview-open")
      );
      var themeNavigationIsOpen = Boolean(
        document.body.classList
        && (
          document.body.classList.contains("reveal-mobile-nav")
          || document.body.classList.contains("show-search")
        )
      );
      if (htmlHasDyofPreview || themeNavigationIsOpen) {
        return;
      }

      if (this.marketingPopupMayOwnBodyLock) {
        var hadScrollbarPadding = document.body.classList.contains("cc-popup-no-scroll-pad-right");
        document.body.classList.remove("cc-popup-no-scroll", "cc-popup-no-scroll-pad-right");
        if (hadScrollbarPadding && document.body.style) {
          document.body.style.removeProperty("padding-right");
        }
        this.marketingPopupMayOwnBodyLock = false;
      }
      if (
        this.marketingPopupMayOwnInlineBodyLock
        && document.body.style
        && document.body.style.getPropertyValue
        && document.body.style.getPropertyValue("overflow") === "hidden"
      ) {
        if (this.marketingPopupInitialBodyOverflow) {
          document.body.style.setProperty(
            "overflow",
            this.marketingPopupInitialBodyOverflow,
            this.marketingPopupInitialBodyOverflowPriority
          );
        } else {
          document.body.style.removeProperty("overflow");
        }
      }
      this.marketingPopupMayOwnInlineBodyLock = false;
    }

    cacheElements() {
      this.elements = {
        panels: this.querySelectorAll("[data-dyof-panel]"),
        appShell: this.querySelector(".dyof__app"),
        toolbar: this.querySelector(".dyof__toolbar"),
        controls: this.querySelector("[data-dyof-controls]"),
        workspace: this.querySelector(".dyof__workspace"),
        progress: this.querySelector(".dyof__progress"),
        stepButtons: this.querySelectorAll("[data-dyof-step]"),
        hero: this.querySelector("[data-dyof-hero]"),
        heroImage: this.querySelector("[data-dyof-hero-image]"),
        heroTitle: this.querySelector("[data-dyof-hero-title]"),
        heroSubtitle: this.querySelector("[data-dyof-hero-subtitle]"),
        price: this.querySelector("[data-dyof-price]"),
        priceLabel: this.querySelector("[data-dyof-price-label]"),
        priceAmount: this.querySelector("[data-dyof-price-amount]"),
        printConfirmation: this.querySelector("[data-dyof-print-confirmation]"),
        previousButton: this.querySelector("[data-dyof-nav='previous']"),
        nextButton: this.querySelector("[data-dyof-nav='next']"),
        refillMenus: this.querySelectorAll("[data-dyof-refill-menu]"),
        refillMenuLabels: this.querySelectorAll("[data-dyof-refill-menu-label]"),
        refillMenuOptions: this.querySelectorAll("[data-dyof-refill-option]"),
        coverOnlyField: this.querySelector("[data-dyof-cover-only-field]"),
        coverOnlyToggle: this.querySelector("[data-dyof-cover-only]"),
        coverOnlyNote: this.querySelector("[data-dyof-cover-only-note]"),
        datedFlowStatus: this.querySelector("[data-dyof-dated-flow-status]"),
        datedHeading: this.querySelector("[data-dyof-dated-heading]"),
        refillSizeGroup: this.querySelector("[data-dyof-refill-size-group]"),
        refillSizeList: this.querySelector("[data-dyof-refill-size-list]"),
        datedControls: this.querySelector("[data-dyof-dated-controls]"),
        paperWeightNote: this.querySelector("[data-dyof-paper-weight-note]"),
        legacyControls: this.querySelector("[data-dyof-legacy-controls]"),
        modernControls: this.querySelector("[data-dyof-modern-controls]"),
        undatedControls: this.querySelector("[data-dyof-undated-controls]"),
        undatedPageCountTemplate: this.querySelector("[data-dyof-undated-page-count-template]"),
        dailyNotice: this.querySelector("[data-dyof-daily-notice]"),
        colourModeList: this.querySelector("[data-dyof-colour-mode-list]"),
        paperList: this.querySelector("[data-dyof-paper-list]"),
        layoutList: this.querySelector("[data-dyof-layout-list]"),
        viewLegend: this.querySelector("[data-dyof-view-legend]"),
        designLegend: this.querySelector("[data-dyof-design-legend]"),
        viewList: this.querySelector("[data-dyof-view-list]"),
        designList: this.querySelector("[data-dyof-design-list]"),
        headerList: this.querySelector("[data-dyof-header-list]"),
        datePositionList: this.querySelector("[data-dyof-date-position-list]"),
        legacyLayoutList: this.querySelector("[data-dyof-legacy-layout-list]"),
        legacyLineStyleGroup: this.querySelector("[data-dyof-legacy-line-style-group]"),
        legacyLineStyleList: this.querySelector("[data-dyof-legacy-line-style-list]"),
        legacyCalendarGroup: this.querySelector("[data-dyof-legacy-calendar-group]"),
        legacyCalendarList: this.querySelector("[data-dyof-legacy-calendar-list]"),
        legacyNotesGroup: this.querySelector("[data-dyof-legacy-notes-group]"),
        legacyNotesList: this.querySelector("[data-dyof-legacy-notes-list]"),
        legacyAppointmentGroup: this.querySelector("[data-dyof-legacy-appointment-group]"),
        legacyAppointmentList: this.querySelector("[data-dyof-legacy-appointment-list]"),
        undatedList: this.querySelector("[data-dyof-undated-list]"),
        firstPageInputs: this.querySelectorAll("[data-dyof-first-page]"),
        firstPageColourControl: this.querySelector("[data-dyof-first-page-colour-control]"),
        firstPageColourList: this.querySelector("[data-dyof-first-page-colour-list]"),
        personalPeriodLabel: this.querySelector("[data-dyof-personal-period-label]"),
        personalPeriodList: this.querySelector("[data-dyof-personal-period-list]"),
        personalStartDayList: this.querySelector("[data-dyof-personal-start-day-list]"),
        plannerMenus: this.querySelectorAll("[data-dyof-planner-menu]"),
        countryHolidayToggle: this.querySelector(
          "[data-dyof-feature-toggle='countryHolidays']"
        ),
        countryHolidayControls: this.querySelector("[data-dyof-country-holiday-controls]"),
        countryHolidayList: this.querySelector("[data-dyof-country-holiday-list]"),
        countryHolidayChips: this.querySelector("[data-dyof-country-holiday-chips]"),
        countrySearch: this.querySelector("[data-dyof-country-search]"),
        religiousHolidayToggle: this.querySelector(
          "[data-dyof-feature-toggle='religiousHolidays']"
        ),
        religiousHolidayControls: this.querySelector(
          "[data-dyof-religious-holiday-controls]"
        ),
        religiousHolidayList: this.querySelector("[data-dyof-religious-holiday-list]"),
        religiousHolidayChips: this.querySelector("[data-dyof-religious-holiday-chips]"),
        religiousSearch: this.querySelector("[data-dyof-religious-search]"),
        moonToggle: this.querySelector("[data-dyof-feature-toggle='moonPhases']"),
        moonControls: this.querySelector("[data-dyof-moon-controls]"),
        moonOffset: this.querySelector("[data-dyof-moon-offset]"),
        moonOffsetLabel: this.querySelector("[data-dyof-moon-offset-label]"),
        moonSearch: this.querySelector("[data-dyof-moon-search]"),
        personalDateLabel: this.querySelector("[data-dyof-personal-date-label]"),
        personalDateDayLabel: this.querySelector("[data-dyof-personal-date-day-label]"),
        personalDateMonthLabel: this.querySelector("[data-dyof-personal-date-month-label]"),
        personalDateColourList: this.querySelector(
          "[data-dyof-personal-date-colour-list]"
        ),
        personalDateError: this.querySelector("[data-dyof-personal-date-error]"),
        personalDateAdd: this.querySelector("[data-dyof-add-personal-date]"),
        personalDateEmpty: this.querySelector("[data-dyof-personal-date-empty]"),
        personalDateList: this.querySelector("[data-dyof-personal-date-list]"),
        messages: this.querySelector("[data-dyof-messages]"),
        holidayErrors: this.querySelector("[data-dyof-holiday-errors]"),
        saveStatus: this.querySelector("[data-dyof-save-status]"),
        previewPanel: this.querySelector(".dyof__preview"),
        previewTitle: this.querySelector("#dyof-preview-title"),
        previewStage: this.querySelector("[data-dyof-preview-stage]"),
        previewPages: this.querySelector("[data-dyof-preview-pages]"),
        previewStatus: this.querySelector("[data-dyof-preview-status]"),
        previewMagnifier: this.querySelector("[data-dyof-preview-magnifier]"),
        previewMagnifierContent: this.querySelector("[data-dyof-preview-magnifier-content]"),
        undatedPreviewDescription: this.querySelector("[data-dyof-undated-preview-description]"),
        previewRetry: this.querySelector("[data-dyof-preview-retry]"),
        previewExpand: this.querySelector("[data-dyof-preview-expand]"),
        previewModal: this.querySelector("[data-dyof-preview-modal]"),
        previewModalContent: this.querySelector("[data-dyof-preview-modal-content]"),
        previewModalClose: this.querySelector(".dyof__preview-modal-close"),
        tags: this.querySelector("[data-dyof-tags]"),
        review: this.querySelector("[data-dyof-review]"),
        reviewScene: this.querySelector("[data-dyof-review-scene]"),
        reviewStatus: this.querySelector("[data-dyof-review-status]"),
        reviewPreviousControl: this.querySelector(".dyof__review-page-control--previous"),
        reviewNextControl: this.querySelector(".dyof__review-page-control--next"),
        reviewPagePrevious: this.querySelector("[data-dyof-review-page-previous]"),
        reviewPageNext: this.querySelector("[data-dyof-review-page-next]"),
        reviewPrevious: this.querySelector("[data-dyof-review-previous]"),
        reviewNext: this.querySelector("[data-dyof-review-next]"),
        reviewPrice: this.querySelector("[data-dyof-review-price]"),
        reviewConfirmations: this.querySelectorAll("[data-dyof-review-confirm]"),
        reviewAddToCart: this.querySelector("[data-dyof-review] [data-dyof-add-to-cart]"),
        reviewCartStatus: this.querySelector("[data-dyof-review-cart-status]"),
        reviewErrors: this.querySelector("[data-dyof-review-errors]"),
        reviewAlert: this.querySelector("[data-dyof-review-alert]"),
        reviewSummary: this.querySelector("[data-dyof-review-summary]")
      };
    }

    setupDesktopStickyOffset() {
      var toolbar = this.elements && this.elements.toolbar;
      if (!toolbar) {
        return;
      }
      var update = function() {
        var height = Math.ceil(toolbar.getBoundingClientRect().height || toolbar.offsetHeight || 80);
        this.style.setProperty("--dyof-desktop-toolbar-offset", height + "px");
        this.style.setProperty("--dyof-mobile-toolbar-offset", height + "px");
      }.bind(this);
      update();
      if (typeof root.ResizeObserver === "function") {
        this.toolbarResizeObserver = new root.ResizeObserver(update);
        this.toolbarResizeObserver.observe(toolbar);
      }
    }

    // While a phone keyboard is open for a text field in the controls, the
    // preview scrolls with the page and Back/Next step aside (CSS "Mobile
    // typing"). The state changes no size, so it cannot feed the keyboard's
    // viewport changes back into itself.
    phoneTypingLayout() {
      return Boolean(
        this.dataset.currentScreen !== "review"
        && root.matchMedia
        && root.matchMedia(PHONE_TYPING_QUERY).matches
      );
    }

    isPhoneTextEntry(element) {
      return this.phoneTypingLayout() && this.isControlsTextEntry(element);
    }

    // At any width: a field that keeps focus through a rotation to a wider
    // layout keeps typing ready for the rotation back.
    isControlsTextEntry(element) {
      var controls = this.elements && this.elements.controls;
      if (
        !element
        || !controls
        || element === controls
        || !controls.contains(element)
        || element.disabled
        || element.readOnly
      ) {
        return false;
      }
      var tag = String(element.tagName || "").toLowerCase();
      return tag === "textarea"
        || (tag === "input" && PHONE_TYPING_TEXT_TYPES.indexOf(String(element.type || "text").toLowerCase()) !== -1);
    }

    // Pinch zoom changes height and scale together, so it is not a keyboard.
    phoneViewportExtent() {
      var viewport = root.visualViewport;
      return viewport ? viewport.height * (viewport.scale || 1) : 0;
    }

    // Neither the keyboard nor pinch zoom changes it; a rotation does.
    phoneLayoutWidth() {
      var page = root.document && root.document.documentElement;
      return Number(page && page.clientWidth) || Number(root.innerWidth) || 0;
    }

    // The baseline is the view without a keyboard: the tallest seen at this
    // width. After a rotation the keyboard may still be up, so it starts from
    // the page's own height, which the iOS Safari keyboard (innerHeight) and
    // Chrome Android's default one (the root's clientHeight) leave alone.
    refreshPhoneKeyboardBaseline() {
      var typing = this.phoneTyping;
      var page = root.document && root.document.documentElement;
      var width = this.phoneLayoutWidth();
      var extent = this.phoneViewportExtent();
      if (width !== typing.width) {
        typing.width = width;
        typing.baseline = Math.max(
          extent,
          Number(root.innerHeight) || 0,
          Number(page && page.clientHeight) || 0
        );
        typing.revealed = false;
      } else if (extent > typing.baseline) {
        typing.baseline = extent;
      }
    }

    phoneKeyboardOpen() {
      if (!this.phoneTyping || !root.visualViewport) {
        return false;
      }
      this.refreshPhoneKeyboardBaseline();
      return this.phoneTyping.baseline - this.phoneViewportExtent() >= PHONE_KEYBOARD_MIN_PX;
    }

    onPhoneTypingFocusIn(event) {
      var typing = this.phoneTyping;
      var controls = this.elements && this.elements.controls;
      var textEntry = this.isPhoneTextEntry(event.target);
      if (typing && !textEntry && controls && controls.contains(event.target)) {
        this.setPhoneTypingAnchor(event.target);
      }
      if (!textEntry) {
        return;
      }
      if (!typing) {
        typing = this.phoneTyping = {
          baseline: this.phoneViewportExtent(),
          width: this.phoneLayoutWidth(),
          field: null,
          anchor: null,
          anchorTop: NaN,
          active: false,
          revealed: false,
          revealTimer: 0,
          settleTimer: 0,
          settleChecks: 0
        };
        if (root.visualViewport) {
          root.visualViewport.addEventListener("resize", this.boundPhoneTypingViewport);
        }
      }
      clearTimeout(typing.settleTimer);
      typing.settleTimer = 0;
      typing.field = event.target;
      this.setPhoneTypingAnchor(event.target);
      typing.revealed = false;
      // Without the Visual Viewport API focus alone decides; otherwise the
      // keyboard's resize does, so a focus that opens no keyboard changes nothing.
      if (!root.visualViewport || this.phoneKeyboardOpen()) {
        this.setPhoneTypingActive(true);
        this.schedulePhoneTypingReveal(PHONE_TYPING_REVEAL_FALLBACK_MS);
      }
    }

    onPhoneTypingViewport() {
      var typing = this.phoneTyping;
      if (!typing) {
        return;
      }
      var activeElement = root.document && root.document.activeElement;
      var focused = this.isControlsTextEntry(activeElement);
      // Rotated to a wider layout, where none of this applies. A field that
      // keeps its focus keeps this listener, so rotating back with the
      // keyboard still up releases the preview again.
      if (!this.phoneTypingLayout()) {
        this.leavePhoneTyping(false);
        if (!focused) {
          this.endPhoneTyping(false);
        }
        return;
      }
      if (this.phoneKeyboardOpen()) {
        if (focused) {
          typing.field = activeElement;
          this.setPhoneTypingActive(true);
        }
        if (typing.active && !typing.revealed) {
          this.schedulePhoneTypingReveal(PHONE_TYPING_REVEAL_MS);
        }
        return;
      }
      // The keyboard, or a select's picker, has closed.
      if (typing.active) {
        this.leavePhoneTyping(true);
      }
      if (!focused) {
        this.endPhoneTyping(false);
      }
    }

    onPhoneTypingFocusOut(event) {
      var typing = this.phoneTyping;
      var controls = this.elements && this.elements.controls;
      if (!typing || this.isControlsTextEntry(event.relatedTarget)) {
        return;
      }
      // Focus taken outside the controls: nothing there to keep in view.
      if (event.relatedTarget && !(controls && controls.contains(event.relatedTarget))) {
        this.setPhoneTypingAnchor(null);
      }
      clearTimeout(typing.settleTimer);
      typing.settleChecks = 0;
      typing.settleTimer = setTimeout(this.settlePhoneTyping.bind(this), PHONE_TYPING_SETTLE_MS);
    }

    // Runs after the tap that moved focus has been delivered, never under it.
    settlePhoneTyping() {
      var typing = this.phoneTyping;
      if (!typing) {
        return;
      }
      typing.settleTimer = 0;
      var activeElement = root.document && root.document.activeElement;
      if (this.isControlsTextEntry(activeElement)) {
        return;
      }
      // A closing keyboard or an open picker: check again rather than rely
      // on one resize event. Only a select's picker stays open for longer
      // than a keyboard takes to close, so a misread keyboard can never keep
      // Back/Next hidden.
      if (
        typing.active
        && this.phoneTypingLayout()
        && this.phoneKeyboardOpen()
        && (
          String(activeElement && activeElement.tagName || "").toLowerCase() === "select"
          || typing.settleChecks++ < PHONE_TYPING_SETTLE_CHECKS
        )
      ) {
        typing.settleTimer = setTimeout(this.settlePhoneTyping.bind(this), PHONE_TYPING_SETTLE_MS * 2);
        return;
      }
      this.endPhoneTyping(this.phoneTypingLayout());
    }

    onPhoneTypingClick(event) {
      var typing = this.phoneTyping;
      var controls = this.elements && this.elements.controls;
      if (!typing || !typing.active) {
        return;
      }
      this.setPhoneTypingAnchor(controls && controls.contains(event.target)
        ? event.target.closest("button, input, select, textarea, [tabindex]") || typing.field
        : null);
    }

    // The control to keep clear of the returning preview, and where it is on
    // the page in case a render replaces it before the keyboard has closed.
    setPhoneTypingAnchor(anchor) {
      var typing = this.phoneTyping;
      typing.anchor = anchor || null;
      typing.anchorTop = anchor
        && anchor.isConnected !== false
        && typeof anchor.getBoundingClientRect === "function"
        ? anchor.getBoundingClientRect().top + (Number(root.pageYOffset) || 0)
        : NaN;
    }

    setPhoneTypingActive(active) {
      var typing = this.phoneTyping;
      if (!typing || typing.active === active) {
        return;
      }
      typing.active = active;
      if (active) {
        this.dataset.dyofTyping = "true";
      } else {
        delete this.dataset.dyofTyping;
      }
    }

    schedulePhoneTypingReveal(delay) {
      var typing = this.phoneTyping;
      clearTimeout(typing.revealTimer);
      typing.revealTimer = setTimeout(this.revealPhoneTypingField.bind(this), delay);
    }

    // Puts the field just under the sticky toolbar so the controls below it,
    // such as Add date, are above the keyboard too. A field already in the
    // upper third stays still, so moving between neighbouring fields is calm.
    revealPhoneTypingField() {
      var typing = this.phoneTyping;
      if (!typing) {
        return;
      }
      typing.revealTimer = 0;
      var field = typing.field;
      if (
        !typing.active
        || !field
        || field.isConnected === false
        || !root.document
        || root.document.activeElement !== field
      ) {
        return;
      }
      typing.revealed = true;
      var viewport = root.visualViewport;
      var viewTop = viewport ? Number(viewport.offsetTop) || 0 : 0;
      var viewBottom = viewTop + (viewport ? viewport.height : Number(root.innerHeight) || 0);
      var toolbar = this.elements && this.elements.toolbar;
      var toolbarBottom = toolbar && typeof toolbar.getBoundingClientRect === "function"
        ? toolbar.getBoundingClientRect().bottom
        : 0;
      var top = Math.max(viewTop, Number(toolbarBottom) || 0) + PHONE_TYPING_GAP_PX;
      var fieldTop = field.getBoundingClientRect().top;
      if (fieldTop >= top && fieldTop <= top + (viewBottom - top) / 3) {
        return;
      }
      root.scrollBy(0, fieldTop - top);
    }

    // Restores the sticky preview and Back/Next. The control the customer
    // used last is kept clear of the returning preview by the phone scroll
    // margins, unless it is off screen or they tapped outside the controls.
    // A control a render has replaced is found again, or failing that the
    // field; with neither left, the place it had is kept clear instead.
    leavePhoneTyping(keepAnchorVisible) {
      var typing = this.phoneTyping;
      if (!typing || !typing.active) {
        return;
      }
      clearTimeout(typing.revealTimer);
      typing.revealTimer = 0;
      var anchor = typing.anchor;
      var anchorTop = typing.anchorTop;
      var field = typing.field;
      typing.revealed = false;
      this.setPhoneTypingAnchor(field);
      this.setPhoneTypingActive(false);
      if (!keepAnchorVisible || !anchor) {
        return;
      }
      var target = this.phoneTypingTarget(anchor)
        || (field && field !== anchor ? this.phoneTypingTarget(field) : null);
      if (target) {
        var bounds = target.getBoundingClientRect();
        if (!bounds.height || bounds.bottom <= 0 || bounds.top >= (Number(root.innerHeight) || 0)) {
          return;
        }
        target.scrollIntoView({ block: "nearest" });
        return;
      }
      var preview = this.elements && this.elements.previewPanel;
      var top = anchorTop - (Number(root.pageYOffset) || 0);
      if (!Number.isFinite(top) || top < 0 || !preview || typeof preview.getBoundingClientRect !== "function") {
        return;
      }
      var clearTop = preview.getBoundingClientRect().bottom + PHONE_TYPING_GAP_PX;
      if (top < clearTop && clearTop < (Number(root.innerHeight) || 0)) {
        root.scrollBy(0, top - clearTop);
      }
    }

    // The control itself, or the one a render put in its place: the same
    // kind of element with the same data attributes (and option value).
    phoneTypingTarget(node) {
      if (node.isConnected !== false) {
        return typeof node.scrollIntoView === "function" ? node : null;
      }
      var controls = this.elements && this.elements.controls;
      var data = node.dataset || {};
      var keys = Object.keys(data);
      if (!keys.length || !controls || typeof controls.querySelectorAll !== "function") {
        return null;
      }
      var option = node.type === "checkbox" || node.type === "radio";
      return Array.from(controls.querySelectorAll(node.tagName)).filter(function(candidate) {
        var candidateData = candidate.dataset || {};
        return Object.keys(candidateData).length === keys.length
          && keys.every(function(key) { return candidateData[key] === data[key]; })
          && (!option || candidate.value === node.value)
          && typeof candidate.scrollIntoView === "function"
          && candidate.getBoundingClientRect().height > 0;
      })[0] || null;
    }

    endPhoneTyping(keepAnchorVisible) {
      var typing = this.phoneTyping;
      if (!typing) {
        return;
      }
      this.leavePhoneTyping(keepAnchorVisible);
      clearTimeout(typing.revealTimer);
      clearTimeout(typing.settleTimer);
      if (root.visualViewport) {
        root.visualViewport.removeEventListener("resize", this.boundPhoneTypingViewport);
      }
      this.phoneTyping = null;
    }

    setupPdfPreviewSizing() {
      if (!root.ResizeObserver || !root.MutationObserver || this.pdfPreviewResizeObserver) {
        return;
      }
      this.pdfPreviewSources = this.pdfPreviewSources || new WeakMap();
      this.pdfPreviewObserved = new Set();
      this.pdfPreviewSizingGeneration = (this.pdfPreviewSizingGeneration || 0) + 1;
      this.pdfPreviewSizingActive = 0;
      this.pdfPreviewResizeObserver = new root.ResizeObserver(function(entries) {
        entries.forEach(function(entry) { this.resizePdfPreviewCanvas(entry.target); }, this);
      }.bind(this));
      this.pdfPreviewMutationObserver = new root.MutationObserver(
        this.onPdfPreviewMutations.bind(this)
      );
      this.pdfPreviewMutationObserver.observe(this, { childList: true, subtree: true });
      this.boundPdfPreviewResize = this.syncPdfPreviewCanvases.bind(this);
      root.addEventListener("resize", this.boundPdfPreviewResize);
      this.syncPdfPreviewCanvases();
    }

    stopPdfPreviewSizing() {
      if (this.pdfPreviewResizeObserver) { this.pdfPreviewResizeObserver.disconnect(); }
      if (this.pdfPreviewMutationObserver) { this.pdfPreviewMutationObserver.disconnect(); }
      if (this.boundPdfPreviewResize) { root.removeEventListener("resize", this.boundPdfPreviewResize); }
      (this.pdfPreviewObserved || []).forEach(function(canvas) {
        var source = this.pdfPreviewSources.get(canvas);
        if (source && source.controller) { source.controller.abort(); }
      }, this);
      this.pdfPreviewResizeObserver = null;
      this.pdfPreviewMutationObserver = null;
      this.pdfPreviewObserved = null;
      this.pdfPreviewSizingGeneration = (this.pdfPreviewSizingGeneration || 0) + 1;
      this.pdfPreviewSizingActive = 0;
    }

    // Every render changes the page, but only a canvas arriving or leaving
    // changes what is observed; size changes reach the ResizeObserver. Sync
    // measures each mounted canvas, which forces a layout, so other changes
    // (such as typing into the cover) do not call it.
    onPdfPreviewMutations(records) {
      var changesCanvas = function(node) {
        return Boolean(node && (
          node.nodeName === "CANVAS"
          || (typeof node.querySelector === "function" && node.querySelector("canvas"))
        ));
      };
      var relevant = !records || Array.prototype.some.call(records, function(record) {
        return Array.prototype.some.call(record.addedNodes || [], changesCanvas)
          || Array.prototype.some.call(record.removedNodes || [], changesCanvas);
      });
      if (relevant) {
        this.syncPdfPreviewCanvases();
      }
    }

    syncPdfPreviewCanvases() {
      if (!this.pdfPreviewResizeObserver) { return; }
      var mounted = new Set(Array.from(this.querySelectorAll("canvas")).filter(function(canvas) {
        return this.pdfPreviewSources.has(canvas);
      }, this));
      this.pdfPreviewObserved.forEach(function(canvas) {
        if (mounted.has(canvas)) { return; }
        this.pdfPreviewResizeObserver.unobserve(canvas);
        var source = this.pdfPreviewSources.get(canvas);
        if (source && source.controller) { source.controller.abort(); }
      }, this);
      mounted.forEach(function(canvas) {
        if (!this.pdfPreviewObserved.has(canvas)) { this.pdfPreviewResizeObserver.observe(canvas); }
        this.resizePdfPreviewCanvas(canvas);
      }, this);
      this.pdfPreviewObserved = mounted;
    }

    pdfPreviewPixelWidth(baseWidth, baseHeight, displayWidth, pixelWidth) {
      if (!Number.isFinite(baseWidth) || !Number.isFinite(baseHeight) || baseWidth <= 0 || baseHeight <= 0) {
        throw dyofCustomerError(dyofT("cfg.interaction.pdf_dimensions_invalid", "The PDF preview has invalid page dimensions."));
      }
      var density = Math.min(3, Math.max(1, Number(root.devicePixelRatio) || 1));
      var requested = Number(pixelWidth) || (Number(displayWidth) || baseWidth) * density;
      var width = Math.max(1, Math.floor(Math.min(
        requested,
        PDF_PREVIEW_MAX_EDGE,
        PDF_PREVIEW_MAX_EDGE * baseWidth / baseHeight,
        Math.sqrt(PDF_PREVIEW_MAX_PIXELS * baseWidth / baseHeight)
      )));
      while (width > 1 && width * Math.ceil(width * baseHeight / baseWidth) > PDF_PREVIEW_MAX_PIXELS) {
        width -= 1;
      }
      if (Math.ceil(width * baseHeight / baseWidth) > PDF_PREVIEW_MAX_EDGE) {
        throw dyofCustomerError(dyofT("cfg.interaction.pdf_proportions_unsupported", "The PDF preview has unsupported page proportions."));
      }
      return width;
    }

    copyPdfPreviewSource(sourceCanvas, destinationCanvas) {
      var source = this.pdfPreviewSources && this.pdfPreviewSources.get(sourceCanvas);
      if (source) {
        this.pdfPreviewSources.set(destinationCanvas, {
          pdfBase64: source.pdfBase64,
          imageSvg: source.imageSvg,
          predefinedArtwork: source.predefinedArtwork,
          baseWidth: source.baseWidth,
          baseHeight: source.baseHeight,
          width: destinationCanvas.width
        });
      }
    }

    async resizePdfPreviewCanvas(canvas) {
      var source = this.pdfPreviewSources && this.pdfPreviewSources.get(canvas);
      if (!source || !canvas.isConnected || !canvas.getBoundingClientRect) { return; }
      var bounds = canvas.getBoundingClientRect();
      if (!(bounds.width > 0) || !(bounds.height > 0)) {
        if (source.controller) { source.controller.abort(); }
        return;
      }
      var width = this.pdfPreviewPixelWidth(source.baseWidth, source.baseHeight, bounds.width);
      if (source.controller && source.pendingWidth !== width) { source.controller.abort(); }
      if (width === source.width || source.controller || source.failedWidth === width) { return; }
      if (this.pdfPreviewSizingActive >= 2) { return; }
      var controller = new AbortController();
      var generation = this.pdfPreviewSizingGeneration;
      source.controller = controller;
      source.pendingWidth = width;
      this.pdfPreviewSizingActive += 1;
      try {
        var rendered = source.predefinedArtwork
          ? this.renderPredefinedLayoutPage(source.predefinedArtwork, canvas.getAttribute("aria-label"), width)
          : await this.renderPageContent(
            { pdfBase64: source.pdfBase64, imageSvg: source.imageSvg },
            canvas.getAttribute("aria-label"),
            { signal: controller.signal, pixelWidth: width, adaptive: false }
          );
        if (controller.signal.aborted || !canvas.isConnected) { return; }
        canvas.width = rendered.width;
        canvas.height = rendered.height;
        canvas.getContext("2d").drawImage(rendered, 0, 0);
        source.width = rendered.width;
        source.failedWidth = null;
      } catch (error) {
        if (!controller.signal.aborted) { source.failedWidth = width; }
      } finally {
        if (source.controller === controller) { source.controller = null; }
        if (generation === this.pdfPreviewSizingGeneration) { this.pdfPreviewSizingActive -= 1; }
        this.syncPdfPreviewCanvases();
      }
    }

    showDependencyError() {
      var status = this.querySelector("[data-dyof-preview-status]");
      if (status) {
        status.textContent = dyofT("cfg.interaction.startup_failed", "The configurator could not start. Refresh the page to retry.");
      }
    }

    wp2Now() {
      return root.performance && typeof root.performance.now === "function"
        ? root.performance.now()
        : Date.now();
    }

    wp2InteractionLabel(target) {
      if (!target || !target.dataset) {
        return "interaction";
      }
      var dataset = target.dataset;
      var parts = [
        dataset.dyofField,
        dataset.dyofValue,
        dataset.dyofRefillOption,
        dataset.dyofNav,
        dataset.dyofStep,
        dataset.dyofReviewEdit,
        dataset.coverSize,
        dataset.coverSource,
        dataset.coverDesign
      ].filter(Boolean);
      return parts.length ? parts.join(":") : "interaction";
    }

    beginWp2Interaction(event, target) {
      if (!target || (this.contains && !this.contains(target))) {
        return null;
      }
      var now = this.wp2Now();
      var eventTime = Number(event && event.timeStamp);
      if (!Number.isFinite(eventTime) || eventTime < 0 || Math.abs(now - eventTime) > 60000) {
        eventTime = now;
      }
      var state = this.store && this.store.getState ? this.store.getState() : null;
      this.wp2MetricSequence = Number(this.wp2MetricSequence || 0) + 1;
      var interaction = {
        interactionId: this.wp2MetricSequence,
        startedAt: eventTime,
        screen: state && state.screen || "unknown",
        control: this.wp2InteractionLabel(target)
      };
      this.wp2PendingPaintInteraction = interaction;
      this.wp2ActivePreviewInteraction = interaction;
      return interaction;
    }

    recordWp2Metric(kind, detail) {
      var metric = Object.assign({
        kind: kind,
        at: this.wp2Now()
      }, detail || {});
      this.wp2Metrics = (this.wp2Metrics || []).concat([metric]).slice(-120);
      if (this.dataset) {
        var serialized = JSON.stringify(metric);
        this.dataset.dyofWp2LastMetric = serialized;
        this.dataset.dyofWp2Metrics = JSON.stringify(
          this.wp2Metrics.slice(-32).map(function(item) {
            return Object.assign({}, item, {
              key: String(item.key || "").slice(0, 96)
            });
          })
        );
        if (kind === "selection-paint") {
          this.dataset.dyofWp2SelectionMetric = serialized;
        } else if (kind === "preview-commit") {
          this.dataset.dyofWp2PreviewMetric = serialized;
        }
      }
      if (typeof this.dispatchEvent === "function" && typeof CustomEvent === "function") {
        this.dispatchEvent(new CustomEvent("dyof:wp2metric", {
          bubbles: true,
          detail: scrubRestoreCapabilities(metric)
        }));
      }
      return metric;
    }

    recordWp2SelectionPaint(state, action) {
      var interaction = this.wp2PendingPaintInteraction;
      if (!interaction) {
        return;
      }
      this.wp2PendingPaintInteraction = null;
      var record = function() {
        this.wp2SelectionPaintFramePending = false;
        this.recordWp2Metric("selection-paint", {
          interactionId: interaction.interactionId,
          startedAt: interaction.startedAt,
          durationMs: Math.max(0, this.wp2Now() - interaction.startedAt),
          screen: state && state.screen || interaction.screen,
          productType: state && state.journey && state.journey.productType || null,
          refillType: state && state.journey && state.journey.refillType || null,
          viewportWidth: this.viewportWidth() || null,
          source: "state-render",
          key: action && action.type || "state-change",
          control: interaction.control
        });
      }.bind(this);
      if (typeof root.requestAnimationFrame === "function") {
        this.wp2SelectionPaintFramePending = true;
        root.requestAnimationFrame(record);
      } else {
        setTimeout(record, 0);
      }
    }

    recordWp2PreviewCommit(source, key, stateInput) {
      var interaction = this.wp2ActivePreviewInteraction;
      var state = stateInput || this.store && this.store.getState && this.store.getState();
      return this.recordWp2Metric("preview-commit", {
        interactionId: interaction ? interaction.interactionId : null,
        startedAt: interaction ? interaction.startedAt : null,
        durationMs: interaction
          ? Math.max(0, this.wp2Now() - interaction.startedAt)
          : null,
        screen: state && state.screen || "unknown",
        productType: state && state.journey && state.journey.productType || null,
        refillType: state && state.journey && state.journey.refillType || null,
        viewportWidth: this.viewportWidth() || null,
        source: source || "unknown",
        key: String(key || "").slice(0, 512),
        control: interaction ? interaction.control : null
      });
    }

    getWp2Metrics() {
      return (this.wp2Metrics || []).map(function(metric) {
        return Object.assign({}, metric);
      });
    }

    recordWp2CacheTrace(entry) {
      var selection = entry && entry.candidateState && entry.candidateState.selection || {};
      var trace = {
        at: this.wp2Now(),
        status: entry && entry.status || "unknown",
        error: entry && entry.lastError || null,
        priority: Boolean(entry && entry.priority),
        selectedByCustomer: Boolean(entry && entry.selectedByCustomer),
        engine: selection.engine || null,
        size: selection.size || null,
        style: selection.style || null,
        layout: selection.layout || selection.variant || null
      };
      this.wp2CacheTrace = (this.wp2CacheTrace || []).concat([trace]).slice(-24);
      if (this.dataset) {
        this.dataset.dyofWp2CacheTrace = JSON.stringify(this.wp2CacheTrace);
      }
      return trace;
    }

    onStateChange(state, previous, action) {
      var resetsConfiguration = action
        && (action.type === "RESET" || action.type === "HYDRATE_SNAPSHOT");
      if (resetsConfiguration) {
        this.resetTransientConfigurationUi();
        if (this.pendingEditorResumeState) {
          var pendingResume = this.pendingEditorResumeState;
          this.pendingEditorResumeState = null;
          if (pendingResume.schemaVersion === 1) {
            this.restoreEditorResumeState(pendingResume, { progressOnly: true });
          } else {
            this.markRestoredRefillChoices();
          }
        }
      }
      if (previous && previous.screen === "dated-layout" && state.screen !== "dated-layout") {
        if (
          !resetsConfiguration
          && previous.journey.refillType === "dated"
          && state.journey.refillType === "dated"
        ) {
          this.captureRetainedLayoutPreview(previous);
        } else {
          this.discardRetainedLayoutPreview();
        }
        this.releaseLayoutPreviewCacheEntries();
        this.lastCommittedLayoutPreviewCacheKey = null;
      }
      if (
        previous
        && previous.screen === "refill-type"
        && state.screen !== "refill-type"
        && state.screen !== "dated-layout"
      ) {
        this.releaseLayoutPreviewCacheEntries();
      }
      if (previous && previous.screen === "undated-layout" && state.screen !== "undated-layout") {
        if (this.undatedPreviewAbortController) {
          this.undatedPreviewAbortController.abort();
          this.undatedPreviewAbortController = null;
        }
        this.undatedPreviewPendingKey = null;
        this.undatedPreviewPendingIdentity = null;
        if (this.elements.previewStage) {
          delete this.elements.previewStage.dataset.previewLoading;
        }
      }
      if (previous && previous.screen === "review" && state.screen !== "review") {
        this.suspendReviewSession();
      }
      // Step navigation owns the scroll, so typing ends without one.
      if (previous && state.screen !== previous.screen) {
        this.endPhoneTyping(false);
      }
      // An Add to cart outcome is for the design and the Review visit it was made on.
      if (
        resetsConfiguration
        || (previous && state.revision !== previous.revision)
        || (previous && previous.screen === "review" && state.screen !== "review")
      ) {
        this.clearCartStatus();
      }
      if (
        previous
        && state.screen !== previous.screen
        && !(action && action.meta && action.meta.scrollToTop === false)
      ) {
        this.schedulePageTopScroll();
      }
      if (action && action.type === "SET_COVER_SIZE") {
        this.handleCoverSizeFlowChange(state, previous);
      }
      if (this.normalizeLegacyCommerceSelection(state)) {
        return;
      }
      if (
        this.retainedLayoutPreview
        && this.retainedLayoutPreview.key !== this.layoutPreviewVisualKey(state)
      ) {
        this.discardRetainedLayoutPreview();
      }
      if (action && action.type === "SET_COVER_SIZE") {
        this.releaseLayoutPreviewCacheEntries();
        this.discardReviewCoverPreload();
        this.ensureReviewCoverPreload(state);
        this.prewarmPreviewPaths(state);
      }
      this.updateDatedFlowFromAction(state, action);
      var descriptor = this.stateApi.getPreviewDescriptor(state);
      var previousDescriptor = this.stateApi.getPreviewDescriptor(previous);
      if (
        previous
        && previous.screen !== "dated-layout"
        && state.screen === "dated-layout"
      ) {
        this.restoreRetainedLayoutPreview(state);
      }
      this.renderStatePreservingChoiceFocus(state, previous);
      this.recordWp2SelectionPaint(state, action);
      if (
        action
        && action.type === "SET_SELECTION"
        && action.payload
        && Object.prototype.hasOwnProperty.call(action.payload, "size")
        && state.screen === "dated-layout"
      ) {
        this.preloadDirectLayoutPreviewManifest();
        this.preloadLayoutPreviewCandidates(state);
      }
      if (state.screen === "refill-type") {
        this.ensureReviewCoverPreload(state);
        this.prewarmPreviewPaths(state);
      }
      this.dispatchEvent(new CustomEvent("dyof:statechange", {
        bubbles: true,
        detail: scrubRestoreCapabilities({
          action: action,
          state: this.stateApi.getSnapshot(state)
        })
      }));

      if (!this.shouldRequestPreview(state)) {
        clearTimeout(this.previewTimer);
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      if (
        this.shouldRequestPreview(state) &&
        (
          resetsConfiguration
          || state.revision !== previous.revision
          || previousDescriptor.renderer !== "server"
        )
        && !this.hasAuthoritativeRetainedLayoutPreview(state)
      ) {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
        this.schedulePreview(state, false);
      }

      if (
        this.shouldRequestPreview(state)
        && state.screen === "dated-layout"
        && this.layoutPreviewCacheEnabled()
      ) {
        this.showCachedLayoutPreview(state);
        this.preloadLayoutPreviewCandidates(state);
      }
      this.scheduleContentCheck(state, {
        immediate: state.screen === "review" && (!previous || previous.screen !== "review")
      });
      this.scheduleReloadResumeState(state, action);
    }

    onPageHide() {
      this.flushReloadResumeState();
      this.discardReviewNextSpread();
      // Back from the cart (back/forward cache), Add to cart works again.
      if (this.addToCartLeaving) {
        this.addToCartLeaving = false;
        this.finishAddToCart();
      }
    }

    onReviewVisibilityChange() {
      // A phone can close a hidden tab without a pagehide, so the typing that
      // is waiting for a pause is saved now.
      if (document.hidden && this.reloadResumeTimer) {
        this.flushReloadResumeState();
      }
      if (document.hidden && this.reviewNextSpread && !this.reviewNextSpread.claimed) {
        this.discardReviewNextSpread();
      }
    }

    getStepScrollTop() {
      var workspace = this.elements && this.elements.workspace;
      if (!workspace || typeof workspace.getBoundingClientRect !== "function") {
        return 0;
      }
      var currentScrollY = Number(root.scrollY);
      if (!Number.isFinite(currentScrollY)) {
        currentScrollY = Number(root.pageYOffset) || 0;
      }
      var workspaceTop = currentScrollY + workspace.getBoundingClientRect().top;
      var toolbar = this.elements && this.elements.toolbar;
      var toolbarHeight = toolbar && typeof toolbar.getBoundingClientRect === "function"
        ? toolbar.getBoundingClientRect().height
        : 0;
      return Math.max(0, workspaceTop - (Number(toolbarHeight) || 0));
    }

    schedulePageTopScroll() {
      if (this.pageTopScrollFrame) {
        root.cancelAnimationFrame(this.pageTopScrollFrame);
      }
      this.pageTopScrollFrame = root.requestAnimationFrame(function() {
        this.pageTopScrollFrame = 0;
        var reducedMotion = root.matchMedia
          && root.matchMedia("(prefers-reduced-motion: reduce)").matches;
        root.scrollTo({
          top: this.getStepScrollTop(),
          left: 0,
          behavior: reducedMotion ? "auto" : "smooth"
        });
      }.bind(this));
    }

    schedulePageScrollRestore(position) {
      if (this.pageTopScrollFrame) {
        root.cancelAnimationFrame(this.pageTopScrollFrame);
      }
      this.pageTopScrollFrame = root.requestAnimationFrame(function() {
        this.pageTopScrollFrame = 0;
        root.scrollTo({
          top: Number(position && position.y) || 0,
          left: Number(position && position.x) || 0,
          behavior: "auto"
        });
      }.bind(this));
    }

    onClick(event) {
      if (event.target.closest("[data-dyof-daily-notice-close]")) {
        if (this.elements.dailyNotice && this.elements.dailyNotice.open) {
          this.elements.dailyNotice.close();
        }
        return;
      }
      var refillMenuToggle = event.target.closest("[data-dyof-refill-menu-toggle]");
      var refillOption = event.target.closest("[data-dyof-refill-option]");
      var plannerMenuToggle = event.target.closest("[data-dyof-planner-menu-toggle]");
      var periodOption = event.target.closest("[data-dyof-period-start]");
      var moonOption = event.target.closest("[data-dyof-moon-offset-option]");
      var removeHoliday = event.target.closest("[data-dyof-remove-holiday-feature]");
      var firstPageColour = event.target.closest("[data-dyof-first-page-colour]");
      var personalDateColour = event.target.closest("[data-dyof-personal-date-colour]");
      var personalDateDayOption = event.target.closest("[data-dyof-personal-date-day-option]");
      var personalDateMonthOption = event.target.closest("[data-dyof-personal-date-month-option]");
      var personalDateFrequencyOption = event.target.closest("[data-dyof-personal-date-frequency-option]");
      var removePersonalDate = event.target.closest("[data-dyof-remove-personal-date]");
      var control = event.target.closest("[data-dyof-field]");
      var step = event.target.closest("[data-dyof-step]");
      var navigation = event.target.closest("[data-dyof-nav]");
      var reviewEdit = event.target.closest("[data-dyof-review-edit]");
      var wp2InteractionTarget = event.target.closest(
        "[data-dyof-field],[data-dyof-refill-option],[data-dyof-step],[data-dyof-nav]," +
        "[data-dyof-review-edit],[data-dyof-review-page-previous],[data-dyof-review-page-next]," +
        "[data-dyof-review-previous],[data-dyof-review-next],[data-cover-size]," +
        "[data-cover-source],[data-cover-design],[data-cover-menu-option]"
      );
      if (wp2InteractionTarget) {
        this.beginWp2Interaction(event, wp2InteractionTarget);
      }

      if (this.coverEditor && this.coverEditor.onClick(event)) {
        return;
      }
      if (this.coverEditor) {
        this.coverEditor.clearSelectionFromEvent(event);
      }

      var reviewPagePrevious = event.target.closest("[data-dyof-review-page-previous]");
      var reviewPageNext = event.target.closest("[data-dyof-review-page-next]");
      var reviewDatePrevious = event.target.closest("[data-dyof-review-previous]");
      var reviewDateNext = event.target.closest("[data-dyof-review-next]");

      if (reviewPagePrevious) {
        this.moveReviewPage(-1, reviewPagePrevious);
        return;
      }

      if (reviewPageNext) {
        this.moveReviewPage(1, reviewPageNext);
        return;
      }

      if (reviewDatePrevious) {
        this.moveReviewPersonalDate(-1, reviewDatePrevious);
        return;
      }

      if (reviewDateNext) {
        this.moveReviewPersonalDate(1, reviewDateNext);
        return;
      }

      if (event.target.closest("[data-dyof-review-retry]")) {
        this.loadReviewPages(this.store.getState(), true);
        return;
      }

      if (reviewEdit && this.contains(reviewEdit)) {
        this.dispatchScreenNavigation(reviewEdit.dataset.dyofReviewEdit);
        return;
      }

      if (refillMenuToggle && this.contains(refillMenuToggle)) {
        event.preventDefault();
        this.toggleRefillMenu(refillMenuToggle.closest("[data-dyof-refill-menu]"));
        return;
      }

      if (refillOption && this.contains(refillOption)) {
        var refillType = refillOption.dataset.dyofRefillOption === "undated" ? "undated" : "dated";
        var refillTypeScrollPosition = { x: root.scrollX, y: root.scrollY };
        var refillOptionWasFocused = Boolean(
          root.document && root.document.activeElement === refillOption
        );
        var currentRefillState = this.store.getState();
        var currentRefillType = currentRefillState.journey.refillType;
        var targetRefillScreen = refillType === "undated" ? "undated-layout" : "dated-layout";
        var refillTypeChanged = currentRefillType !== refillType;
        this.didChooseRefillType = true;
        if (
          currentRefillType === refillType
          && currentRefillState.screen === targetRefillScreen
        ) {
          this.closeRefillMenus();
          this.persistReloadResumeState(currentRefillState);
          if (refillOptionWasFocused) {
            this.focusScreenEntry(targetRefillScreen);
          }
          return;
        }
        this.closeRefillMenus();
        if (refillTypeChanged) {
          this.didChooseUndatedFill = false;
          this.resetDatedFlow();
          this.discardRetainedLayoutPreview();
          this.store.dispatch({ type: "SET_REFILL_TYPE", payload: refillType });
        }
        this.dispatchScreenNavigation(
          targetRefillScreen,
          refillOptionWasFocused,
          { scrollToTop: false }
        );
        this.schedulePageScrollRestore(refillTypeScrollPosition);
        return;
      }

      if (this.openRefillMenu) {
        this.closeRefillMenus();
      }

      if (plannerMenuToggle && this.contains(plannerMenuToggle)) {
        event.preventDefault();
        this.togglePlannerMenu(plannerMenuToggle.dataset.dyofPlannerMenuToggle);
        return;
      }

      if (periodOption && this.contains(periodOption)) {
        var periodTrigger = this.querySelector("[data-dyof-planner-menu-toggle='period']");
        var periodOptionWasFocused = Boolean(
          root.document && root.document.activeElement === periodOption
        );
        this.closePlannerMenus();
        this.store.dispatch({
          type: "SET_SELECTION",
          payload: { startMonth: periodOption.dataset.dyofPeriodStart }
        });
        this.restoreMenuChoiceFocus(periodTrigger, periodOptionWasFocused);
        return;
      }

      if (moonOption && this.contains(moonOption)) {
        var moonTrigger = this.querySelector("[data-dyof-planner-menu-toggle='moon']");
        var moonOptionWasFocused = Boolean(
          root.document && root.document.activeElement === moonOption
        );
        this.closePlannerMenus();
        this.store.dispatch({
          type: "SET_FEATURES",
          payload: {
            moonPhases: {
              enabled: this.store.getState().features.moonPhases.enabled,
              timezoneOffset: Number(moonOption.dataset.dyofMoonOffsetOption)
            }
          }
        });
        this.restoreMenuChoiceFocus(moonTrigger, moonOptionWasFocused);
        return;
      }

      if (removeHoliday && this.contains(removeHoliday)) {
        this.removeHolidayGroup(
          removeHoliday.dataset.dyofRemoveHolidayFeature,
          removeHoliday.dataset.dyofRemoveHolidayValue
        );
        return;
      }

      if (this.openPlannerMenu && !event.target.closest("[data-dyof-planner-menu]")) {
        this.closePlannerMenus();
      }

      if (firstPageColour && this.contains(firstPageColour)) {
        this.store.dispatch({
          type: "SET_FIRST_PAGE",
          payload: { textColor: firstPageColour.dataset.dyofFirstPageColour }
        });
        return;
      }

      if (personalDateColour && this.contains(personalDateColour)) {
        this.personalDateColour = personalDateColour.dataset.dyofPersonalDateColour;
        this.clearPersonalDateError();
        this.renderPersonalDateDraftColours();
        return;
      }

      if (personalDateDayOption && this.contains(personalDateDayOption)) {
        var personalDateDayTrigger = this.querySelector("[data-dyof-planner-menu-toggle='personal-day']");
        var personalDateDayWasFocused = Boolean(
          root.document && root.document.activeElement === personalDateDayOption
        );
        this.personalDateDay = personalDateDayOption.dataset.dyofPersonalDateDayOption;
        this.clearPersonalDateError();
        this.closePlannerMenus();
        this.renderPersonalDateDraftControls();
        this.restoreMenuChoiceFocus(personalDateDayTrigger, personalDateDayWasFocused);
        return;
      }

      if (personalDateMonthOption && this.contains(personalDateMonthOption)) {
        var personalDateMonthTrigger = this.querySelector("[data-dyof-planner-menu-toggle='personal-month']");
        var personalDateMonthWasFocused = Boolean(
          root.document && root.document.activeElement === personalDateMonthOption
        );
        this.personalDateMonth = personalDateMonthOption.dataset.dyofPersonalDateMonthOption;
        this.clearPersonalDateError();
        this.closePlannerMenus();
        this.renderPersonalDateDraftControls();
        this.restoreMenuChoiceFocus(personalDateMonthTrigger, personalDateMonthWasFocused);
        return;
      }

      if (personalDateFrequencyOption && this.contains(personalDateFrequencyOption)) {
        this.personalDateFrequency = personalDateFrequencyOption.dataset.dyofPersonalDateFrequencyOption;
        this.clearPersonalDateError();
        this.renderPersonalDateDraftControls();
        return;
      }

      if (removePersonalDate && this.contains(removePersonalDate)) {
        this.removePersonalDate(removePersonalDate.dataset.dyofRemovePersonalDate);
        return;
      }

      if (event.target.closest("[data-dyof-add-personal-date]")) {
        this.addPersonalDate();
        return;
      }

      if (control && this.contains(control)) {
        this.handleChoice(control);
        return;
      }

      if (step && this.contains(step)) {
        this.navigateToPhase(step.dataset.dyofStep);
        return;
      }

      if (navigation && this.contains(navigation)) {
        this.navigate(navigation.dataset.dyofNav);
        return;
      }

      if (event.target.closest("[data-dyof-preview-retry]")) {
        var retryState = this.store.getState();
        if (this.stateApi.getPreviewDescriptor(retryState).renderer === "cached-pdf") {
          this.undatedPreviewKey = null;
          this.undatedPreviewIdentity = null;
          this.renderUndatedPreview(retryState);
        } else {
          this.schedulePreview(retryState, true);
        }
        return;
      }

      if (event.target.closest("[data-dyof-preview-expand]")) {
        this.openPreviewFullscreen();
        return;
      }

      if (event.target.closest("[data-dyof-preview-modal-close]")) {
        this.closePreviewFullscreen(true);
        return;
      }

      if (event.target.closest("[data-dyof-save]")) {
        this.requestSave();
        return;
      }

      if (event.target.closest("[data-dyof-restore-save]")) {
        this.restoreSavedConfiguration();
        return;
      }

      if (event.target.closest("[data-dyof-add-to-cart]")) {
        this.addToCart();
        return;
      }

      if (event.target.closest("[data-dyof-review-more]")) {
        this.loadReviewPages(this.store.getState(), false);
      }
    }

    hasStaticPhotoPreview() {
      var pages = this.elements && this.elements.previewPages;
      var mode = pages && pages.dataset && pages.dataset.mode;
      return Boolean(pages && (
        ["personal-dates", "refill-size-preview", "blank-open", "undated-scene"].indexOf(mode) !== -1
        || pages.querySelector && pages.querySelector(".dyof__cover-size-preview")
      ));
    }

    previewMagnifierAllowed(event) {
      var screen = this.store && this.store.getState
        ? this.store.getState().screen
        : this.dataset.currentScreen;
      // The cheap rules first: the viewport width is read last, and never on
      // the cover screens or on a touch screen (see viewportWidth).
      if (
        screen === "front-cover"
        || screen === "back-cover"
        || !this.elements
        || !this.elements.previewStage
        || !this.elements.previewPages
        || !this.elements.previewMagnifier
        || !this.elements.previewMagnifierContent
        || (event && event.pointerType && event.pointerType !== "mouse")
        || this.hasStaticPhotoPreview()
        || (this.elements.previewPages.dataset && this.elements.previewPages.dataset.dyofPreviewStale === "true")
        || (root.matchMedia && !root.matchMedia("(hover: hover) and (pointer: fine)").matches)
      ) {
        return false;
      }
      var width = this.viewportWidth();
      return !width || width >= 768;
    }

    // Reading innerWidth after the page has changed forces a synchronous
    // layout in some engines (Chromium with a mobile viewport). While the
    // component is connected the width is read once after each window resize;
    // otherwise it is read directly.
    viewportWidth() {
      if (!this.viewportWidthTracked) {
        return Number(root.innerWidth) || 0;
      }
      if (!(this.cachedViewportWidth > 0)) {
        this.cachedViewportWidth = Number(root.innerWidth) || 0;
      }
      return this.cachedViewportWidth;
    }

    onViewportResize() {
      this.cachedViewportWidth = 0;
    }

    refreshPreviewMagnifier() {
      var source = this.elements.previewPages;
      var content = this.elements.previewMagnifierContent;
      if (!source || !content || !source.cloneNode) {
        return false;
      }

      var clone = source.cloneNode(true);
      if (clone.removeAttribute) {
        clone.removeAttribute("data-dyof-preview-pages");
      }
      if (clone.querySelectorAll) {
        Array.prototype.forEach.call(clone.querySelectorAll("[id]"), function(node) {
          node.removeAttribute("id");
        });
        var sourceCanvases = source.querySelectorAll("canvas");
        var cloneCanvases = clone.querySelectorAll("canvas");
        Array.prototype.forEach.call(sourceCanvases, function(sourceCanvas, index) {
          var cloneCanvas = cloneCanvases[index];
          var context = cloneCanvas && cloneCanvas.getContext
            ? cloneCanvas.getContext("2d")
            : null;
          if (!cloneCanvas || !context) {
            return;
          }
          cloneCanvas.width = sourceCanvas.width;
          cloneCanvas.height = sourceCanvas.height;
          context.drawImage(sourceCanvas, 0, 0);
          this.copyPdfPreviewSource(sourceCanvas, cloneCanvas);
        }, this);
      }

      var sourceRect = source.getBoundingClientRect();
      clone.style.width = sourceRect.width + "px";
      clone.style.height = sourceRect.height + "px";
      clone.style.maxWidth = "none";
      while (content.firstChild) {
        content.removeChild(content.firstChild);
      }
      content.appendChild(clone);
      content.style.width = sourceRect.width + "px";
      content.style.height = sourceRect.height + "px";
      return true;
    }

    positionPreviewMagnifier(event) {
      var sourceRect = this.elements.previewPages.getBoundingClientRect();
      var stageRect = this.elements.previewStage.getBoundingClientRect();
      var lens = this.elements.previewMagnifier;
      var content = this.elements.previewMagnifierContent;
      var clientX = Number(event.clientX);
      var clientY = Number(event.clientY);

      if (
        !Number.isFinite(clientX)
        || !Number.isFinite(clientY)
        || clientX < sourceRect.left
        || clientX > sourceRect.right
        || clientY < sourceRect.top
        || clientY > sourceRect.bottom
      ) {
        this.hidePreviewMagnifier();
        return;
      }

      lens.hidden = false;
      var lensRect = lens.getBoundingClientRect();
      var scale = 2;
      var sourceX = clientX - sourceRect.left;
      var sourceY = clientY - sourceRect.top;
      lens.style.left = clientX - stageRect.left + "px";
      lens.style.top = clientY - stageRect.top + "px";
      content.style.transform = "translate(" + (
        lensRect.width / 2 - sourceX * scale
      ) + "px," + (
        lensRect.height / 2 - sourceY * scale
      ) + "px) scale(" + scale + ")";
    }

    hidePreviewMagnifier() {
      if (this.elements && this.elements.previewMagnifier) {
        this.elements.previewMagnifier.hidden = true;
      }
    }

    onPreviewPointerEnter(event) {
      if (!this.previewMagnifierAllowed(event)) {
        this.hidePreviewMagnifier();
        return;
      }
      if (this.refreshPreviewMagnifier()) {
        this.positionPreviewMagnifier(event);
      }
    }

    onPreviewPointerMove(event) {
      if (!this.previewMagnifierAllowed(event)) {
        this.hidePreviewMagnifier();
        return;
      }
      if (this.elements.previewMagnifier.hidden && !this.refreshPreviewMagnifier()) {
        return;
      }
      this.positionPreviewMagnifier(event);
    }

    onPreviewPointerLeave() {
      this.hidePreviewMagnifier();
    }

    openPreviewFullscreen() {
      if (
        this.hasStaticPhotoPreview()
        || !this.elements.previewStage
        || !this.elements.previewModal
        || !this.elements.previewModalContent
        || !this.elements.previewModal.hidden
      ) {
        return;
      }
      this.previewScrollPosition = {
        x: Number(root.scrollX || root.pageXOffset || 0),
        y: Math.max(0, Number(root.scrollY || root.pageYOffset || 0))
      };
      this.previewBodyStyle = document.body.getAttribute("style");
      this.previewReturnFocus = document.activeElement;
      this.previewStageHome = this.elements.previewStage.parentNode;
      this.previewStageNextSibling = this.elements.previewStage.nextSibling;
      this.previewStagePlaceholder = document.createElement("div");
      this.previewStagePlaceholder.className = "dyof__preview-stage-placeholder";
      this.previewStagePlaceholder.setAttribute("aria-hidden", "true");
      this.previewStageHome.insertBefore(
        this.previewStagePlaceholder,
        this.elements.previewStage
      );
      this.elements.previewModalContent.appendChild(this.elements.previewStage);
      this.elements.previewModal.hidden = false;
      if (this.elements.previewExpand) {
        this.elements.previewExpand.setAttribute("aria-expanded", "true");
      }
      if (this.elements.appShell) {
        this.elements.appShell.inert = true;
      }
      document.documentElement.classList.add("dyof-preview-open");
      document.body.style.position = "fixed";
      document.body.style.left = -this.previewScrollPosition.x + "px";
      document.body.style.right = "0";
      document.body.style.top = -this.previewScrollPosition.y + "px";
      document.body.style.width = "100%";
      if (this.elements.previewModalClose) {
        this.elements.previewModalClose.focus();
      }
    }

    closePreviewFullscreen(restoreFocus) {
      if (!this.elements || !this.elements.previewModal || this.elements.previewModal.hidden) {
        return;
      }
      if (
        this.previewStagePlaceholder
        && this.previewStagePlaceholder.parentNode
        && this.elements.previewStage
      ) {
        this.previewStagePlaceholder.parentNode.replaceChild(
          this.elements.previewStage,
          this.previewStagePlaceholder
        );
      } else if (this.previewStageHome && this.elements.previewStage) {
        if (
          this.previewStageNextSibling
          && this.previewStageNextSibling.parentNode === this.previewStageHome
        ) {
          this.previewStageHome.insertBefore(
            this.elements.previewStage,
            this.previewStageNextSibling
          );
        } else {
          this.previewStageHome.appendChild(this.elements.previewStage);
        }
      }
      this.elements.previewModal.hidden = true;
      if (this.elements.previewExpand) {
        this.elements.previewExpand.setAttribute("aria-expanded", "false");
      }
      if (this.elements.appShell) {
        this.elements.appShell.inert = false;
      }
      document.documentElement.classList.remove("dyof-preview-open");
      if (this.previewBodyStyle == null) {
        document.body.removeAttribute("style");
      } else {
        document.body.setAttribute("style", this.previewBodyStyle);
      }
      if (this.previewScrollPosition) {
        root.scrollTo(this.previewScrollPosition.x, this.previewScrollPosition.y);
      }
      if (restoreFocus && this.previewReturnFocus && this.previewReturnFocus.focus) {
        this.previewReturnFocus.focus();
      }
      this.previewReturnFocus = null;
      this.previewStageHome = null;
      this.previewStageNextSibling = null;
      this.previewStagePlaceholder = null;
      this.previewScrollPosition = null;
      this.previewBodyStyle = null;
    }

    onKeyDown(event) {
      if (this.elements && this.elements.previewModal && !this.elements.previewModal.hidden) {
        if (event.key === "Escape") {
          event.preventDefault();
          this.closePreviewFullscreen(true);
          return;
        }
        if (event.key !== "Tab") { return; }
        var previewFocusable = Array.from(this.elements.previewModal.querySelectorAll(
          'button:not([hidden]):not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function(element) { return element.offsetParent !== null; });
        if (!previewFocusable.length) {
          event.preventDefault();
          return;
        }
        var previewFirst = previewFocusable[0];
        var previewLast = previewFocusable[previewFocusable.length - 1];
        if (event.shiftKey && document.activeElement === previewFirst) {
          event.preventDefault();
          previewLast.focus();
        } else if (!event.shiftKey && document.activeElement === previewLast) {
          event.preventDefault();
          previewFirst.focus();
        }
        return;
      }
      if (event.key === "Escape" && this.openPlannerMenu) {
        event.preventDefault();
        var plannerTrigger = this.querySelector(
          "[data-dyof-planner-menu-toggle='" + this.openPlannerMenu + "']"
        );
        this.closePlannerMenus();
        if (plannerTrigger) {
          plannerTrigger.focus();
        }
        return;
      }
      if (
        ["personal-day", "personal-month"].indexOf(this.openPlannerMenu) !== -1
        && ["ArrowDown", "ArrowUp", "Home", "End"].indexOf(event.key) !== -1
      ) {
        var dateMenu = this.querySelector(
          "[data-dyof-planner-menu='" + this.openPlannerMenu + "']"
        );
        if (dateMenu && dateMenu.contains(event.target)) {
          var dateOptions = Array.from(dateMenu.querySelectorAll(
            "[data-dyof-personal-date-day-option], [data-dyof-personal-date-month-option]"
          )).filter(function(option) {
            return !option.disabled && !option.hidden && !option.closest("[hidden]");
          });
          if (dateOptions.length) {
            var dateIndex = dateOptions.indexOf(event.target);
            if (event.key === "Home") {
              dateIndex = 0;
            } else if (event.key === "End") {
              dateIndex = dateOptions.length - 1;
            } else if (dateIndex === -1) {
              dateIndex = event.key === "ArrowUp" ? dateOptions.length - 1 : 0;
            } else {
              dateIndex = (dateIndex + (event.key === "ArrowUp" ? -1 : 1)
                + dateOptions.length) % dateOptions.length;
            }
            event.preventDefault();
            dateOptions[dateIndex].focus();
            return;
          }
        }
      }
      if (event.key === "Escape" && this.openRefillMenu) {
        event.preventDefault();
        var refillTrigger = this.openRefillMenu.querySelector("[data-dyof-refill-menu-toggle]");
        this.closeRefillMenus();
        if (refillTrigger) {
          refillTrigger.focus();
        }
        return;
      }
      if (
        this.store
        && this.store.getState().screen === "review"
        && (event.key === "ArrowLeft" || event.key === "ArrowRight")
        && !event.target.matches("input, textarea, select, button, [contenteditable='true']")
      ) {
        event.preventDefault();
        this.moveReviewPage(event.key === "ArrowLeft" ? -1 : 1);
        return;
      }
    }

    onInput(event) {
      if (this.coverEditor && this.coverEditor.onInput(event)) {
        return;
      }
      if (event.target.matches("[data-dyof-first-page]")) {
        var patch = {};
        patch[event.target.dataset.dyofFirstPage] = this.printableInputValue(event, "firstPage");
        this.store.dispatch({
          type: "SET_FIRST_PAGE",
          payload: patch
        });
        return;
      }

      if (event.target.matches("[data-dyof-personal-date-label]")) {
        var labelFonts = root.DYOFPrintableText
          && root.DYOFPrintableText.fieldFontIds("personalDate", this.store.getState().selection);
        // The notice names what an edit removed; a later edit that removes
        // nothing clears it.
        if (labelFonts && !event.isComposing
          && !root.DYOFPrintableText.sanitizeText(event.target.value, labelFonts).removed.length) {
          root.DYOFPrintableText.clearNotice(event.target, "notice");
        }
        this.printableInputValue(event, "personalDate");
        this.clearPersonalDateError();
        return;
      }

      if (event.target.matches("[data-dyof-country-search]")) {
        this.filterHolidayChoices(
          this.elements.countryHolidayList,
          event.target.value
        );
        return;
      }

      if (event.target.matches("[data-dyof-religious-search]")) {
        this.filterHolidayChoices(
          this.elements.religiousHolidayList,
          event.target.value
        );
        return;
      }

      if (event.target.matches("[data-dyof-moon-search]")) {
        this.filterMoonChoices(event.target.value);
      }
    }

    printableInputValue(event, field) {
      var printable = root.DYOFPrintableText;
      if (!printable || event.isComposing) {
        return event.target.value;
      }
      return printable.sanitizeInput(
        event.target,
        printable.fieldFontIds(field, this.store.getState().selection)
      );
    }

    // A name typed before a style change may use characters the new style's
    // font cannot print. Convert what it can in place, so the cleaned name is
    // what is checked and added; remove and name the rest before adding.
    refuseUnprintableLabel(input) {
      var printable = root.DYOFPrintableText;
      var fontIds = printable && printable.fieldFontIds("personalDate", this.store.getState().selection);
      var result = fontIds ? printable.sanitizeText(input.value, fontIds) : null;
      if (!result || result.text === input.value) {
        return false;
      }
      printable.sanitizeInput(input, fontIds);
      if (!result.removed.length) {
        return false;
      }
      input.focus();
      return true;
    }

    onChange(event) {
      if (
        event.target
        && event.target.matches
        && event.target.matches(
          "[data-dyof-feature-toggle],[data-dyof-holiday-group],[data-cover-source-select]," +
          "[data-cover-filter],[data-cover-elastic-enabled],[data-cover-elastic-disabled]," +
          "[data-dyof-cover-only]"
        )
      ) {
        this.beginWp2Interaction(event, event.target);
      }
      if (this.coverEditor && this.coverEditor.onChange(event)) {
        return;
      }
      if (event.target.matches("[data-dyof-review-confirm]")) {
        this.reviewConfirmations[event.target.dataset.dyofReviewConfirm] = event.target.checked;
        this.updateReviewCheckoutAvailability(this.store.getState());
        return;
      }
      if (event.target.matches("[data-dyof-cover-only]")) {
        this.setCoverOnly(event.target.checked);
        return;
      }
      if (event.target.matches("[data-dyof-feature-toggle]")) {
        this.setFeatureEnabled(
          event.target.dataset.dyofFeatureToggle,
          event.target.checked
        );
        return;
      }

      if (event.target.matches("[data-dyof-holiday-group]")) {
        this.updateHolidayGroups(
          event.target.dataset.dyofHolidayGroup,
          event.target.value,
          event.target.checked
        );
        return;
      }
    }

    renderImmediatePressedChoice(control) {
      var field = control && control.dataset && control.dataset.dyofField;
      var stage = control && control.closest
        ? control.closest("[data-dyof-dated-stage]")
        : null;
      if (!field) {
        return;
      }
      if (typeof this.querySelectorAll !== "function") {
        if (typeof control.setAttribute === "function") {
          control.setAttribute("aria-pressed", "true");
        }
        return;
      }
      this.querySelectorAll("[data-dyof-field]").forEach(function(candidate) {
        if (
          candidate.dataset.dyofField !== field
          || (
            stage
            && candidate.closest("[data-dyof-dated-stage]") !== stage
          )
        ) {
          return;
        }
        candidate.setAttribute("aria-pressed", String(candidate === control));
      });
    }

    captureChoiceFocus(control) {
      var ownerDocument = root.document;
      var stage = control && control.closest
        ? control.closest("[data-dyof-dated-stage]")
        : null;
      var panel = control && control.closest
        ? control.closest("[data-dyof-panel]")
        : null;

      if (
        !ownerDocument
        || !control
        || ownerDocument.activeElement !== control
        || !control.dataset
        || !control.dataset.dyofField
      ) {
        return null;
      }

      return {
        field: control.dataset.dyofField,
        value: control.dataset.dyofValue,
        stage: stage && stage.dataset ? stage.dataset.dyofDatedStage || "" : "",
        panel: panel && panel.dataset ? panel.dataset.dyofPanel || "" : "",
        className: typeof control.className === "string" ? control.className : "",
        ariaLabel: typeof control.getAttribute === "function"
          ? control.getAttribute("aria-label") || ""
          : ""
      };
    }

    renderStatePreservingChoiceFocus(state, previous) {
      var focusIdentity = previous
        && state
        && previous.screen === state.screen
        && root.document
        ? this.captureChoiceFocus(root.document.activeElement)
        : null;
      this.render(state);
      this.restoreChoiceFocus(focusIdentity);
    }

    restoreChoiceFocus(identity) {
      if (!identity || typeof this.querySelectorAll !== "function") {
        return;
      }

      var candidates = Array.from(this.querySelectorAll("[data-dyof-field]")).filter(function(candidate) {
        var stage = candidate.closest
          ? candidate.closest("[data-dyof-dated-stage]")
          : null;
        var panel = candidate.closest
          ? candidate.closest("[data-dyof-panel]")
          : null;
        var stageName = stage && stage.dataset ? stage.dataset.dyofDatedStage || "" : "";
        var panelName = panel && panel.dataset ? panel.dataset.dyofPanel || "" : "";
        var hiddenAncestor = candidate.closest ? candidate.closest("[hidden]") : null;
        return candidate.dataset
          && candidate.dataset.dyofField === identity.field
          && stageName === identity.stage
          && panelName === identity.panel
          && !candidate.disabled
          && !candidate.hidden
          && !hiddenAncestor;
      });
      var exactCandidates = candidates.filter(function(candidate) {
        return String(candidate.dataset.dyofValue) === String(identity.value);
      });
      var replacement = exactCandidates.find(function(candidate) {
        var className = typeof candidate.className === "string" ? candidate.className : "";
        var ariaLabel = typeof candidate.getAttribute === "function"
          ? candidate.getAttribute("aria-label") || ""
          : "";
        return className === identity.className && ariaLabel === identity.ariaLabel;
      }) || exactCandidates[0] || candidates.find(function(candidate) {
        return typeof candidate.getAttribute === "function"
          && candidate.getAttribute("aria-pressed") === "true";
      }) || candidates[0];

      if (!replacement || typeof replacement.focus !== "function") {
        return;
      }
      try {
        replacement.focus({ preventScroll: true });
      } catch (_error) {
        replacement.focus();
      }
    }

    handleChoice(control) {
      var field = control.dataset.dyofField;
      var value = control.dataset.dyofValue;
      var focusIdentity = this.captureChoiceFocus(control);
      var choiceState = this.store.getState();
      if (field === "layout" && choiceState.journey.productType === "planner" && value === "daily") {
        return;
      }
      // The notice acknowledges capacity only: selecting Daily remains the
      // ordinary selection, and dismissing never advances the journey.
      if (field === "layout" && value === "daily" && choiceState.journey.productType === "clipbook") {
        this.showDailyNoticeAfterChoice = true;
        this.dailyNoticeReturnFocus = focusIdentity;
      }

      if (field === "undatedFill") {
        this.didChooseUndatedFill = true;
        this.renderImmediatePressedChoice(control);
        this.store.dispatch({ type: "SET_UNDATED_FILL", payload: value });
        this.restoreChoiceFocus(focusIdentity);
        return;
      }

      var patch = {};
      patch[field] = ["calendar", "notes", "appointmentTimes"].indexOf(field) !== -1
        ? value === "true"
        : value;
      if (field === "singleColour") {
        patch.colourMode = "single-colour";
      }
      if (field === "colourMode" && value === "single-colour") {
        var currentSelection = this.store.getState().selection;
        var singleColours = this.contract.getSingleColours(currentSelection.style) || [];
        var hasAvailableSingleColour = singleColours.some(function(option) {
          return option.value === currentSelection.singleColour;
        });
        if (
          currentSelection.colourMode !== "single-colour"
          || !hasAvailableSingleColour
        ) {
          patch.singleColour = singleColours.length
            ? singleColours[0].value
            : "colour-01";
        }
      }
      var currentSelectionForChoice = this.store.getState().selection;
      var changesSelection = Object.keys(patch).some(function(key) {
        return String(currentSelectionForChoice[key]) !== String(patch[key]);
      });
      var stage = control.closest ? control.closest("[data-dyof-dated-stage]") : null;
      var explicitChoiceKey = stage && stage.dataset
        ? stage.dataset.dyofDatedStage + ":" + field
        : "";
      if (
        !changesSelection
        && explicitChoiceKey
        && this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has(explicitChoiceKey)
      ) {
        this.openDailyNotice();
        return;
      }
      if (!this.prepareDatedFlowChoice(control)) {
        this.showDailyNoticeAfterChoice = false;
        return;
      }
      this.renderImmediatePressedChoice(control);
      if (!changesSelection) {
        this.completeDatedFlowChoiceWithoutSelection(this.store.getState());
        this.restoreChoiceFocus(focusIdentity);
        this.openDailyNotice();
        return;
      }
      this.store.dispatch({ type: "SET_SELECTION", payload: patch });
      this.restoreChoiceFocus(focusIdentity);
      this.openDailyNotice();
    }

    openDailyNotice() {
      if (!this.showDailyNoticeAfterChoice) { return; }
      this.showDailyNoticeAfterChoice = false;
      var dialog = this.elements && this.elements.dailyNotice;
      if (dialog && !dialog.open && typeof dialog.showModal === "function") {
        dialog.showModal();
      }
    }

    onDailyNoticeClose() {
      // Preview completion can rebuild the clicked button while the native
      // modal is open. Resolve its replacement instead of focusing a detached node.
      this.restoreChoiceFocus(this.dailyNoticeReturnFocus);
      this.dailyNoticeReturnFocus = null;
    }

    toggleRefillMenu(menu) {
      var shouldOpen = menu && this.openRefillMenu !== menu;
      this.closeRefillMenus();
      if (!shouldOpen) {
        return;
      }
      var trigger = menu.querySelector("[data-dyof-refill-menu-toggle]");
      var panel = menu.querySelector("[data-dyof-refill-menu-panel]");
      menu.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      panel.hidden = false;
      this.openRefillMenu = menu;
    }

    closeRefillMenus() {
      (this.elements.refillMenus || []).forEach(function(menu) {
        var trigger = menu.querySelector("[data-dyof-refill-menu-toggle]");
        var panel = menu.querySelector("[data-dyof-refill-menu-panel]");
        menu.classList.remove("is-open");
        if (trigger) {
          trigger.setAttribute("aria-expanded", "false");
        }
        if (panel) {
          panel.hidden = true;
        }
      });
      this.openRefillMenu = null;
    }

    togglePlannerMenu(name) {
      var menu = this.querySelector("[data-dyof-planner-menu='" + name + "']");
      var shouldOpen = menu && this.openPlannerMenu !== name;
      this.closePlannerMenus();
      if (!shouldOpen) {
        return;
      }
      this.openPlannerMenu = name;
      this.renderPlannerMenuVisibility();
      var search = menu.querySelector(".dyof__planner-menu-search");
      if (search) {
        requestAnimationFrame(function() { search.focus(); });
      }
    }

    closePlannerMenus() {
      this.openPlannerMenu = null;
      this.renderPlannerMenuVisibility();
    }

    renderPlannerMenuVisibility() {
      (this.elements.plannerMenus || []).forEach(function(menu) {
        var name = menu.dataset.dyofPlannerMenu;
        var trigger = menu.querySelector("[data-dyof-planner-menu-toggle]");
        var panel = menu.querySelector("[data-dyof-planner-menu-panel]");
        var open = this.openPlannerMenu === name;
        menu.classList.toggle("is-open", open);
        if (trigger) {
          trigger.setAttribute("aria-expanded", String(open));
        }
        if (panel) {
          panel.hidden = !open;
        }
      }, this);
    }

    setFeatureEnabled(feature, enabled) {
      var state = this.store.getState();
      var payload = {};

      if (feature === "moonPhases") {
        payload.moonPhases = {
          enabled: enabled,
          timezoneOffset: state.features.moonPhases.timezoneOffset
        };
      } else if (feature === "countryHolidays" || feature === "religiousHolidays") {
        payload[feature] = {
          enabled: enabled,
          groups: state.features[feature].groups
        };
      } else {
        return;
      }

      this.store.dispatch({ type: "SET_FEATURES", payload: payload });
    }

    updateHolidayGroups(feature, value, checked) {
      var state = this.store.getState();
      var payload = {};
      var groups;

      if (!state.features[feature]) {
        return;
      }
      groups = state.features[feature].groups.slice();
      if (checked && groups.indexOf(value) === -1) {
        groups.push(value);
      } else if (!checked) {
        groups = groups.filter(function(group) { return group !== value; });
      }
      payload[feature] = {
        enabled: state.features[feature].enabled,
        groups: groups
      };
      this.store.dispatch({ type: "SET_FEATURES", payload: payload });
    }

    removeHolidayGroup(feature, value) {
      var state = this.store.getState();
      var current = state.features[feature];
      var payload = {};
      if (!current || ["countryHolidays", "religiousHolidays"].indexOf(feature) === -1) {
        return;
      }
      payload[feature] = {
        enabled: current.enabled,
        groups: current.groups.filter(function(group) { return group !== value; })
      };
      this.store.dispatch({ type: "SET_FEATURES", payload: payload });
    }

    filterHolidayChoices(container, query) {
      var normalized = String(query || "").trim().toLowerCase();
      if (!container) {
        return;
      }
      container.querySelectorAll("[data-dyof-holiday-option]").forEach(function(option) {
        option.hidden = Boolean(normalized) &&
          option.textContent.toLowerCase().indexOf(normalized) === -1;
      });
    }

    filterMoonChoices(query) {
      var normalized = String(query || "").trim().toLowerCase();
      if (!this.elements.moonOffset) {
        return;
      }
      this.elements.moonOffset.querySelectorAll("[data-dyof-moon-offset-option]").forEach(function(option) {
        option.hidden = Boolean(normalized) &&
          option.textContent.toLowerCase().indexOf(normalized) === -1;
      });
    }

    personalDateIso(dayValue, monthValue, startMonth) {
      // One entry rule, shared with start-month rebasing in the state module.
      return this.stateApi.personalDateIso(dayValue, monthValue, startMonth);
    }

    addPersonalDate() {
      if (this.refuseUnprintableLabel(this.elements.personalDateLabel)) {
        return;
      }
      var state = this.store.getState();
      var label = String(this.elements.personalDateLabel.value || "").trim();
      var date = this.personalDateIso(
        this.personalDateDay,
        this.personalDateMonth,
        state.selection.startMonth
      );
      var personalDates;

      if (!label) {
        this.elements.personalDateError.textContent = dyofT("cfg.interaction.event_name_required", "Enter an event name.");
        this.elements.personalDateLabel.focus();
        return;
      }
      if (!this.personalDateColour) {
        this.elements.personalDateError.textContent = dyofT("cfg.interaction.event_colour_required", "Choose an event colour.");
        return;
      }
      if (!this.personalDateDay || !this.personalDateMonth) {
        this.elements.personalDateError.textContent = dyofT("cfg.interaction.event_date_required", "Choose a day and month.");
        return;
      }
      if (!date) {
        this.elements.personalDateError.textContent =
          dyofT("cfg.interaction.event_date_invalid", "Choose a day that exists in the selected month.");
        return;
      }

      personalDates = state.features.personalDates.concat([{
        id: "personal-date-" + Date.now(),
        label: label,
        date: date,
        color: this.personalDateColour,
        frequency: this.personalDateFrequency || "one-time"
      }]);
      return this.commitPersonalDates(state, personalDates);
    }

    personalDateDraft() {
      return {
        label: String(this.elements.personalDateLabel.value || "").trim(),
        day: this.personalDateDay,
        month: this.personalDateMonth,
        frequency: this.personalDateFrequency
      };
    }

    // Too many entries on one day is a stop, decided by the server's own
    // capacity rules before the date is added. An unavailable check never stops.
    async commitPersonalDates(state, personalDates) {
      var added = personalDates[personalDates.length - 1];
      var draft = this.personalDateDraft();
      var prospective = this.stateApi.reduce(state, {
        type: "SET_FEATURES",
        payload: { personalDates: personalDates }
      });
      var key = this.contentCheckKey(prospective);
      var check;
      var result;
      var blocking;

      // Without a check endpoint the answer is always "unavailable": add at once.
      if (!key || !this.contentCheckEndpoints().length) {
        this.applyPersonalDateAdd(personalDates, draft);
        return true;
      }
      if (this.personalDateAddCheck) {
        return false;
      }
      check = { controller: new AbortController() };
      this.personalDateAddCheck = check;
      this.clearPersonalDateError();
      this.renderPersonalDateAddCheck();
      this.renderStep(this.store.getState());
      result = await this.fetchContentCheck(this.contentCheckBody(prospective), check.controller);
      if (this.personalDateAddCheck !== check) {
        return false;
      }
      this.personalDateAddCheck = null;
      this.renderPersonalDateAddCheck();
      this.renderStep(this.store.getState());
      if (this.contentCheckKey(this.store.getState()) !== this.contentCheckKey(state)) {
        // The design changed while this date was checked; check it against the new one.
        return this.addPersonalDate();
      }
      blocking = this.personalDateAddBlockingIssue(state, added, result);
      if (blocking) {
        this.elements.personalDateError.textContent = blocking.contentType === "holidays"
          ? dyofT("cfg.interaction.event_holiday_fit", "This entry doesn't fit beside the holidays on {date} on this layout. Choose another date, fewer holiday groups or a roomier layout.", { date: contentCheckDateLabel(blocking.isoDate, false) })
          : blocking.reason === "too-long"
            ? personalDateTooLongMessage(blocking, added)
            : dyofT("cfg.interaction.event_capacity", "There's no room for another entry on {date} on this layout (up to {maximum}). Remove one first or choose a roomier layout.", { date: contentCheckDateLabel(blocking.isoDate, false), maximum: blocking.maximum });
        // On a phone the sticky Back/Next bar can cover the line under Add date.
        if (typeof this.elements.personalDateError.scrollIntoView === "function") {
          this.elements.personalDateError.scrollIntoView({ block: "nearest" });
        }
        return false;
      }
      if (result.status !== "unavailable") {
        this.setContentCheckResult(key, result);
      }
      this.applyPersonalDateAdd(personalDates, draft);
      return true;
    }

    personalDateAddBlockingIssue(state, added, result) {
      var baseline = this.contentCheckKnownIssues(state);
      var payload = this.stateApi.getPreviewRequest(state);
      var legacy = Boolean(payload && payload.engine === "legacy");
      if (result.status !== "issues") {
        return null;
      }
      return result.issues.filter(function(issue) {
        // Classic day boxes keep holidays apart from personal dates, so adding
        // a date can only cause a personal-date issue there.
        if (legacy && issue.contentType !== "personal dates") {
          return false;
        }
        return personalDateOccursOn(added, issue.isoDate)
          || (baseline && !baseline.some(function(known) {
            return known.isoDate === issue.isoDate
              && known.contentType === issue.contentType
              && known.count >= issue.count;
          }));
      })[0] || null;
    }

    applyPersonalDateAdd(personalDates, draft) {
      var current = this.personalDateDraft();
      this.elements.personalDateError.textContent = "";
      // Keep a draft the customer changed while the date was being checked.
      if (
        current.label === draft.label
        && current.day === draft.day
        && current.month === draft.month
        && current.frequency === draft.frequency
      ) {
        this.elements.personalDateLabel.value = "";
        if (root.DYOFPrintableText) {
          root.DYOFPrintableText.clearNotice(this.elements.personalDateLabel);
        }
        this.personalDateDay = "";
        this.personalDateMonth = "";
        this.personalDateFrequency = "";
      }
      this.store.dispatch({
        type: "SET_FEATURES",
        payload: { personalDates: personalDates }
      });
    }

    cancelPersonalDateAddCheck() {
      if (this.personalDateAddCheck) {
        this.personalDateAddCheck.controller.abort();
        this.personalDateAddCheck = null;
        this.renderPersonalDateAddCheck();
      }
    }

    // A new date can take a round trip to check: Add date says so (and repeat
    // clicks are ignored) while Review waits for the answer.
    renderPersonalDateAddCheck() {
      var button = this.elements && this.elements.personalDateAdd;
      if (!button || Boolean(this.personalDateAddCheck) === button.hasAttribute("aria-busy")) {
        return;
      }
      if (this.personalDateAddCheck) {
        button.dataset.dyofIdleLabel = button.textContent;
        button.textContent = dyofT("cfg.interaction.checking", "Checking…");
        button.setAttribute("aria-busy", "true");
        button.setAttribute("aria-disabled", "true");
        return;
      }
      button.textContent = button.dataset.dyofIdleLabel;
      delete button.dataset.dyofIdleLabel;
      button.removeAttribute("aria-busy");
      button.removeAttribute("aria-disabled");
    }

    contentCheckKey(state) {
      var payload;
      var features;
      var selection = {};
      if (!state || !this.stateApi || typeof this.stateApi.getPreviewRequest !== "function") {
        return null;
      }
      payload = this.stateApi.getPreviewRequest(state);
      // Classic (legacy) layouts get the same stop, from their own capacity rules.
      if (!payload || ["modern", "legacy"].indexOf(payload.engine) === -1) {
        return null;
      }
      features = payload.features || {};
      if (!["events", "birthdays", "activities", "holidays"].some(function(name) {
        return Array.isArray(features[name]) && features[name].length > 0;
      })) {
        return null;
      }
      // Capacity follows the layout, dates and entries; first-page copy and
      // cover edits must not trigger a new check.
      Object.keys(payload.selection || {}).sort().forEach(function(name) {
        if (name !== "firstPage" && name !== "cover") {
          selection[name] = payload.selection[name];
        }
      });
      return JSON.stringify({ selection: selection, features: features });
    }

    contentCheckBody(state) {
      var payload = this.stateApi.getPreviewRequest(state);
      if (payload) {
        delete payload.pageRequest;
      }
      return payload;
    }

    contentCheckEndpoints() {
      var dataset = this.dataset || {};
      var location = root.location || {};
      var endpoints = [dataset.previewEndpoint];
      if ((location.hostname === "127.0.0.1" || location.hostname === "localhost") && dataset.devPreviewEndpoint) {
        endpoints.push(dataset.devPreviewEndpoint);
      }
      return endpoints.map(function(endpoint) {
        try {
          return endpoint ? new URL(CONTENT_CHECK_PATH, endpoint).toString() : "";
        } catch (error) {
          return "";
        }
      }).filter(function(endpoint, index, values) {
        return endpoint && values.indexOf(endpoint) === index;
      });
    }

    // Resolves, never rejects: { status: "ok" | "issues" | "unavailable", issues }.
    fetchContentCheck(body, controller) {
      var endpoints = this.contentCheckEndpoints();
      var unavailable = { status: "unavailable", issues: [] };
      var timer = 0;
      var attempt = async function() {
        for (var index = 0; index < endpoints.length; index += 1) {
          try {
            var response = await fetch(endpoints[index], {
              method: "POST",
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(body),
              signal: controller.signal
            });
            // An older backend answers 404; 400 and 5xx are ours to fix, not the customer's.
            var result = response && response.ok
              ? normalizeContentCheckResponse(await response.json())
              : null;
            if (result) {
              return result;
            }
          } catch (error) {
            if (controller.signal.aborted) {
              break;
            }
          }
        }
        return unavailable;
      };
      if (!body || !endpoints.length || typeof fetch !== "function") {
        return Promise.resolve(unavailable);
      }
      return Promise.race([
        attempt(),
        new Promise(function(resolve) {
          timer = setTimeout(function() {
            controller.abort();
            resolve(unavailable);
          }, CONTENT_CHECK_TIMEOUT_MS);
        })
      ]).then(function(result) {
        clearTimeout(timer);
        return result;
      });
    }

    contentCheckRecord() {
      if (!this.contentCheck) {
        this.contentCheck = {
          key: null,
          status: "idle",
          issues: [],
          timer: 0,
          controller: null,
          generation: 0,
          settled: null,
          resolveSettled: null
        };
      }
      return this.contentCheck;
    }

    cancelContentCheck() {
      var record = this.contentCheck;
      if (!record) {
        return;
      }
      record.generation += 1;
      clearTimeout(record.timer);
      record.timer = 0;
      if (record.controller) {
        record.controller.abort();
        record.controller = null;
      }
      if (record.status === "pending") {
        // A cancelled check never answers, so nothing may wait on it or reuse it.
        record.status = "idle";
        record.key = null;
      }
      if (record.resolveSettled) {
        record.resolveSettled();
        record.resolveSettled = null;
      }
    }

    // Re-check whenever the layout, dates, holidays or moon phases change.
    // Rapid changes share one debounced request; a newer change aborts the
    // older request and its late answer is ignored.
    scheduleContentCheck(state, options) {
      var record = this.contentCheckRecord();
      var key = this.contentCheckKey(state);
      var immediate = Boolean(options && options.immediate);
      if (key && key === record.key) {
        if (record.status === "pending" && record.timer && immediate) {
          clearTimeout(record.timer);
          record.timer = 0;
          this.runContentCheck(record, state);
        }
        if (record.status !== "unavailable" || !immediate) {
          return;
        }
      }
      this.cancelContentCheck();
      record.key = key;
      record.issues = [];
      if (!key) {
        record.status = "idle";
        return;
      }
      record.status = "pending";
      record.settled = new Promise(function(resolve) {
        record.resolveSettled = resolve;
      });
      if (immediate) {
        this.runContentCheck(record, state);
        return;
      }
      record.timer = setTimeout(function() {
        record.timer = 0;
        this.runContentCheck(record, state);
      }.bind(this), CONTENT_CHECK_DEBOUNCE_MS);
    }

    runContentCheck(record, state) {
      var generation = record.generation;
      var controller = new AbortController();
      record.controller = controller;
      return this.fetchContentCheck(this.contentCheckBody(state), controller).then(function(result) {
        if (record.generation !== generation) {
          return;
        }
        record.controller = null;
        record.status = result.status;
        record.issues = result.issues.slice();
        if (record.resolveSettled) {
          record.resolveSettled();
          record.resolveSettled = null;
        }
        // A pending check shows nothing, so only a stop changes the page.
        if (result.status === "issues") {
          this.renderContentCheckOutcome();
        }
      }.bind(this));
    }

    setContentCheckResult(key, result) {
      var record = this.contentCheckRecord();
      this.cancelContentCheck();
      record.key = key;
      record.status = result.status;
      record.issues = result.issues.slice();
    }

    async waitForContentCheck(state) {
      var record = this.contentCheck;
      var key = this.contentCheckKey(state);
      var settled;
      while (key && record && record.key === key && record.status === "pending") {
        if (record.timer) {
          clearTimeout(record.timer);
          record.timer = 0;
          this.runContentCheck(record, state);
        }
        settled = record.settled;
        await settled;
        if (record.settled === settled && record.status === "pending") {
          // Nothing will answer this check any more; never spin on a settled promise.
          return;
        }
      }
    }

    // Issues for exactly this design, [] when it cannot have any, or null when
    // the last check is pending, failed or belongs to another design.
    contentCheckKnownIssues(state) {
      var record = this.contentCheck;
      var key = this.contentCheckKey(state);
      if (!key) {
        return [];
      }
      if (!record || record.key !== key || ["ok", "issues"].indexOf(record.status) === -1) {
        return null;
      }
      return record.issues.slice();
    }

    contentCheckGate(state) {
      var record = this.contentCheck;
      var issues = record && record.status === "issues"
        ? this.contentCheckKnownIssues(state) || []
        : [];
      return issues.length
        ? { valid: false, message: contentCheckMessage(issues) }
        : { valid: true, message: "" };
    }

    // Review also waits for a new date that is still being checked, so the
    // answer never lands on a hidden step or changes the design under Review.
    reviewContentGate(state) {
      var gate = this.contentCheckGate(state);
      return gate.valid && this.personalDateAddCheck
        ? { valid: false, pending: true, message: dyofT("cfg.interaction.checking_new_date", "Checking that your new date fits…") }
        : gate;
    }

    renderContentCheckOutcome() {
      var state = this.store && this.store.getState();
      if (!state || !this.elements || this.restoringConfiguration) {
        return;
      }
      this.renderStep(state);
      this.renderMessages(state);
      this.renderReview(state);
      // Other steps announce the stop above the step; Review reads it out here.
      this.announceReviewStop(state, this.contentCheckGate(state).message);
    }

    clearPersonalDateError() {
      if (this.elements.personalDateError) {
        this.elements.personalDateError.textContent = "";
      }
    }

    removePersonalDate(id) {
      var state = this.store.getState();
      this.store.dispatch({
        type: "SET_FEATURES",
        payload: {
          personalDates: state.features.personalDates.filter(function(item) {
            return item.id !== id;
          })
        }
      });
    }

    focusElementWithoutScroll(element) {
      if (!element || typeof element.focus !== "function") {
        return false;
      }
      try {
        element.focus({ preventScroll: true });
      } catch (_error) {
        element.focus();
      }
      return true;
    }

    elementIsVisibleForFocus(element) {
      if (!element || element.disabled || element.hidden) {
        return false;
      }
      if (element.closest && element.closest("[hidden]")) {
        return false;
      }
      if (
        typeof element.getClientRects === "function"
        && element.getClientRects().length === 0
      ) {
        return false;
      }
      return true;
    }

    focusScreenEntry(screen) {
      var panel = typeof this.querySelector === "function"
        ? this.querySelector("[data-dyof-panel='" + screen + "']")
        : null;
      var preferredSelector = screen === "dated-layout"
        ? "[data-dyof-dated-stage]:not([hidden]) [data-dyof-field]:not([disabled])"
        : screen === "undated-layout"
          ? "[data-dyof-undated-list] [data-dyof-field]:not([disabled])"
          : screen === "review"
            ? "[data-dyof-review-edit]:not([disabled])"
            : "button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex='-1'])";
      var candidates = panel && typeof panel.querySelectorAll === "function"
        ? Array.from(panel.querySelectorAll(preferredSelector)).filter(
          this.elementIsVisibleForFocus.bind(this)
        )
        : [];
      var heading;

      if (candidates.length) {
        return this.focusElementWithoutScroll(candidates[0]);
      }
      heading = panel && typeof panel.querySelector === "function"
        ? panel.querySelector("h1, h2, h3")
        : null;
      if (heading) {
        heading.setAttribute("tabindex", "-1");
      }
      return this.focusElementWithoutScroll(heading);
    }

    restoreMenuChoiceFocus(trigger, shouldRestore) {
      if (!shouldRestore) {
        return;
      }
      this.focusElementWithoutScroll(trigger);
    }

    dispatchScreenNavigation(target, forceFocus, meta) {
      var ownerDocument = root.document;
      var activeBefore = ownerDocument && ownerDocument.activeElement;
      var action = {
        type: "NAVIGATE_SCREEN",
        payload: target
      };
      var focusWasInside = Boolean(
        forceFocus
        || (
          activeBefore
          && typeof this.contains === "function"
          && this.contains(activeBefore)
        )
      );

      if (meta) {
        action.meta = meta;
      }
      this.store.dispatch(action);

      if (!focusWasInside || !ownerDocument) {
        return;
      }
      var activeAfter = ownerDocument.activeElement;
      if (
        activeAfter
        && activeAfter !== ownerDocument.body
        && typeof this.contains === "function"
        && this.contains(activeAfter)
        && this.elementIsVisibleForFocus(activeAfter)
      ) {
        return;
      }
      this.focusScreenEntry(target);
    }

    navigate(direction) {
      var state = this.store.getState();
      var route = this.stateApi.getRoute(state);
      var index = route.indexOf(state.screen);
      var delta = direction === "previous" ? -1 : 1;
      var target = route[Math.max(0, Math.min(route.length - 1, index + delta))];
      var completion = this.stateApi.canAdvanceScreen(state, state.screen, holidayValidationMessages(this));
      var flowGate = this.datedFlowGate(state);
      var reviewGate;
      var purchase;
      if (direction !== "previous" && (!completion.valid || !flowGate.valid)) {
        this.appendMessage(completion.valid ? flowGate.message : completion.message, "error");
        return;
      }
      reviewGate = direction !== "previous" && target === "review" ? this.reviewContentGate(state) : null;
      if (reviewGate && !reviewGate.valid) {
        if (!reviewGate.pending) {
          // The blocking message already lists the days; repaint it so it is announced again.
          this.renderMessages(state);
        }
        return;
      }
      if (
        direction !== "previous"
        && state.screen === "dated-layout"
        && state.selection.engine === "legacy"
      ) {
        purchase = this.resolveCartVariant(state);
        if (purchase.status !== "ready") {
          this.appendMessage(
            purchase.message || dyofT("cfg.interaction.legacy_layout_required", "Choose an available legacy layout before continuing."),
            "error"
          );
          return;
        }
      }
      if (
        direction !== "previous"
        && target === "review"
        && state.journey.productType === "refill"
        && this.reviewPagePayload(state, [1])
      ) {
        this.navigateToPreloadedReview(state, target);
        return;
      }
      this.dispatchScreenNavigation(target);
    }

    navigateToPreloadedReview(state, target) {
      // Begin the exact page work, but never hold the customer on the previous
      // step. Review mounts its correct shell synchronously and consumes this
      // same guarded request when it is ready.
      this.ensureReviewPreload(state);
      this.dispatchScreenNavigation(target);
    }

    stepMenuDescriptors(state) {
      if (state && state.journey && state.journey.productType === "refill") {
        return [
          { id: "design", label: dyofT("cfg.interaction.phase_design", "Design"), screens: ["dated-layout"] },
          { id: "layout", label: dyofT("cfg.interaction.phase_setup", "Setup"), screens: ["planner-details"] },
          { id: "personalise", label: dyofT("cfg.interaction.phase_personalise", "Personalise"), screens: ["personal-dates"] }
        ];
      }
      var descriptors = this.stateApi.getStepDescriptors(state);
      if (
        state && state.journey
        && (state.journey.refillType === "undated" || state.journey.refillType === "none")
      ) {
        // Undated and Cover only have no date-setup screens; retain Figma's
        // three labelled phases, with the last opening the existing Review.
        return descriptors.map(function(item) {
          return item.id === "personalise"
            ? { id: "personalise", label: dyofT("cfg.interaction.phase_personalise", "Personalise"), screens: ["review"] }
            : item;
        });
      }
      return descriptors;
    }

    phaseTarget(state, phase) {
      var route = this.stateApi.getRoute(state);
      var descriptors = this.stepMenuDescriptors(state);
      var descriptor = descriptors.filter(function(item) {
        return item.id === phase;
      })[0];
      var branchTarget;
      if (descriptor && descriptor.screens.indexOf(state.screen) !== -1) {
        return state.screen;
      }
      if (
        phase === "layout"
        && state.journey.productType !== "refill"
        && state.journey.refillType !== "none"
        && this.didChooseRefillType
      ) {
        branchTarget = state.journey.refillType === "undated"
          ? "undated-layout"
          : "dated-layout";
        if (route.indexOf(branchTarget) !== -1) {
          return branchTarget;
        }
      }
      return descriptor && descriptor.screens.filter(function(screen) {
        return route.indexOf(screen) !== -1;
      })[0];
    }

    navigateToPhase(phase) {
      var state = this.store.getState();
      var route = this.stateApi.getRoute(state);
      var target = this.phaseTarget(state, phase);
      var currentIndex = route.indexOf(state.screen);
      var targetIndex = route.indexOf(target);
      var flowGate = this.datedFlowGate(state);
      var reviewGate;
      var completion;
      var purchase;

      reviewGate = target && targetIndex > currentIndex && targetIndex >= route.indexOf("review")
        ? this.reviewContentGate(state)
        : null;
      if (reviewGate && !reviewGate.valid) {
        if (!reviewGate.pending) {
          this.renderMessages(state);
        }
        return;
      }
      if (target && targetIndex > currentIndex && state.journey.refillType === "none") {
        // A Cover only jump passes every screen Next would have checked: its
        // step menu reaches Review straight from the Design step.
        completion = route.slice(Math.max(0, currentIndex), targetIndex).map(function(screen) {
          return this.stateApi.canAdvanceScreen(state, screen, holidayValidationMessages(this));
        }, this).filter(function(result) {
          return !result.valid;
        })[0];
        if (completion) {
          this.appendMessage(completion.message, "error");
          return;
        }
      } else if (target && targetIndex > currentIndex
        && ["planner-details", "personal-dates"].indexOf(state.screen) !== -1) {
        completion = this.stateApi.canAdvanceScreen(state, state.screen, holidayValidationMessages(this));
        if (!completion.valid) {
          this.appendMessage(completion.message, "error");
          return;
        }
      }
      if (target && targetIndex > currentIndex && state.journey.productType === "refill") {
        completion = this.stateApi.canAdvanceScreen(state, state.screen, holidayValidationMessages(this));
        if (!completion.valid || !flowGate.valid) {
          return;
        }
        if (state.screen === "dated-layout" && state.selection.engine === "legacy") {
          purchase = this.resolveCartVariant(state);
          if (purchase.status !== "ready") {
            this.appendMessage(
              purchase.message || dyofT("cfg.interaction.legacy_layout_required", "Choose an available legacy layout before continuing."),
              "error"
            );
            return;
          }
        }
      }

      if (target && (targetIndex <= currentIndex || flowGate.valid)) {
        this.dispatchScreenNavigation(target);
      }
    }

    reloadResumeScope(stateInput) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : null
      );
      var location = root.location || {};
      var pathname = String(location.pathname || "");
      var search = String(location.search || "");
      var rowId = "";
      if (!pathname && location.href) {
        try {
          pathname = new URL(location.href).pathname;
        } catch (error) {
          pathname = "";
        }
      }
      try {
        rowId = new URLSearchParams(search).get("iam_row") || "";
      } catch (error) {
        rowId = "";
      }
      return {
        pathname: pathname,
        productType: state && state.journey ? state.journey.productType : "",
        lifestyle: state && state.journey ? state.journey.lifestyle : "",
        rowId: rowId
      };
    }

    reloadResumeScopeMatches(stored, current) {
      return Boolean(
        stored
        && current
        && stored.pathname === current.pathname
        && stored.productType === current.productType
        && stored.lifestyle === current.lifestyle
        && stored.rowId === current.rowId
      );
    }

    hasReloadResumeProgress(stateInput) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : null
      );
      if (!state || !this.stateApi) {
        return false;
      }
      var route = this.stateApi.getRoute(state);
      var coverChoices = this.coverEditor && this.coverEditor.getExplicitChoices
        ? this.coverEditor.getExplicitChoices()
        : {
            sizeChosen: Boolean(this.coverEditor && this.coverEditor.didChooseSize),
            sourceChosen: Boolean(this.coverEditor && this.coverEditor.didChooseSource),
            designChosen: Boolean(this.coverEditor && this.coverEditor.didChooseDesign)
          };
      return Boolean(
        state.screen !== route[0]
        || this.didChooseRefillType
        || this.didChooseUndatedFill
        || this.datedFlowExplicitFields && this.datedFlowExplicitFields.size
        || coverChoices && (
          coverChoices.sizeChosen
          || coverChoices.sourceChosen
          || coverChoices.designChosen
        )
      );
    }

    normalizeReloadReviewDestination(destination, state) {
      if (!destination || typeof destination !== "object") {
        return null;
      }
      if (["start", "front-cover", "back-cover"].indexOf(destination.kind) !== -1) {
        return { kind: destination.kind };
      }
      var pageNumber = Number(destination.pageNumber);
      // A Clipbook cover on its own has no refill pages to return to.
      var coverOnly = Boolean(state && state.journey && state.journey.refillType === "none");
      return destination.kind === "page" && !coverOnly && Number.isInteger(pageNumber) && pageNumber > 0
        ? { kind: "page", pageNumber: pageNumber }
        : null;
    }

    currentReloadReviewDestination(stateInput) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : null
      );
      if (!state || state.screen !== "review") {
        return null;
      }
      if (this.pendingReloadReviewDestination) {
        return this.normalizeReloadReviewDestination(this.pendingReloadReviewDestination, state);
      }
      var items = this.reviewItems ? this.reviewItems() : [];
      var item = items[Number(this.reviewCurrentIndex) || 0];
      var range = this.reviewItemPageRange ? this.reviewItemPageRange(item) : null;
      if (range) {
        return { kind: "page", pageNumber: range.start };
      }
      var kind = item && item.dataset ? item.dataset.dyofReviewItem : "";
      return ["front-cover", "back-cover"].indexOf(kind) !== -1
        ? { kind: kind }
        : null;
    }

    restorePendingReloadReviewDestination(stateInput) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : null
      );
      var destination = this.normalizeReloadReviewDestination(
        this.pendingReloadReviewDestination,
        state
      );
      var hasRestorableItem = this.reviewItems && this.reviewItems().some(function(item) {
        return this.isRestorableReviewItem(item);
      }, this);
      if (
        !state
        || state.screen !== "review"
        || !destination
        || !hasRestorableItem
        || this.reloadReviewDestinationRestoring
      ) {
        return false;
      }
      this.reloadReviewDestinationRestoring = true;
      Promise.resolve(this.activateReviewDestination(
        destination,
        dyofT("cfg.interaction.restoring_review_position", "Restoring your last review position…")
      )).then(function(restored) {
        if (restored) {
          this.pendingReloadReviewDestination = null;
        }
        this.reloadReviewDestinationRestoring = false;
        if (this.store && this.store.getState) {
          this.persistReloadResumeState(this.store.getState());
        }
      }.bind(this), function() {
        this.reloadReviewDestinationRestoring = false;
      }.bind(this));
      return true;
    }

    clearReloadResumeState(options) {
      var clearSavedConfiguration = Boolean(
        options && options.clearSavedConfiguration
      );
      if (clearSavedConfiguration) {
        this.baseConfigurationId = null;
      }
      if (!root.history || typeof root.history.replaceState !== "function") {
        return false;
      }
      try {
        var current = root.history.state && typeof root.history.state === "object"
          ? root.history.state
          : {};
        var hadReloadResume = Object.prototype.hasOwnProperty.call(
          current,
          RELOAD_RESUME_HISTORY_KEY
        );
        var nextUrl = root.location && root.location.href || "";
        var removedSavedConfiguration = false;
        if (clearSavedConfiguration && nextUrl) {
          var parsedUrl = new URL(nextUrl);
          removedSavedConfiguration = parsedUrl.searchParams.has("dyof_saved");
          parsedUrl.searchParams.delete("dyof_saved");
          var savedHashParams = new URLSearchParams(
            String(parsedUrl.hash || "").replace(/^#\??/, "")
          );
          if (savedHashParams.has("dyof_saved")) {
            removedSavedConfiguration = true;
            savedHashParams.delete("dyof_saved");
            parsedUrl.hash = savedHashParams.toString();
          }
          nextUrl = parsedUrl.toString();
        }
        if (!hadReloadResume && !removedSavedConfiguration) {
          return false;
        }
        var replacement = Object.assign({}, current);
        delete replacement[RELOAD_RESUME_HISTORY_KEY];
        root.history.replaceState(replacement, "", nextUrl);
        return true;
      } catch (error) {
        return false;
      }
    }

    scheduleReloadResumeState(stateInput, action) {
      var actionType = action && String(action.type || "");
      if (actionType === "RESET") {
        this.clearReloadResumeState({ clearSavedConfiguration: true });
      }
      if (/^PREVIEW_/.test(actionType) || actionType === "SAVE_STATUS") {
        return false;
      }
      var coalesce = actionType === "SET_FIRST_PAGE"
        || actionType === "SET_COVER"
        || /^COVER_/.test(actionType);
      if (this.reloadResumeTimer) {
        clearTimeout(this.reloadResumeTimer);
        this.reloadResumeTimer = 0;
      }
      this.reloadResumePendingState = null;
      if (!coalesce) {
        return this.persistReloadResumeState(stateInput);
      }
      this.reloadResumePendingState = stateInput;
      // Typing is saved once the customer pauses: each save copies the whole
      // design into the history entry, and Safari refuses more than about
      // 100 history replacements in 30 seconds. Leaving or hiding the page
      // saves at once (onPageHide, onReviewVisibilityChange).
      this.reloadResumeTimer = setTimeout(function() {
        var pendingState = this.reloadResumePendingState;
        this.reloadResumeTimer = 0;
        this.reloadResumePendingState = null;
        this.persistReloadResumeState(pendingState);
      }.bind(this), RELOAD_RESUME_TYPING_DELAY_MS);
      return true;
    }

    flushReloadResumeState(stateInput) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : this.reloadResumePendingState
      );
      if (this.reloadResumeTimer) {
        clearTimeout(this.reloadResumeTimer);
        this.reloadResumeTimer = 0;
      }
      this.reloadResumePendingState = null;
      return this.persistReloadResumeState(state);
    }

    persistReloadResumeState(stateInput, options) {
      var state = stateInput || (
        this.store && typeof this.store.getState === "function"
          ? this.store.getState()
          : null
      );
      if (
        !state
        || !root.history
        || typeof root.history.replaceState !== "function"
      ) {
        return false;
      }
      if (!this.hasReloadResumeProgress(state)) {
        this.clearReloadResumeState();
        return false;
      }
      try {
        var current = root.history.state && typeof root.history.state === "object"
          ? root.history.state
          : {};
        var currentEnvelope = current[RELOAD_RESUME_HISTORY_KEY];
        var savedConfigurationId = this.savedConfigurationId();
        var authorizedSavedConfigurationId = options
          && options.savedConfigurationId === savedConfigurationId
          ? options.savedConfigurationId
          : "";
        if (
          savedConfigurationId
          && (!currentEnvelope || currentEnvelope.savedConfigurationId !== savedConfigurationId)
          && authorizedSavedConfigurationId !== savedConfigurationId
        ) {
          return false;
        }
        var replacement = Object.assign({}, current);
        replacement[RELOAD_RESUME_HISTORY_KEY] = {
          schemaVersion: RELOAD_RESUME_SCHEMA_VERSION,
          updatedAt: new Date().toISOString(),
          savedConfigurationId: savedConfigurationId || null,
          // The configuration the next save builds on. Add to cart saves a
          // newer one without changing the saved link, and the photos it
          // added have no upload claims left, so a reload must not fall back
          // to the link's older configuration. It is the same kind of bearer
          // ID as the saved link and stays in this history entry.
          baseConfigurationId: RESTORE_CAPABILITY_PATTERN.test(String(this.baseConfigurationId || ""))
            ? this.baseConfigurationId
            : null,
          scope: this.reloadResumeScope(state),
          resume: this.getEditorResumeState(state),
          reviewDestination: this.currentReloadReviewDestination(state)
        };
        root.history.replaceState(replacement, "", root.location && root.location.href || "");
        return true;
      } catch (error) {
        return false;
      }
    }

    restoreReloadResumeState() {
      if (
        !root.history
        || !root.history.state
        || typeof root.history.state !== "object"
      ) {
        return false;
      }
      var envelope = root.history.state[RELOAD_RESUME_HISTORY_KEY];
      var savedConfigurationId = this.savedConfigurationId();
      if (
        savedConfigurationId
        && (!envelope || envelope.savedConfigurationId !== savedConfigurationId)
      ) {
        return false;
      }
      var resume = envelope && envelope.resume;
      var snapshot = resume && resume.snapshot;
      var currentState = this.store && this.store.getState
        ? this.store.getState()
        : null;
      var restoredState;
      try {
        if (
          !envelope
          || envelope.schemaVersion !== RELOAD_RESUME_SCHEMA_VERSION
          || !resume
          || resume.schemaVersion !== EDITOR_RESUME_SCHEMA_VERSION
          || !snapshot
        ) {
          this.clearReloadResumeState();
          return false;
        }
        restoredState = this.stateApi.hydrateSnapshot(snapshot);
        if (
          restoredState.screen !== resume.screen
          || !this.reloadResumeScopeMatches(
            envelope.scope,
            this.reloadResumeScope(currentState)
          )
          || !this.reloadResumeScopeMatches(
            envelope.scope,
            this.reloadResumeScope(restoredState)
          )
        ) {
          this.clearReloadResumeState();
          return false;
        }
        if (!this.restoreEditorResumeState(resume)) {
          this.clearReloadResumeState();
          return false;
        }
        // This envelope belongs to the saved link in the URL (checked above),
        // so its base is that link's or a newer save's from this history entry.
        var envelopeBaseConfigurationId = RESTORE_CAPABILITY_PATTERN.test(
          String(envelope.baseConfigurationId || "")
        ) ? envelope.baseConfigurationId : "";
        if (envelopeBaseConfigurationId || savedConfigurationId) {
          this.baseConfigurationId = envelopeBaseConfigurationId || savedConfigurationId;
        }
        this.pendingReloadReviewDestination = restoredState.screen === "review"
          ? this.normalizeReloadReviewDestination(envelope.reviewDestination, restoredState)
          : null;
        return true;
      } catch (error) {
        this.clearReloadResumeState();
        return false;
      }
    }

    getEditorResumeState(stateInput) {
      var state = stateInput || this.store.getState();
      var snapshot = this.stateApi.getSnapshot(state);
      var coverChoices = this.coverEditor && this.coverEditor.getExplicitChoices
        ? this.coverEditor.getExplicitChoices()
        : {
            sizeChosen: Boolean(this.coverEditor && this.coverEditor.didChooseSize),
            sourceChosen: Boolean(this.coverEditor && this.coverEditor.didChooseSource),
            designChosen: Boolean(this.coverEditor && this.coverEditor.didChooseDesign)
          };
      return {
        schemaVersion: EDITOR_RESUME_SCHEMA_VERSION,
        snapshot: snapshot,
        screen: snapshot.screen,
        flow: {
          refillTypeChosen: Boolean(this.didChooseRefillType),
          undatedFillChosen: Boolean(this.didChooseUndatedFill),
          dated: {
            explicitFields: Array.from(this.datedFlowExplicitFields || []).filter(function(field, index, fields) {
              return EDITOR_RESUME_DATED_FIELDS.indexOf(field) !== -1
                && fields.indexOf(field) === index;
            }),
            visibleThrough: Math.max(0, Math.min(8, Number(this.datedFlowVisibleThrough) || 0)),
            pendingIndex: !this.datedFlowComplete && Number.isInteger(this.datedFlowPendingIndex)
              ? Math.max(0, Math.min(9, this.datedFlowPendingIndex))
              : null,
            complete: Boolean(this.datedFlowComplete)
          }
        },
        cover: {
          sizeChosen: Boolean(coverChoices && coverChoices.sizeChosen),
          sourceChosen: Boolean(coverChoices && coverChoices.sourceChosen),
          designChosen: Boolean(coverChoices && coverChoices.designChosen)
        }
      };
    }

    restoreEditorResumeState(resumeInput, options) {
      var resume = resumeInput && typeof resumeInput === "object" ? resumeInput : null;
      var snapshot = resume && resume.snapshot && typeof resume.snapshot === "object"
        ? resume.snapshot
        : null;
      var screen = resume && typeof resume.screen === "string"
        ? resume.screen
        : snapshot && snapshot.screen;
      var progressOnly = options && options.progressOnly;
      var restoredState = progressOnly && this.store && this.store.getState
        ? this.store.getState()
        : null;
      if (
        !resume
        || resume.schemaVersion !== EDITOR_RESUME_SCHEMA_VERSION
        || !snapshot
        || EDITOR_RESUME_SCREENS.indexOf(screen) === -1
        || (snapshot.screen && snapshot.screen !== screen)
      ) {
        return false;
      }
      if (restoredState && restoredState.screen !== screen) {
        return false;
      }

      if (!progressOnly && this.stateApi && this.stateApi.hydrateSnapshot) {
        try {
          if (this.stateApi.hydrateSnapshot(snapshot).screen !== screen) {
            return false;
          }
        } catch (error) {
          return false;
        }
      }

      if (!progressOnly && this.store && this.store.dispatch) {
        this.pendingEditorResumeState = resume;
        this.store.dispatch({ type: "HYDRATE_SNAPSHOT", payload: snapshot });
        if (this.pendingEditorResumeState === resume) {
          this.pendingEditorResumeState = null;
          return this.restoreEditorResumeState(resume, { progressOnly: true });
        }
        return true;
      }

      var flow = resume.flow && typeof resume.flow === "object" ? resume.flow : {};
      var dated = flow.dated && typeof flow.dated === "object" ? flow.dated : {};
      var explicitFields = Array.isArray(dated.explicitFields) ? dated.explicitFields : [];
      var visibleThrough = Number(dated.visibleThrough);
      var pendingIndex = dated.pendingIndex === null ? null : Number(dated.pendingIndex);
      var complete = Boolean(dated.complete);
      var restoredJourney = restoredState && restoredState.journey
        ? restoredState.journey
        : snapshot.journey || {};
      var isDatedJourney = restoredJourney.refillType === "dated";
      this.didChooseRefillType = Boolean(flow.refillTypeChosen);
      this.didChooseUndatedFill = Boolean(flow.undatedFillChosen)
        && restoredJourney.refillType === "undated";
      this.datedFlowExplicitFields = new Set((isDatedJourney ? explicitFields : []).filter(function(field, index, fields) {
        return EDITOR_RESUME_DATED_FIELDS.indexOf(field) !== -1
          && fields.indexOf(field) === index;
      }));
      this.datedFlowVisibleThrough = isDatedJourney && Number.isInteger(visibleThrough)
        ? Math.max(0, Math.min(8, visibleThrough))
        : 0;
      this.datedFlowPendingIndex = isDatedJourney && !complete && Number.isInteger(pendingIndex)
        ? Math.max(0, Math.min(9, pendingIndex))
        : null;
      this.datedFlowComplete = isDatedJourney && complete;
      this.datedFlowWaiting = false;
      if (this.coverEditor && this.coverEditor.restoreExplicitChoices) {
        this.coverEditor.restoreExplicitChoices(resume.cover || {});
      } else if (this.coverEditor) {
        this.coverEditor.didChooseSize = Boolean(resume.cover && resume.cover.sizeChosen);
        this.coverEditor.didChooseSource = Boolean(resume.cover && resume.cover.sourceChosen);
        this.coverEditor.didChooseDesign = Boolean(resume.cover && resume.cover.designChosen);
      }
      return true;
    }

    // Saving waits for uploads and the configuration service. A repeat click
    // on the design being saved is ignored; a click after an edit saves the
    // edited design once this save has finished.
    async requestSave() {
      if (this.saveInFlight) {
        this.saveAgain = this.saveAgain || this.store.getState().revision !== this.savingRevision;
        return;
      }
      this.saveInFlight = true;
      try {
        do {
          this.saveAgain = false;
          await this.saveDesign();
        } while (this.saveAgain);
      } finally {
        this.saveInFlight = false;
        this.saveAgain = false;
      }
    }

    async saveDesign() {
      var capturedState = this.store.getState();
      this.savingRevision = capturedState.revision;
      if (!this.contentCheckGate(capturedState).valid) {
        // The blocking message lists the days to fix before saving.
        this.clearReviewStop();
        this.renderContentCheckOutcome();
        return;
      }
      var snapshot = this.stateApi.getSnapshot(capturedState);
      var resume = this.getEditorResumeState(capturedState);
      var manifest = this.coverEditor
        ? await this.coverEditor.getAssetManifest(capturedState)
        : [];
      // A photo whose record this browser lost drops out of the manifest. The
      // service can only take it from the base, and otherwise refuses the
      // design as invalid, which would read as an outage.
      var missingPhotoMessage = this.coverEditor && typeof this.coverEditor.assetIds === "function"
        ? missingUploadedPhotoMessage(capturedState, this.coverEditor.assetIds(capturedState), manifest)
        : "";
      var serverRecord = null;
      var refusal = null;
      if (missingPhotoMessage && !this.baseConfigurationId) {
        refusal = { code: null, message: missingPhotoMessage };
      } else {
        try {
          serverRecord = await this.persistConfiguration(capturedState, resume);
        } catch (error) {
          serverRecord = null;
          // The service answered and refused this design (text the print font
          // cannot draw, a photo below the print stop, or a photo that must be
          // uploaded again); that is not an outage.
          if (error && (
            error.code === "DYOF_UNPRINTABLE_TEXT"
            || error.code === "DYOF_PHOTO_RESOLUTION_TOO_LOW"
            || photoStorageRefusalMessage(error.code)
          )) {
            refusal = { code: error.code, message: error.message };
          } else if (missingPhotoMessage && error && error.status === 400) {
            // The base does not hold that photo either.
            refusal = { code: null, message: missingPhotoMessage };
          }
        }
      }
      var snapshotId = serverRecord && serverRecord.configurationId
        ? serverRecord.configurationId
        : "dyof-local-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var payload = {
        id: snapshotId,
        savedAt: new Date().toISOString(),
        snapshot: snapshot,
        resume: resume,
        assets: manifest
      };
      try {
        root.localStorage.setItem("dyof:saved:" + snapshotId, JSON.stringify(payload));
        root.localStorage.setItem("dyof:saved:latest", snapshotId);
      } catch (error) {
        this.beginSaveOutcome(capturedState.revision);
        this.store.dispatch({
          type: "SAVE_STATUS",
          payload: {
            status: "error",
            snapshotId: null,
            error: dyofCustomerMessage(dyofT("cfg.interaction.browser_storage_failed", "This browser could not store the configuration.")),
            errorCode: null
          }
        });
        return;
      }
      this.beginSaveOutcome(capturedState.revision);
      this.store.dispatch({
        type: "SAVE_STATUS",
        payload: {
          status: serverRecord ? "saved" : "saved-local",
          snapshotId: snapshotId,
          error: refusal ? refusal.message : null,
          errorCode: refusal ? refusal.code : null
        }
      });
      this.dispatchEvent(new CustomEvent("dyof:saverequest", {
        bubbles: true,
        detail: scrubRestoreCapabilities({
          snapshot: snapshot,
          serializedSnapshot: JSON.stringify(snapshot),
          // Server IDs are restore bearer capabilities. Keep them out of a
          // bubbling DOM event that unrelated theme scripts could observe.
          snapshotId: serverRecord ? null : snapshotId,
          resume: resume,
          assets: manifest
        })
      }));
      if (serverRecord) {
        this.baseConfigurationId = serverRecord.configurationId;
        var url = new URL(root.location.href);
        // A saved ID is a bearer capability. Keep it in the fragment so it is
        // never sent in Shopify/server requests or browser Referer headers.
        url.searchParams.delete("dyof_saved");
        url.hash = "dyof_saved=" + encodeURIComponent(serverRecord.configurationId);
        var currentHistoryState = root.history.state && typeof root.history.state === "object"
          ? root.history.state
          : {};
        root.history.replaceState(Object.assign({}, currentHistoryState), "", url.toString());
        this.persistReloadResumeState(this.store.getState(), {
          savedConfigurationId: serverRecord.configurationId
        });
      }
    }

    savedConfigurationId() {
      var href = root.location && typeof root.location.href === "string"
        ? root.location.href
        : "";
      var parsed;
      try {
        parsed = new URL(href || "https://dyof.invalid/");
      } catch (error) {
        return "";
      }
      var hashParams = new URLSearchParams(String(parsed.hash || "").replace(/^#\??/, ""));
      var hashId = hashParams.get("dyof_saved");
      if (/^dyof_[a-f0-9]{24}$/.test(String(hashId || ""))) {
        return hashId;
      }

      // Old query links remain readable, but scrub them into a fragment as
      // soon as this code runs so later navigation/analytics cannot retain the
      // capability in the request URL.
      var queryId = parsed.searchParams.get("dyof_saved");
      if (!/^dyof_[a-f0-9]{24}$/.test(String(queryId || ""))) {
        return "";
      }
      if (root.history && typeof root.history.replaceState === "function") {
        try {
          parsed.searchParams.delete("dyof_saved");
          parsed.hash = "dyof_saved=" + encodeURIComponent(queryId);
          var currentState = root.history.state && typeof root.history.state === "object"
            ? root.history.state
            : {};
          root.history.replaceState(Object.assign({}, currentState), "", parsed.toString());
        } catch (error) {
          // The legacy capability still restores if history replacement is not
          // available; no additional logging or analytics call is made here.
        }
      }
      return queryId;
    }

    // The old builder link this page was opened with, or null: one that names
    // an old saved project (savingID) or a size and style. The module's own
    // saved link (#dyof_saved=...) is read first and is never one.
    oldBuilderLink() {
      var href = root.location && typeof root.location.href === "string"
        ? root.location.href
        : "";
      var params = href ? oldBuilderLinkParams(href) : {};
      var projectId = OLD_BUILDER_PROJECT_ID_PATTERN.test(String(params.savingID || ""))
        ? String(params.savingID)
        : "";
      var hasDesign = Boolean((params.format || params.size) && params.type);
      return projectId || hasDesign
        ? { href: href, projectId: projectId, hasDesign: hasDesign }
        : null;
    }

    // POST .../import-legacy: { saved, status }, saved null when the service
    // could not bring this design across.
    async requestOldBuilderImport(endpoint, body) {
      var requestAbortController = new AbortController();
      var response = await withTimeout(fetch(endpoint, {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(body),
        signal: requestAbortController.signal
      }), CONFIGURATION_RESTORE_TIMEOUT_MS, function() {
        requestAbortController.abort();
      });
      var status = response ? response.status : 0;
      if (status !== 201) { return { saved: null, status: status }; }
      var payload = await withTimeout(response.json(), CONFIGURATION_RESTORE_TIMEOUT_MS);
      var saved = payload && typeof payload.saved === "string" ? payload.saved : "";
      return { saved: RESTORE_CAPABILITY_PATTERN.test(saved) ? saved : null, status: status };
    }

    // Opens an old builder link as a new saved design: the old saved project
    // when the link names one (with its birthdays, events and activities),
    // else the link's own choices. The address then carries the module's own
    // saved link (#dyof_saved=...) in place of the old state, and that link
    // restores as any other. The old link holds first-page text: it goes only
    // in the request body and is never logged.
    async importOldBuilderLink(link) {
      var endpoints = this.configurationEndpoints();
      var saved = null;
      var projectStatus = 0;
      for (var index = 0; index < endpoints.length && !saved; index += 1) {
        var endpoint = endpoints[index].replace(/\/$/, "") + "/import-legacy";
        var answer;
        if (link.projectId) {
          try {
            answer = await this.requestOldBuilderImport(endpoint, { projectId: link.projectId });
          } catch (error) {
            answer = { saved: null, status: 0 };
          }
          saved = answer.saved;
          projectStatus = answer.status;
        }
        if (!saved && link.hasDesign) {
          try {
            saved = (await this.requestOldBuilderImport(endpoint, { legacyUrl: link.href })).saved;
          } catch (error) {
            saved = null;
          }
        }
      }
      var replaced = false;
      try {
        var nextUrl = new URL(withoutOldBuilderLink(link.href));
        if (saved) {
          nextUrl.hash = "dyof_saved=" + encodeURIComponent(saved);
        }
        var currentState = root.history.state && typeof root.history.state === "object"
          ? root.history.state
          : {};
        root.history.replaceState(Object.assign({}, currentState), "", nextUrl.toString());
        replaced = true;
      } catch (error) {
        // The old link stays in the address; nothing about it is logged.
      }
      if (saved && replaced && this.savedConfigurationId() === saved) {
        var restored = await this.restoreConfigurationFromUrl();
        if (restored) {
          this.oldBuilderLinkNotice = {
            kind: "success",
            message: dyofT("cfg.interaction.old_link_opened", "We've opened your previous refill in the new designer - check your choices and dates.")
          };
          this.render(this.store.getState());
        }
        return restored;
      }
      this.setRestoringConfiguration(false);
      // A bare old start page ("?=savingID=..." that was never saved) had
      // nothing to bring across: it simply opens the designer.
      this.oldBuilderLinkNotice = !link.hasDesign && projectStatus === 404 ? null : {
        kind: "notice",
        screen: this.store.getState().screen,
        message: dyofT("cfg.interaction.old_link_failed", "We couldn't bring your previous refill across, so the designer has opened as new. Choose your options to start again.")
      };
      this.render(this.store.getState());
      return false;
    }

    renderRestoringConfiguration() {
      var elements = this.elements || {};
      if (this.dataset) {
        this.dataset.restoringConfiguration = "true";
        this.dataset.currentScreen = "restoring";
      }
      if (elements.appShell) {
        elements.appShell.setAttribute("aria-busy", "true");
      }
      (elements.panels || []).forEach(function(panel) {
        panel.hidden = true;
      });
      (elements.stepButtons || []).forEach(function(button) {
        button.disabled = true;
        button.removeAttribute("aria-current");
      });
      if (elements.previousButton) {
        elements.previousButton.disabled = true;
      }
      if (elements.nextButton) {
        elements.nextButton.disabled = true;
      }
      if (elements.previewPages) {
        clearChildren(elements.previewPages);
        this.clearPreviewContentIdentity();
        elements.previewPages.dataset.mode = "restoring";
      }
      if (elements.previewTitle) {
        elements.previewTitle.textContent = dyofT("cfg.interaction.restoring_design", "Restoring your design");
      }
      if (elements.previewStatus) {
        this.setPreviewStatus(dyofT("cfg.interaction.loading_saved_configuration", "Loading your saved configuration…"), "loading");
      }
    }

    setRestoringConfiguration(active) {
      this.restoringConfiguration = Boolean(active);
      if (this.restoringConfiguration) {
        this.renderRestoringConfiguration();
        return;
      }
      if (this.dataset) {
        delete this.dataset.restoringConfiguration;
      }
      if (this.elements && this.elements.appShell) {
        this.elements.appShell.removeAttribute("aria-busy");
      }
    }

    restoreConfigurationState(snapshot, resume) {
      this.setRestoringConfiguration(false);
      if (resume && resume.schemaVersion === EDITOR_RESUME_SCHEMA_VERSION) {
        if (this.restoreEditorResumeState(resume)) {
          return true;
        }
      }
      this.pendingEditorResumeState = { schemaVersion: 0 };
      this.store.dispatch({ type: "HYDRATE_SNAPSHOT", payload: snapshot });
      if (this.pendingEditorResumeState) {
        this.pendingEditorResumeState = null;
        this.markRestoredRefillChoices();
        this.render(this.store.getState());
      }
      return true;
    }

    configurationEndpoints() {
      var isLocal = location.hostname === "127.0.0.1" || location.hostname === "localhost";
      if (isLocal && this.dataset.devConfigurationEndpoint) {
        // A private upload made against the local backend carries short-lived
        // claim credentials. Never try those credentials against production as
        // a fallback; local configuration persistence stays on the dev origin.
        return [this.dataset.devConfigurationEndpoint];
      }
      return [this.dataset.configurationEndpoint].filter(Boolean);
    }

    cartMediaEndpoints() {
      var hostname = root && root.location ? root.location.hostname : "";
      var isLocal = hostname === "127.0.0.1" || hostname === "localhost";
      if (isLocal && this.dataset.devCartMediaEndpoint) {
        return [this.dataset.devCartMediaEndpoint];
      }
      return [this.dataset.cartMediaEndpoint].filter(Boolean);
    }

    validateCapturedCartMedia(asset, requiredKind) {
      var kind = String(asset && asset.kind || "").trim().toLowerCase();
      var contentType = String(asset && asset.contentType || "").trim().toLowerCase();
      var base64 = String(asset && asset.base64 || "");
      var width = Number(asset && asset.width);
      var height = Number(asset && asset.height);
      var padding = (base64.match(/=*$/) || [""])[0].length;
      var decodedBytes = Math.floor(base64.length * 3 / 4) - padding;
      var kindLabel = requiredKind === "cover"
        ? dyofT("cfg.interaction.cart_kind_cover", "cover")
        : requiredKind === "refill"
          ? dyofT("cfg.interaction.cart_kind_refill", "refill")
          : requiredKind;
      if (kind !== requiredKind) {
        throw dyofCustomerError(dyofT("cfg.interaction.cart_preview_role_invalid", "The exact {kind} cart preview has an invalid role.", { kind: kindLabel }));
      }
      if (contentType !== "image/webp" && contentType !== "image/png") {
        throw dyofCustomerError(dyofT("cfg.interaction.cart_preview_format_unsafe", "The exact {kind} cart preview has an unsafe format.", { kind: kindLabel }));
      }
      if (
        !base64
        || base64.length % 4 !== 0
        || !/^[a-zA-Z0-9+/]+={0,2}$/.test(base64)
        || decodedBytes <= 0
        || decodedBytes > 180 * 1024
      ) {
        throw dyofCustomerError(dyofT("cfg.interaction.cart_preview_size_unsafe", "The exact {kind} cart preview exceeds its safe upload size.", { kind: kindLabel }));
      }
      if (
        !Number.isSafeInteger(width)
        || !Number.isSafeInteger(height)
        || width <= 0
        || height <= 0
        || width > 640
        || height > 640
      ) {
        throw dyofCustomerError(dyofT("cfg.interaction.cart_preview_dimensions_unsafe", "The exact {kind} cart preview has unsafe dimensions.", { kind: kindLabel }));
      }
      return {
        kind: kind,
        contentType: contentType,
        base64: base64,
        width: width,
        height: height
      };
    }

    requiredCartMediaKinds(state) {
      var productType = state && state.journey && state.journey.productType;
      return productType === "refill"
        ? ["refill"]
        : productType === "planner" || productType === "clipbook" && state.journey.refillType === "none"
          ? ["cover"]
          : ["cover", "refill"];
    }

    // Content revisions exclude navigation/save/preview status. Editing any
    // pictured state changes the key; moving from Layout to Review does not.
    cartThumbnailKey(kind, state) {
      return JSON.stringify(stablePreviewValue(kind === "cover" ? {
        productType: state.journey.productType,
        lifestyle: state.journey.lifestyle,
        size: state.selection && state.selection.size,
        cover: state.cover
      } : {
        journey: state.journey,
        selection: state.selection,
        firstPage: state.firstPage,
        features: state.features
      }));
    }

    warnCartMedia(error) {
      if (error && error.dyofCartThumbnailDiagnosed) { return; }
      if (root.DYOFCoverEditor && typeof root.DYOFCoverEditor.cartThumbnailWasDiagnosed === "function"
        && root.DYOFCoverEditor.cartThumbnailWasDiagnosed(error)) { return; }
      console.warn("[DYOF] Custom cart media unavailable; using product images.");
    }

    cartMediaNow() {
      return root.performance && typeof root.performance.now === "function" ? root.performance.now() : Date.now();
    }

    cartMediaStateKey(state) {
      return JSON.stringify([state.contractVersion, this.cartThumbnailKey("cover", state), this.cartThumbnailKey("refill", state)]);
    }

    clearCartThumbnailCache() {
      Object.keys(this.cartThumbnailCache || {}).forEach(function(kind) {
        this.cartThumbnailCache[kind].controller.abort();
      }, this);
      this.cartThumbnailCache = {};
      this.cartRefillPreview = null;
      this.cartRefillPreviewReady = null;
      if (this.cartMediaUpload) { this.cartMediaUpload.controller.abort(); }
      this.cartMediaUpload = null;
      this.cartMediaConfiguration = null;
      this.cartMediaReviewKey = null;
      this.cartMediaReviewVisited = false;
    }

    prepareCartThumbnails(state) {
      var cache = this.cartThumbnailCache || (this.cartThumbnailCache = {});
      ["cover", "refill"].forEach(function(kind) {
        if (cache[kind] && cache[kind].key !== this.cartThumbnailKey(kind, state)) {
          cache[kind].controller.abort();
          delete cache[kind];
        }
      }, this);
      if (this.cartRefillPreview && this.cartRefillPreview.key !== this.cartThumbnailKey("refill", state)) {
        this.cartRefillPreview = null;
      }
      var stateKey = this.cartMediaStateKey(state);
      if (this.cartMediaUpload && this.cartMediaUpload.stateKey !== stateKey) {
        this.cartMediaUpload.controller.abort();
        this.cartMediaUpload = null;
      }
      var enteringReview = state.screen === "review" && this.cartMediaReviewKey !== stateKey;
      this.cartMediaReviewKey = state.screen === "review" ? stateKey : null;
      if (state.screen === "review") { this.cartMediaReviewVisited = true; }
      var kinds = this.requiredCartMediaKinds(state);
      if (kinds.indexOf("cover") !== -1 && (this.cartMediaReviewVisited
        || ["refill-type", "dated-layout", "undated-layout", "planner-details", "personal-dates"].indexOf(state.screen) !== -1)) {
        this.prepareCartThumbnail("cover", state, enteringReview);
      }
      if (kinds.indexOf("refill") !== -1 && this.cartMediaReviewVisited) {
        this.prepareCartThumbnail("refill", state, enteringReview);
      }
      var saved = this.cartMediaConfiguration;
      if (saved && saved.key === stateKey && state.screen === "review") {
        this.prepareCartMediaUpload(state, saved.record, enteringReview);
      }
    }

    prepareCartThumbnail(kind, state, retryFailed) {
      var cache = this.cartThumbnailCache || (this.cartThumbnailCache = {});
      var key = this.cartThumbnailKey(kind, state);
      if (cache[kind] && cache[kind].key === key && !(retryFailed && cache[kind].failed)) { return cache[kind]; }
      if (cache[kind]) { cache[kind].controller.abort(); }
      var entry = { key: key, controller: new AbortController(), asset: null, failed: false, promise: null, durationMs: 0 };
      cache[kind] = entry;
      // Render an immutable design, even if the customer edits during capture.
      var snapshot = JSON.parse(JSON.stringify(state));
      entry.promise = (async function() {
        // Create the in-flight entry now, but keep capture out of UI rendering.
        // Briefly debounce edits after a customer returns from Review.
        await new Promise(function(resolve) { setTimeout(resolve, state.screen === "review" ? 0 : 120); });
        if (entry.controller.signal.aborted || cache[kind] !== entry) { return null; }
        entry.startedAt = this.cartMediaNow();
        try {
          var options = { signal: entry.controller.signal };
          var asset = kind === "cover"
            ? await this.coverEditor.captureFrontCartThumbnail(snapshot, options)
            : await this.captureRefillCartThumbnail(snapshot, options);
          if (entry.controller.signal.aborted || cache[kind] !== entry) { return null; }
          entry.asset = this.validateCapturedCartMedia(asset, kind);
          return entry.asset;
        } catch (error) {
          entry.failed = true;
          if (!entry.controller.signal.aborted) { this.warnCartMedia(error); }
          return null;
        } finally {
          entry.finishedAt = this.cartMediaNow();
          entry.durationMs = Math.round(this.cartMediaNow() - entry.startedAt);
        }
      }.bind(this))();
      return entry;
    }

    // Called only after the page has decoded and committed an exact spread.
    // Snapshot its pixels now, while its Blob URLs/canvases are still alive.
    rememberRefillCartPreview(state, rendered) {
      if (this.requiredCartMediaKinds(state).indexOf("refill") === -1) { return; }
      var key = this.cartThumbnailKey("refill", state);
      if (this.store && key !== this.cartThumbnailKey("refill", this.store.getState())) { return; }
      var pages = Array.from(rendered || []).map(function(node) {
        if (node && node.classList && (node.classList.contains("dyof__open-spread-top-layer")
          || node.classList.contains("dyof__undated-scene-image"))) { return null; }
        return node && node.querySelector ? node.querySelector("canvas, img") || node : node;
      }).filter(function(node) {
        return node && Number(node.naturalWidth || node.width) > 0 && Number(node.naturalHeight || node.height) > 0;
      }).slice(0, 2);
      if (!pages.length) { return; }
      this.cartRefillPreview = { key: key, pages: pages };
      this.prepareCartThumbnail("refill", state, true);
    }

    async captureCartMedia(state) {
      var kinds = this.requiredCartMediaKinds(state);
      var entries = kinds.map(function(kind) {
        var entry = this.cartThumbnailCache && this.cartThumbnailCache[kind];
        return entry && entry.key === this.cartThumbnailKey(kind, state) ? entry : null;
      }, this);
      if (entries.some(function(entry) { return !entry; })) { return null; }
      var assets = await Promise.all(entries.map(function(entry) { return entry.asset || entry.promise; }));
      if (assets.some(function(asset) { return !asset; })) { return null; }
      if (entries.some(function(entry, index) {
        return this.cartThumbnailCache[kinds[index]] !== entry || entry.controller.signal.aborted
          || entry.key !== this.cartThumbnailKey(kinds[index], this.store ? this.store.getState() : state);
      }, this)) { return null; }
      return assets.map(function(asset, index) { return this.validateCapturedCartMedia(asset, kinds[index]); }, this);
    }

    async optionalCartMediaReference(state, serverRecord) {
      var startedAt = this.cartMediaNow();
      var entry = this.prepareCartMediaUpload(state, serverRecord, true);
      entry.cartState = state;
      var timeout;
      var reason = "capture-unavailable";
      var reference;
      this.cartMediaPreparing = true;
      this.renderAddToCartBusy();
      // The click has one bounded budget, including a background upload/body.
      var timedOut = new Promise(function(resolve) {
        timeout = setTimeout(function() {
          reason = "timeout";
          entry.controller.abort();
          resolve(undefined);
        }, 5000);
      });
      try {
        reference = await Promise.race([entry.promise, timedOut]);
        if (!this.isAddToCartCurrent(state) || entry.stateKey !== this.cartMediaStateKey(this.store.getState())
          || entry.controller.signal.aborted) {
          reference = undefined;
          if (reason !== "timeout") { reason = entry.reason === "timeout" ? "timeout" : "stale"; }
        } else if (reason !== "timeout") { reason = reference ? "ready" : entry.reason; }
        if (!reference) { this.warnCartMedia(new Error("Thumbnails were not ready within the cart-media budget.")); }
        return reference;
      } catch (error) {
        reason = "upload-failed";
        this.warnCartMedia(error);
        return undefined;
      } finally {
        clearTimeout(timeout);
        this.cartMediaPreparing = false;
        this.renderAddToCartBusy();
        this.logCartMedia(state, reference, reason, startedAt, entry);
      }
    }

    prepareCartMediaUpload(state, serverRecord, retryFailed) {
      var stateKey = this.cartMediaStateKey(state);
      var key = JSON.stringify([stateKey, serverRecord.configurationId, serverRecord.orderReference]);
      var previous = this.cartMediaUpload;
      if (previous && previous.key === key && !previous.controller.signal.aborted
        && !(retryFailed && previous.finishedAt != null && previous.reason !== "ready")) { return previous; }
      if (previous) { previous.controller.abort(); }
      var entry = { key: key, stateKey: stateKey, controller: new AbortController(), durationMs: 0, reason: "capture-unavailable" };
      this.cartMediaUpload = entry;
      var work = (async function() {
        try {
          var media = await this.captureCartMedia(state);
          if (entry.controller.signal.aborted || stateKey !== this.cartMediaStateKey(this.store.getState())
            || entry.cartState && !this.isAddToCartCurrent(entry.cartState)) {
            entry.reason = "stale";
            return undefined;
          }
          if (!media || !media.length) { return undefined; }
          entry.reason = "upload-failed";
          entry.startedAt = this.cartMediaNow();
          var reference = await this.persistCartMedia(serverRecord, media, { signal: entry.controller.signal });
          if (entry.controller.signal.aborted || this.cartMediaUpload !== entry
            || stateKey !== this.cartMediaStateKey(this.store.getState())) { entry.reason = "stale"; return undefined; }
          entry.reason = "ready";
          return reference;
        } catch (error) {
          if (!entry.controller.signal.aborted) { this.warnCartMedia(error); }
          return undefined;
        }
      }.bind(this))();
      var timeout;
      var cancelled = new Promise(function(resolve) {
        var abort = function() { resolve(undefined); };
        entry.controller.signal.addEventListener("abort", abort, { once: true });
        entry.removeAbortListener = function() { entry.controller.signal.removeEventListener("abort", abort); };
        timeout = setTimeout(function() { entry.reason = "timeout"; entry.controller.abort(); }, 15000);
      });
      entry.promise = Promise.race([work, cancelled]).finally(function() {
        clearTimeout(timeout);
        entry.removeAbortListener();
        entry.finishedAt = this.cartMediaNow();
        if (entry.startedAt != null) { entry.durationMs = Math.round(entry.finishedAt - entry.startedAt); }
      }.bind(this));
      return entry;
    }

    logCartMedia(state, reference, reason, startedAt, upload) {
      if (this.cartMediaAttempt && this.cartMediaAttempt.logged) { return; }
      if (this.cartMediaAttempt) { this.cartMediaAttempt.logged = true; }
      var now = this.cartMediaNow();
      var duration = function(entry) {
        return !entry || entry.startedAt == null ? 0
          : entry.finishedAt != null ? entry.durationMs : Math.round(now - entry.startedAt);
      };
      var cache = this.cartThumbnailCache || {};
      var exact = function(kind) {
        return cache[kind] && cache[kind].key === this.cartThumbnailKey(kind, state) ? cache[kind] : null;
      }.bind(this);
      if (typeof console.info !== "function") { return; }
      console.info("[DYOF cart media] " + (reference ? "attached" : "skipped") + " (" + reason + ") in "
        + Math.round(now - startedAt) + "ms (cover " + duration(exact("cover")) + "ms, refill "
        + duration(exact("refill")) + "ms, upload " + duration(upload) + "ms)");
    }

    // Services answer with a string error or with { error: { code } }; never
    // show "[object Object]". A 429 is only a short per-visitor rate limit.
    // Photo upload and storage refusals get the customer's next step instead
    // of their code, which stays on error.code.
    serviceFailure(response, payload, service) {
      var body = payload && typeof payload === "object" ? payload : {};
      var nested = body.error && typeof body.error === "object" ? body.error : null;
      var code = body.code || (nested && nested.code) || (body.details && body.details.code) || null;
      var message;
      if (response.status === 429) {
        message = dyofT("cfg.interaction.service_rate_limit", "Too many requests right now. Please wait a minute and try again.");
      } else if (photoStorageRefusalMessage(code)) {
        message = photoStorageRefusalMessage(code);
      } else if (root.DYOFI18n) {
        // Backend text may name English fields or include internal details.
        // Translate recognized refusals, and keep unknown responses generic.
        message = dyofServiceMessage(code, service, response.status);
      } else if (typeof body.error === "string" && body.error) {
        message = body.error;
      } else if (response.status === 503) {
        message = dyofT("cfg.interaction.service_unavailable", "The {service} is temporarily unavailable. Please try again shortly.", { service: service });
      } else {
        message = typeof code === "string"
          ? dyofT("cfg.interaction.service_failed_code", "The {service} could not complete this request ({code}).", { service: service, code: code })
          : dyofT("cfg.interaction.service_failed_http", "The {service} could not complete this request (HTTP {status}).", { service: service, status: response.status });
      }
      var failure = dyofCustomerError(message);
      failure.code = typeof code === "string" ? code : null;
      failure.status = response.status;
      return failure;
    }

    async persistCartMedia(serverRecord, media, options) {
      var configurationId = String(serverRecord && serverRecord.configurationId || "");
      var orderReference = String(serverRecord && serverRecord.orderReference || "");
      if (!/^dyof_[a-f0-9]{24}$/.test(configurationId)) {
        throw dyofCustomerError(dyofT("cfg.interaction.configuration_reference_unavailable", "The private configuration reference is unavailable for cart artwork."));
      }
      if (!/^dyoforder_[a-f0-9]{32}$/.test(orderReference)) {
        throw dyofCustomerError(dyofT("cfg.interaction.fulfillment_reference_unavailable", "The fulfillment reference is unavailable for cart artwork."));
      }
      var endpoints = this.cartMediaEndpoints();
      var lastError = null;
      for (var index = 0; index < endpoints.length; index += 1) {
        try {
          throwIfPreviewAborted(options && options.signal);
          var response = await fetch(endpoints[index], {
            method: "POST",
            credentials: "omit",
            referrerPolicy: "no-referrer",
            signal: options && options.signal,
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({
              configurationId: configurationId,
              orderReference: orderReference,
              media: media
            })
          });
          var payload = await response.json();
          if (!response.ok) {
            throw this.serviceFailure(response, payload, dyofT("cfg.interaction.cart_media_service", "private cart-media service"));
          }
          var mediaReference = String(payload && payload.mediaReference || "");
          if (!/^dyofmedia_[a-f0-9]{32}$/.test(mediaReference)) {
            throw dyofCustomerError(dyofT("cfg.interaction.cart_media_reference_invalid", "The private cart-media service returned an invalid reference."));
          }
          return mediaReference;
        } catch (error) {
          lastError = error;
        }
      }
      throw lastError || dyofCustomerError(dyofT("cfg.interaction.cart_media_unavailable", "The private cart-media service is unavailable."));
    }

    /**
     * A store other than the UK describes itself in a store profile
     * (shopify-themes/dyof-store-cz). It may supply its catalogue as data
     * and replace the Shopify cart with an order summary. The UK has none.
     */
    applyStoreProfile(profile) {
      this.storeProfile = profile && typeof profile === "object" && /^[a-z]{2,8}$/.test(String(profile.storefront || ""))
        ? profile
        : null;
      if (this.storeProfile && this.storeProfile.catalogueSource === "profile"
        && this.storeProfile.catalogue && typeof this.storeProfile.catalogue === "object") {
        this.commerceCatalogs = this.storeProfile.catalogue;
      }
    }

    /** The saved intent, tagged with this store when it is not the UK. */
    storefrontIntent(intent) {
      return this.storeProfile ? Object.assign({}, intent, { storefront: this.storeProfile.storefront }) : intent;
    }

    usesOrderSummary() {
      return Boolean(this.storeProfile && this.storeProfile.checkout === "order-summary");
    }

    // An organiser page's DESIGN YOUR OWN REFILL button keeps its organiser in
    // the cart (note = product handle, attributes.variant) before opening this
    // page. Only an available variant of exactly that organiser product becomes
    // the bundle parent (UK only); any failure leaves the module as it is.
    async loadOrganiserContext() {
      var entry = organiserEntryParams(root.location && root.location.search);
      var context = null;
      if (!entry || this.storeProfile || typeof fetch !== "function") {
        return null;
      }
      try {
        var cartResponse = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
        var cart = cartResponse.ok ? await cartResponse.json() : null;
        var handle = String(cart && cart.note || "").trim().toLowerCase();
        if (/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) {
          var productResponse = await fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } });
          context = productResponse.ok
            ? this.commerce.organiserContext(cart, await productResponse.json(), entry)
            : null;
        }
      } catch (error) {
        context = null;
      }
      this.organiserContext = context;
      if (context && this.store && this.elements) {
        this.render(this.store.getState());
      }
      return context;
    }

    // The organiser bundle applies to the refill journey only; Clipbook and
    // Planner journeys ignore it.
    organiserFor(state) {
      return this.organiserContext && !this.storeProfile
        && state && state.journey && state.journey.productType === "refill"
        ? this.organiserContext
        : null;
    }

    // "Saffiano A5 Organiser – Black / No Diary": the exact organiser ordered.
    organiserName(organiser) {
      return organiser.variantTitle ? organiser.title + " – " + organiser.variantTitle : organiser.title;
    }

    // Under the preview on the organiser path: the scene's organiser is only
    // an example, and this names the one being ordered (Enes, 2026-10-14).
    renderOrganiserPreviewNote(state) {
      var organiser = this.organiserFor(state);
      var stage = this.elements && this.elements.previewStage;
      var note = this.organiserPreviewNote;
      if (!stage || !stage.parentNode) {
        return;
      }
      if (!note && organiser) {
        note = document.createElement("p");
        // Styled like the description line under the preview.
        note.className = "dyof__undated-preview-description";
        note.dataset.dyofOrganiserPreviewNote = "";
        stage.parentNode.insertBefore(note, stage.nextSibling);
        this.organiserPreviewNote = note;
      }
      if (!note) {
        return;
      }
      note.hidden = !organiser;
      note.textContent = organiser
        ? dyofT("cfg.organiser.preview_note", "The organiser in the preview is only an example. You are ordering the {name}.", {
          name: this.organiserName(organiser)
        })
        : "";
    }

    // The organiser's size counts as the Size choice, so the refill journey
    // opens on Style. A restored design replaces these choices with its own.
    preselectOrganiserSize(state) {
      var entry = organiserEntryParams(root.location && root.location.search);
      if (!entry || !state || state.journey.productType !== "refill"
        || state.selection.size !== entry.size || this.datedFlowExplicitFields.size) {
        return;
      }
      this.datedFlowExplicitFields.add("size:size");
      this.datedFlowVisibleThrough = Math.max(this.datedFlowVisibleThrough, 1);
    }

    // Shown on the refill journey and in Review. The organiser is always
    // bought with the refill; only a Design Your Own refill of its size is
    // 30% off, so the note never promises the offer for any other refill.
    organiserNote(state) {
      var organiser = this.organiserFor(state);
      var offer;
      var organiserItem;
      if (!organiser) {
        return "";
      }
      offer = this.resolvePriceOffer(state);
      organiserItem = offer && offer.status === "ready" && Array.isArray(offer.items)
        ? offer.items.filter(function(item) { return item.role === "organiser"; })[0]
        : null;
      if (organiserItem ? organiserItem.bundled === false : state.selection.size !== organiser.size) {
        return dyofT("cfg.organiser.full_price_note", "Your {title} ({price}) is added too, at full price. The 30% refill offer needs a Design Your Own refill in {size}.", {
          title: this.organiserName(organiser),
          price: dyofDisplayMoney(this, organiser.priceCents, this.commerceCatalogs && this.commerceCatalogs.currency || "GBP"),
          size: dyofDisplayLabel(sizeLabel(organiser.size))
        });
      }
      return dyofT("cfg.organiser.note", "Bundled with your {title} ({price}). The total shown is before discounts; 30% off this refill is applied in your basket.", {
        title: this.organiserName(organiser),
        price: dyofDisplayMoney(this, organiser.priceCents, this.commerceCatalogs && this.commerceCatalogs.currency || "GBP")
      });
    }

    // A refill bought with an organiser is the organiser's size (Enes,
    // 2026-10-14): the other sizes stay visible, greyed out and unclickable.
    renderOrganiserSizeLock(state) {
      var organiser = this.organiserFor(state);
      if (!organiser || !this.elements || !this.elements.refillSizeList) {
        return;
      }
      this.elements.refillSizeList.querySelectorAll("[data-dyof-field='size']").forEach(function(button) {
        if (button.dataset.dyofValue !== organiser.size) {
          button.disabled = true;
          button.title = dyofT("cfg.organiser.size_locked", "This refill is for your {title}, so it is {size}.", {
            title: this.organiserName(organiser),
            size: dyofDisplayLabel(sizeLabel(organiser.size))
          });
        }
      }, this);
    }

    // Review shows the standard catalogue prices before adding to the basket.
    // Shopify applies the qualifying refill offer in the actual basket.
    organiserBreakdownRows(state) {
      var offer = this.organiserFor(state) ? this.resolvePriceOffer(state) : null;
      var currency = offer && offer.price && offer.price.currency || "GBP";
      var items = offer && offer.status === "ready" && Array.isArray(offer.items) ? offer.items : [];
      var organiserItem = items.filter(function(item) { return item.role === "organiser"; })[0];
      var refillItem = items.filter(function(item) { return item.role === "refill"; })[0];
      var money = function(amount) { return dyofDisplayMoney(this, amount, currency); }.bind(this);
      var refillPrice;
      if (!organiserItem || !refillItem) {
        return [];
      }
      refillPrice = Number(refillItem.variant.price);
      return [
        { label: this.organiserName(this.organiserFor(state)), value: money(Number(organiserItem.variant.price)) },
        {
          label: dyofT("cfg.organiser.refill_row", "Design Your Own refill"),
          value: money(refillPrice)
        },
        { label: dyofT("cfg.organiser.total_row", "Total"), value: money(dyofPreviewOfferPrice(offer).amount) }
      ];
    }

    /** Hands the finished order to the store's summary instead of the Shopify cart. */
    openOrderSummary(state, cartItems, purchaseItems, serverRecord, orderReference) {
      var currency = this.commerceCatalogs && this.commerceCatalogs.currency || "GBP";
      var lines = cartItems.map(function(item) {
        var purchase = purchaseItems.find(function(candidate) {
          return Number(candidate.variant && candidate.variant.id) === Number(item.id);
        }) || {};
        var variant = purchase.variant || {};
        var price = this.commerce.purchaseItemPriceCents(purchase, purchaseItems, this.commerceCatalogs && this.commerceCatalogs.currency);
        return {
          role: purchase.role || "",
          title: purchase.title || variant.title || "",
          quantity: item.quantity,
          price: price,
          priceLabel: price !== Number(variant.price)
            ? dyofDisplayMoney(this, price, currency)
            : variant.priceLabel || "",
          properties: Object.keys(item.properties || {}).filter(function(key) {
            return key.charAt(0) !== "_";
          }).reduce(function(result, key) {
            result[key] = item.properties[key];
            return result;
          }, {})
        };
      }, this);
      var summary = [];
      if (this.elements && this.elements.reviewSummary) {
        this.elements.reviewSummary.querySelectorAll(".dyof__review-summary-row").forEach(function(row) {
          var term = row.querySelector("dt");
          var description = row.querySelector("dd");
          summary.push({ label: term ? term.textContent : "", value: description ? description.textContent : "" });
        });
      }
      var restoreUrl = "";
      try {
        if (root.location && typeof root.location.href === "string" && serverRecord && serverRecord.configurationId) {
          var url = new URL(root.location.href);
          url.searchParams.delete("dyof_saved");
          url.hash = "dyof_saved=" + encodeURIComponent(serverRecord.configurationId);
          restoreUrl = url.toString();
        }
      } catch (error) {
        restoreUrl = "";
      }
      var covered = state.journey.productType === "clipbook" || state.journey.productType === "planner";
      // An Undated layout download needs that size's own production pages.
      var undatedPurchase = state.journey.refillType === "undated" ? this.undatedPurchase(state) : null;
      this.dispatchEvent(new CustomEvent("dyof:ordersummary", {
        bubbles: true,
        detail: {
          orderReference: orderReference,
          configurationId: serverRecord && serverRecord.configurationId || "",
          restoreUrl: restoreUrl,
          currency: currency,
          lines: lines,
          summary: summary,
          total: lines.reduce(function(sum, line) { return sum + line.price * line.quantity; }, 0),
          downloads: {
            cover: covered,
            layout: state.journey.refillType === "dated" || state.journey.refillType !== "none"
              && Boolean(undatedPurchase)
              && undatedPurchase.status === "ready"
              && Number(undatedPurchase.pageCount) > 0
          }
        }
      }));
    }

    async persistConfiguration(state, resumeInput) {
      var production = this.coverEditor
        ? await this.coverEditor.getProductionReferences(state)
        : { catalogue: null, assets: [], uploadClaims: [] };
      var uploadClaims = Array.isArray(production.uploadClaims)
        ? production.uploadClaims
        : [];
      var body = {
        intent: this.storefrontIntent(this.stateApi.getOrderIntent(state)),
        resume: resumeInput || this.getEditorResumeState(state),
        production: {
          catalogue: production.catalogue || null,
          assets: Array.isArray(production.assets) ? production.assets : []
        },
        uploadClaims: uploadClaims,
        baseConfigurationId: this.baseConfigurationId
      };
      // The Filofax back logo the customer saw goes with the cover, in the
      // production intent and the resume snapshot alike (the service checks
      // that they match). A cover without one is saved exactly as before.
      if (production.backLogo && body.intent.cover) {
        body = withSavedBackLogo(body, production.backLogo);
      }
      var backLogoRetried = false;
      var lastError = null;
      var endpoints = this.configurationEndpoints();
      for (var index = 0; index < endpoints.length; index += 1) {
        try {
          var response = await fetch(endpoints[index], {
            method: "POST",
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(body)
          });
          var payload = await response.json();
          // A service on another release of the reviewed back-logo table
          // refuses this theme's colour and names its own (or none): save that
          // once more at the same endpoint, and show it from now on, rather
          // than fail the save while a release rolls out.
          var serviceBackLogo = !response.ok && !backLogoRetried && response.status === 400
            ? refusedBackLogo(payload)
            : undefined;
          if (serviceBackLogo !== undefined && body.intent.cover && body.intent.cover.backLogo) {
            backLogoRetried = true;
            body = withSavedBackLogo(body, serviceBackLogo);
            if (this.coverEditor && typeof this.coverEditor.adoptServiceBackLogo === "function") {
              this.coverEditor.adoptServiceBackLogo(state, serviceBackLogo);
            }
            index -= 1;
            continue;
          }
          if (!response.ok) {
            var failure = this.serviceFailure(response, payload, dyofT("cfg.interaction.configuration_service", "configuration service"));
            // Upload refusals list the photos the service could not accept;
            // name them when this design shows them.
            var refusedAssetIds = PHOTO_UPLOAD_AGAIN_CODES.indexOf(failure.code) !== -1
              && payload && payload.error && Array.isArray(payload.error.assetIds)
              ? payload.error.assetIds.filter(function(id) { return typeof id === "string"; })
              : [];
            var namedMessage = refusedAssetIds.length
              ? missingUploadedPhotoMessage(state, refusedAssetIds, [])
              : "";
            if (namedMessage) { failure.message = namedMessage; }
            throw failure;
          }
          // The new configuration now holds the claimed photos. Record it as
          // this history entry's base before the claims are dropped, so a
          // reload (Add to cart leaves the page next) still builds on it.
          this.baseConfigurationId = payload.configurationId;
          try {
            this.flushReloadResumeState();
          } catch (error) {
            // The reload checkpoint is best effort; the save itself succeeded.
          }
          if (this.coverEditor && typeof this.coverEditor.clearProductionUploadClaims === "function") {
            this.coverEditor.clearProductionUploadClaims(uploadClaims);
          }
          // Only an exact successful save permits early media upload. Opening
          // Review alone must not create/claim another production record.
          if (state && state.journey) {
            this.cartMediaConfiguration = { key: this.cartMediaStateKey(state), record: payload };
            var current = this.store && this.store.getState();
            if (current && current.screen === "review" && !this.addToCartInFlight
              && this.cartMediaStateKey(current) === this.cartMediaConfiguration.key) {
              this.prepareCartMediaUpload(current, payload);
            }
          }
          return payload;
        } catch (error) {
          lastError = error;
        }
      }
      throw lastError || dyofCustomerError(dyofT("cfg.interaction.configuration_service_unavailable", "The configuration service is unavailable."));
    }

    // POSTs a saved-link restore; null when the service does not return it.
    async requestConfigurationRestore(endpoint, id) {
      var requestAbortController = new AbortController();
      var response = await withTimeout(fetch(endpoint, {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ configurationId: id }),
        signal: requestAbortController.signal
      }), CONFIGURATION_RESTORE_TIMEOUT_MS, function() {
        requestAbortController.abort();
      });
      if (!response.ok) { return null; }
      return withTimeout(
        response.json(),
        CONFIGURATION_RESTORE_TIMEOUT_MS
      );
    }

    // A restore's assets, each private one's bytes fetched into an object URL
    // (added to preparedAssetUrls). With onlyIds, only those assets.
    async prepareRestoredAssets(endpoint, id, payloadAssets, preparedAssetUrls, onlyIds) {
      var origin = new URL(endpoint, root.location.href).origin;
      var assets = [];
      for (var assetIndex = 0; assetIndex < (payloadAssets || []).length; assetIndex += 1) {
        var asset = payloadAssets[assetIndex];
        if (onlyIds && (!asset || onlyIds.indexOf(asset.id) === -1)) { continue; }
        var copy = Object.assign({}, asset);
        if (copy.previewEndpoint) {
          var privateAssetEndpoint = /^\//.test(copy.previewEndpoint)
            ? origin + copy.previewEndpoint
            : new URL(copy.previewEndpoint, endpoint).toString();
          var assetAbortController = new AbortController();
          var assetResponse = await withTimeout(fetch(privateAssetEndpoint, {
            method: "POST",
            headers: { "Accept": copy.mime || "application/octet-stream", "Content-Type": "application/json" },
            body: JSON.stringify({ configurationId: id, assetId: copy.id }),
            signal: assetAbortController.signal
          }), CONFIGURATION_RESTORE_TIMEOUT_MS, function() {
            assetAbortController.abort();
          });
          if (!assetResponse.ok) {
            throw new Error("A private saved asset could not be restored.");
          }
          var advertisedLength = Number(
            assetResponse.headers && assetResponse.headers.get
              ? assetResponse.headers.get("content-length") || 0
              : 0
          );
          if (advertisedLength > PRIVATE_RESTORE_ASSET_MAX_BYTES) {
            throw new Error("A private saved asset exceeds the restore limit.");
          }
          var assetBytes = await withTimeout(
            assetResponse.arrayBuffer(),
            CONFIGURATION_RESTORE_TIMEOUT_MS
          );
          if (assetBytes.byteLength > PRIVATE_RESTORE_ASSET_MAX_BYTES) {
            throw new Error("A private saved asset exceeds the restore limit.");
          }
          copy.previewUrl = URL.createObjectURL(new Blob([assetBytes], {
            type: copy.mime || "application/octet-stream"
          }));
          preparedAssetUrls.push(copy.previewUrl);
          delete copy.previewEndpoint;
        }
        if (copy.previewUrl && /^\//.test(copy.previewUrl)) {
          copy.previewUrl = origin + copy.previewUrl;
        }
        assets.push(copy);
      }
      return assets;
    }

    // Revokes restore object URLs and tells the cover editor, whose records
    // then fall back to what this browser keeps (if anything).
    revokeRestoredAssetUrls(urls) {
      if (!urls || !urls.length) { return; }
      if (this.coverEditor && typeof this.coverEditor.releaseObjectUrls === "function") {
        this.coverEditor.releaseObjectUrls(urls);
      }
      urls.forEach(function(url) { URL.revokeObjectURL(url); });
    }

    // A reload (or a local restore) may show photos this browser keeps no
    // copy of: another browser uploaded them and this one opened the saved
    // link (see the cover editor's restoreAssets). The configuration this page
    // builds on holds them, so their previews are fetched from it again.
    // Never throws or rejects: startup calls it.
    restoreMissingAssetPreviews(idsInput) {
      var id = this.baseConfigurationId;
      var editor = this.coverEditor;
      var ids;
      if (
        !RESTORE_CAPABILITY_PATTERN.test(String(id || ""))
        || !editor
        || typeof editor.restoreMissingPreviews !== "function"
      ) {
        return Promise.resolve(0);
      }
      try {
        ids = idsInput || (typeof editor.assetIds === "function" && this.store
          ? editor.assetIds(this.store.getState())
          : []);
      } catch (error) {
        ids = [];
      }
      if (!ids || !ids.length) {
        return Promise.resolve(0);
      }
      return editor.restoreMissingPreviews(ids, function(missing) {
        return this.fetchRestoredAssets(id, missing);
      }.bind(this));
    }

    async fetchRestoredAssets(id, onlyIds) {
      var endpoints = this.configurationEndpoints();
      for (var index = 0; index < endpoints.length; index += 1) {
        var preparedAssetUrls = [];
        try {
          var endpoint = endpoints[index].replace(/\/$/, "") + "/restore";
          var payload = await this.requestConfigurationRestore(endpoint, id);
          if (!payload) { continue; }
          var assets = await this.prepareRestoredAssets(endpoint, id, payload.assets, preparedAssetUrls, onlyIds);
          this.restoredAssetObjectUrls = (this.restoredAssetObjectUrls || []).concat(preparedAssetUrls);
          return assets;
        } catch (error) {
          this.revokeRestoredAssetUrls(preparedAssetUrls);
        }
      }
      return [];
    }

    async restoreConfigurationFromUrl() {
      var id = this.savedConfigurationId();
      if (!id) {
        return false;
      }
      var endpoints = this.configurationEndpoints();
      for (var index = 0; index < endpoints.length; index += 1) {
        var preparedAssetUrls = [];
        try {
          var endpoint = endpoints[index].replace(/\/$/, "") + "/restore";
          var payload = await this.requestConfigurationRestore(endpoint, id);
          if (!payload) { continue; }
          var assets = await this.prepareRestoredAssets(endpoint, id, payload.assets, preparedAssetUrls);
          if (this.coverEditor) {
            try {
              await withTimeout(
                this.coverEditor.restoreAssets(assets),
                CONFIGURATION_RESTORE_TIMEOUT_MS
              );
            } catch (error) {
              this.revokeRestoredAssetUrls(preparedAssetUrls);
              preparedAssetUrls = [];
              throw error;
            }
          }
          this.restoredAssetObjectUrls = (this.restoredAssetObjectUrls || []).concat(preparedAssetUrls);
          this.baseConfigurationId = id;
          this.restoreConfigurationState(
            payload.resume && payload.resume.snapshot ? payload.resume.snapshot : payload.intent,
            payload.resume
          );
          this.store.dispatch({ type: "SAVE_STATUS", payload: { status: "restored", snapshotId: id, error: null, errorCode: null } });
          this.persistReloadResumeState(this.store.getState(), {
            savedConfigurationId: id
          });
          return true;
        } catch (error) {
          this.revokeRestoredAssetUrls(preparedAssetUrls);
          // Try the next configured endpoint.
        }
      }
      var localRestore = await this.restoreLocalConfiguration(id, {
        requireMatchingId: true,
        savedConfigurationId: id
      });
      if (localRestore.restored) {
        return true;
      }
      this.setRestoringConfiguration(false);
      this.render(this.store.getState());
      this.appendMessage(dyofT("cfg.interaction.restore_failed", "The saved configuration could not be restored right now."), "error");
      return false;
    }

    async restoreLocalConfiguration(idInput, options) {
      var id = String(idInput || "");
      var raw;
      var payload;
      if (!id) {
        return { restored: false, reason: "missing" };
      }
      try {
        raw = root.localStorage.getItem("dyof:saved:" + id);
      } catch (error) {
        return { restored: false, reason: "unavailable" };
      }
      if (!raw) {
        return { restored: false, reason: "missing" };
      }
      try {
        payload = JSON.parse(raw);
        if (
          !payload
          || typeof payload !== "object"
          || !payload.snapshot
          || (
            options
            && options.requireMatchingId
            && payload.id !== id
          )
        ) {
          return { restored: false, reason: "unreadable" };
        }
        if (this.coverEditor && this.coverEditor.restoreAssets) {
          await withTimeout(
            this.coverEditor.restoreAssets(Array.isArray(payload.assets) ? payload.assets : []),
            CONFIGURATION_RESTORE_TIMEOUT_MS
          );
        }
        // A browser copy of a server save builds on that server configuration,
        // which holds its photos; a "dyof-local-" copy has none.
        var adoptsBase = Boolean(
          options
          && options.adoptServerBase
          && RESTORE_CAPABILITY_PATTERN.test(id)
        );
        if ((options && options.savedConfigurationId === id) || adoptsBase) {
          this.baseConfigurationId = id;
        }
        if (adoptsBase) {
          // Before the restored design renders, which then waits for them.
          this.restoreMissingAssetPreviews((Array.isArray(payload.assets) ? payload.assets : []).map(function(asset) {
            return asset && asset.id;
          }).filter(Boolean));
        }
        this.restoreConfigurationState(
          payload.resume && payload.resume.snapshot ? payload.resume.snapshot : payload.snapshot,
          payload.resume
        );
        this.store.dispatch({
          type: "SAVE_STATUS",
          payload: { status: "restored", snapshotId: id, error: null, errorCode: null }
        });
        if (options && options.savedConfigurationId === id) {
          this.persistReloadResumeState(this.store.getState(), {
            savedConfigurationId: id
          });
        } else if (adoptsBase) {
          this.persistReloadResumeState(this.store.getState());
        }
        return { restored: true, reason: null };
      } catch (error) {
        return { restored: false, reason: "unreadable" };
      }
    }

    async restoreSavedConfiguration() {
      var id;
      try {
        id = root.localStorage.getItem("dyof:saved:latest");
      } catch (error) {
        id = null;
      }
      if (!id) {
        this.appendMessage(dyofT("cfg.interaction.saved_configuration_missing", "No saved configuration was found in this browser."), "error");
        return;
      }
      var localRestore = await this.restoreLocalConfiguration(id, { adoptServerBase: true });
      if (!localRestore.restored) {
        this.appendMessage(dyofT("cfg.interaction.saved_configuration_unreadable", "The saved configuration is unreadable."), "error");
      }
    }

    catalogVariantOption(variant, index) {
      if (variant && Array.isArray(variant.options)) {
        return String(variant.options[index] || "").trim().toLowerCase();
      }
      return String(variant && variant["option" + (index + 1)] || "").trim().toLowerCase();
    }

    purchasableCatalogVariants(catalog) {
      return (catalog && Array.isArray(catalog.variants) ? catalog.variants : []).filter(function(variant) {
        return this.commerce.isPurchasableVariant(variant);
      }, this);
    }

    clipbookBaseVariants(size) {
      var expectedSize = String(size || "").trim().toLowerCase();
      return this.purchasableCatalogVariants(this.commerceCatalogs.clipbook).filter(function(variant) {
        var option = this.catalogVariantOption(variant, 0);
        return (option === expectedSize || option === expectedSize + " / print-to-order")
          && option.indexOf("standard fill") === -1
          && String(variant.title || "").toLowerCase().indexOf("standard fill") === -1;
      }, this);
    }

    // A store profile catalogue made before New Colourful (the Czech store)
    // keeps selling modern refills as the old Classic (white paper) or
    // Luxury (cream paper) variants. The UK catalogue always lists New
    // Colourful, so a missing product there fails closed instead.
    usesLegacyModernPricing() {
      return Boolean(
        this.storeProfile
        && this.commerceCatalogs
        && !this.commerceCatalogs.newColourful
      );
    }

    // The custom-notebook style a modern Planner is priced as: Luxury for
    // either paper (New Colourful costs the same as Luxury).
    modernPlannerStyle(selection) {
      var source = selection || {};
      if (this.usesLegacyModernPricing()) {
        return source.paperColour === "cream" ? "luxury" : "classic";
      }
      var refills = this.contract && this.contract.newColourfulRefills;
      return refills && refills.plannerStyle ? refills.plannerStyle : "luxury";
    }

    modernPricingSelection(selection) {
      var source = selection || {};
      if (
        source.engine !== "modern"
        || String(source.size || "a5").trim().toLowerCase() !== "a5"
        || !this.commerce.legacyLayoutOption(source.layout)
      ) {
        return null;
      }
      return Object.assign({}, source, {
        engine: "legacy",
        size: "a5",
        style: this.modernPlannerStyle(source)
      });
    }

    // The live New Colourful variant a modern Clipbook or Refill layout
    // sells as. Its price and availability come from the catalogue; a
    // missing, unavailable or mis-owned row fails closed.
    newColourfulVariant(selection) {
      var source = selection || {};
      var missing = {
        status: "missing",
        variant: null,
        message: dyofT("cfg.cart.modern_refill_missing", "This modern dated refill configuration does not have a matching Shopify variant yet.")
      };
      var entry = source.engine === "modern"
        && this.contract
        && typeof this.contract.getNewColourfulRefill === "function"
        ? this.contract.getNewColourfulRefill(source.layout, source.size || "a5")
        : null;
      var live;
      if (!entry) {
        return missing;
      }
      live = this.commerce.findVariantById(this.commerceCatalogs && this.commerceCatalogs.newColourful, entry.variantId);
      if (
        live.status !== "ready"
        || String(live.variant && live.variant.productHandle || "").trim().toLowerCase() !== entry.productHandle
      ) {
        return Object.assign({}, live, { status: live.status === "ready" ? "missing" : live.status, variant: null, message: missing.message });
      }
      return live;
    }

    // Every live New Colourful variant a modern layout can sell as at this
    // size, for "From" prices before the layout is chosen.
    newColourfulPriceVariants(size, layoutKey) {
      var layouts = layoutKey ? [layoutKey] : Object.keys(this.contract && this.contract.modernVariants || {});
      var seen = new Set();
      return layouts.reduce(function(variants, layout) {
        var purchase = this.newColourfulVariant({ engine: "modern", size: size, layout: layout });
        if (purchase.status === "ready" && !seen.has(Number(purchase.variant.id))) {
          seen.add(Number(purchase.variant.id));
          variants.push(purchase.variant);
        }
        return variants;
      }.bind(this), []);
    }

    trustedPlannerCatalog() {
      var catalog = this.commerceCatalogs && this.commerceCatalogs.planner;
      var handle = String(catalog && catalog.handle || "").trim().toLowerCase();

      if (handle !== "custom-notebook") {
        return null;
      }
      return Object.assign({}, catalog, {
        variants: this.purchasableCatalogVariants(catalog).filter(function(variant) {
          return String(variant.productHandle || "").trim().toLowerCase() === handle;
        })
      });
    }

    datedPlannerVariant(state) {
      var missingMessage = dyofT("cfg.cart.dated_planner_missing", "This dated Planner configuration does not have a matching Shopify variant yet.");
      var trustedCatalog;
      var pricingSelection;
      var purchase;

      if (state.selection.layout === "daily") {
        return { status: "missing", variant: null, message: dyofT("cfg.cart.daily_planner_unavailable", "Daily is not available for Planner & Notebook. Choose a different layout.") };
      }

      trustedCatalog = this.trustedPlannerCatalog();
      if (!trustedCatalog) {
        return { status: "missing", variant: null, message: missingMessage };
      }
      if (state.selection.engine === "modern") {
        pricingSelection = this.modernPricingSelection(state.selection);
        purchase = pricingSelection
          ? this.commerce.resolveLegacyVariant(trustedCatalog, pricingSelection)
          : { status: "missing", variant: null };
        if (purchase.status !== "ready") {
          purchase.message = dyofT("cfg.cart.modern_planner_missing", "This modern Planner configuration does not have a matching Shopify variant yet.");
        }
        return purchase;
      }
      if (state.selection.engine !== "legacy") {
        return { status: "missing", variant: null, message: missingMessage };
      }

      return this.commerce.resolveLegacyVariant(trustedCatalog, state.selection);
    }

    datedPlannerPriceOffer(state, forceExact) {
      var trustedCatalog;
      var explicitFields;
      var expectedSize;
      var expectedStyle;
      var modernStyles;
      var expectedLayout;
      var legacyStyles;
      var legacyLayouts;
      var modern;
      var styleExplicit;
      var paperExplicit;
      var layoutExplicit;
      var exact;
      var candidates;

      if (
        !state
        || !state.journey
        || state.journey.productType !== "planner"
        || state.journey.refillType !== "dated"
        || ["legacy", "modern"].indexOf(state.selection.engine) === -1
      ) {
        return null;
      }

      trustedCatalog = this.trustedPlannerCatalog();
      explicitFields = this.datedFlowExplicitFields || new Set();
      modern = state.selection.engine === "modern";
      expectedSize = String(state.selection.size || "a5").trim().toLowerCase();
      expectedStyle = modern
        ? this.modernPlannerStyle(state.selection)
        : String(state.selection.style || "").trim().toLowerCase();
      // Before paper and layout are chosen a modern Planner may still become
      // either legacy price alias (the Czech store) or only Luxury (the UK).
      modernStyles = this.usesLegacyModernPricing() ? ["classic", "luxury"] : [expectedStyle];
      expectedLayout = String(
        this.commerce.legacyLayoutOption(state.selection.layout) || ""
      ).trim().toLowerCase();
      legacyStyles = this.contract && this.contract.styles
        ? this.contract.styles
        : {};
      styleExplicit = explicitFields.has("style:style");
      paperExplicit = explicitFields.has("paper:paperColour");
      layoutExplicit = modern
        ? Boolean(this.datedFlowComplete)
        : explicitFields.has("legacy-layout:layout");
      // Before any interior choice the "From" price is the cheapest Planner
      // of every design and layout, not just the default design's layouts.
      legacyLayouts = Object.keys(modern && (forceExact || styleExplicit || paperExplicit || layoutExplicit)
        ? this.contract && this.contract.modernVariants || {}
        : this.commerce.legacyLayoutOptions || {}).filter(function(key) {
        return key !== "daily";
      }).map(function(key) {
        return String(this.commerce.legacyLayoutOptions[key] || "").trim().toLowerCase();
      }, this).filter(Boolean);
      exact = Boolean(
        forceExact
        || styleExplicit && layoutExplicit
      );
      candidates = (trustedCatalog && trustedCatalog.variants || []).filter(function(variant) {
        var variantStyle = this.catalogVariantOption(variant, 1);
        var styleContract = legacyStyles[variantStyle];
        var variantLayout = this.catalogVariantOption(variant, 2);
        return this.catalogVariantOption(variant, 0) === expectedSize
          && styleContract
          && styleContract.engine === "legacy"
          && legacyLayouts.indexOf(variantLayout) !== -1
          && (modern && styleExplicit && !(forceExact || paperExplicit || layoutExplicit)
            ? modernStyles.indexOf(variantStyle) !== -1
            : !(forceExact || styleExplicit) || variantStyle === expectedStyle)
          && (!(forceExact || layoutExplicit)
            || variantLayout === expectedLayout);
      }, this).map(function(variant) {
        return {
          offerKey: "planner:" + String(variant.id),
          items: [{ role: "planner", variant: variant, quantity: 1 }]
        };
      });

      return this.commerce.resolveOfferCandidates(
        candidates,
        exact,
        this.commerceCatalogs.currency || "GBP"
      );
    }

    undatedPlannerVariant(state) {
      var missingMessage = dyofT("cfg.cart.undated_planner_missing", "This Undated refill is not available as a Planner product.");
      var journalHandles = {
        "baby-journal": "dyof-planner-baby-journal-a5",
        "wedding-journal": "dyof-planner-wedding-journal-a5",
        "gardening-journal": "dyof-planner-gardening-journal-a5",
        "life-essentials": "dyof-planner-life-essentials-a5",
        "cookbook-journal": "dyof-planner-cookbook-journal-a5",
        "pet-journal": "dyof-planner-pet-journal-a5"
      };
      var fillKey = state.journey.undatedFill;
      var journal = Object.prototype.hasOwnProperty.call(journalHandles, fillKey);
      var fill = this.contract && typeof this.contract.getUndatedFill === "function"
        ? this.contract.getUndatedFill(fillKey)
        : this.contract && this.contract.undatedFills
          ? this.contract.undatedFills[fillKey]
          : null;
      var live;
      // A Planner is one line of its own product: a Journal's
      // dyof-planner-<journal>-a5 variant, or an Everyday fill's custom-notebook
      // "Undated / Undated / X" variant (cover and fill), never the
      // Clipbook's refill variant.
      var expectedHandle = journal ? journalHandles[fillKey] : "custom-notebook";
      var variantId = fill && fill.plannerVariantId;

      if (!fill || fill.status !== "ready" || !variantId
        || fill.plannerProductHandle !== expectedHandle
        || String(variantId) === String(fill.variantId)
        || !state.selection || state.selection.size !== "a5") {
        return { status: "missing", variant: null, message: missingMessage };
      }
      live = this.commerce.findVariantById(
        this.commerceCatalogs && this.commerceCatalogs.undated,
        variantId
      );
      if (
        live.status !== "ready"
        || String(live.variant && live.variant.productHandle || "").trim().toLowerCase()
          !== expectedHandle
      ) {
        return { status: "missing", variant: null, message: missingMessage };
      }
      return live;
    }

    // What the chosen Undated fill sells at the customer's size and product.
    // Personal never borrows the A5 variant; a contract without per-size data
    // only sells A5.
    undatedPurchase(state, fillKey) {
      var key = fillKey || (state && state.journey && state.journey.undatedFill);
      var size = state && state.selection ? state.selection.size : "";
      var productType = state && state.journey ? state.journey.productType : "";
      var fill;
      var purchase;
      // A store profile can leave out the Personal Everyday fills (the Czech store does).
      var unavailable = { status: "unavailable", variantId: null, sku: null, price: null, pageCount: null, productHandle: null, stockFill: false };
      if (size !== "a5" && this.storeProfile && this.storeProfile.personalEveryday === false) {
        return unavailable;
      }
      if (this.contract && typeof this.contract.getUndatedPurchase === "function") {
        purchase = this.contract.getUndatedPurchase(key, size, productType);
      } else {
        fill = this.contract && typeof this.contract.getUndatedFill === "function"
          ? this.contract.getUndatedFill(key)
          : this.contract && this.contract.undatedFills
            ? this.contract.undatedFills[key]
            : null;
        if (!fill || size !== "a5" || (Array.isArray(fill.sizes) && fill.sizes.indexOf(size) === -1)) {
          return unavailable;
        }
        purchase = {
          status: fill.status,
          variantId: fill.variantId || null,
          sku: fill.sku || null,
          price: fill.price == null ? null : fill.price,
          pageCount: fill.pageCount || null,
          productHandle: fill.productHandle || null,
          stockFill: fill.stockFill === true
        };
      }
      // The printer's stock Everyday fills are the UK's English pages, so a
      // store profile (the Czech store prints in Czech) sells none unless it
      // opts in with "stockFills": true. Its Everyday fills then keep needing
      // production pages and stay behind the production gate.
      if (purchase && purchase.stockFill === true && this.storeProfile && this.storeProfile.stockFills !== true) {
        return Object.assign({}, purchase, { stockFill: false });
      }
      return purchase;
    }

    // A ready stock fill (an Everyday fill) at this size: the printer prints
    // the standard fill for its SKU and only the cover is personalised, so it
    // sells without production pages. Review and the cart refill thumbnail
    // show its static sample spread. A Planner sells it as one line.
    isStockFill(state) {
      if (!state || !state.journey || state.journey.refillType !== "undated") {
        return false;
      }
      var purchase = this.undatedPurchase(state);
      return purchase.status === "ready" && purchase.stockFill === true;
    }

    undatedFillAvailableForProduct(state, fillKey) {
      if (state.journey.productType !== "planner") {
        return true;
      }
      return this.undatedPlannerVariant({
        journey: Object.assign({}, state.journey, { undatedFill: fillKey }),
        selection: state.selection
      }).status === "ready";
    }

    legacyLayoutAvailability(state, selection) {
      if (state && state.journey && state.journey.productType === "planner") {
        return this.datedPlannerVariant({
          journey: state.journey,
          selection: selection
        });
      }
      return this.commerce.resolveLegacyVariant(this.productCatalog, selection);
    }

    renderModernLayoutAvailability(state) {
      if (!this.elements.layoutList) { return; }
      this.elements.layoutList.querySelectorAll("[data-dyof-field='layout']").forEach(function(button) {
        var unavailable = state.selection.engine === "modern"
          && state.journey.productType === "planner"
          && (button.dataset.dyofValue === "daily" || this.datedPlannerVariant({
            journey: state.journey,
            selection: Object.assign({}, state.selection, { layout: button.dataset.dyofValue })
          }).status !== "ready");
        button.hidden = unavailable;
        button.disabled = unavailable;
      }, this);
    }

    priceChoiceContext(state) {
      var coveredSize = Boolean(
        this.coverEditor
        && this.coverEditor.hasExplicitSizeChoice
        && this.coverEditor.hasExplicitSizeChoice()
      );
      var standaloneSize = this.datedFlowExplicitFields.has("size:size");
      return {
        refillType: state.journey.productType === "refill"
          || this.didChooseRefillType
          || state.journey.refillType === "none",
        size: state.journey.productType === "refill" ? standaloneSize : coveredSize,
        style: this.datedFlowExplicitFields.has("style:style"),
        paper: this.datedFlowExplicitFields.has("paper:paperColour"),
        layout: state.selection.engine === "legacy"
          ? this.datedFlowExplicitFields.has("legacy-layout:layout")
          : this.datedFlowComplete,
        undatedFill: this.didChooseUndatedFill
      };
    }

    datedPriceVariants(state, size, explicit) {
      var expectedSize = String(size || "").toLowerCase();
      var style = String(state.selection.style || "").toLowerCase();
      var layout = this.commerce.legacyLayoutOption(state.selection.layout);
      var variants = this.purchasableCatalogVariants(this.productCatalog).filter(function(variant) {
        return this.catalogVariantOption(variant, 0) === expectedSize
          && (!explicit.style || state.selection.engine !== "legacy"
            || this.catalogVariantOption(variant, 1) === style)
          && (!explicit.layout || state.selection.engine !== "legacy"
            || this.catalogVariantOption(variant, 2) === String(layout || "").toLowerCase());
      }, this);

      var legacyModernPricing = this.usesLegacyModernPricing();

      if (explicit.style && state.selection.engine === "modern") {
        if (expectedSize !== "a5") {
          return [];
        }
        if (!legacyModernPricing) {
          // New Colourful: one variant per layout, whatever the paper.
          return this.newColourfulPriceVariants(expectedSize, explicit.layout ? state.selection.layout : null);
        }
        var pricingStyle = state.selection.paperColour === "cream" ? "luxury" : "classic";
        var modernLayouts = Object.keys(this.contract && this.contract.modernVariants || {}).map(function(key) {
          return String(this.commerce.legacyLayoutOptions[key] || "").trim().toLowerCase();
        }, this).filter(Boolean);
        return this.purchasableCatalogVariants(this.productCatalog).filter(function(variant) {
          var variantStyle = this.catalogVariantOption(variant, 1);
          var variantLayout = this.catalogVariantOption(variant, 2);
          return this.catalogVariantOption(variant, 0) === "a5"
            && modernLayouts.indexOf(variantLayout) !== -1
            && (explicit.paper || explicit.layout
              ? variantStyle === pricingStyle
              : ["classic", "luxury"].indexOf(variantStyle) !== -1)
            && (!explicit.layout || variantLayout === String(layout || "").toLowerCase());
        }, this);
      }
      if (!explicit.style && !legacyModernPricing) {
        // Before a style is chosen the floor also covers the modern styles.
        variants = variants.concat(this.newColourfulPriceVariants(expectedSize, null));
      }
      return variants;
    }

    // Only fills that sell at this size are priced, with that size's own
    // variant: a Personal preview-only fill has no offer, never the A5 one.
    undatedPriceVariants(size, selectedFillKey, productType) {
      var fills = this.contract && this.contract.undatedFills
        ? this.contract.undatedFills
        : {};
      var catalog = this.commerceCatalogs.undated || { variants: [] };
      var seen = new Set();
      return Object.keys(fills).reduce(function(variants, key) {
        var fill = fills[key];
        var purchase;
        var live;
        if (
          selectedFillKey && key !== selectedFillKey
          || !fill
          || fill.status !== "ready"
          || !fill.variantId
          || Array.isArray(fill.sizes) && fill.sizes.indexOf(size) === -1
        ) {
          return variants;
        }
        purchase = this.undatedPurchase({
          journey: { productType: productType, undatedFill: key },
          selection: { size: size }
        }, key);
        if (purchase.status !== "ready" || !purchase.variantId) {
          return variants;
        }
        live = this.commerce.findVariantById(catalog, purchase.variantId);
        if (
          live.status === "ready"
          && (!purchase.productHandle
            || String(live.variant.productHandle || "").trim().toLowerCase() === purchase.productHandle)
          && !seen.has(Number(live.variant.id))
        ) {
          seen.add(Number(live.variant.id));
          variants.push(live.variant);
        }
        return variants;
      }.bind(this), []);
    }

    resolvePriceOffer(state) {
      var explicit = this.priceChoiceContext(state);
      var productType = state.journey.productType;
      var sizes;
      var exactRefill = false;
      var candidates = [];
      var selectedType = explicit.refillType ? state.journey.refillType : null;
      var currency = this.commerceCatalogs.currency || "GBP";
      var organiser = this.organiserFor(state);
      var commerce = this.commerce;
      // Prices the organiser with its refill (display only); submitToCart
      // passes it to buildCartItems, which adds the organiser line, bundled
      // or at full price.
      var organiserVariant = organiser ? {
        id: organiser.variantId,
        productHandle: organiser.handle,
        title: organiser.title,
        available: true,
        price: organiser.priceCents
      } : null;

      if (productType !== "clipbook" && productType !== "refill") {
        return null;
      }

      if (productType === "clipbook" && selectedType === "none") {
        // A Clipbook cover on its own is its Print-to-order variant alone.
        (explicit.size ? [state.selection.size] : ["a5", "personal"]).forEach(function(size) {
          this.clipbookBaseVariants(size).forEach(function(baseVariant) {
            candidates.push({
              offerKey: [productType, size, baseVariant.id].join(":"),
              items: [{ role: "clipbook", variant: baseVariant, quantity: 1 }]
            });
          });
        }, this);
        return this.commerce.resolveOfferCandidates(candidates, explicit.size, currency);
      }

      if (productType === "clipbook") {
        sizes = explicit.size ? [state.selection.size] : ["a5", "personal"];
      } else if (selectedType === "dated") {
        sizes = explicit.size ? [state.selection.size] : ["a4", "a5", "personal"];
      } else if (!selectedType) {
        sizes = ["a4", "a5", "personal"];
      } else {
        sizes = [state.selection.size || "a5"];
      }

      if (selectedType === "undated") {
        exactRefill = explicit.undatedFill;
      } else if (selectedType === "dated") {
        exactRefill = explicit.size
          && explicit.style
          && explicit.layout;
      }

      // Before the refill is chosen a Clipbook starts at its cover alone
      // (Cover Only), the lowest price it sells at.
      var coverOnlyFrom = productType === "clipbook" && !selectedType && this.coverOnlyOffered(state);

      sizes.forEach(function(size) {
        var baseVariants = productType === "clipbook"
          ? this.clipbookBaseVariants(size)
          : [null];
        var refillVariants = [];
        if (!selectedType || selectedType === "dated") {
          refillVariants = refillVariants.concat(
            this.datedPriceVariants(state, size, selectedType === "dated" ? explicit : {
              style: false,
              layout: false
            })
          );
        }
        if (!selectedType || selectedType === "undated") {
          refillVariants = refillVariants.concat(
            this.undatedPriceVariants(size, exactRefill ? state.journey.undatedFill : null, productType)
          );
        }
        baseVariants.forEach(function(baseVariant) {
          if (baseVariant && coverOnlyFrom) {
            candidates.push({
              offerKey: [productType, size, baseVariant.id].join(":"),
              items: [{ role: "clipbook", variant: baseVariant, quantity: 1 }]
            });
          }
          refillVariants.forEach(function(refillVariant) {
            var items = [];
            if (baseVariant) {
              items.push({ role: "clipbook", variant: baseVariant, quantity: 1 });
            } else if (organiserVariant) {
              // The organiser is always bought; only a Design Your Own refill
              // of its size is 30% off with it.
              items.push({
                role: "organiser",
                variant: organiserVariant,
                quantity: 1,
                bundled: size === organiser.size && commerce.isOrganiserRefillVariant(refillVariant)
              });
            }
            items.push({ role: "refill", variant: refillVariant, quantity: 1 });
            candidates.push({
              offerKey: [productType, size].concat(items.map(function(item) {
                return item.variant.id;
              })).join(":"),
              items: items
            });
          });
        });
      }, this);

      return this.commerce.resolveOfferCandidates(
        candidates,
        Boolean(
          explicit.refillType
          && (productType !== "clipbook" || explicit.size)
          && exactRefill
        ),
        currency
      );
    }

    offerPriceText(offer) {
      var formatted;
      var previewPrice = dyofPreviewOfferPrice(offer);
      if (!previewPrice || previewPrice.mode === "none") {
        return dyofT("cfg.price.unavailable", "Price unavailable");
      }
      formatted = dyofDisplayMoney(this, previewPrice.amount, previewPrice.currency);
      if (!formatted) {
        return dyofT("cfg.price.unavailable", "Price unavailable");
      }
      return previewPrice.mode === "from"
        ? dyofT("cfg.price.from_amount", "From {amount}", { amount: formatted })
        : dyofT("cfg.price.price_amount", "Price {amount}", { amount: formatted });
    }

    setToolbarPriceText(value) {
      if (!this.elements || !this.elements.price) {
        return;
      }
      var rendered = String(value || "").trim();
      var labelled = /^(Price|From)(?:\s+(.*))?$/.exec(rendered);
      if (root.DYOFI18n) {
        var prefixes = [dyofT("cfg.price.label", "Price"), dyofT("cfg.price.from_label", "From")];
        labelled = null;
        prefixes.some(function(prefix) {
          if (rendered === prefix || rendered.indexOf(prefix + " ") === 0) {
            labelled = [rendered, prefix, rendered.slice(prefix.length).trim()];
            return true;
          }
          return false;
        });
      }
      var label = this.elements.priceLabel;
      var amount = this.elements.priceAmount;
      if (!label || !amount) {
        this.elements.price.textContent = rendered;
        return;
      }
      if (labelled) {
        label.hidden = false;
        label.textContent = labelled[1];
        amount.textContent = labelled[2] || "";
        return;
      }
      label.hidden = true;
      label.textContent = "";
      amount.textContent = rendered;
    }

    undatedProductionError(state) {
      if (
        !state
        || !state.journey
        || state.journey.refillType !== "undated"
      ) {
        return null;
      }
      var fill = this.contract && typeof this.contract.getUndatedFill === "function"
        ? this.contract.getUndatedFill(state.journey.undatedFill)
        : this.contract && this.contract.undatedFills
          ? this.contract.undatedFills[state.journey.undatedFill]
          : null;
      var purchase = fill ? this.undatedPurchase(state) : null;
      // The page count is the chosen size's; a size that does not sell (or
      // only previews) the fill is stopped by validateState instead. A stock
      // fill needs no production pages: the printer prints the standard fill.
      if (!fill || purchase.status !== "ready" || Number(purchase.pageCount) > 0 || purchase.stockFill === true) {
        return null;
      }
      return dyofT("cfg.cart.production_pdf_missing", "The complete production PDF for this Undated refill is not available yet, so it cannot be added to cart.");
    }

    // Last check before anything is saved: an Undated refill line at a size
    // other than A5 must be that size's own ready variant and never one of
    // the A5 Everyday or Journal variants (a Personal customer would get an
    // A5 print). Returns the stop message, or "".
    undatedSizeCartError(state, purchaseItems) {
      if (
        !state
        || !state.journey
        || state.journey.refillType !== "undated"
        || !state.selection
        || state.selection.size === "a5"
      ) {
        return "";
      }
      var fills = this.contract && this.contract.undatedFills ? this.contract.undatedFills : {};
      var a5Ids = Object.keys(fills).reduce(function(ids, key) {
        [fills[key].variantId, fills[key].plannerVariantId].forEach(function(id) {
          if (id) {
            ids.push(String(id));
          }
        });
        return ids;
      }, []);
      var purchase = this.undatedPurchase(state);
      var refillItems = (Array.isArray(purchaseItems) ? purchaseItems : []).filter(function(item) {
        return item && item.role !== "clipbook";
      });
      var allowed = refillItems.length > 0
        && purchase.status === "ready"
        && Boolean(purchase.variantId)
        && a5Ids.indexOf(String(purchase.variantId)) === -1
        && refillItems.every(function(item) {
          var id = String(item.variant && item.variant.id);
          return id === String(purchase.variantId) && a5Ids.indexOf(id) === -1;
        });
      return allowed
        ? ""
        : dyofT("cfg.cart.undated_fill_unavailable", "This undated fill is not available to purchase yet.");
    }

    resolveCartVariant(state) {
      var fill;
      var purchase;
      var fallbackId;

      if (
        state.journey.productType === "planner"
        && state.journey.refillType === "dated"
      ) {
        return this.datedPlannerVariant(state);
      }

      if (
        state.journey.productType === "planner"
        && state.journey.refillType === "undated"
      ) {
        return this.undatedPlannerVariant(state);
      }

      if (state.journey.refillType === "dated" && state.selection.engine === "legacy") {
        return this.commerce.resolveLegacyVariant(this.productCatalog, state.selection);
      }

      if (state.journey.refillType === "undated") {
        fill = this.contract.undatedFills
          ? this.contract.undatedFills[state.journey.undatedFill]
          : null;
        // The size's own variant only: Personal never carts the A5 fill.
        purchase = fill ? this.undatedPurchase(state) : null;
        if (!fill || !purchase || purchase.status !== "ready" || !purchase.variantId) {
          return {
            status: "missing",
            variant: null,
            message: dyofT("cfg.cart.undated_fill_unavailable", "This undated fill is not available to purchase yet.")
          };
        }
        return {
          status: "ready",
          variant: {
            id: Number(purchase.variantId),
            sku: purchase.sku || null,
            available: true,
            price: Number(purchase.price)
          },
          message: null
        };
      }

      if (state.journey.refillType === "dated" && state.selection.engine === "modern") {
        if (!this.usesLegacyModernPricing()) {
          return this.newColourfulVariant(state.selection);
        }
        var pricingSelection = this.modernPricingSelection(state.selection);
        var modernPurchase = pricingSelection
          ? this.commerce.resolveLegacyVariant(this.productCatalog, pricingSelection)
          : { status: "missing", variant: null };
        if (modernPurchase.status !== "ready") {
          modernPurchase.message = dyofT("cfg.cart.modern_refill_missing", "This modern dated refill configuration does not have a matching Shopify variant yet.");
        }
        return modernPurchase;
      }

      fallbackId = Number(this.dataset.variantId);
      if (!Number.isFinite(fallbackId) || fallbackId <= 0) {
        return {
          status: "invalid",
          variant: null,
          message: dyofT("cfg.cart.variant_unavailable", "The product variant is unavailable. Refresh the page and try again.")
        };
      }

      return this.commerce.findVariantById(this.productCatalog, fallbackId);
    }

    normalizeLegacyCommerceSelection(state) {
      var purchase;
      var fallbackLayout;
      var selectionAction;
      var planner = state && state.journey.productType === "planner";
      var modern = state && state.selection.engine === "modern";

      // Never silently substitute a different product for a saved Daily
      // Planner. State validation sends it back to Layout for an explicit choice.
      if (planner && state.selection.layout === "daily") { return false; }

      if (
        !state
        || (!planner && state.journey.productType !== "refill")
        || state.journey.refillType !== "dated"
        || (!planner && modern)
        || ["legacy", "modern"].indexOf(state.selection.engine) === -1
      ) {
        return false;
      }

      purchase = planner
        ? this.datedPlannerVariant(state)
        : this.commerce.resolveLegacyVariant(this.productCatalog, state.selection);
      if (purchase.status === "ready") {
        return false;
      }

      fallbackLayout = modern
        ? ["daily", "weekly", "vertical-weekly", "monthly"].find(function(layout) {
          if (planner && layout === "daily") { return false; }
          if (!(this.contract && this.contract.modernVariants || {})[layout]) { return false; }
          return this.datedPlannerVariant({
            journey: state.journey,
            selection: Object.assign({}, state.selection, { layout: layout })
          }).status === "ready";
        }, this)
        : this.commerce.firstAvailableLegacyLayout(
          planner ? this.trustedPlannerCatalog() : this.productCatalog,
          state.selection
        );
      if (!fallbackLayout || fallbackLayout === state.selection.layout) {
        return false;
      }
      if (planner && fallbackLayout === "daily") { return false; }

      this.invalidateDatedFlowFromStage(state, modern ? "layout" : "legacy-layout");
      selectionAction = {
        type: "SET_SELECTION",
        payload: { layout: fallbackLayout }
      };
      if (
        planner && modern
        && ["planner-details", "personal-dates", "review"].indexOf(state.screen) !== -1
      ) {
        // A newly substituted layout must be chosen before Review. Apply the
        // selection and route change atomically; never migrate the saved record.
        selectionAction.meta = { requireDatedLayoutConfirmation: true };
      }
      this.store.dispatch(selectionAction);
      return true;
    }

    // Add to cart can wait for a date check, a save and cart previews. Repeat
    // clicks are ignored and the button stays busy until it has finished; once
    // the cart page is loading it stays busy until this page is left.
    async addToCart() {
      var added = false;
      var button = this.elements && this.elements.reviewAddToCart;
      var ownerDocument = root.document;
      var started;
      var hadFocus;
      if (this.addToCartInFlight) {
        return;
      }
      this.addToCartInFlight = true;
      this.cartMediaAttempt = { startedAt: this.cartMediaNow(), logged: false };
      started = this.store.getState();
      hadFocus = Boolean(button && ownerDocument && ownerDocument.activeElement === button);
      this.clearCartStatus();
      this.clearReviewStop();
      this.renderAddToCartBusy();
      try {
        added = await this.submitToCart();
      } finally {
        if (!this.cartMediaAttempt.logged) {
          this.logCartMedia(started, undefined, "cart-cancelled", this.cartMediaAttempt.startedAt, null);
        }
        this.cartMediaAttempt = null;
        this.addToCartLeaving = added;
        if (!added) {
          this.finishAddToCart();
          // Disabling the focused button sent keyboard focus to the page.
          if (hadFocus && !button.disabled && this.isAddToCartCurrent(started)
            && (!ownerDocument.activeElement || ownerDocument.activeElement === ownerDocument.body)) {
            this.focusElementWithoutScroll(button);
          }
        }
      }
    }

    // Add to cart waits for checks, saves and optional media. Once the customer has
    // left Review or changed the design, it stops without adding to cart,
    // leaving the page or reporting anything.
    isAddToCartCurrent(started) {
      var state = this.store.getState();
      return state.screen === started.screen && state.revision === started.revision;
    }

    finishAddToCart() {
      var status = this.elements && this.elements.reviewCartStatus;
      this.addToCartInFlight = false;
      if (status && status.dataset.status === "loading") {
        this.clearCartStatus();
      }
      this.renderAddToCartBusy();
    }

    renderAddToCartBusy() {
      var button = this.elements && this.elements.reviewAddToCart;
      if (!button || typeof button.setAttribute !== "function") {
        return;
      }
      if (this.cartMediaPreparing) {
        if (this.cartMediaButtonLabel == null) { this.cartMediaButtonLabel = button.textContent; }
        button.textContent = dyofT("cfg.cart.preparing_cart_preview", "Preparing your cart preview…");
      } else if (this.cartMediaButtonLabel != null) {
        button.textContent = this.cartMediaButtonLabel;
        this.cartMediaButtonLabel = null;
      }
      if (this.addToCartInFlight) {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        return;
      }
      button.removeAttribute("aria-busy");
      this.updateReviewCheckoutAvailability(this.store.getState());
    }

    // Add to cart is pressed on Review, where the step messages and the
    // preview status are hidden: its progress and failures are shown under
    // the Review buttons, in a status of their own the review pages never use.
    setCartStatus(state, message, status) {
      var region = this.elements && this.elements.reviewCartStatus;
      if (state.screen !== "review" || !region) {
        return;
      }
      region.textContent = message;
      region.dataset.status = status;
      // It sits under Save for later, which can be the bottom of the screen.
      if (status === "error" && typeof region.scrollIntoView === "function") {
        region.scrollIntoView({ block: "nearest" });
      }
    }

    clearCartStatus() {
      var region = this.elements && this.elements.reviewCartStatus;
      if (region && (region.textContent || region.dataset.status)) {
        region.textContent = "";
        delete region.dataset.status;
      }
    }

    failAddToCart(state, message) {
      this.appendMessage(message, "error");
      this.setCartStatus(state, message, "error");
    }

    // The list of stops beside Add to cart is not a live region. A stop found
    // on Review by Add to cart, Save for later or the date check is read out
    // once in a visually hidden status.
    announceReviewStop(state, message) {
      var region = this.elements && this.elements.reviewAlert;
      if (region && state.screen === "review" && message && region.textContent !== message) {
        region.textContent = message;
      }
    }

    clearReviewStop() {
      if (this.elements && this.elements.reviewAlert) {
        this.elements.reviewAlert.textContent = "";
      }
    }

    async submitToCart() {
      var state = this.store.getState();
      var resume = this.getEditorResumeState(state);
      var validation = this.stateApi.validateState(state, holidayValidationMessages(this));
      var productionError;
      var contentGate;
      var purchase;
      var offer;
      var purchaseItems;
      if (
        state.screen === "review"
        && (!this.reviewConfirmations.details || !this.reviewConfirmations.policy)
      ) {
        this.failAddToCart(state, dyofT("cfg.cart.confirm_review", "Confirm both review statements before adding this product to cart."));
        return;
      }
      if (!validation.valid) {
        this.failAddToCart(state, validation.errors[0]);
        return;
      }
      if (this.contentCheck && this.contentCheck.status === "pending") {
        this.setCartStatus(state, dyofT("cfg.cart.checking_dates", "Checking your dates…"), "loading");
        await this.waitForContentCheck(state);
        if (!this.isAddToCartCurrent(state)) {
          return;
        }
      }
      contentGate = this.contentCheckGate(state);
      if (!contentGate.valid) {
        this.appendMessage(contentGate.message, "error");
        this.renderContentCheckOutcome();
        return;
      }
      productionError = this.undatedProductionError(state);
      if (productionError) {
        this.failAddToCart(state, productionError);
        return;
      }
      offer = this.resolvePriceOffer(state);
      if (offer) {
        if (offer.status !== "ready" || !offer.items.length) {
          this.failAddToCart(state, offer.message || dyofT("cfg.cart.finish_choosing", "Finish choosing the product before adding it to cart."));
          return;
        }
        purchaseItems = offer.items;
      } else {
        purchase = this.resolveCartVariant(state);
        if (purchase.status !== "ready") {
          this.failAddToCart(state, purchase.message || dyofT("cfg.cart.configuration_unavailable", "This configuration is not available to purchase."));
          return;
        }
        purchaseItems = [{ role: state.journey.productType, variant: purchase.variant, quantity: 1 }];
      }
      // The organiser rides in the offer for its price only.
      var organiser = purchaseItems.some(function(item) { return item.role === "organiser"; })
        ? this.organiserFor(state)
        : null;
      purchaseItems = purchaseItems.filter(function(item) { return item.role !== "organiser"; });
      var undatedSizeError = this.undatedSizeCartError(state, purchaseItems);
      if (undatedSizeError) {
        this.failAddToCart(state, undatedSizeError);
        return;
      }
      var manifest = this.coverEditor ? await this.coverEditor.getAssetManifest(state) : [];
      if (!this.isAddToCartCurrent(state)) {
        return;
      }
      // Only missing production originals block a purchase. A saved or
      // securely stored photo remains printable without its browser preview.
      var missingPhotoMessage = this.coverEditor && typeof this.coverEditor.assetIds === "function"
        ? missingUploadedPhotoMessage(state, this.coverEditor.assetIds(state), manifest)
        : "";
      if (missingPhotoMessage) {
        this.failAddToCart(state, missingPhotoMessage);
        return;
      }
      if (!this.baseConfigurationId && manifest.some(function(asset) {
        return !asset.remoteUrl && !hasPrivateStorageFields(asset);
      })) {
        this.failAddToCart(state, dyofT("cfg.cart.upload_storage", "One or more uploaded files have not reached secure production storage. Upload them again before adding to cart."));
        return;
      }
      // The manifest has now loaded every upload record, so re-check photo
      // resolution with complete pixel dimensions before saving the order.
      validation = this.stateApi.validateState(state, holidayValidationMessages(this));
      if (!validation.valid) {
        this.appendMessage(validation.errors[0], "error");
        // Review now lists the stop beside Add to cart, disables it and reads it out.
        if (state.screen === "review" && this.elements) {
          this.renderReview(this.store.getState());
          this.announceReviewStop(state, validation.errors[0]);
        }
        return;
      }
      var intent = this.stateApi.getOrderIntent(state);
      var serverRecord;
      var productionRole = purchaseItems.some(function(item) {
        return item.role === "clipbook";
      }) ? "clipbook" : purchaseItems[0].role;
      var cartItems;
      try {
        serverRecord = await this.persistConfiguration(state, resume);
      } catch (error) {
        if (this.isAddToCartCurrent(state)) {
          this.failAddToCart(state, dyofErrorMessage(error, dyofT("cfg.cart.configuration_service_unavailable", "The order configuration service is unavailable.")));
        }
        return;
      }
      if (!this.isAddToCartCurrent(state)) {
        return;
      }
      var orderReference = String(serverRecord && serverRecord.orderReference || "");
      if (!/^dyoforder_[a-f0-9]{32}$/.test(orderReference)) {
        this.failAddToCart(state, dyofT("cfg.cart.fulfillment_unavailable", "The fulfillment reference service is unavailable. Your design was not added to cart."));
        return;
      }
      this.setPreviewStatus(dyofT("cfg.cart.preparing_cart_preview", "Preparing your cart preview…"), "loading");
      this.setCartStatus(state, dyofT("cfg.cart.preparing_cart_preview", "Preparing your cart preview…"), "loading");
      var mediaReference = await this.optionalCartMediaReference(state, serverRecord);
      if (!this.isAddToCartCurrent(state)) {
        return;
      }
      var orderEvent = new CustomEvent("dyof:orderintent", {
        bubbles: true,
        cancelable: true,
        detail: scrubRestoreCapabilities({ orderReference: orderReference, intent: intent })
      });
      if (!this.dispatchEvent(orderEvent)) {
        return;
      }
      var publicLabels = {
        design: state.cover.background ? state.cover.background.title : state.selection.style,
        size: sizeLabel(state.selection.size)
      };
      // A Clipbook cover on its own has no Refill or Layout on its cart line.
      if (state.journey.refillType === "undated") {
        // An Undated line names its fill, not the dated layout last shown.
        var undatedFill = this.contract.getUndatedFill(state.journey.undatedFill);
        publicLabels.refill = undatedFill ? dyofDisplayLabel(undatedFill.label) : state.journey.undatedFill;
        publicLabels.layout = dyofT("cfg.render.undated_refill", "Undated Refill");
      } else if (state.journey.refillType !== "none") {
        publicLabels.refill = state.selection.style;
        publicLabels.layout = state.selection.engine === "legacy"
          ? this.commerce.legacyLayoutOption(state.selection.layout)
          : state.selection.layout;
      }
      try {
        cartItems = this.commerce.buildCartItems({
          purchaseItems: purchaseItems,
          currency: this.commerceCatalogs && this.commerceCatalogs.currency,
          orderReference: orderReference,
          mediaReference: mediaReference,
          productionRole: productionRole,
          // Picks a Clipbook's Interior Colour code; the colour is always White.
          size: state.selection.size,
          coverOnly: state.journey.refillType === "none",
          // An organiser line first, then this refill at 30% off (bundle-filo).
          organiser: organiser ? {
            variantId: organiser.variantId,
            priceCents: organiser.priceCents,
            title: organiser.title,
            size: organiser.size
          } : null,
          publicLabels: publicLabels,
          // Safe lookup markers only. The private media itself is resolved from
          // a separate body-only media capability and is never a cart URL.
          cartMedia: {
            clipbook: "cover",
            planner: "cover",
            refill: "refill"
          }
        });
      } catch (error) {
        this.failAddToCart(state, dyofErrorMessage(error, dyofT("cfg.cart.prepare_failed", "This configuration could not be prepared for cart.")));
        return;
      }
      if (this.usesOrderSummary()) {
        // The summary opens over Review; Add to cart is usable again after it.
        this.setPreviewStatus("", "ready");
        this.clearCartStatus();
        this.openOrderSummary(state, cartItems, purchaseItems, serverRecord, orderReference);
        return false;
      }
      this.setPreviewStatus(dyofT("cfg.cart.adding", "Adding your configuration to cart…"), "loading");
      this.setCartStatus(state, dyofT("cfg.cart.adding", "Adding your configuration to cart…"), "loading");
      try {
        var response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({
            items: cartItems
          })
        });
        if (!response.ok) {
          throw dyofCustomerError(dyofT("cfg.cart.http_error", "The cart returned HTTP {status}.", { status: response.status }));
        }
        if (organiser) {
          // The organiser is in the cart now. Clearing the button's cart note
          // and attributes means Back and Add to cart cannot add it twice.
          this.organiserContext = null;
          try {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify({ note: "", attributes: { variant: "", variant2: "" } })
            });
          } catch (error) {
            // The order is already in the cart; a stale note only matters on a repeat add.
          }
        }
        // Once the cart has the design, the cart page follows even if the
        // customer has since left Review.
        root.location.assign("/cart");
        return true;
      } catch (error) {
        if (!this.isAddToCartCurrent(state)) {
          return false;
        }
        var cartError = dyofErrorMessage(error, dyofT("cfg.cart.add_failed", "The configuration could not be added to cart."));
        this.setPreviewStatus(cartError, "error");
        this.setCartStatus(state, cartError, "error");
      }
      return false;
    }

    render(state) {
      if (this.restoringConfiguration) {
        this.renderRestoringConfiguration();
        return;
      }
      this.prepareCartThumbnails(state);
      // Cover text is measured before this render writes to the page, so a
      // measurement that needs layout (Safari's unkerned probe) stays cheap
      // and the preview below reuses it.
      if (
        (state.screen === "front-cover" || state.screen === "back-cover")
        && this.coverEditor
        && typeof this.coverEditor.prepareTextMetrics === "function"
      ) {
        this.coverEditor.prepareTextMetrics(state);
      }
      var descriptor = this.stateApi.getPreviewDescriptor(state);
      this.renderHero(state);
      if (state.screen === "review") {
        this.renderStep(state);
        this.renderMessages(state);
        this.renderTags(state);
        this.renderReview(state);
        this.renderPreviewMode(state);
        return;
      }
      this.clearDatedFlowDisabled();
      this.renderControlVisibility(state);
      this.renderOrganiserPreviewNote(state);
      // The refill choice lists are hidden on the cover screens, where typing
      // redrew them on every keystroke. They are drawn once there, and again
      // by the first render on any other screen (every screen change renders).
      if (!COVER_SCREENS_WITHOUT_REFILL_CHOICES[state.screen] || !this.dynamicChoicesRendered) {
        this.renderDynamicChoices(state);
        this.dynamicChoicesRendered = true;
      }
      // The Planner details and dates panels are hidden on every other screen
      // (and Review renders itself), so they are drawn when shown. Every
      // screen change renders them afresh.
      if (state.screen === "planner-details" || state.screen === "personal-dates") {
        this.renderPersonalise(state);
      } else {
        this.ensurePeriodAnchorMonth(state);
      }
      this.renderDatedFlow(state);
      this.renderPressedStates(state);
      // After renderDatedFlow, whose automatic choices feed the step gates.
      this.renderStep(state);
      this.renderMessages(state);
      this.renderTags(state);
      if (this.coverEditor) {
        this.coverEditor.render(state);
      }
      if (root.DYOFPrintableText) {
        root.DYOFPrintableText.flagInputs(this, state);
      }

      this.renderRefillMenus(state);
      this.renderCoverOnly(state);
      if (this.elements.startMonth) {
        this.elements.startMonth.value = state.selection.startMonth;
      }
      if (this.elements.legacyStartMonth) {
        this.elements.legacyStartMonth.value = state.selection.startMonth;
      }
      if (this.elements.previewStage && descriptor.renderer !== "server") {
        this.elements.previewStage.dataset.paper = effectivePaperColour(state);
      }

      this.renderPreviewMode(state);
    }

    renderRefillMenus(state) {
      if (this.elements.datedHeading) {
        this.elements.datedHeading.textContent = state.journey.productType === "refill"
          ? dyofT("cfg.render.dated_refill", "Dated Refill") : dyofT("cfg.render.refill", "Refill");
      }
      var value = state.journey.refillType === "undated" ? "undated" : "dated";
      // Cover only keeps the menu on its "Select Refill Type" placeholder.
      var hasExplicitChoice = state.journey.refillType !== "none"
        && (state.screen !== "refill-type" || this.didChooseRefillType);
      var label = hasExplicitChoice
        ? value === "undated" ? dyofT("cfg.render.undated_refill", "Undated Refill") : dyofT("cfg.render.dated_refill", "Dated Refill")
        : dyofT("cfg.render.select_refill_type", "Select Refill Type");
      (this.elements.refillMenuLabels || []).forEach(function(node) {
        var field = node.closest && node.closest(".dyof__refill-type-field");
        if (field) {
          field.hidden = state.journey.productType === "refill";
        }
      });
      (this.elements.refillMenuLabels || []).forEach(function(node) {
        node.textContent = label;
      });
      (this.elements.refillMenuOptions || []).forEach(function(option) {
        option.setAttribute(
          "aria-selected",
          String(hasExplicitChoice && option.dataset.dyofRefillOption === value)
        );
      });
    }

    // "No refill, thanks": the Clipbook cover on its own (opt-out switch, like
    // the Elastic closure one). Planner and standalone Refill never show it.
    renderCoverOnly(state) {
      var coverOnly = state.journey.refillType === "none";
      if (this.elements.coverOnlyField) {
        this.elements.coverOnlyField.hidden = !this.coverOnlyOffered(state);
      }
      if (this.elements.coverOnlyToggle) {
        this.elements.coverOnlyToggle.checked = coverOnly;
      }
      if (this.elements.coverOnlyNote) {
        // The note stays mounted as a live region and only its text changes, so
        // screen readers announce "All set!" when the switch turns on. Its text
        // is the server-rendered translation in data-dyof-cover-only-note.
        var note = coverOnly ? this.elements.coverOnlyNote.dataset.dyofCoverOnlyNote || "" : "";
        if (this.elements.coverOnlyNote.textContent !== note) {
          this.elements.coverOnlyNote.textContent = note;
        }
      }
    }

    /** Clipbook only; a store profile can leave it out (the Czech store does). */
    coverOnlyOffered(state) {
      return state.journey.productType === "clipbook"
        && !(this.storeProfile && this.storeProfile.coverOnly === false);
    }

    setCoverOnly(enabled) {
      var state = this.store.getState();
      if (!this.coverOnlyOffered(state) || (state.journey.refillType === "none") === Boolean(enabled)) {
        this.renderCoverOnly(state);
        return;
      }
      this.closeRefillMenus();
      if (enabled) {
        this.didChooseUndatedFill = false;
        this.resetDatedFlow();
        this.discardRetainedLayoutPreview();
        this.store.dispatch({ type: "SET_REFILL_TYPE", payload: "none" });
        return;
      }
      // Back to choosing a refill: the menu shows its placeholder and Next waits.
      this.didChooseRefillType = false;
      this.store.dispatch({ type: "SET_REFILL_TYPE", payload: "dated" });
    }

    resetDatedFlow() {
      this.datedFlowExplicitFields.clear();
      this.datedFlowVisibleThrough = 0;
      this.datedFlowPendingIndex = null;
      this.datedFlowComplete = false;
      this.datedFlowWaiting = false;
    }

    invalidateDatedFlowFromStage(state, stageName) {
      var sequence = this.getDatedFlowSequence(state);
      var stageIndex = sequence.indexOf(stageName);
      if (stageIndex === -1) {
        return false;
      }
      sequence.slice(stageIndex).forEach(function(name) {
        var prefix = name + ":";
        Array.from(this.datedFlowExplicitFields).forEach(function(key) {
          if (key.indexOf(prefix) === 0) {
            this.datedFlowExplicitFields.delete(key);
          }
        }, this);
      }, this);
      this.datedFlowVisibleThrough = Math.min(
        Math.max(0, Number(this.datedFlowVisibleThrough) || 0),
        stageIndex
      );
      this.datedFlowPendingIndex = null;
      this.datedFlowComplete = false;
      this.datedFlowWaiting = false;
      return true;
    }

    resetTransientConfigurationUi() {
      clearTimeout(this.previewTimer);
      this.previewTimer = 0;
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      this.discardRetainedLayoutPreview();
      this.clearPreviewContentIdentity();
      this.releasePreviewUrls();
      if (this.elements && this.elements.previewPages) {
        clearChildren(this.elements.previewPages);
      }
      this.releaseLayoutPreviewCacheEntries();
      this.lastCommittedLayoutPreviewCacheKey = null;
      this.didChooseRefillType = false;
      this.didChooseUndatedFill = false;
      this.undatedPreviewKey = null;
      this.undatedPreviewIdentity = null;
      this.undatedPreviewPendingKey = null;
      this.undatedPreviewPendingIdentity = null;
      if (this.undatedPreviewAbortController) {
        this.undatedPreviewAbortController.abort();
        this.undatedPreviewAbortController = null;
      }
      this.reviewNavigationGeneration = Number(this.reviewNavigationGeneration || 0) + 1;
      this.reviewNavigationBusy = false;
      this.reviewRevision = null;
      this.reviewKey = null;
      this.reviewMountedIdentity = null;
      this.pendingReloadReviewDestination = null;
      this.reloadReviewDestinationRestoring = false;
      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
        this.reviewAbortController = null;
      }
      this.discardReviewPreload();
      this.discardReviewCoverPreload();
      this.reviewConfirmations = { details: false, policy: false };
      this.discardReviewNextSpread();
      this.reviewRendererVersion = "";
      this.reviewConfirmationRevision = null;
      this.personalDateColour = "";
      this.personalDateDay = "";
      this.personalDateMonth = "";
      this.personalDateFrequency = "";
      if (this.elements && this.elements.personalDateLabel) {
        this.elements.personalDateLabel.value = "";
        if (root.DYOFPrintableText) {
          root.DYOFPrintableText.clearNotice(this.elements.personalDateLabel);
        }
      }
      if (this.elements && this.elements.personalDateError) {
        this.elements.personalDateError.textContent = "";
      }
      this.periodAnchorMonth = null;
      this.openRefillMenu = null;
      this.openPlannerMenu = null;
      this.resetDatedFlow();
      this.cancelPersonalDateAddCheck();
      if (this.coverEditor && this.coverEditor.invalidatePreview) {
        this.coverEditor.invalidatePreview();
      }
      if (this.coverEditor && this.coverEditor.resetExplicitChoices) {
        this.coverEditor.resetExplicitChoices();
      }
    }

    handleCoverSizeFlowChange(state, previous) {
      var fill;
      var sizes;
      if (
        !state
        || !previous
        || !state.selection
        || !previous.selection
        || state.selection.size === previous.selection.size
      ) {
        return false;
      }

      this.resetDatedFlow();
      this.discardRetainedLayoutPreview();
      this.undatedPreviewKey = null;
      this.undatedPreviewIdentity = null;
      this.undatedPreviewPendingIdentity = null;
      if (state.journey.refillType === "undated" && this.didChooseUndatedFill) {
        fill = this.contract && this.contract.getUndatedFill
          ? this.contract.getUndatedFill(state.journey.undatedFill)
          : null;
        sizes = fill && Array.isArray(fill.sizes) ? fill.sizes : null;
        if (sizes && sizes.indexOf(state.selection.size) === -1) {
          this.didChooseUndatedFill = false;
        }
      }
      return true;
    }

    markRestoredRefillChoices() {
      var state = this.store.getState();
      var sequence;
      var route = this.stateApi.getRoute(state);
      var screenIndex = route.indexOf(state.screen);
      var coverSelectionIndex = route.indexOf("cover-selection");
      var refillTypeIndex = route.indexOf("refill-type");
      var datedLayoutIndex = route.indexOf("dated-layout");
      var undatedLayoutIndex = route.indexOf("undated-layout");
      if (this.coverEditor && this.coverEditor.resetExplicitChoices) {
        this.coverEditor.resetExplicitChoices();
      }
      if (
        this.coverEditor
        && this.coverEditor.markRestoredChoices
        && state.journey.productType !== "refill"
        && coverSelectionIndex !== -1
        && screenIndex > coverSelectionIndex
      ) {
        this.coverEditor.markRestoredChoices();
      }
      this.didChooseRefillType = refillTypeIndex !== -1 && screenIndex > refillTypeIndex;
      this.didChooseUndatedFill = state.journey.refillType === "undated"
        && undatedLayoutIndex !== -1
        && screenIndex > undatedLayoutIndex;
      this.resetDatedFlow();
      if (
        state.journey.refillType !== "dated"
        || datedLayoutIndex === -1
        || screenIndex <= datedLayoutIndex
      ) {
        return;
      }
      sequence = this.getDatedFlowSequence(state);
      this.querySelectorAll("[data-dyof-dated-stage] [data-dyof-field]").forEach(function(control) {
        var stage = control.closest("[data-dyof-dated-stage]");
        if (stage && sequence.indexOf(stage.dataset.dyofDatedStage) !== -1) {
          this.datedFlowExplicitFields.add(
            stage.dataset.dyofDatedStage + ":" + control.dataset.dyofField
          );
        }
      }, this);
      this.datedFlowVisibleThrough = Math.max(0, sequence.length - 1);
      this.datedFlowPendingIndex = null;
      this.datedFlowComplete = true;
      this.datedFlowWaiting = false;
    }

    getDatedFlowSequence(state) {
      var sequence = [];
      var legacyLayout;
      var legacyControls;

      if (state.journey.productType === "refill") {
        sequence.push("size");
      }
      sequence.push("style");

      if (state.selection.engine === "legacy") {
        sequence.push("legacy-layout");
        legacyLayout = this.contract.getLegacyLayout
          ? this.contract.getLegacyLayout(state.selection.layout)
          : null;
        legacyControls = legacyLayout ? legacyLayout.controls || [] : [];
        if (["lineStyle", "calendar", "notes", "appointmentTimes"].some(function(field) {
          return legacyControls.indexOf(field) !== -1;
        })) {
          sequence.push("legacy-design");
        }
        return sequence;
      }

      return sequence.concat([
        "colour-mode",
        "paper",
        "layout",
        "view",
        "date-position",
        "day-design",
        "header"
      ]).filter(function(stageName) {
        return stageName !== "date-position"
          || this.contract.getSupportedDatePositions(state.selection).length > 1;
      }, this);
    }

    legacyControlsFor(state) {
      var layout = state.selection.engine === "legacy" && this.contract.getLegacyLayout
        ? this.contract.getLegacyLayout(state.selection.layout)
        : null;
      return layout ? layout.controls || [] : [];
    }

    isDatedStageGroupApplicable(group, state) {
      var requiredLegacyControl = group && group.dataset
        ? group.dataset.dyofLegacyControl
        : "";
      if (group && group.dataset && group.dataset.dyofLegacyAddGroup !== undefined) {
        var controls = this.legacyControlsFor(state);
        return state.journey.refillType === "dated"
          && state.selection.engine === "legacy"
          && (controls.indexOf("lineStyle") === -1
            || this.datedFlowExplicitFields.has("legacy-design:lineStyle"));
      }
      if (!requiredLegacyControl) {
        return true;
      }
      return state.journey.refillType === "dated"
        && state.selection.engine === "legacy"
        && this.legacyControlsFor(state).indexOf(requiredLegacyControl) !== -1;
    }

    prepareDatedFlowChoice(control) {
      var state = this.store.getState();
      var stage = control.closest("[data-dyof-dated-stage]");
      var sequence;
      var index;

      if (state.screen !== "dated-layout" || !stage) {
        return true;
      }

      sequence = this.getDatedFlowSequence(state);
      index = sequence.indexOf(stage.dataset.dyofDatedStage);
      if (
        index === -1
        || index > this.datedFlowVisibleThrough
      ) {
        return false;
      }

      var nextStyle = control.dataset.dyofField === "style" && this.contract && this.contract.getStyle
        ? this.contract.getStyle(control.dataset.dyofValue)
        : null;
      var keepModernChoices = state.selection && state.selection.engine === "modern"
        && nextStyle && nextStyle.engine === "modern"
        && this.datedFlowExplicitFields.has("style:style");
      var replaceUnavailableColour = state.selection && state.selection.engine === "modern"
        && control.dataset.dyofField === "singleColour"
        && this.datedFlowExplicitFields.has("colour-mode:colourMode")
        && !this.datedFlowExplicitFields.has("colour-mode:singleColour")
        && index < this.datedFlowVisibleThrough;
      var keepModernColourChoices = state.selection && state.selection.engine === "modern"
        && stage.dataset.dyofDatedStage === "colour-mode"
        && (control.dataset.dyofField === "colourMode"
          ? ["single-colour", "signature-multicolour"].indexOf(control.dataset.dyofValue) !== -1
          : control.dataset.dyofField === "singleColour"
            && this.contract.getSingleColours(state.selection.style).some(function(option) {
              return option.value === control.dataset.dyofValue;
            }));
      if (keepModernChoices || replaceUnavailableColour || keepModernColourChoices && index < this.datedFlowVisibleThrough) {
        this.datedFlowExplicitFields.add(stage.dataset.dyofDatedStage + ":" + control.dataset.dyofField);
        if (keepModernColourChoices) {
          this.datedFlowExplicitFields.add("colour-mode:colourMode");
          if (control.dataset.dyofField === "singleColour" || control.dataset.dyofValue === "single-colour") {
            this.datedFlowExplicitFields.add("colour-mode:singleColour");
          }
        }
        if (keepModernChoices && state.selection.colourMode === "single-colour"
          && !this.contract.getSingleColours(control.dataset.dyofValue).some(function(option) {
            return option.value === state.selection.singleColour;
          })) {
          this.datedFlowExplicitFields.delete("colour-mode:singleColour");
        }
        this.datedFlowPendingIndex = null;
        this.datedFlowWaiting = false;
        return true;
      }

      sequence.slice(
        stage.dataset.dyofDatedStage === "legacy-design" ? index + 1 : index
      ).forEach(function(stageName) {
        var prefix = stageName + ":";
        Array.from(this.datedFlowExplicitFields).forEach(function(key) {
          if (key.indexOf(prefix) === 0) {
            this.datedFlowExplicitFields.delete(key);
          }
        }, this);
      }, this);
      this.datedFlowExplicitFields.add(
        stage.dataset.dyofDatedStage + ":" + control.dataset.dyofField
      );
      if (control.dataset.dyofField === "singleColour") {
        this.datedFlowExplicitFields.add(
          stage.dataset.dyofDatedStage + ":colourMode"
        );
      }
      if (
        control.dataset.dyofField === "colourMode"
        && control.dataset.dyofValue === "single-colour"
      ) {
        this.datedFlowExplicitFields.add(
          stage.dataset.dyofDatedStage + ":singleColour"
        );
      }

      this.datedFlowVisibleThrough = Math.min(
        index + 1,
        Math.max(0, sequence.length - 1)
      );
      this.datedFlowPendingIndex = null;
      this.datedFlowComplete = index >= sequence.length - 1;
      this.datedFlowWaiting = false;
      return true;
    }

    datedFlowPreviewReady(state) {
      if (!state || state.preview.status === "error") {
        return false;
      }
      return state.preview.status === "ready"
        || this.hasCurrentLayoutPreviewVisual(state);
    }

    advanceDatedFlowPendingChoice(state) {
      var sequence;
      if (!state || this.datedFlowPendingIndex === null) {
        return false;
      }
      sequence = this.getDatedFlowSequence(state);
      this.datedFlowComplete = this.datedFlowPendingIndex >= sequence.length;
      this.datedFlowVisibleThrough = Math.min(
        this.datedFlowPendingIndex,
        Math.max(0, sequence.length - 1)
      );
      this.datedFlowPendingIndex = null;
      return true;
    }

    completeDatedFlowChoiceWithoutSelection(state) {
      if (!state || state.screen !== "dated-layout") {
        return;
      }
      var hasCurrentVisual = this.hasMountedLayoutPreview()
        && this.currentLayoutVisualKey
        && this.currentLayoutVisualKey === this.layoutPreviewVisualKey(state)
        && this.elements.previewPages.dataset.dyofPreviewSource !== "predefined-layout";
      var needsAuthoritativePreview = this.shouldRequestPreview(state)
        && state.preview.status === "idle"
        && !hasCurrentVisual;
      this.datedFlowWaiting = false;
      this.datedFlowPendingIndex = null;
      this.render(state);
      if (this.layoutPreviewCacheEnabled()) {
        this.retainLayoutPreviewCacheEntriesForState(state);
        this.showCachedLayoutPreview(state);
        this.preloadLayoutPreviewCandidates(state);
      }
      // The first visible choice can equal the normalized internal default
      // (for example Gradient). That customer action still needs to mount a
      // preview even though SET_SELECTION correctly remains a no-op.
      if (needsAuthoritativePreview) {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
        this.schedulePreview(state, true);
      }
      this.persistReloadResumeState(state);
    }

    acceptCurrentLayoutPreviewCacheVisual(state) {
      if (
        !state
        || state.screen !== "dated-layout"
        || !this.hasCurrentLayoutPreviewCacheVisual(state)
      ) {
        return;
      }
      this.datedFlowWaiting = false;
      this.advanceDatedFlowPendingChoice(state);
      this.render(state);
      this.retainLayoutPreviewCacheEntriesForState(state);
      this.preloadLayoutPreviewCandidates(state);
    }

    updateDatedFlowFromAction(state, action) {
      if (!action || state.screen !== "dated-layout") {
        return;
      }
      if (
        /^PREVIEW_(REQUESTED|SUCCEEDED|FAILED)$/.test(action.type)
        && (!action.payload || action.payload.requestKey !== state.preview.requestKey)
      ) {
        return;
      }
      if (!/^PREVIEW_(REQUESTED|SUCCEEDED|FAILED)$/.test(action.type)) {
        return;
      }
      this.datedFlowWaiting = false;
      this.datedFlowPendingIndex = null;
    }

    clearDatedFlowDisabled() {
      this.querySelectorAll("[data-dyof-flow-disabled]").forEach(function(button) {
        button.disabled = false;
        button.removeAttribute("aria-disabled");
        button.removeAttribute("tabindex");
        delete button.dataset.dyofFlowDisabled;
      });
    }

    datedFlowGate(state) {
      if (state.journey.productType === "planner" && state.journey.refillType === "dated"
        && state.selection.layout === "daily"
        && ["dated-layout", "planner-details", "personal-dates", "review"].indexOf(state.screen) !== -1) {
        return { valid: false, message: dyofT("cfg.render.planner_daily_unavailable", "Daily is not available for Planner & Notebook. Choose a different layout.") };
      }
      if (
        state.screen === "cover-selection"
        && this.coverEditor
        && this.coverEditor.hasExplicitSizeChoice
        && !this.coverEditor.hasExplicitSizeChoice()
      ) {
        return { valid: false, message: dyofT("cfg.render.choose_cover_size", "Choose A5 or Personal to continue.") };
      }
      if (state.screen === "refill-type" && !this.didChooseRefillType && state.journey.refillType !== "none") {
        return { valid: false, message: dyofT("cfg.render.choose_refill_type", "Choose Dated or Undated Refill to continue.") };
      }
      if (state.screen === "undated-layout" && !this.didChooseUndatedFill) {
        return { valid: false, message: dyofT("cfg.render.choose_undated", "Choose an undated refill to continue.") };
      }
      if (
        state.journey.productType === "planner"
        && state.journey.refillType === "undated"
        && (state.screen === "undated-layout" || state.screen === "review")
        && !this.undatedFillAvailableForProduct(state, state.journey.undatedFill)
      ) {
        return { valid: false, message: dyofT("cfg.render.planner_undated_unavailable", "This Undated refill is not available as a Planner product. Choose an available refill.") };
      }
      if (
        state.screen === "undated-layout"
        && this.didChooseUndatedFill
        && (
          this.undatedPreviewKey !== state.journey.undatedFill
          || this.undatedPreviewIdentity !== this.undatedPreviewRequestKey(
            state,
            state.journey.undatedFill
          )
          || !this.hasMountedUndatedPreview(state.journey.undatedFill)
        )
      ) {
        return { valid: false, message: dyofT("cfg.render.wait_undated_preview", "Wait until the Undated refill preview is visible.") };
      }
      if (state.screen !== "dated-layout") {
        return { valid: true, message: "" };
      }
      if (state.selection.engine === "modern"
        && state.selection.colourMode === "single-colour"
        && this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has("colour-mode:colourMode")
        && !this.datedFlowExplicitFields.has("colour-mode:singleColour")) {
        return { valid: false, message: dyofT("cfg.render.choose_available_colour", "Choose an available colour for this style before continuing.") };
      }
      if (state.preview.status === "error") {
        return { valid: false, message: dyofT("cfg.render.retry_preview", "Retry the preview before continuing.") };
      }
      if (
        state.preview.status !== "ready"
        || !state.preview.pages
        || !state.preview.pages.length
        || this.datedFlowWaiting
      ) {
        return { valid: false, message: dyofT("cfg.render.wait_refill_preview", "Wait until the refill preview is visible.") };
      }
      if (!this.datedFlowComplete) {
        return { valid: false, message: dyofT("cfg.render.complete_refill_choice", "Complete the visible refill choice to continue.") };
      }
      return { valid: true, message: "" };
    }

    autoSelectSingleDatedStages(state, sequence) {
      var stageName;
      var groups;
      var choices;
      var toggles;
      var choice;
      var selected;

      if (
        state.screen !== "dated-layout"
      ) {
        return;
      }

      while (!this.datedFlowComplete) {
        stageName = sequence[this.datedFlowVisibleThrough];
        groups = Array.from(this.querySelectorAll("[data-dyof-dated-stage]")).filter(function(group) {
          return group.dataset.dyofDatedStage === stageName
            && this.isDatedStageGroupApplicable(group, state);
        }, this);
        choices = groups.reduce(function(items, group) {
          return items.concat(Array.from(group.querySelectorAll(
            "button[data-dyof-field]:not([disabled]):not([data-dyof-toggle-field])"
          )));
        }, []);
        toggles = groups.reduce(function(items, group) {
          return items.concat(Array.from(group.querySelectorAll(
            "button[data-dyof-field][data-dyof-toggle-field]:not([disabled])"
          )));
        }, []);

        if (choices.length > 1 || (choices.length === 0 && toggles.length === 0)) {
          return;
        }

        if (choices.length === 1) {
          choice = choices[0];
          selected = state.selection[choice.dataset.dyofField];
          if (String(selected) !== String(choice.dataset.dyofValue)) {
            return;
          }

          this.datedFlowExplicitFields.add(
            stageName + ":" + choice.dataset.dyofField
          );
        }
        if (this.datedFlowVisibleThrough >= sequence.length - 1) {
          this.datedFlowComplete = true;
          return;
        }
        this.datedFlowVisibleThrough += 1;
      }
    }

    renderDatedFlow(state) {
      var groups = this.querySelectorAll("[data-dyof-dated-stage]");
      var panel = this.querySelector("[data-dyof-panel='dated-layout']");
      var sequence;
      var blocked;

      if (state.screen !== "dated-layout") {
        if (this.elements.datedFlowStatus) {
          this.elements.datedFlowStatus.textContent = "";
          this.elements.datedFlowStatus.hidden = true;
        }
        return;
      }

      sequence = this.getDatedFlowSequence(state);
      this.datedFlowVisibleThrough = Math.min(
        this.datedFlowVisibleThrough,
        Math.max(0, sequence.length - 1)
      );
      this.autoSelectSingleDatedStages(state, sequence);
      if (this.elements.paperWeightNote) {
        this.elements.paperWeightNote.hidden = !this.datedFlowExplicitFields.has("style:style");
        this.elements.paperWeightNote.textContent = this.elements.paperWeightNote.hidden
          ? ""
          : state.selection.style === "luxury"
            ? dyofT("cfg.render.paper_weight_luxury", "This refill style features 90gsm cream paper.")
            : dyofT("cfg.render.paper_weight_standard", "This refill style features 100gsm paper.");
      }
      blocked = false;

      groups.forEach(function(group) {
        var index = sequence.indexOf(group.dataset.dyofDatedStage);
        var isVisible = this.isDatedStageGroupApplicable(group, state)
          && index !== -1
          && index <= this.datedFlowVisibleThrough;
        group.hidden = !isVisible;
      }, this);

      if (panel) {
        panel.removeAttribute("aria-busy");
      }
      if (!this.elements.datedFlowStatus) {
        return;
      }
      var organiserNote = this.organiserNote(state);
      this.elements.datedFlowStatus.hidden = state.journey.productType === "refill" && !organiserNote;
      this.elements.datedFlowStatus.textContent = this.elements.datedFlowStatus.hidden
        ? ""
        : organiserNote || dyofT("cfg.render.choose_refill_options", "Choose your refill options and see your design in the preview.");
    }

    renderHero(state) {
      var productType = ["clipbook", "planner", "refill"].indexOf(state.journey.productType) !== -1
        ? state.journey.productType
        : "clipbook";
      var copy = {
        clipbook: [dyofT("cfg.render.clipbook", "Clipbook"), dyofT("cfg.render.clipbook_subtitle", "A flexible organiser for everyday planning.")],
        planner: [dyofT("cfg.render.planner_notebook", "Planner & Notebook"), dyofT("cfg.render.planner_subtitle", "Portable, refillable and built for your lifestyle.")],
        refill: [dyofT("cfg.render.diary_refill", "Diary Refill"), dyofT("cfg.render.refill_subtitle", "Find the layout that works for you.")]
      }[productType];
      var purchase;
      var price;
      var offer;

      if (this.elements.hero) {
        this.elements.hero.dataset.productType = productType;
      }
      if (this.elements.heroImage) {
        var heroImage = this.elements.heroImage.dataset[
          "hero" + productType.charAt(0).toUpperCase() + productType.slice(1)
        ];
        if (heroImage && this.elements.heroImage.getAttribute("src") !== heroImage) {
          this.elements.heroImage.setAttribute("src", heroImage);
        }
      }
      if (this.elements.heroTitle) {
        this.elements.heroTitle.textContent = copy[0];
      }
      if (this.elements.heroSubtitle) {
        this.elements.heroSubtitle.textContent = copy[1];
      }
      if (this.elements.price) {
        offer = this.resolvePriceOffer(state) || this.datedPlannerPriceOffer(state, false);
        if (offer) {
          this.setToolbarPriceText(this.offerPriceText(offer));
        } else if (
          state.journey.productType === "planner"
          && state.journey.refillType === "undated"
          || state.journey.productType === "refill"
            && (
              state.journey.refillType === "undated"
              || state.journey.refillType === "dated" && state.selection.engine === "legacy"
            )
        ) {
          purchase = this.resolveCartVariant(state);
          price = dyofPreviewVariantPrice(this, purchase.variant);
          this.setToolbarPriceText(purchase.status === "ready" && price
            ? dyofT("cfg.render.price", "Price {price}", { price: price })
            : purchase.status === "unavailable" && price
              ? dyofT("cfg.render.unavailable_price", "Unavailable · {price}", { price: price })
              : dyofT("cfg.render.unavailable", "Unavailable"));
        } else {
          this.setToolbarPriceText(state.journey.productType === "refill"
            ? dyofFallbackPrice(this, state, 1200)
            : dyofFallbackPrice(this, state, 2200));
        }
      }
      if (this.elements.printConfirmation) {
        var confirmed = ["front", "back"].some(function(sideName) {
          return state.cover[sideName].objects.some(function(object) {
            return object.type === "text"
              && Boolean(object.overflowWarningFor)
              && object.overflowAcceptedFor === object.overflowWarningFor;
          });
        });
        this.elements.printConfirmation.hidden = !confirmed;
        this.elements.printConfirmation.setAttribute("aria-label", confirmed ? dyofT("cfg.render.print_confirmed", "Print as shown confirmed") : "");
      }
      this.dataset.productType = state.journey.productType;
    }

    renderPersonalise(state) {
      var controls = this.contract.controls || {};
      var isMinimal = state.selection.style === "minimal";
      var firstPageColours = isMinimal
        ? controls.minimalFirstPageColours || ["#666666"]
        : controls.firstPageColours || ["#FFFFFF", "#1C1B1A"];

      this.elements.firstPageInputs.forEach(function(input) {
        var value = state.firstPage[input.dataset.dyofFirstPage] || "";
        if (input.value !== value) {
          input.value = value;
        }
      });

      this.renderPersonalColourChoices(
        this.elements.firstPageColourList,
        firstPageColours,
        "firstPage",
        state.firstPage.textColor
      );
      if (this.elements.firstPageColourControl) {
        this.elements.firstPageColourControl.hidden = false;
      }
      this.renderPersonalColourChoices(
        this.elements.personalDateColourList,
        controls.personalisationColours,
        "personalDate",
        this.personalDateColour
      );
      this.renderValueChoices(
        this.elements.personalStartDayList,
        "startDay",
        this.contract.getSupportedStartDays(state.selection),
        function(value) {
          return controlLabel("startDay", value);
        }
      );
      this.renderPeriodOptions(state);

      this.elements.countryHolidayToggle.checked =
        state.features.countryHolidays.enabled;
      this.elements.countryHolidayControls.hidden =
        !state.features.countryHolidays.enabled;
      this.elements.religiousHolidayToggle.checked =
        state.features.religiousHolidays.enabled;
      this.elements.religiousHolidayControls.hidden =
        !state.features.religiousHolidays.enabled;
      this.elements.moonToggle.checked = state.features.moonPhases.enabled;
      this.elements.moonControls.hidden = !state.features.moonPhases.enabled;

      this.renderHolidayGroupChoices(
        this.elements.countryHolidayList,
        "countryHolidays",
        controls.countryHolidayGroups,
        state.features.countryHolidays.groups
      );
      this.renderHolidayGroupChoices(
        this.elements.religiousHolidayList,
        "religiousHolidays",
        controls.religiousHolidayGroups,
        state.features.religiousHolidays.groups
      );
      this.renderHolidayChips(
        this.elements.countryHolidayChips,
        "countryHolidays",
        state.features.countryHolidays.groups
      );
      this.renderHolidayChips(
        this.elements.religiousHolidayChips,
        "religiousHolidays",
        state.features.religiousHolidays.groups
      );
      this.filterHolidayChoices(
        this.elements.countryHolidayList,
        this.elements.countrySearch.value
      );
      this.filterHolidayChoices(
        this.elements.religiousHolidayList,
        this.elements.religiousSearch.value
      );
      this.renderMoonOffsets(
        controls.moonTimezoneOffsets,
        state.features.moonPhases.timezoneOffset
      );
      this.filterMoonChoices(this.elements.moonSearch ? this.elements.moonSearch.value : "");
      this.renderPlannerMenuVisibility();
      this.renderPersonalDateDraftControls();
      this.renderPersonalDates(state);
    }

    // The period list opens around the start month of the first render, even
    // when Planner details is drawn later.
    ensurePeriodAnchorMonth(state) {
      if (!this.elements.personalPeriodList || !this.elements.personalPeriodLabel) {
        return false;
      }
      if (!this.periodAnchorMonth) {
        this.periodAnchorMonth = shiftMonthValue(state.selection.startMonth, -1) || state.selection.startMonth;
      }
      return true;
    }

    renderPeriodOptions(state) {
      var duration = state.selection.documentLengthMonths;
      if (!this.ensurePeriodAnchorMonth(state)) {
        return;
      }
      clearChildren(this.elements.personalPeriodList);
      for (var index = 0; index < 7; index += 1) {
        var startMonth = shiftMonthValue(this.periodAnchorMonth, index);
        var button = document.createElement("button");
        button.type = "button";
        button.textContent = plannerPeriodLabel(startMonth, duration);
        button.dataset.dyofPeriodStart = startMonth;
        button.setAttribute("role", "option");
        button.setAttribute("aria-selected", String(startMonth === state.selection.startMonth));
        this.elements.personalPeriodList.appendChild(button);
      }
      this.elements.personalPeriodLabel.textContent = plannerPeriodLabel(
        state.selection.startMonth,
        duration
      );
    }

    renderPersonalColourChoices(container, colours, kind, selected) {
      if (!container) {
        return;
      }

      clearChildren(container);
      (colours || []).forEach(function(colour, index) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "dyof__personal-colour";
        button.style.backgroundColor = colour;
        button.setAttribute("aria-label", dyofT("cfg.render.colour_number", "Colour {number}: {colour}", { number: index + 1, colour: colour }));
        button.setAttribute("aria-pressed", String(colour === selected));
        if (kind === "firstPage") {
          button.dataset.dyofFirstPageColour = colour;
        } else {
          button.dataset.dyofPersonalDateColour = colour;
        }
        container.appendChild(button);
      });
    }

    renderPersonalDateDraftColours() {
      this.querySelectorAll("[data-dyof-personal-date-colour]").forEach(function(button) {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.dyofPersonalDateColour === this.personalDateColour)
        );
      }, this);
    }

    renderPersonalDateDraftControls() {
      if (this.elements.personalDateDayLabel) {
        this.elements.personalDateDayLabel.textContent = this.personalDateDay || dyofT("cfg.render.day", "Day");
      }
      if (this.elements.personalDateMonthLabel) {
        this.elements.personalDateMonthLabel.textContent = this.personalDateMonth
          ? PERSONAL_DATE_MONTHS[Number(this.personalDateMonth) - 1]
          : dyofT("cfg.render.month", "Month");
      }
      this.querySelectorAll("[data-dyof-personal-date-day-option]").forEach(function(option) {
        option.setAttribute(
          "aria-selected",
          String(option.dataset.dyofPersonalDateDayOption === this.personalDateDay)
        );
      }, this);
      this.querySelectorAll("[data-dyof-personal-date-month-option]").forEach(function(option) {
        var monthIndex = Number(option.dataset.dyofPersonalDateMonthOption) - 1;
        if (PERSONAL_DATE_MONTHS[monthIndex]) {
          option.textContent = PERSONAL_DATE_MONTHS[monthIndex];
        }
        option.setAttribute(
          "aria-selected",
          String(option.dataset.dyofPersonalDateMonthOption === this.personalDateMonth)
        );
      }, this);
      this.querySelectorAll("[data-dyof-personal-date-frequency-option]").forEach(function(option) {
        option.setAttribute(
          "aria-checked",
          String(option.dataset.dyofPersonalDateFrequencyOption === this.personalDateFrequency)
        );
      }, this);
    }

    renderHolidayGroupChoices(container, feature, values, selectedValues) {
      if (!container) {
        return;
      }

      clearChildren(container);
      (values || []).forEach(function(value) {
        var label = document.createElement("label");
        var input = document.createElement("input");
        var text = document.createElement("span");
        label.dataset.dyofHolidayOption = "";
        input.type = "checkbox";
        input.value = value;
        input.checked = (selectedValues || []).indexOf(value) !== -1;
        input.dataset.dyofHolidayGroup = feature;
        text.textContent = dyofDisplayLabel(value);
        label.appendChild(input);
        label.appendChild(text);
        container.appendChild(label);
      });
    }

    renderHolidayChips(container, feature, selectedValues) {
      if (!container) {
        return;
      }
      clearChildren(container);
      (selectedValues || []).forEach(function(value) {
        var chip = document.createElement("span");
        var text = document.createElement("span");
        var remove = document.createElement("button");
        chip.className = "dyof__planner-chip";
        text.textContent = holidayDisplayLabel(feature, value);
        remove.type = "button";
        remove.textContent = "×";
        remove.dataset.dyofRemoveHolidayFeature = feature;
        remove.dataset.dyofRemoveHolidayValue = value;
        remove.setAttribute("aria-label", dyofT("cfg.render.remove", "Remove {label}", { label: holidayDisplayLabel(feature, value) }));
        chip.appendChild(text);
        chip.appendChild(remove);
        container.appendChild(chip);
      });
    }

    renderMoonOffsets(offsets, selected) {
      if (!this.elements.moonOffset) {
        return;
      }

      clearChildren(this.elements.moonOffset);
      (offsets || []).forEach(function(offset) {
        var option = document.createElement("button");
        option.type = "button";
        option.dataset.dyofMoonOffsetOption = String(offset);
        option.textContent = timezoneLabel(offset);
        option.setAttribute("role", "option");
        option.setAttribute("aria-selected", String(Number(selected) === Number(offset)));
        this.elements.moonOffset.appendChild(option);
      }, this);
      if (this.elements.moonOffsetLabel) {
        this.elements.moonOffsetLabel.textContent = timezoneLabel(selected);
      }
    }

    renderPersonalDates(state) {
      var list = this.elements.personalDateList;
      var dates = state.features.personalDates;
      var stateApi = this.stateApi;
      var unprintable = {};
      var markerId = "dyof-" + (this.id || "module") + "-personal-date-unprintable-";
      if (!list) {
        return;
      }

      // A restored name the print font cannot draw is marked where it can be
      // removed, not only on Review.
      if (root.DYOFPrintableText) {
        root.DYOFPrintableText.findIssues(state).forEach(function(issue) {
          unprintable[issue.key] = issue;
        });
      }
      clearChildren(list);
      this.elements.personalDateEmpty.hidden = dates.length > 0;
      dates.forEach(function(item, index) {
        var row = document.createElement("li");
        var copy = document.createElement("span");
        var remove = document.createElement("button");
        var issue = unprintable["personalDate:personalDates:" + index];
        var date = new Date(item.date + "T00:00:00Z");
        var dateOptions = { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" };
        var dateLabel = root.DYOFI18n
          ? root.DYOFI18n.date(date, dateOptions)
          : cachedDateFormat("en-GB", dateOptions).format(date);
        copy.textContent = dyofT("cfg.render.personal_date_row", "{date}: {label}{frequency}{range}{notice}", {
          date: dateLabel,
          label: item.label,
          frequency: item.frequency === "one-time" ? ""
            : dyofT("cfg.render.personal_date_frequency", " ({frequency})", { frequency: titleCase(item.frequency) }),
          // A date the start-month rebase cannot place (29 February) will not print.
          range: stateApi && stateApi.isPersonalDateInRange && !stateApi.isPersonalDateInRange(item, state.selection)
            ? dyofT("cfg.render.personal_date_out_of_range", " (not in this diary)") : "",
          notice: issue ? " " : ""
        });
        remove.type = "button";
        remove.textContent = "×";
        remove.dataset.dyofRemovePersonalDate = item.id;
        remove.setAttribute("aria-label", dyofT("cfg.render.remove", "Remove {label}", { label: item.label }));
        if (issue) {
          // A list row cannot be marked invalid; the remove button says why.
          var marker = document.createElement("span");
          marker.id = markerId + index;
          marker.textContent = dyofT("cfg.render.unprintable_date", "(can't be printed: remove it and add it again)");
          copy.appendChild(marker);
          remove.setAttribute("aria-describedby", marker.id);
        }
        row.appendChild(copy);
        row.appendChild(remove);
        list.appendChild(row);
      });
    }

    renderPersonalDatesScene() {
      clearChildren(this.elements.previewPages);
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "personal-dates";
      var scene = document.createElement("div");
      var image = document.createElement("img");
      var note = document.createElement("p");
      scene.className = "dyof__personal-dates-scene";
      image.src = this.dataset.personalDatesScene;
      image.alt = dyofT("cfg.render.personal_date_scene_alt", "Example diary page showing how personal dates and colours will appear");
      image.width = 711;
      image.height = 711;
      image.loading = "eager";
      image.decoding = "async";
      note.textContent = dyofT("cfg.render.personal_date_reference", "Reference only. Your dates and colours will be applied.");
      scene.appendChild(image);
      scene.appendChild(note);
      this.elements.previewPages.appendChild(scene);
      this.setPreviewStatus(dyofT("cfg.render.personal_date_reference", "Reference only. Your dates and colours will be applied."), "ready");
    }

    // Typing a first-page line redraws the page on every keystroke. Mounting a
    // new SVG makes the browser rebuild the whole scene and run style, layout
    // and paint for it again, though only a line changed (the scene
    // photographs are already decoded and are reused either way). When the
    // new page has the same structure, the mounted page takes its attributes
    // and text instead, and the result is the same page. In desktop Chromium
    // at phone width this measured about 1.5-3 ms less layout and raster per
    // keystroke.
    //
    // The render hid the desktop lens (clearPreviewContentIdentity). A new
    // page under a resting mouse makes Chromium send pointerenter, which shows
    // the lens again with the new text; an updated page does not, so a lens
    // that was showing is shown again here.
    mountInstantFirstPage(wrapper, lensWasShown) {
      var pages = this.elements.previewPages;
      var mounted = pages && pages.childNodes && pages.childNodes.length === 1
        ? pages.firstChild
        : null;
      if (mounted && morphPreviewTree(mounted, wrapper)) {
        // The page keeps its size and place, so the lens keeps its position.
        if (lensWasShown && this.previewMagnifierAllowed() && this.refreshPreviewMagnifier()) {
          this.elements.previewMagnifier.hidden = false;
        }
        return;
      }
      clearChildren(pages);
      pages.appendChild(wrapper);
    }

    previewMagnifierShown() {
      var lens = this.elements && this.elements.previewMagnifier;
      return Boolean(lens && lens.hidden === false);
    }

    renderInstantPersonalFirstPage(state) {
      var organiser = state.journey.productType === "refill";
      var lifestyle = organiser
        ? refillPreviewTemplate(state, this.merchandising)
        : personalClipbookLifestyle(state, this.merchandising);
      var sceneConfig = (organiser ? PERSONAL_ORGANISER_SCENES : PERSONAL_CLIPBOOK_SCENES)[lifestyle];
      var styleKey = PERSONAL_FIRST_PAGE_STYLES[state.selection.style]
        ? state.selection.style
        : "classic";
      var style = PERSONAL_FIRST_PAGE_STYLES[styleKey];
      var wrapper = document.createElement("div");
      var svg = createSvgElement("svg", {
        viewBox: "0 0 1600 1600",
        role: "img",
        "aria-label": dyofT("cfg.render.personal_first_page_alt", "Instant personalised Personal first-page preview")
      });
      var page = { x: 834, y: 438, width: 397, height: 716 };
      var trim = { width: 269.2906, height: 484.7244 };
      var scaleX = page.width / trim.width;
      var scaleY = page.height / trim.height;
      var lines = [state.firstPage.line1, state.firstPage.line2, state.firstPage.line3];
      var baseArtworkUrl = this.dataset[style.baseDataset]
        || this.dataset.personalFirstPageClassicBase;
      var sceneUrl = this.dataset[sceneConfig.frontSheetDataset]
        || this.dataset[organiser ? "personalOrganiserFrontSheetClassic" : "personalClipbookFrontSheetClassic"]
        || this.dataset.personalFirstPageScene;
      var layoutLabel = this.contract.getLegacyFirstPageLabel(state.selection);
      var point = function(x, y) {
        return { x: page.x + Number(x) * scaleX, y: page.y + Number(y) * scaleY };
      };
      var centeredText = function(rect, attributes, value) {
        var center = point(rect.x + rect.width / 2, rect.y + rect.height / 2);
        // The PDF draws these lines without kerning; the preview must match.
        return createSvgElement("text", Object.assign({
          x: String(center.x),
          y: String(center.y),
          "dominant-baseline": "middle",
          "text-anchor": "middle",
          style: "font-kerning:none;font-feature-settings:\"kern\" 0"
        }, attributes), value);
      };

      // A lens the mouse rests on is shown again with the updated page.
      var lensWasShown = this.previewMagnifierShown();
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "front-sheet";
      this.elements.previewPages.dataset.dyofFirstPageScene =
        (organiser ? "personal-organiser-front-" : "personal-clipbook-front-") + lifestyle;
      wrapper.className = "dyof__preview-page dyof__preview-page--instant";

      svg.appendChild(createSvgElement("rect", {
        x: String(page.x),
        y: String(page.y),
        width: String(page.width),
        height: String(page.height),
        fill: "#FFFFFF"
      }));
      if (baseArtworkUrl) {
        svg.appendChild(createSvgElement("image", {
          href: baseArtworkUrl,
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          preserveAspectRatio: "none"
        }));
      }
      if (effectivePaperColour(state) === "cream") {
        svg.appendChild(createSvgElement("rect", {
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          fill: "#F7F0DF",
          opacity: "0.68",
          style: "mix-blend-mode:multiply"
        }));
      }

      svg.appendChild(centeredText(style.layout, {
        fill: style.layout.color,
        "font-family": style.layout.fontFamily,
        "font-size": String(style.layout.fontSize * scaleY),
        "font-weight": style.layout.fontWeight
      }, layoutLabel));

      style.lines.forEach(function(rect, index) {
        svg.appendChild(centeredText(rect, {
          fill: state.firstPage.textColor || "#000000",
          "font-family": style.lineFontFamily,
          "font-size": String(8 * scaleY),
          "font-weight": style.lineFontWeight
        }, lines[index] || ""));
      });

      if (sceneUrl) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl,
          x: "0",
          y: "0",
          width: "1600",
          height: "1600",
          preserveAspectRatio: "none"
        }));
      }

      wrapper.appendChild(svg);
      this.mountInstantFirstPage(wrapper, lensWasShown);
      if (this.elements.previewTitle) {
        this.elements.previewTitle.textContent = dyofT("cfg.render.instant_first_page_title", "Instant first-page preview");
      }
      this.setPreviewStatus(
        dyofT("cfg.render.instant_first_page_status", "Updates immediately as you type — no PDF regeneration required."),
        "ready"
      );
    }

    renderInstantA4FirstPage(state) {
      var format = LEGACY_FIRST_PAGE_FORMATS.a4;
      var styleKey = format.styles[state.selection.style]
        ? state.selection.style
        : "classic";
      var style = format.styles[styleKey];
      var lifestyle = a4OrganiserLifestyle(state, this.merchandising);
      var sceneConfig = A4_ORGANISER_SCENES[lifestyle];
      var wrapper = document.createElement("div");
      var svg = createSvgElement("svg", {
        viewBox: "0 0 1600 1600",
        role: "img",
        "aria-label": dyofT("cfg.render.a4_first_page_alt", "Instant personalised A4 first-page preview")
      });
      var page = {
        x: A4_ORGANISER_PAGE.rightX,
        y: A4_ORGANISER_PAGE.top,
        width: A4_ORGANISER_PAGE.width,
        height: A4_ORGANISER_PAGE.height
      };
      var trim = format.trim;
      var scaleX = page.width / trim.width;
      var scaleY = page.height / trim.height;
      var lines = [state.firstPage.line1, state.firstPage.line2, state.firstPage.line3];
      var baseArtworkUrl = this.dataset[style.baseDataset];
      var sceneUrl = this.dataset[sceneConfig.frontSheetDataset]
        || this.dataset.a4OrganiserFrontSheetClassic;
      var layoutLabel = this.contract.getLegacyFirstPageLabel(state.selection);
      var point = function(x, y) {
        return { x: page.x + Number(x) * scaleX, y: page.y + Number(y) * scaleY };
      };
      var centeredText = function(rect, attributes, value) {
        var center = point(rect.x + rect.width / 2, rect.y + rect.height / 2);
        // The PDF draws these lines without kerning; the preview must match.
        return createSvgElement("text", Object.assign({
          x: String(center.x),
          y: String(center.y),
          "dominant-baseline": "middle",
          "text-anchor": "middle",
          style: "font-kerning:none;font-feature-settings:\"kern\" 0"
        }, attributes), value);
      };

      // A lens the mouse rests on is shown again with the updated page.
      var lensWasShown = this.previewMagnifierShown();
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "front-sheet";
      this.elements.previewPages.dataset.dyofFirstPageScene =
        "a4-organiser-front-" + lifestyle;
      wrapper.className = "dyof__preview-page dyof__preview-page--instant";

      svg.appendChild(createSvgElement("rect", {
        x: String(page.x),
        y: String(page.y),
        width: String(page.width),
        height: String(page.height),
        fill: "#FFFFFF"
      }));
      if (baseArtworkUrl) {
        svg.appendChild(createSvgElement("image", {
          href: baseArtworkUrl,
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          preserveAspectRatio: "none"
        }));
      }
      if (effectivePaperColour(state) === "cream") {
        svg.appendChild(createSvgElement("rect", {
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          fill: "#F7F0DF",
          opacity: "0.68",
          style: "mix-blend-mode:multiply"
        }));
      }

      svg.appendChild(centeredText(style.layout, {
        fill: style.layoutColor,
        "font-family": style.layoutFontFamily,
        "font-size": String(style.layoutFontSize * scaleY),
        "font-weight": style.fontWeight
      }, layoutLabel));
      style.lines.forEach(function(rect, index) {
        svg.appendChild(centeredText(rect, {
          fill: state.firstPage.textColor || style.layoutColor,
          "font-family": style.lineFontFamily,
          "font-size": String(style.lineFontSize * scaleY),
          "font-weight": style.fontWeight
        }, lines[index] || ""));
      });

      if (sceneUrl) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl,
          x: "0",
          y: "0",
          width: "1600",
          height: "1600",
          preserveAspectRatio: "none"
        }));
      }

      wrapper.appendChild(svg);
      this.mountInstantFirstPage(wrapper, lensWasShown);
      if (this.elements.previewTitle) {
        this.elements.previewTitle.textContent = dyofT("cfg.render.instant_first_page_title", "Instant first-page preview");
      }
      this.setPreviewStatus(
        dyofT("cfg.render.instant_first_page_status", "Updates immediately as you type — no PDF regeneration required."),
        "ready"
      );
    }

    firstPageProductScene(state) {
      var product = state && state.journey && state.journey.productType;
      var size = state && state.selection && state.selection.size;
      if (!this.dataset || ["clipbook", "refill", "planner"].indexOf(product) === -1) {
        return null;
      }
      var scene = this.openSpreadScene(state);
      if (size === "a5") {
        var frontSheetKey = A5_FRONT_SHEET_SCENES[product][scene.previewTemplate];
        if (frontSheetKey && this.dataset[frontSheetKey]) {
          // The editor and Review share the supplied inside-cover photograph.
          // Its only transparent paper aperture is the personalised right page.
          var page = product === "planner"
            ? { x: 812, y: 436, width: 513, height: 723 }
            : product === "clipbook"
              ? { x: 823, y: 435, width: 510, height: 719 }
              : { x: 958, y: 440, width: 503, height: 713 };
          return Object.assign({}, scene, {
            id: "a5-" + product + "-" + scene.previewTemplate + "-front-sheet",
            image: this.dataset[frontSheetKey],
            width: 1600,
            height: 1600,
            frontSheet: true,
            page: page
          });
        }
      }
      var config = null;
      if (size === "personal" && product !== "planner") {
        config = (product === "refill" ? PERSONAL_ORGANISER_SCENES : PERSONAL_CLIPBOOK_SCENES)[scene.previewTemplate];
      } else if (size === "a4" && product === "refill") {
        config = A4_ORGANISER_SCENES[scene.previewTemplate];
      }
      if (config && this.dataset[config.frontSheetDataset]) {
        return Object.assign({}, scene, {
          id: scene.id + "-front-sheet",
          image: this.dataset[config.frontSheetDataset],
          frontSheet: true
        });
      }
      if (size === "a5" && product === "refill" && scene.image && scene.id !== "a5") {
        return Object.assign({}, scene, {
          id: scene.id + "-first-page",
          frontSheet: false,
          page: { x: 958, y: 440, width: 503, height: 713 },
          leftPage: { x: 426, y: 440, width: 503, height: 713 }
        });
      }
      return null;
    }

    renderInstantLegacyFirstPage(state) {
      if (state.selection.size === "personal") {
        this.renderInstantPersonalFirstPage(state);
        return;
      }

      if (state.selection.size === "a4") {
        this.renderInstantA4FirstPage(state);
        return;
      }

      var format = LEGACY_FIRST_PAGE_FORMATS[state.selection.size];
      var styleKey = format && format.styles[state.selection.style]
        ? state.selection.style
        : "classic";
      var style = format && format.styles[styleKey];
      var productScene = this.firstPageProductScene(state);
      var sceneSize = productScene ? productScene.width : 1378;
      var wrapper = document.createElement("div");
      var svg = createSvgElement("svg", {
        viewBox: "0 0 " + sceneSize + " " + sceneSize,
        role: "img",
        "aria-label": dyofT("cfg.render.legacy_first_page_alt", "Instant personalised legacy first-page preview")
      });
      var page = productScene ? productScene.page : { x: 708, y: 374, width: 439, height: 621 };
      var trim = format && format.trim;
      var scaleX;
      var scaleY;
      var lines = [state.firstPage.line1, state.firstPage.line2, state.firstPage.line3];
      var baseArtworkUrl;
      var sceneUrl = productScene ? productScene.image : this.dataset.firstPageScene;
      var layoutLabel = this.contract.getLegacyFirstPageLabel(state.selection);
      var point;
      var centeredText;

      if (!format || !style || !trim) {
        this.renderPreviewPlaceholder(
          dyofT("cfg.render.legacy_first_page_unavailable", "The legacy first-page preview is not available for this size yet."),
          sizeLabel(state.selection.size),
          "front-sheet"
        );
        return;
      }

      scaleX = page.width / trim.width;
      scaleY = page.height / trim.height;
      baseArtworkUrl = this.dataset[style.baseDataset];
      point = function(x, y) {
        return { x: page.x + Number(x) * scaleX, y: page.y + Number(y) * scaleY };
      };
      centeredText = function(rect, attributes, value) {
        var center = point(rect.x + rect.width / 2, rect.y + rect.height / 2);
        // The PDF draws these lines without kerning; the preview must match.
        return createSvgElement("text", Object.assign({
          x: String(center.x),
          y: String(center.y),
          "dominant-baseline": "middle",
          "text-anchor": "middle",
          style: "font-kerning:none;font-feature-settings:\"kern\" 0"
        }, attributes), value);
      };

      // A lens the mouse rests on is shown again with the updated page.
      var lensWasShown = this.previewMagnifierShown();
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "front-sheet";
      this.elements.previewPages.dataset.dyofFirstPageScene =
        productScene ? productScene.id : "legacy-" + state.selection.size + "-" + styleKey;
      wrapper.className = "dyof__preview-page dyof__preview-page--instant";

      if (productScene && productScene.leftPage) {
        svg.appendChild(createSvgElement("rect", Object.assign({}, productScene.leftPage, {
          fill: effectivePaperColour(state) === "cream" ? "#F7F0DF" : "#FFFFFF"
        })));
      } else if (!productScene && sceneUrl) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl,
          x: "0",
          y: "0",
          width: "1378",
          height: "1378",
          preserveAspectRatio: "none"
        }));
      }
      svg.appendChild(createSvgElement("rect", {
        x: String(page.x),
        y: String(page.y),
        width: String(page.width),
        height: String(page.height),
        fill: "#FFFFFF"
      }));
      if (baseArtworkUrl) {
        svg.appendChild(createSvgElement("image", {
          href: baseArtworkUrl,
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          preserveAspectRatio: "none"
        }));
      }
      if (effectivePaperColour(state) === "cream") {
        svg.appendChild(createSvgElement("rect", {
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          fill: "#F7F0DF",
          opacity: "0.68",
          style: "mix-blend-mode:multiply"
        }));
      }

      svg.appendChild(centeredText(style.layout, {
        fill: style.layoutColor,
        "font-family": style.layoutFontFamily,
        "font-size": String(style.layoutFontSize * scaleY),
        "font-weight": style.fontWeight
      }, layoutLabel));
      style.lines.forEach(function(rect, index) {
        svg.appendChild(centeredText(rect, {
          fill: state.firstPage.textColor || style.layoutColor,
          "font-family": style.lineFontFamily,
          "font-size": String(style.lineFontSize * scaleY),
          "font-weight": style.fontWeight
        }, lines[index] || ""));
      });

      if (productScene) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl, x: "0", y: "0", width: String(sceneSize), height: String(sceneSize),
          preserveAspectRatio: "none", "data-dyof-first-page-product-layer": productScene.id
        }));
      }

      wrapper.appendChild(svg);
      this.mountInstantFirstPage(wrapper, lensWasShown);
      if (this.elements.previewTitle) {
        this.elements.previewTitle.textContent = dyofT("cfg.render.instant_first_page_title", "Instant first-page preview");
      }
      this.setPreviewStatus(
        dyofT("cfg.render.instant_first_page_status", "Updates immediately as you type — no PDF regeneration required."),
        "ready"
      );
    }

    renderInstantFirstPage(state) {
      if (state.selection.engine === "legacy") {
        this.renderInstantLegacyFirstPage(state);
        return;
      }

      var copy = FIRST_PAGE_COPY[state.selection.language] || FIRST_PAGE_COPY.en;
      var productScene = this.firstPageProductScene(state);
      var sceneSize = productScene ? productScene.width : 1378;
      var wrapper = document.createElement("div");
      var svg = createSvgElement("svg", {
        viewBox: "0 0 " + sceneSize + " " + sceneSize,
        role: "img",
        "aria-label": dyofT("cfg.render.first_page_alt", "Instant personalised first-page preview")
      });
      var lines = [state.firstPage.line1, state.firstPage.line2, state.firstPage.line3];
      var baseArtworkUrl = this.dataset.prelim01Base;
      var sceneUrl = productScene ? productScene.image : this.dataset.firstPageScene;
      var page = productScene ? productScene.page : { x: 708, y: 374, width: 439, height: 621 };
      var scaleX = page.width / 419.528;
      var scaleY = page.height / 595.276;
      var point = function(x, y) {
        return { x: page.x + Number(x) * scaleX, y: page.y + Number(y) * scaleY };
      };

      // A lens the mouse rests on is shown again with the updated page.
      var lensWasShown = this.previewMagnifierShown();
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "front-sheet";
      if (productScene) {
        this.elements.previewPages.dataset.dyofFirstPageScene = productScene.id;
      } else {
        delete this.elements.previewPages.dataset.dyofFirstPageScene;
      }
      wrapper.className = "dyof__preview-page dyof__preview-page--instant";

      if (productScene && productScene.leftPage) {
        svg.appendChild(createSvgElement("rect", Object.assign({}, productScene.leftPage, {
          fill: effectivePaperColour(state) === "cream" ? "#F7F0DF" : "#FFFFFF"
        })));
      } else if (!productScene && sceneUrl) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl,
          x: "0",
          y: "0",
          width: "1378",
          height: "1378",
          preserveAspectRatio: "none"
        }));
      }
      svg.appendChild(createSvgElement("rect", {
        x: String(page.x),
        y: String(page.y),
        width: String(page.width),
        height: String(page.height),
        fill: state.firstPage.backgroundColor
      }));
      if (baseArtworkUrl) {
        svg.appendChild(createSvgElement("image", {
          href: baseArtworkUrl,
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          preserveAspectRatio: "none"
        }));
      }
      [
        { x: "70", y: "132", width: "248", height: "92" },
        { x: "67", y: "214", width: "214", height: "72" },
        { x: "90", y: "316", width: "110", height: "20" }
      ].forEach(function(rect) {
        var origin = point(rect.x, rect.y);
        svg.appendChild(createSvgElement("rect", {
          x: String(origin.x),
          y: String(origin.y),
          width: String(rect.width * scaleX),
          height: String(rect.height * scaleY),
          fill: state.firstPage.backgroundColor
        }));
      });
      var titleOne = point(84, 174);
      var titleTwo = point(84, 220);
      var tagline = point(78, 264);
      var underlineStart = point(78, 275);
      var underlineControlOne = point(125, 257);
      var underlineControlTwo = point(181, 258);
      var underlineEnd = point(264, 265);
      var owner = point(95, 332.5);
      svg.appendChild(createSvgElement("text", {
        x: String(titleOne.x),
        y: String(titleOne.y),
        fill: "#FFFFFF",
        "font-family": "'DYOF Montserrat PDF', Montserrat, Arial, sans-serif",
        "font-size": String(34 * scaleY),
        "font-weight": "400"
      }, copy.titleLine1));
      svg.appendChild(createSvgElement("text", {
        x: String(titleTwo.x),
        y: String(titleTwo.y),
        fill: "#FFFFFF",
        "font-family": "'DYOF Montserrat PDF', Montserrat, Arial, sans-serif",
        "font-size": String(34 * scaleY),
        "font-weight": "400"
      }, copy.titleLine2));
      svg.appendChild(createSvgElement("text", {
        x: String(tagline.x),
        y: String(tagline.y),
        fill: "#120F11",
        "font-family": "'DYOF Meritocracy PDF', cursive",
        "font-size": String(60 * scaleY),
        "font-weight": "400"
      }, copy.tagline));
      svg.appendChild(createSvgElement("path", {
        d: "M" + underlineStart.x + " " + underlineStart.y +
          " C" + underlineControlOne.x + " " + underlineControlOne.y +
          " " + underlineControlTwo.x + " " + underlineControlTwo.y +
          " " + underlineEnd.x + " " + underlineEnd.y,
        fill: "none",
        stroke: "#120F11",
        "stroke-width": String(2 * scaleY)
      }));
      svg.appendChild(createSvgElement("text", {
        x: String(owner.x),
        y: String(owner.y),
        fill: "#FFFFFF",
        "font-family": "'DYOF Montserrat Owner PDF', Montserrat, Arial, sans-serif",
        "font-size": String(10 * scaleY),
        "font-weight": "400",
        "font-kerning": "none",
        style: "font-kerning:none"
      }, copy.ownerLabel));
      lines.forEach(function(line, index) {
        var linePoint = point(99, 350.5 + index * 16);
        svg.appendChild(createSvgElement("text", {
          x: String(linePoint.x),
          y: String(linePoint.y),
          fill: state.firstPage.textColor,
          "font-family": "'DYOF Montserrat Owner PDF', Montserrat, Arial, sans-serif",
          "font-size": String(9 * scaleY),
          "font-weight": "400",
          "font-kerning": "none",
          style: "font-kerning:none"
        }, line));
      });

      if (productScene && effectivePaperColour(state) === "cream") {
        // Cream is the paper stock under white print; the PDF stays white.
        // Tint only the page aperture, after all page ink, the way Review
        // multiplies the whole generated page onto its cream stock. The CSS
        // exempts these product scenes from the stage overlay, so the product
        // photo is never tinted and the page is tinted exactly once.
        svg.appendChild(createSvgElement("rect", {
          x: String(page.x),
          y: String(page.y),
          width: String(page.width),
          height: String(page.height),
          fill: "#F7F0DF",
          opacity: "0.68",
          style: "mix-blend-mode:multiply;pointer-events:none",
          "data-dyof-first-page-paper-stock": "cream"
        }));
      }

      if (productScene) {
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl, x: "0", y: "0", width: String(sceneSize), height: String(sceneSize),
          preserveAspectRatio: "none", "data-dyof-first-page-product-layer": productScene.id
        }));
      } else if (sceneUrl) {
        firstPageHardwareClipSequence += 1;
        var hardwareClipId = "dyof-first-page-hardware-clip-" + firstPageHardwareClipSequence;
        var hardwareClip = createSvgElement("clipPath", {
          id: hardwareClipId,
          clipPathUnits: "userSpaceOnUse"
        });
        [446, 508, 570, 784, 846, 908].forEach(function(y) {
          hardwareClip.appendChild(createSvgElement("rect", {
            x: "708",
            y: String(y),
            width: "105",
            height: "66"
          }));
        });
        var definitions = createSvgElement("defs");
        definitions.appendChild(hardwareClip);
        svg.appendChild(definitions);
        svg.appendChild(createSvgElement("image", {
          href: sceneUrl,
          x: "0",
          y: "0",
          width: "1378",
          height: "1378",
          preserveAspectRatio: "none",
          "clip-path": "url(#" + hardwareClipId + ")",
          "data-dyof-first-page-hardware-overlay": "true",
          style: "mix-blend-mode:multiply;pointer-events:none"
        }));
      }

      wrapper.appendChild(svg);
      this.mountInstantFirstPage(wrapper, lensWasShown);
      if (this.elements.previewTitle) {
        this.elements.previewTitle.textContent = dyofT("cfg.render.instant_first_page_title", "Instant first-page preview");
      }
      this.setPreviewStatus(
        dyofT("cfg.render.instant_first_page_status", "Updates immediately as you type — no PDF regeneration required."),
        "ready"
      );
    }

    renderStep(state) {
      var route = this.stateApi.getRoute(state);
      var descriptors = this.stepMenuDescriptors(state);
      var activeDescriptor = descriptors.filter(function(item) {
        return item.screens.indexOf(state.screen) !== -1;
      })[0];
      var phase = activeDescriptor ? activeDescriptor.id : this.stateApi.getScreenStep(state, state.screen);
      var index = route.indexOf(state.screen);
      var visibleStepIndex = 0;
      var flowGate = this.datedFlowGate(state);
      var reviewIndex = route.indexOf("review");
      var contentGate = this.reviewContentGate(state);
      var undatedFill = state.screen === "undated-layout"
        && this.didChooseUndatedFill
        && this.contract.getUndatedFill
        ? this.contract.getUndatedFill(state.journey.undatedFill)
        : null;
      this.elements.panels.forEach(function(panel) {
        panel.hidden = panel.dataset.dyofPanel !== state.screen;
      });

      if (this.elements.undatedPreviewDescription) {
        var chooserPreview = undatedFill && this.undatedChooserPreview(state);
        this.elements.undatedPreviewDescription.textContent = undatedFill && undatedFill.description
          ? dyofDisplayLabel(undatedFill.description) + (chooserPreview && chooserPreview.illustrativeScene
            ? dyofT("cfg.render.baby_illustrative_pages", " Illustrative interior pages from this Baby Journal.")
            : "")
          : "";
        this.elements.undatedPreviewDescription.hidden = !(
          undatedFill && undatedFill.description
        );
      }

      this.elements.stepButtons.forEach(function(button) {
        var descriptor = descriptors.filter(function(item) {
          return item.id === button.dataset.dyofStep;
        })[0];
        var descriptorScreens = descriptor ? descriptor.screens.filter(function(screen) {
          return route.indexOf(screen) !== -1;
        }) : [];
        var phaseExists = descriptorScreens.length > 0;
        var phaseLastIndex = descriptorScreens.reduce(function(lastIndex, screen) {
          return Math.max(lastIndex, route.indexOf(screen));
        }, -1);
        var label = dyofDisplayLabel(descriptor ? descriptor.label : button.dataset.dyofStep);
        var labelElement = typeof button.querySelector === "function"
          ? button.querySelector("[data-dyof-step-label]")
          : null;
        var stepItem = button.closest("li");
        if (labelElement) {
          labelElement.textContent = label;
        }
        // The tooltip source attribute retains its English identifier, even
        // when the visible descriptor label has been translated.
        var sourceLabels = { design: "Design", layout: state.journey.productType === "refill" ? "Setup" : "Layout", personalise: "Personalise" };
        button.dataset.dyofStepLabel = descriptor
          ? root.DYOFI18n ? sourceLabels[descriptor.id] || descriptor.id : descriptor.label
          : button.dataset.dyofStep;
        button.disabled = state.screen === "dated-layout"
          && !flowGate.valid
          && this.stateApi.STEPS.indexOf(button.dataset.dyofStep) > this.stateApi.STEPS.indexOf(phase);
        if (["planner-details", "personal-dates"].indexOf(state.screen) !== -1
          && route.indexOf(this.phaseTarget(state, button.dataset.dyofStep)) > index
          && !this.stateApi.canAdvanceScreen(state, state.screen, holidayValidationMessages(this)).valid) {
          button.disabled = true;
        }
        if (!contentGate.valid && reviewIndex > index
          && route.indexOf(this.phaseTarget(state, button.dataset.dyofStep)) >= reviewIndex) {
          button.disabled = true;
        }
        if (stepItem) {
          stepItem.hidden = !phaseExists;
          if (phaseExists) {
            stepItem.dataset.dyofVisibleIndex = String(visibleStepIndex);
            visibleStepIndex += 1;
          } else {
            delete stepItem.dataset.dyofVisibleIndex;
          }
        }
        if (button.dataset.dyofStep === phase) {
          button.setAttribute("aria-current", "step");
          button.setAttribute("aria-label", dyofT("cfg.render.current_step", "{label}, current step", { label: label }));
          button.dataset.dyofStepState = "active";
        } else {
          button.removeAttribute("aria-current");
          if (phaseExists) {
            button.dataset.dyofStepState = phaseLastIndex < index
              ? "complete"
              : "inactive";
            button.setAttribute(
              "aria-label",
              button.dataset.dyofStepState === "complete" ? dyofT("cfg.render.completed_step", "{label}, completed", { label: label }) : label
            );
          } else {
            delete button.dataset.dyofStepState;
            button.removeAttribute("aria-label");
          }
        }
      }, this);

      if (this.elements.progress) {
        this.elements.progress.dataset.dyofVisibleSteps = String(visibleStepIndex);
      }

      if (this.elements.previousButton) {
        this.elements.previousButton.disabled = index <= 0;
      }
      if (this.elements.nextButton) {
        var completion = this.stateApi.canAdvanceScreen(state, state.screen, holidayValidationMessages(this));
        var reviewGate = route[index + 1] === "review" ? contentGate : { valid: true, message: "" };
        this.elements.nextButton.disabled =
          index >= route.length - 1 || !completion.valid || !flowGate.valid || !reviewGate.valid;
        this.elements.nextButton.title = !completion.valid
          ? completion.message
          : !reviewGate.valid
            ? reviewGate.message
            : flowGate.valid ? "" : flowGate.message;
        this.elements.nextButton.textContent = route[index + 1] === "review" ? dyofT("cfg.render.review", "Review") : dyofT("cfg.render.next", "Next");
      }

      this.dataset.currentScreen = state.screen;
      // Only a lens that is showing can need hiding.
      var magnifier = this.elements.previewMagnifier;
      if (magnifier && magnifier.hidden !== true && !this.previewMagnifierAllowed()) {
        this.hidePreviewMagnifier();
      }
    }

    layoutPreviewVisualKey(state) {
      if (!state || !state.journey || state.journey.refillType !== "dated") {
        return "";
      }
      var selection = {};
      Object.keys(state.selection || {}).sort().forEach(function(key) {
        selection[key] = state.selection[key];
      });
      return JSON.stringify({
        productType: state.journey.productType,
        lifestyle: state.journey.lifestyle,
        refillType: "dated",
        previewTemplate: refillPreviewTemplate(state, this.merchandising),
        selection: selection
      });
    }

    hasMountedLayoutPreview() {
      var pages = this.elements && this.elements.previewPages;
      var source = pages && pages.dataset
        ? pages.dataset.dyofPreviewSource
        : "";
      return Boolean(
        pages
        && pages.dataset.mode === "open-spread"
        && ["server", "layout-cache", "retained-layout", "predefined-layout"].indexOf(source) !== -1
        && pages.children
        && pages.children.length > 0
      );
    }

    hasMountedUndatedPreview(expectedKey) {
      var pages = this.elements && this.elements.previewPages;
      if (!pages || !pages.dataset || !pages.children || !pages.children.length) {
        return false;
      }
      return ["open-spread", "undated-scene"].indexOf(pages.dataset.mode) !== -1
        && Boolean(pages.dataset.dyofUndatedPreview)
        && (!expectedKey || pages.dataset.dyofUndatedPreview === expectedKey);
    }

    // The chooser artwork for one fill at the customer's size. A5 is the
    // fill's own entry; another size uses its bySize pages (Personal: 660 x
    // 1188) and is null without them, so A5 art never fills a Personal page.
    undatedSizedPreview(state, previewKey) {
      var preview = this.undatedPreviews && this.undatedPreviews[previewKey];
      var size = state && state.selection ? state.selection.size : "";
      var sized;
      if (!preview || !size || size === "a5") {
        return preview || null;
      }
      sized = preview.bySize && Object.prototype.hasOwnProperty.call(preview.bySize, size)
        ? preview.bySize[size]
        : null;
      if (!sized || !sized.left || !sized.right) {
        return null;
      }
      return {
        kind: "spread",
        size: size,
        left: sized.left,
        right: sized.right,
        width: Number(sized.width) || null,
        height: Number(sized.height) || null
      };
    }

    undatedChooserPreview(state, previewKey) {
      var key = previewKey || (state && state.journey && state.journey.undatedFill);
      var preview = this.undatedSizedPreview(state, key);
      var journalScene = this.undatedJournalChooserScene(state, key, preview);
      if (journalScene) {
        return Object.assign({}, preview, { journalScene: journalScene });
      }
      var source = this.dataset && this.dataset.clipbookBabyIllustrativeScene;
      if (
        source
        && state && state.screen === "undated-layout"
        && state.journey.productType === "clipbook"
        && state.journey.refillType === "undated"
        && state.selection.size === "a5"
        && key === "baby-journal"
      ) {
        // Figma 1156:10659 illustrates verified Baby PDF pages 28 and 25.
        // Keep this chooser-only scene separate from canonical ordered pages.
        return { kind: "scene", scene: source, illustrativeScene: "clipbook-baby" };
      }
      return preview;
    }

    undatedJournalChooserScene(state, key, preview) {
      var product = state && state.journey && state.journey.productType;
      var image = preview && preview.sceneByProduct && preview.sceneByProduct[product];
      if (!image || !preview.left || !preview.right
        || !Array.isArray(preview.physicalPages) || preview.physicalPages.length !== 2
        || !state || state.screen !== "undated-layout"
        || state.journey.refillType !== "undated"
        || !state.selection || state.selection.size !== "a5"
        || ["clipbook", "planner"].indexOf(product) === -1) {
        return null;
      }
      var rects = product === "clipbook"
        ? [{ x: 459, y: 748, width: 880, height: 1241 }, { x: 1417, y: 748, width: 880, height: 1241 }]
        : [{ x: 472, y: 749, width: 886, height: 1249 }, { x: 1397, y: 749, width: 884, height: 1249 }];
      return {
        id: "journal-" + product + "-" + key,
        image: image,
        width: 1600,
        height: 1600,
        previewTemplate: "supplied-journal",
        pageRects: rects.map(function(rect) {
          return { x: rect.x / 2756, y: rect.y / 2756, width: rect.width / 2756, height: rect.height / 2756 };
        })
      };
    }

    undatedPreviewRequestKey(state, previewKey) {
      var key = previewKey || (state && state.journey && state.journey.undatedFill);
      return JSON.stringify(stablePreviewValue({
        screen: "undated-layout",
        journey: state && state.journey,
        size: state && state.selection && state.selection.size,
        fill: key,
        preview: this.undatedChooserPreview(state, key)
      }));
    }

    clearPreviewContentIdentity() {
      var pages = this.elements && this.elements.previewPages;
      this.hidePreviewMagnifier();
      this.currentLayoutVisualKey = null;
      this.currentPredefinedLayoutKey = "";
      if (!pages || !pages.dataset) {
        return;
      }
      delete pages.dataset.dyofPreviewSource;
      delete pages.dataset.dyofPreviewRequest;
      delete pages.dataset.dyofPreviewStale;
      delete pages.dataset.dyofOpenScene;
      delete pages.dataset.dyofUndatedPreview;
      delete pages.dataset.dyofFirstPageScene;
      delete pages.dataset.dyofPreviewTemplate;
      delete pages.dataset.dyofPreviewScene;
      delete pages.dataset.refillSizePreview;
    }

    captureRetainedLayoutPreview(state) {
      var pages = this.elements && this.elements.previewPages;
      if (
        !pages
        || !this.currentLayoutVisualKey
        || pages.dataset.dyofPreviewSource === "predefined-layout"
        || !this.hasMountedLayoutPreview()
      ) {
        return false;
      }
      this.discardRetainedLayoutPreview();
      var children = Array.from(pages.children || []);
      children.forEach(function(child) {
        if (child.parentNode === pages) {
          pages.removeChild(child);
        }
      });
      this.retainedLayoutPreview = {
        key: this.currentLayoutVisualKey,
        children: children,
        urls: (this.previewUrls || []).slice(),
        single: pages.classList.contains("dyof__preview-pages--single"),
        openScene: pages.dataset.dyofOpenScene || "",
        previewTemplate: pages.dataset.dyofPreviewTemplate || "",
        paper: this.elements.previewStage
          ? this.elements.previewStage.dataset.paper || ""
          : "",
        status: this.elements.previewStatus
          ? this.elements.previewStatus.textContent || ""
          : dyofT("cfg.render.preview_matches", "Preview matches the current configuration."),
        statusKind: this.elements.previewStatus
          ? this.elements.previewStatus.dataset.status || "ready"
          : "ready"
      };
      this.previewUrls = [];
      this.currentLayoutVisualKey = null;
      return true;
    }

    restoreRetainedLayoutPreview(state) {
      var retained = this.retainedLayoutPreview;
      var pages = this.elements && this.elements.previewPages;
      if (!retained || !pages) {
        return false;
      }
      if (retained.key !== this.layoutPreviewVisualKey(state)) {
        this.discardRetainedLayoutPreview();
        return false;
      }
      this.releasePreviewUrls();
      clearChildren(pages);
      this.clearPreviewContentIdentity();
      pages.dataset.mode = "open-spread";
      pages.dataset.dyofPreviewSource = "retained-layout";
      if (retained.openScene) {
        pages.dataset.dyofOpenScene = retained.openScene;
      }
      if (retained.previewTemplate) {
        pages.dataset.dyofPreviewTemplate = retained.previewTemplate;
      }
      pages.classList.toggle("dyof__preview-pages--single", retained.single);
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.paper = retained.paper;
      }
      pages.replaceChildren.apply(pages, retained.children);
      this.previewUrls = retained.urls;
      this.currentLayoutVisualKey = retained.key;
      this.retainedLayoutPreview = null;
      this.setPreviewStatus(retained.status, retained.statusKind);
      return true;
    }

    discardRetainedLayoutPreview() {
      if (!this.retainedLayoutPreview) {
        return;
      }
      (this.retainedLayoutPreview.urls || []).forEach(function(url) {
        URL.revokeObjectURL(url);
      });
      this.retainedLayoutPreview.children = [];
      this.retainedLayoutPreview.urls = [];
      this.retainedLayoutPreview = null;
    }

    renderRefillSizePreview(state) {
      if (
        !state
        || state.screen !== "dated-layout"
        || !state.journey
        || state.journey.productType !== "refill"
        || state.journey.refillType !== "dated"
      ) {
        return false;
      }

      var explicitSize = Boolean(
        this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has("size:size")
      );
      var requestedSize = explicitSize
        ? String(state.selection && state.selection.size || "").toLowerCase()
        : "default";
      var assets = {
        default: this.dataset.refillSizeDefault,
        a4: this.dataset.refillSizeA4,
        a5: this.dataset.refillSizeA5,
        personal: this.dataset.refillSizePersonal
      };
      var descriptions = {
        default: dyofT("cfg.render.refill_sizes_alt", "A4, A5 and Personal diary refill sizes"),
        a4: dyofT("cfg.render.a4_refill_alt", "A4 diary refill pages"),
        a5: dyofT("cfg.render.a5_refill_alt", "A5 diary refill pages"),
        personal: dyofT("cfg.render.personal_refill_alt", "Personal diary refill pages")
      };
      var dimensions = {
        default: [1422, 1424],
        a4: [1067, 1068],
        a5: [711, 712],
        personal: [711, 712]
      };
      var size = assets[requestedSize] ? requestedSize : "default";
      var imageSource = assets[size];
      if (!imageSource) {
        return false;
      }

      clearChildren(this.elements.previewPages);
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "refill-size-preview";
      this.elements.previewPages.dataset.refillSizePreview = size;
      this.elements.previewPages.classList.remove("dyof__preview-pages--single");
      if (this.elements.previewTitle) {
        this.elements.previewTitle.textContent = dyofT("cfg.render.refill_size_preview", "Refill size preview");
      }
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.paper = "white";
      }
      var image = document.createElement("img");
      image.className = "dyof__refill-size-preview";
      image.src = imageSource;
      image.alt = descriptions[size];
      image.width = dimensions[size][0];
      image.height = dimensions[size][1];
      this.elements.previewPages.appendChild(image);
      this.setPreviewStatus(
        size === "default"
          ? dyofT("cfg.render.choose_refill_size", "Choose a refill size to continue.")
          : dyofT("cfg.render.choose_style_preview", "Choose a style to start your dated refill preview."),
        "idle"
      );
      return true;
    }

    renderPreviewMode(state) {
      var descriptor = this.stateApi.getPreviewDescriptor(state);
      var previousPreviewScreen = this.elements.previewStage
        ? this.elements.previewStage.dataset.screen || ""
        : "";
      var previousPreviewMode = this.elements.previewStage
        ? this.elements.previewStage.dataset.previewMode || ""
        : "";
      var fill;
      var message;
      var badge;

      this.activePreviewMode = descriptor.mode;
      if (this.elements.previewTitle) {
        // Cover only shows the empty Clipbook, not a refill design.
        this.elements.previewTitle.textContent = descriptor.screen === "refill-type" && state.journey.refillType === "none"
          ? dyofT("cfg.preview.cover_only_title", "Clipbook cover")
          : dyofDisplayLabel(descriptor.title);
      }
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.screen = descriptor.screen;
        this.elements.previewStage.dataset.previewMode = descriptor.mode;
      }

      if (descriptor.renderer === "server") {
        if (!this.hasExplicitDatedStyle(state)) {
          if (this.renderRefillSizePreview(state)) {
            return;
          }
          this.renderBlankOpenScene(
            dyofT("cfg.render.choose_style_preview", "Choose a style to start your dated refill preview."),
            state
          );
          return;
        }
        var pending = state.preview.status === "idle" || state.preview.status === "loading";
        if (pending) { this.showPredefinedLayoutPreview(state); }
        var hasMatchedPreview = this.hasMountedLayoutPreview()
          && this.currentLayoutVisualKey === this.layoutPreviewVisualKey(state)
          && (this.elements.previewPages.dataset.dyofPreviewSource !== "predefined-layout"
            || Boolean(this.currentPredefinedLayoutKey
              && this.currentPredefinedLayoutKey === this.predefinedLayoutKey(state)));
        var keepPreviousPreview = !hasMatchedPreview
          && previousPreviewScreen === "dated-layout"
          && state.screen === "dated-layout"
          && this.hasMountedLayoutPreview()
          && (pending || state.preview.status === "error");
        if (!hasMatchedPreview && !keepPreviousPreview) {
          clearChildren(this.elements.previewPages);
          this.releasePreviewUrls();
          this.clearPreviewContentIdentity();
          this.elements.previewPages.dataset.mode = "layout-loading";
          this.elements.previewPages.classList.remove("dyof__preview-pages--single");
        }
        if (keepPreviousPreview) {
          this.elements.previewPages.dataset.dyofPreviewStale = "true";
          this.hidePreviewMagnifier();
        } else {
          delete this.elements.previewPages.dataset.dyofPreviewStale;
        }
        this.setPreviewStatus(
          state.preview.status === "error" ? dyofErrorMessage({ code: state.preview.errorCode, message: state.preview.error }, dyofT("cfg.render.preview_load_failed", "The selected preview could not load. Please retry."))
            : pending ? dyofT("cfg.render.generating_preview", "Generating your refill preview…") : dyofT("cfg.render.preview_matches", "Preview matches the current configuration."),
          state.preview.status === "error" ? "error" : pending ? "loading" : "ready"
        );
        return;
      }

      if ((descriptor.mode === "sizes" || descriptor.mode === "closed-cover") && this.coverEditor) {
        this.clearPreviewContentIdentity();
        if (
          (previousPreviewScreen !== descriptor.screen || previousPreviewMode !== descriptor.mode)
          && typeof this.coverEditor.renderPreviewShell === "function"
        ) {
          this.coverEditor.renderPreviewShell(state, this.elements);
        }
        this.coverEditor.renderPreview(state, this.elements);
        return;
      }

      if (descriptor.mode === "review") {
        var reviewKey = this.reviewPreloadKey(state);
        var reviewIdentity = this.reviewIdentityForState(state);
        if (
          this.reviewRevision === state.revision
          && this.reviewKey === reviewKey
          && this.reviewMountedIdentity === reviewIdentity
        ) {
          return;
        }
        if (this.canResumeReview(state, reviewIdentity)) {
          this.resumeMountedReview(state, reviewKey, reviewIdentity);
          return;
        }
        this.loadReviewPages(state, true);
        return;
      }

      if (descriptor.mode === "front-sheet") {
        this.renderInstantFirstPage(state);
        return;
      }

      if (descriptor.mode === "personal-dates") {
        this.renderPersonalDatesScene();
        this.ensureReviewPreload(state);
        return;
      }

      if (descriptor.renderer === "cached-pdf") {
        if (!this.didChooseUndatedFill) {
          if (this.undatedPreviewAbortController) {
            this.undatedPreviewAbortController.abort();
            this.undatedPreviewAbortController = null;
          }
          this.undatedPreviewPendingKey = null;
          this.undatedPreviewPendingIdentity = null;
          this.renderBlankOpenScene(
            dyofT("cfg.render.choose_undated_preview", "Choose an Undated refill to see its page preview."),
            state
          );
          return;
        }
        if (!this.hasMountedUndatedPreview()) {
          this.renderBlankOpenScene(dyofT("cfg.render.loading_undated_preview", "Loading the selected Undated refill preview…"), state);
        }
        this.renderUndatedPreview(state);
        return;
      }

      if (descriptor.mode === "blank-open") {
        this.renderBlankOpenScene(state.journey.refillType === "none"
          ? dyofT("cfg.preview.cover_only_status", "Clipbook with the included 112 ruled pages.")
          : dyofT("cfg.render.choose_refill_design", "Choose Dated or Undated to begin the refill design."), state);
        return;
      } else {
        message = dyofT("cfg.render.review_pending", "The scrollable page review will be connected after every page step is complete.");
        badge = dyofT("cfg.render.review", "Review");
      }

      this.renderPreviewPlaceholder(message, badge, descriptor.mode);
    }

    renderControlVisibility(state) {
      var dated = state.journey.refillType === "dated";
      var modern = state.selection.engine === "modern";
      var legacy = state.selection.engine === "legacy";
      var legacyLayout = this.contract.getLegacyLayout
        ? this.contract.getLegacyLayout(state.selection.layout)
        : null;
      var legacyControls = legacyLayout ? legacyLayout.controls || [] : [];

      if (this.elements.datedControls) {
        this.elements.datedControls.hidden = !dated;
      }
      if (this.elements.refillSizeGroup) {
        this.elements.refillSizeGroup.hidden = !dated || state.journey.productType !== "refill";
      }
      if (this.elements.modernControls) {
        this.elements.modernControls.hidden = !dated || !modern;
      }
      if (this.elements.legacyControls) {
        this.elements.legacyControls.hidden = !dated || !legacy;
      }
      if (this.elements.undatedControls) {
        this.elements.undatedControls.hidden = state.journey.refillType !== "undated";
      }
      if (this.elements.legacyLineStyleGroup) {
        this.elements.legacyLineStyleGroup.hidden = !this.isDatedStageGroupApplicable(
          this.elements.legacyLineStyleGroup,
          state
        );
      }
      if (this.elements.legacyCalendarGroup) {
        this.elements.legacyCalendarGroup.hidden =
          !dated || !legacy || legacyControls.indexOf("calendar") === -1;
      }
      if (this.elements.legacyNotesGroup) {
        this.elements.legacyNotesGroup.hidden =
          !dated
          || !legacy
          || legacyControls.indexOf("notes") === -1
          || state.selection.lineStyle !== "blank";
      }
      if (this.elements.legacyAppointmentGroup) {
        this.elements.legacyAppointmentGroup.hidden =
          !dated
          || !legacy
          || legacyControls.indexOf("appointmentTimes") === -1
          || state.selection.lineStyle !== "ruled";
      }
      this.querySelectorAll("[data-dyof-field='style']").forEach(function(button) {
        var style = this.contract.getStyle(button.dataset.dyofValue);
        var unavailable = dated && state.selection.size !== "a5" && style && style.engine === "modern";
        button.hidden = Boolean(unavailable);
        button.disabled = Boolean(unavailable);
        button.title = "";
      }, this);
    }

    renderDynamicChoices(state) {
      var layouts = this.contract.modernVariants || {};
      var layout = layouts[state.selection.layout] || { views: {} };
      var view = layout.views[state.selection.layoutView] || { designs: {} };
      var fills = this.contract.undatedFills || {};
      var controls = this.contract.controls || {};
      var legacyLayouts = this.contract.legacyVariants || {};
      var datePositions = this.contract.getSupportedDatePositions(state.selection);
      var startDays = this.contract.getSupportedStartDays(state.selection);

      this.renderValueChoices(
        this.elements.refillSizeList,
        "size",
        this.contract.legacySizes || ["a4", "a5", "personal"],
        sizeLabel
      );
      this.renderOrganiserSizeLock(state);

      this.renderLegacyLayoutChoices(
        this.elements.legacyLayoutList,
        legacyLayouts
      );
      if (this.elements.legacyLayoutList && state.selection.engine === "legacy") {
        this.elements.legacyLayoutList.querySelectorAll("[data-dyof-field='layout']").forEach(function(button) {
          var legacyDefinition = legacyLayouts[button.dataset.dyofValue] || {};
          var candidate = Object.assign({}, state.selection, {
            layout: button.dataset.dyofValue
          });
          var availability = this.legacyLayoutAvailability(state, candidate);
          var unavailable = availability.status !== "ready";
          button.hidden = unavailable;
          button.disabled = unavailable;
          button.title = unavailable ? "" : dyofDisplayLabel(legacyDefinition.description || legacyDefinition.label || "");
        }, this);
      }
      this.renderValueChoices(
        this.elements.legacyLineStyleList,
        "lineStyle",
        ["blank", "ruled"],
        function(value) { return value === "blank" ? dyofT("cfg.render.blank", "Blank") : dyofT("cfg.render.ruled", "Ruled"); }
      );
      this.renderBooleanToggle(
        this.elements.legacyCalendarList,
        "calendar",
        dyofT("cfg.render.calendar", "Calendar"),
        state.selection.calendar
      );
      this.renderBooleanToggle(
        this.elements.legacyNotesList,
        "notes",
        dyofT("cfg.render.notes", "Notes"),
        state.selection.notes
      );
      this.renderBooleanToggle(
        this.elements.legacyAppointmentList,
        "appointmentTimes",
        dyofT("cfg.render.appointment_times", "Appointment Times"),
        state.selection.appointmentTimes
      );
      this.renderColourModeChoices(this.elements.colourModeList, state);
      this.renderValueChoices(
        this.elements.paperList,
        "paperColour",
        controls.paperColours,
        function(value) {
          return value === "cream" ? dyofT("cfg.render.cream", "Cream") : dyofT("cfg.render.white", "White");
        }
      );

      this.renderModernLayoutChoices(
        this.elements.layoutList,
        layouts
      );
      this.renderModernLayoutAvailability(state);
      this.renderObjectChoices(
        this.elements.viewList,
        "layoutView",
        layout.views,
        function(item) {
          return dyofDisplayLabel(item.label);
        }
      );
      this.renderObjectChoices(
        this.elements.designList,
        "dayDesign",
        view.designs,
        function(_item, key) {
          return designLabel(key);
        }
      );
      this.renderValueChoices(
        this.elements.headerList,
        "headerTheme",
        this.contract.controls.headerThemes,
        headerLabel
      );
      this.renderValueChoices(
        this.elements.datePositionList,
        "datePosition",
        datePositions,
        function(value) {
          return controlLabel("datePosition", value);
        }
      );
      if (this.elements.viewLegend) {
        this.elements.viewLegend.textContent = state.selection.layout === "daily"
          ? dyofT("cfg.render.day_view", "Day View")
          : state.selection.layout === "monthly" ? dyofT("cfg.render.month_view", "Month View") : dyofT("cfg.render.week_view", "Week View");
      }
      if (this.elements.designLegend) {
        this.elements.designLegend.textContent = state.selection.layout === "monthly"
          ? dyofT("cfg.render.month_design_title", "Month Design")
          : dyofT("cfg.render.day_design", "Day design");
      }

      var undatedChoiceSignature = JSON.stringify([state.journey.productType, state.selection.size,
        Object.keys(fills).map(function(key) {
          return [key, fills[key].label, fills[key].status, this.undatedPurchase(state, key).status,
            this.undatedFillAvailableForProduct(state, key)];
        }, this)]);
      if (this.elements.undatedList && this.undatedChoiceSignature !== undatedChoiceSignature) {
        // Keep subgroup tooltip buttons stable during asynchronous preview
        // paints so keyboard focus and touch disclosure aren't discarded.
        this.undatedChoiceSignature = undatedChoiceSignature;
        clearChildren(this.elements.undatedList);
        [
          {
            label: "Journals",
            values: ["baby-journal", "wedding-journal", "gardening-journal", "life-essentials", "cookbook-journal", "pet-journal"]
          },
          {
            label: "Everyday",
            values: ["undated-weekly", "undated-vertical-weekly", "mix", "ruled", "dotted", "plain", "squared", "dotted-ruled", "to-do", "work-life-balance", "self-care"]
          }
        ].forEach(function(group) {
          var visibleValues = group.values.filter(function(key) {
            var fill = fills[key];
            // Preview-only fills (Personal Everyday) stay clickable; a fill
            // the size does not offer at all (Personal Vertical) is hidden.
            return Boolean(fill) && (
              !Array.isArray(fill.sizes)
              || fill.sizes.indexOf(state.selection.size) !== -1
            ) && this.undatedPurchase(state, key).status !== "unavailable"
              && this.undatedFillAvailableForProduct(state, key);
          }, this);
          if (!visibleValues.length) {
            return;
          }
          var heading = document.createElement("p");
          heading.className = "dyof__undated-group-heading";
          heading.textContent = dyofDisplayLabel(group.label);
          var pageCountTemplate = this.elements.undatedPageCountTemplate;
          if (pageCountTemplate && pageCountTemplate.content) {
            var pageCount = pageCountTemplate.content.cloneNode(true);
            var tooltip = pageCount.querySelector("[role='tooltip']");
            var trigger = pageCount.querySelector("button");
            tooltip.id = "dyof-undated-" + (this.id || "module") + "-" + group.label.toLowerCase();
            trigger.setAttribute("aria-describedby", tooltip.id);
            trigger.setAttribute("aria-label", dyofPlural("cfg.render.group_pages", 112, { one: "{group}: {count} removable page, made with 100gsm paper", other: "{group}: {count} removable pages, made with 100gsm paper" }, { group: dyofDisplayLabel(group.label) }));
            heading.appendChild(pageCount);
          }
          this.elements.undatedList.appendChild(heading);
          visibleValues.forEach(function(key) {
            var fill = fills[key];
            var button = createChoice(
              "undatedFill",
              key,
              dyofDisplayLabel(fill.label),
              fill.status !== "ready"
            );
            button.classList.add("dyof__undated-choice");
            button.setAttribute("role", "radio");
            if (fill.status !== "ready") {
              button.title = dyofT("cfg.render.awaiting_production_pdf", "Awaiting production PDF");
            }
            this.elements.undatedList.appendChild(button);
          }, this);
        }, this);
        if (!this.elements.undatedList.firstChild) {
          // No Undated refill at this size on this store (Czech Personal).
          var none = document.createElement("p");
          none.className = "dyof__field-help";
          none.textContent = dyofT("cfg.render.no_undated_for_size", "No Undated refills are available in this size yet.");
          this.elements.undatedList.appendChild(none);
        }
      }
    }

    renderLegacyLayoutChoices(container, layouts) {
      if (!container) {
        return;
      }

      clearChildren(container);
      var appendChoice = function(target, key, hideLabel) {
        var definition = layouts[key];
        var label;
        var button;
        var labelElement;
        if (!definition) {
          return;
        }
        label = dyofDisplayLabel(definition.label || key);
        if (hideLabel) {
          label = dyofDisplayLabel(definition.description) || (key === "weekly"
            ? dyofT("cfg.render.horizontal_week", "Horizontal week to view")
            : key === "vertical-weekly" ? dyofT("cfg.render.vertical_week", "Vertical week to view") : dyofT("cfg.render.two_weeks", "Two weeks to view"));
        }
        button = createChoice("layout", key, label, false);
        if (hideLabel) {
          button.setAttribute("aria-label", label);
          labelElement = button.querySelector("span");
          if (labelElement) {
            labelElement.classList.add("dyof__visually-hidden-label");
          }
        }
        target.appendChild(button);
      };

      appendChoice(container, "daily", false);

      var weeklyGroup = document.createElement("div");
      var weeklyIcons = document.createElement("div");
      var weeklyLabel = document.createElement("span");
      weeklyGroup.className = "dyof__layout-choice-group dyof__layout-choice-group--weekly";
      weeklyGroup.setAttribute("role", "group");
      weeklyGroup.setAttribute("aria-label", dyofT("cfg.render.weekly_layouts", "Weekly layouts"));
      weeklyIcons.className = "dyof__layout-choice-group-icons";
      ["weekly", "vertical-weekly", "two-weeks"].forEach(function(key) {
        appendChoice(weeklyIcons, key, true);
      });
      weeklyLabel.className = "dyof__layout-choice-group-label";
      weeklyLabel.setAttribute("aria-hidden", "true");
      weeklyLabel.textContent = dyofT("cfg.render.weekly", "Weekly");
      weeklyGroup.appendChild(weeklyIcons);
      weeklyGroup.appendChild(weeklyLabel);
      container.appendChild(weeklyGroup);

      appendChoice(container, "monthly", false);
    }

    renderModernLayoutChoices(container, layouts) {
      this.renderLegacyLayoutChoices(container, {
        daily: layouts.daily,
        weekly: layouts.weekly,
        "vertical-weekly": layouts["vertical-weekly"],
        monthly: layouts.monthly
      });
    }

    renderObjectChoices(container, field, object, labelFor, order) {
      if (!container) {
        return;
      }
      clearChildren(container);
      (order || Object.keys(object || {})).forEach(function(key) {
        if (!Object.prototype.hasOwnProperty.call(object || {}, key)) {
          return;
        }
        container.appendChild(createChoice(field, key, labelFor(object[key], key), false));
      });
    }

    renderValueChoices(container, field, values, labelFor) {
      if (!container) {
        return;
      }
      clearChildren(container);
      (values || []).forEach(function(value) {
        container.appendChild(createChoice(field, value, labelFor(value), false));
      });
    }

    renderBooleanToggle(container, field, label, selected) {
      if (!container) {
        return;
      }
      clearChildren(container);
      var button = document.createElement("button");
      var control = document.createElement("i");
      var text = document.createElement("span");
      button.type = "button";
      button.className = "dyof__toggle-choice";
      button.dataset.dyofField = field;
      button.dataset.dyofValue = String(!Boolean(selected));
      button.dataset.dyofToggleField = field;
      button.setAttribute("aria-pressed", String(Boolean(selected)));
      control.setAttribute("aria-hidden", "true");
      text.textContent = label;
      button.appendChild(control);
      button.appendChild(text);
      container.appendChild(button);
    }

    renderColourModeChoices(container, state) {
      if (!container) {
        return;
      }
      clearChildren(container);
      var palettes = this.contract.getSingleColours(state.selection.style) || [];
      var modes = [
        {
          value: "signature-multicolour",
          label: dyofT("cfg.render.multi_colour_title", "Multi-Colour:"),
          description: dyofT("cfg.render.multi_colour_description", "Different colours throughout the year.")
        },
        {
          value: "single-colour",
          label: dyofT("cfg.render.single_colour_title", "Single Colour:"),
          description: dyofT("cfg.render.single_colour_description", "Pick one colour for all 12 months")
        }
      ];

      modes.forEach(function(mode) {
        var card = document.createElement("div");
        var select = document.createElement("button");
        var radio = document.createElement("i");
        var copy = document.createElement("span");
        var title = document.createElement("strong");
        var description = document.createElement("small");
        var swatches;
        var isSelected = state.selection.colourMode === mode.value;
        card.className = "dyof__colour-mode-card dyof__colour-mode-card--" + mode.value;
        select.type = "button";
        select.className = "dyof__colour-mode-choice";
        select.dataset.dyofField = "colourMode";
        select.dataset.dyofValue = mode.value;
        select.setAttribute("aria-pressed", String(isSelected));
        radio.className = "dyof__colour-mode-radio";
        radio.setAttribute("aria-hidden", "true");
        title.textContent = mode.label;
        description.textContent = mode.description;
        copy.appendChild(title);
        copy.appendChild(description);
        select.appendChild(radio);
        select.appendChild(copy);
        card.appendChild(select);

        if (mode.value === "single-colour") {
          swatches = document.createElement("span");
          swatches.className = "dyof__colour-mode-swatches";
          palettes.forEach(function(option) {
            var swatch = document.createElement("button");
            swatch.type = "button";
            swatch.dataset.dyofField = "singleColour";
            swatch.dataset.dyofValue = option.value;
            swatch.setAttribute("aria-label", dyofDisplayLabel(option.label));
            swatch.setAttribute("aria-pressed", String(state.selection.colourMode === "single-colour" && state.selection.singleColour === option.value));
            swatch.style.background = splitSwatchBackground(option.swatches);
            swatches.appendChild(swatch);
          });
          card.appendChild(swatches);
        }
        container.appendChild(card);
      });
    }

    renderColourChoices(container, options) {
      if (!container) {
        return;
      }
      clearChildren(container);
      (options || []).forEach(function(option) {
        var button = createChoice(
          "singleColour",
          option.value,
          dyofDisplayLabel(option.label),
          false
        );
        var swatch = document.createElement("span");
        button.classList.add("dyof__colour-choice");
        button.setAttribute("aria-label", dyofDisplayLabel(option.label));
        swatch.className = "dyof__colour-swatch";
        swatch.style.background = swatchBackground(option.swatches);
        swatch.setAttribute("aria-hidden", "true");
        button.insertBefore(swatch, button.firstChild);
        container.appendChild(button);
      });
    }

    renderPressedStates(state) {
      this.querySelectorAll("[data-dyof-field]").forEach(function(button) {
        var field = button.dataset.dyofField;
        var datedStage = button.closest("[data-dyof-dated-stage]");
        var selected = field === "undatedFill"
          ? state.journey.undatedFill
          : state.selection[field];
        if (field === "undatedFill" && !this.didChooseUndatedFill) {
          button.setAttribute("aria-pressed", "false");
          return;
        }
        if (
          state.screen === "dated-layout"
          && datedStage
          && !this.datedFlowExplicitFields.has(
            datedStage.dataset.dyofDatedStage + ":" + field
          )
        ) {
          button.setAttribute("aria-pressed", "false");
          return;
        }
        if (button.dataset.dyofToggleField) {
          button.setAttribute("aria-pressed", String(Boolean(selected)));
          return;
        }
        button.setAttribute(
          "aria-pressed",
          String(String(selected) === String(button.dataset.dyofValue))
        );
      }, this);
    }

    renderMessages(state) {
      var validation = this.stateApi.validateState(state, holidayValidationMessages(this));
      var holidays = this.stateApi.validateHolidaySelection(state, holidayValidationMessages(this));
      var showHolidayErrors = ["planner-details", "personal-dates", "review"].indexOf(state.screen) !== -1;
      // Shown on every step: Save is blocked everywhere while days are overfull.
      // Review lists it once, next to Add to cart.
      var contentGate = this.contentCheckGate(state);
      var showContentStop = !contentGate.valid && state.screen !== "review";
      clearChildren(this.elements.messages);
      if (this.elements.holidayErrors) {
        clearChildren(this.elements.holidayErrors);
        this.elements.holidayErrors.hidden = (!showHolidayErrors || holidays.valid) && !showContentStop;
        if (showHolidayErrors) {
          holidays.errors.forEach(function(message) {
            var paragraph = document.createElement("p");
            paragraph.dataset.kind = "error";
            paragraph.textContent = message;
            this.elements.holidayErrors.appendChild(paragraph);
          }, this);
        }
        if (showContentStop) {
          var contentParagraph = document.createElement("p");
          contentParagraph.dataset.kind = "error";
          contentParagraph.textContent = contentGate.message;
          this.elements.holidayErrors.appendChild(contentParagraph);
        }
      }

      validation.errors.forEach(function(message) {
        if (holidays.errors.indexOf(message) !== -1) {
          return;
        }
        this.appendMessage(message, "error");
      }, this);
      validation.warnings.forEach(function(message) {
        if (message === "This style will use the retained legacy renderer.") {
          return;
        }
        this.appendMessage(message, "warning");
      }, this);

      this.renderSaveStatus(state);
      var oldLinkNotice = this.oldBuilderLinkNotice;
      if (oldLinkNotice && oldLinkNotice.kind === "success" && state.save.status === "restored") {
        // An old refill's QR code: this note in place of "restored".
        this.appendMessage(oldLinkNotice.message, "success");
      } else if (state.save.status === "restored") {
        this.appendMessage(dyofT("cfg.render.saved_restored", "Your saved configuration has been restored."), "success");
      }
      if (oldLinkNotice && oldLinkNotice.kind === "notice" && state.screen === oldLinkNotice.screen) {
        this.appendMessage(oldLinkNotice.message, "notice");
      }
      try {
        if (
          ["refill-type", "dated-layout", "undated-layout"].indexOf(state.screen) === -1 &&
          root.localStorage.getItem("dyof:saved:latest")
        ) {
          var restore = document.createElement("button");
          restore.type = "button";
          restore.className = "dyof__restore-save";
          restore.dataset.dyofRestoreSave = "";
          restore.textContent = dyofT("cfg.render.restore_last_saved", "Restore last saved design");
          this.elements.messages.appendChild(restore);
        }
      } catch (error) {
        // Storage may be disabled; saving will surface a concrete error when requested.
      }
    }

    // Save for later is on every step, so what it did is shown above the step
    // panels (not in one step's messages) until the design changes again.
    renderSaveStatus(state) {
      var region = this.elements.saveStatus;
      var outcome = state.revision === this.saveStatusRevision ? this.saveOutcome(state.save) : null;
      var shown = region && region.firstChild;
      if (!region || (shown ? shown.textContent : "") === (outcome ? outcome.message : "")) {
        return;
      }
      clearChildren(region);
      if (outcome) {
        var paragraph = document.createElement("p");
        paragraph.dataset.kind = outcome.kind;
        paragraph.textContent = outcome.message;
        region.appendChild(paragraph);
        // A scrolled step, Review and the phone's sticky preview can all hide
        // the top of the form.
        if (typeof region.scrollIntoView === "function") {
          region.scrollIntoView({ block: "nearest" });
        }
      }
    }

    // Called just before a save records its outcome, so the outcome is shown
    // only while the design is the one saved, and announced even when it
    // repeats the last one.
    beginSaveOutcome(revision) {
      this.saveStatusRevision = revision;
      if (this.elements && this.elements.saveStatus) {
        clearChildren(this.elements.saveStatus);
      }
    }

    saveOutcome(save) {
      if (save.status === "saved") {
        return {
          kind: "success",
          message: dyofT("cfg.render.saved_securely", "Saved securely. This design can be restored from its saved link; a local copy is also kept in this browser.")
        };
      }
      if (save.status === "saved-local" && save.error) {
        // The storefront check names the same text at the field and on Review.
        // A photo refusal (print resolution, or a photo to upload again)
        // carries its own next step.
        return save.errorCode === "DYOF_UNPRINTABLE_TEXT"
          ? {
              kind: "warning",
              message: root.DYOFPrintableText
                ? dyofT("cfg.render.saved_unprintable", "Saved in this browser only. A saved link was not created because some text can't be printed.")
                : dyofT("cfg.render.saved_unprintable_error", "Saved in this browser only. A saved link was not created because some text can't be printed. {error}", {
                    error: dyofErrorMessage({ code: save.errorCode, message: save.error }, dyofT("cfg.render.service_unavailable", "The service is unavailable. Please try again."))
                  })
            }
          : { kind: "error", message: dyofT("cfg.render.saved_browser_error", "Saved in this browser only. {error}", {
              error: dyofErrorMessage({ code: save.errorCode, message: save.error }, dyofT("cfg.render.service_unavailable", "The service is unavailable. Please try again."))
            }) };
      }
      if (save.status === "saved-local") {
        return {
          kind: "warning",
          message: dyofT("cfg.render.saved_browser_service_unavailable", "Saved in this browser, but the cross-device configuration service was unavailable.")
        };
      }
      return save.status === "error" && save.error
        ? { kind: "error", message: dyofErrorMessage({ code: save.errorCode, message: save.error }, dyofT("cfg.render.service_unavailable", "The service is unavailable. Please try again.")) } : null;
    }

    appendMessage(message, kind) {
      if (!this.elements.messages) {
        return;
      }
      var paragraph = document.createElement("p");
      paragraph.dataset.kind = kind;
      paragraph.textContent = message;
      this.elements.messages.appendChild(paragraph);
    }

    renderTags(state) {
      var values;
      clearChildren(this.elements.tags);

      if (state.screen === "refill-type" && !this.didChooseRefillType && state.journey.refillType !== "none") {
        return;
      }

      if (["cover-selection", "front-cover", "back-cover"].indexOf(state.screen) !== -1) {
        values = [];
        if (
          !this.coverEditor
          || !this.coverEditor.hasExplicitSizeChoice
          || this.coverEditor.hasExplicitSizeChoice()
        ) {
          values.push(sizeLabel(state.selection.size));
        }
        if (!this.coverEditor || this.coverEditor.didChooseSource) {
          values.push(state.cover.source === "upload" ? dyofT("cfg.render.own_design", "Own Design") : dyofT("cfg.render.filofax_design", "Filofax Design"));
        }
        values.forEach(function(value) {
          var item = document.createElement("li");
          item.textContent = dyofDisplayLabel(value);
          this.elements.tags.appendChild(item);
        }, this);
        return;
      }

      if (state.journey.refillType === "none") {
        // A Clipbook cover on its own: the size, the cover source and both sides.
        [
          sizeLabel(state.selection.size),
          state.cover.source === "upload" ? dyofT("cfg.render.own_design", "Own Design") : dyofT("cfg.render.filofax_design", "Filofax Design"),
          dyofT("cover.preview.front_caption", "Front cover"),
          dyofT("cover.preview.back_caption", "Back cover")
        ].forEach(function(value) {
          var item = document.createElement("li");
          item.textContent = dyofDisplayLabel(value);
          this.elements.tags.appendChild(item);
        }, this);
        return;
      }

      if (state.journey.refillType === "undated") {
        var fill = this.didChooseUndatedFill
          ? this.contract.getUndatedFill(state.journey.undatedFill)
          : null;
        values = fill
          ? [sizeLabel(state.selection.size), dyofT("cfg.render.undated", "Undated"), dyofDisplayLabel(fill.label)]
          : [];
      } else {
        var colourLabel = state.selection.colourMode === "single-colour"
          ? titleCase(state.selection.singleColour)
          : controlLabel("colourMode", state.selection.colourMode);
        var legacyLayout = state.selection.engine === "legacy"
          ? this.contract.getLegacyLayout(state.selection.layout)
          : null;
        var legacyControls = legacyLayout ? legacyLayout.controls || [] : [];
        if (state.screen === "dated-layout") {
          var explicit = this.datedFlowExplicitFields || new Set();
          var coveredSizeChosen = state.journey.productType !== "refill"
            && this.coverEditor
            && this.coverEditor.hasExplicitSizeChoice
            && this.coverEditor.hasExplicitSizeChoice();
          values = [];
          if (coveredSizeChosen || explicit.has("size:size")) {
            values.push(sizeLabel(state.selection.size));
          }
          if (explicit.has("style:style")) {
            values.push(dyofDisplayLabel(this.contract.getStyle(state.selection.style).label));
          }
          if (state.selection.engine === "legacy") {
            if (explicit.has("legacy-layout:layout") && legacyLayout) {
              values.push(
                legacyLayout.description
                  ? dyofT("cfg.render.layout_description", "{layout} — {description}", {
                    layout: dyofDisplayLabel(legacyLayout.label), description: dyofDisplayLabel(legacyLayout.description)
                  })
                  : dyofDisplayLabel(legacyLayout.label)
              );
            }
            if (explicit.has("legacy-design:lineStyle")) {
              values.push(titleCase(state.selection.lineStyle));
            }
            if (explicit.has("legacy-design:calendar") && state.selection.calendar) {
              values.push(dyofT("cfg.render.calendar", "Calendar"));
            }
            if (explicit.has("legacy-design:notes") && state.selection.notes) {
              values.push(dyofT("cfg.render.notes", "Notes"));
            }
            if (
              explicit.has("legacy-design:appointmentTimes")
              && state.selection.appointmentTimes
            ) {
              values.push(dyofT("cfg.render.appointment_times", "Appointment Times"));
            }
          } else {
            if (explicit.has("layout:layout")) {
              values.push(titleCase(state.selection.layout));
            }
            if (explicit.has("view:layoutView")) {
              values.push(titleCase(state.selection.layoutView));
            }
            if (explicit.has("day-design:dayDesign")) {
              values.push(designLabel(state.selection.dayDesign));
            }
            if (explicit.has("header:headerTheme")) {
              values.push(headerLabel(state.selection.headerTheme));
            }
            if (explicit.has("colour-mode:colourMode")) {
              values.push(colourLabel);
            }
            if (explicit.has("paper:paperColour")) {
              values.push(controlLabel("paperColour", state.selection.paperColour));
            }
            if (explicit.has("date-position:datePosition")) {
              values.push(controlLabel("datePosition", state.selection.datePosition));
            }
          }
        } else {
          values = [
            sizeLabel(state.selection.size),
            dyofDisplayLabel(this.contract.getStyle(state.selection.style).label),
            state.selection.engine === "modern"
              ? titleCase(state.selection.layout)
              : legacyLayout
                ? legacyLayout.description
                  ? dyofT("cfg.render.layout_description", "{layout} — {description}", { layout: dyofDisplayLabel(legacyLayout.label), description: dyofDisplayLabel(legacyLayout.description) })
                  : dyofDisplayLabel(legacyLayout.label)
                : dyofT("cfg.render.legacy", "Legacy"),
            state.selection.engine === "modern" ? titleCase(state.selection.layoutView) : "",
            state.selection.engine === "modern" ? designLabel(state.selection.dayDesign) : "",
            state.selection.engine === "modern" ? headerLabel(state.selection.headerTheme) : "",
            state.selection.engine === "modern" ? colourLabel : "",
            state.selection.engine === "modern"
              ? controlLabel("paperColour", state.selection.paperColour)
              : "",
            state.selection.engine === "modern"
              ? controlLabel("datePosition", state.selection.datePosition)
              : legacyControls.indexOf("lineStyle") !== -1
                ? titleCase(state.selection.lineStyle)
                : "",
            state.selection.engine === "legacy"
              && legacyControls.indexOf("calendar") !== -1
              && state.selection.calendar ? dyofT("cfg.render.calendar", "Calendar") : "",
            state.selection.engine === "legacy"
              && legacyControls.indexOf("notes") !== -1
              && state.selection.notes ? dyofT("cfg.render.notes", "Notes") : "",
            state.selection.engine === "legacy"
              && legacyControls.indexOf("appointmentTimes") !== -1
              && state.selection.appointmentTimes ? dyofT("cfg.render.appointment_times", "Appointment Times") : "",
            controlLabel("startDay", state.selection.startDay),
            controlLabel("language", state.selection.language)
          ];
        }
      }

      values.filter(Boolean).forEach(function(value) {
        var item = document.createElement("li");
        item.textContent = dyofDisplayLabel(value);
        this.elements.tags.appendChild(item);
      }, this);
    }

    reviewPriceText(state) {
      var offer;
      var purchase;
      var variantPrice;
      if (state.journey.productType === "planner") {
        offer = this.datedPlannerPriceOffer(state, true);
        if (offer) {
          return this.offerPriceText(offer);
        }
        if (state.journey.refillType === "undated") {
          purchase = this.resolveCartVariant(state);
          variantPrice = dyofPreviewVariantPrice(this, purchase.variant);
          return purchase.status === "ready" && variantPrice
            ? dyofT("cfg.render.price", "Price {price}", { price: variantPrice })
            : dyofT("cfg.render.price_unavailable", "Price unavailable");
        }
        var currentPrice = this.elements && this.elements.price
          ? String(this.elements.price.textContent || "").trim()
          : "";
        return (root.DYOFI18n ? Boolean(currentPrice) : /^(?:Price|From)\s+/.test(currentPrice))
          ? currentPrice
          : dyofT("cfg.render.price_unavailable", "Price unavailable");
      }
      offer = this.resolvePriceOffer(state);
      if (offer) {
        return this.offerPriceText(offer);
      }
      purchase = this.resolveCartVariant(state);
      variantPrice = dyofVariantPrice(this, purchase.variant);
      if (variantPrice) {
        return dyofT("cfg.render.price", "Price {price}", { price: variantPrice });
      }
      return state.journey.productType === "refill" ? dyofFallbackPrice(this, state, 1200) : dyofFallbackPrice(this, state, 2200);
    }

    reviewColourLabel(state) {
      if (state.selection.colourMode !== "single-colour") {
        return controlLabel("colourMode", state.selection.colourMode);
      }
      var colour = (this.contract.getSingleColours(state.selection.style) || []).filter(function(option) {
        return option.value === state.selection.singleColour;
      })[0];
      return colour ? dyofT("cfg.render.single_colour_label", "Single Colour - {colour}", { colour: dyofDisplayLabel(colour.label) }) : dyofT("cfg.render.single_colour", "Single Colour");
    }

    reviewPersonalDateLabel(item, selection) {
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(item.date || ""));
      var dateLabel = match
        ? root.DYOFI18n
          ? root.DYOFI18n.date(new Date(item.date + "T00:00:00Z"), { day: "numeric", month: "long", timeZone: "UTC" })
          : Number(match[3]) + " " + PERSONAL_DATE_MONTHS[Number(match[2]) - 1]
        : dyofT("cfg.render.date", "Date");
      return dyofT("cfg.render.review_personal_date", "{date} · {label}{frequency}{range}", {
        date: dateLabel,
        label: item.label,
        frequency: item.frequency && item.frequency !== "one-time"
          ? dyofT("cfg.render.review_date_frequency", " · {frequency}", { frequency: titleCase(item.frequency) }) : "",
        // Same flag as the Personal Dates list for a date the rebase cannot place.
        range: selection && this.stateApi.isPersonalDateInRange && !this.stateApi.isPersonalDateInRange(item, selection)
          ? dyofT("cfg.render.review_date_out_of_range", " · Not in this diary") : ""
      });
    }

    appendReviewSummaryGroup(titleText, editTarget, rows) {
      var section = document.createElement("section");
      var header = document.createElement("header");
      var title = document.createElement("h3");
      var edit = document.createElement("button");
      var list = document.createElement("dl");

      section.className = "dyof__review-summary-group";
      title.textContent = titleText;
      edit.type = "button";
      edit.className = "dyof__review-edit";
      edit.dataset.dyofReviewEdit = editTarget;
      edit.textContent = dyofT("cfg.render.edit", "Edit");
      edit.setAttribute("aria-label", dyofT("cfg.render.edit_choices", "Edit {title} choices", { title: titleText.toLowerCase() }));
      header.appendChild(title);
      if (editTarget) {
        header.appendChild(edit);
      }
      section.appendChild(header);

      rows.forEach(function(row) {
        if (row.value === null || row.value === undefined || row.value === "") {
          return;
        }
        var wrapper = document.createElement("div");
        var check = document.createElement("span");
        var term = document.createElement("dt");
        var description = document.createElement("dd");
        wrapper.className = "dyof__review-summary-row";
        check.className = "dyof__review-summary-check";
        check.setAttribute("aria-hidden", "true");
        term.textContent = row.label;
        if (Array.isArray(row.value)) {
          description.className = "dyof__review-summary-list";
          row.value.forEach(function(value) {
            var line = document.createElement("span");
            line.textContent = value;
            description.appendChild(line);
          });
        } else {
          description.textContent = row.value;
        }
        wrapper.appendChild(check);
        wrapper.appendChild(term);
        wrapper.appendChild(description);
        list.appendChild(wrapper);
      });
      section.appendChild(list);
      this.elements.reviewSummary.appendChild(section);
    }

    renderReviewSummary(state) {
      if (!this.elements.reviewSummary) {
        return;
      }
      clearChildren(this.elements.reviewSummary);
      var coveredProduct = state.journey.productType === "clipbook" || state.journey.productType === "planner";
      var extraPictures = coveredProduct
        ? state.cover.front.objects.concat(state.cover.back.objects).filter(function(object) {
          return object.type === "image";
        }).map(function(object) { return object.name; })
        : [];
      var style = this.contract.getStyle(state.selection.style);
      var legacyLayout = state.selection.engine === "legacy" && this.contract.getLegacyLayout
        ? this.contract.getLegacyLayout(state.selection.layout)
        : null;
      var legacyControls = legacyLayout ? legacyLayout.controls || [] : [];
      var fill = this.contract.getUndatedFill
        ? this.contract.getUndatedFill(state.journey.undatedFill)
        : null;
      var designRows = [
        { label: dyofT("cfg.render.size", "Size"), value: dyofDisplayLabel(sizeLabel(state.selection.size)) }
      ];
      var layoutRows = [
        {
          label: dyofT("cfg.render.refill_type", "Refill type"),
          value: state.journey.refillType === "undated" ? dyofT("cfg.render.undated_refill", "Undated Refill") : dyofT("cfg.render.dated_refill", "Dated Refill")
        }
      ];
      var personalRows = [];
      var organiserRows = this.organiserBreakdownRows(state);
      var organiserNote = organiserRows.length ? "" : this.organiserNote(state);

      if (organiserNote) {
        designRows.push({ label: dyofT("cfg.organiser.review_label", "Bundle"), value: organiserNote });
      }
      if (coveredProduct) {
        designRows.push({
          label: dyofT("cfg.render.cover_design", "Cover design"),
          value: state.cover.background ? dyofDisplayLabel(state.cover.background.title) : dyofT("cfg.render.no_cover_selected", "No cover selected")
        });
        if (elasticClosureOffered()) {
          designRows.push({
            label: dyofT("cfg.render.elastic_closure", "Elastic closure"),
            value: elasticClosureLabel(state.cover.elastic)
          });
        }
        if (extraPictures.length) {
          designRows.push({ label: dyofT("cfg.render.extra_picture", "Extra picture"), value: root.DYOFI18n ? root.DYOFI18n.list(extraPictures) : extraPictures.join(", ") });
        }
      }

      if (state.journey.refillType === "none") {
        // A Clipbook cover on its own has no Layout or Personalise to summarise.
        this.appendReviewSummaryGroup(dyofT("cfg.render.design", "Design"), "cover-selection", designRows);
        return;
      }

      if (state.journey.refillType === "undated") {
        layoutRows.push({
          label: dyofT("cfg.render.refill", "Refill"),
          value: fill ? dyofDisplayLabel(fill.label) : titleCase(state.journey.undatedFill)
        });
      } else {
        layoutRows.push(
          { label: dyofT("cfg.render.style", "Style"), value: style ? dyofDisplayLabel(style.label) : titleCase(state.selection.style) },
          {
            label: dyofT("cfg.render.colour_style", "Colour style"),
            value: state.selection.engine === "modern" ? this.reviewColourLabel(state) : dyofT("cfg.render.classic", "Classic")
          },
          {
            label: dyofT("cfg.render.paper_colour", "Paper colour"),
            value: effectivePaperColour(state) === "cream" ? dyofT("cfg.render.cream", "Cream") : dyofT("cfg.render.white", "White")
          },
          { label: dyofT("cfg.render.layout", "Layout"), value: designLabel(state.selection.layout) }
        );
        if (state.selection.engine === "modern") {
          layoutRows.push(
            { label: dyofT("cfg.render.view", "View"), value: designLabel(state.selection.layoutView) },
            { label: dyofT("cfg.render.date_position", "Date position"), value: controlLabel("datePosition", state.selection.datePosition) },
            {
              label: state.selection.layout === "monthly" ? dyofT("cfg.render.month_design", "Month design") : dyofT("cfg.render.day_design", "Day design"),
              value: designLabel(state.selection.dayDesign)
            },
            { label: dyofT("cfg.render.header_theme", "Header theme"), value: headerLabel(state.selection.headerTheme) }
          );
        } else {
          if (legacyControls.indexOf("lineStyle") !== -1) {
            layoutRows.push({ label: dyofT("cfg.render.line_style", "Line style"), value: titleCase(state.selection.lineStyle) });
          }
          if (legacyControls.indexOf("calendar") !== -1) {
            layoutRows.push({
              label: dyofT("cfg.render.calendar", "Calendar"),
              value: state.selection.calendar ? dyofT("cfg.render.included", "Included") : dyofT("cfg.render.not_included", "Not included")
            });
          }
          if (legacyControls.indexOf("notes") !== -1) {
            layoutRows.push({
              label: dyofT("cfg.render.notes", "Notes"),
              value: state.selection.notes ? dyofT("cfg.render.included", "Included") : dyofT("cfg.render.not_included", "Not included")
            });
          }
          if (legacyControls.indexOf("appointmentTimes") !== -1) {
            layoutRows.push({
              label: dyofT("cfg.render.appointment_times_summary", "Appointment times"),
              value: state.selection.appointmentTimes ? dyofT("cfg.render.included", "Included") : dyofT("cfg.render.not_included", "Not included")
            });
          }
        }

        var firstPageText = [state.firstPage.line1, state.firstPage.line2, state.firstPage.line3]
          .filter(Boolean)
          .join(" · ");
        var countries = state.features.countryHolidays.enabled
          ? state.features.countryHolidays.groups.map(function(value) {
            return holidayDisplayLabel("countryHolidays", value);
          })
          : [];
        var religions = state.features.religiousHolidays.enabled
          ? state.features.religiousHolidays.groups.map(function(value) {
            return holidayDisplayLabel("religiousHolidays", value);
          })
          : [];
        var personalDates = state.features.personalDates.map(function(item) {
          return this.reviewPersonalDateLabel(item, state.selection);
        }, this);
        personalRows = [
          { label: dyofT("cfg.render.cover_page", "Cover page"), value: firstPageText || dyofT("cfg.render.no_personal_text", "No personal text") },
          {
            label: dyofT("cfg.render.start_end_month", "Start and end month"),
            value: plannerPeriodLabel(
              state.selection.startMonth,
              state.selection.documentLengthMonths
            )
          },
          { label: dyofT("cfg.render.start_week", "Start week"), value: controlLabel("startDay", state.selection.startDay) },
          { label: dyofT("cfg.render.country_holidays", "Country holidays"), value: countries.length ? (root.DYOFI18n ? root.DYOFI18n.list(countries) : countries.join(", ")) : dyofT("cfg.render.none_selected", "None selected") },
          { label: dyofT("cfg.render.religious_holidays", "Religious holidays"), value: religions.length ? (root.DYOFI18n ? root.DYOFI18n.list(religions) : religions.join(", ")) : dyofT("cfg.render.none_selected", "None selected") },
          {
            label: dyofT("cfg.render.moon_location", "Moon phases location"),
            value: state.features.moonPhases.enabled
              ? timezoneLabel(state.features.moonPhases.timezoneOffset)
              : dyofT("cfg.render.not_included", "Not included")
          },
          { label: dyofT("cfg.render.personal_dates", "Personal dates"), value: personalDates.length ? personalDates : [dyofT("cfg.render.none_added", "None added")] }
        ];
      }

      if (organiserRows.length) {
        this.appendReviewSummaryGroup(dyofT("cfg.organiser.together_title", "Added to your basket together"), null, organiserRows);
      }
      this.appendReviewSummaryGroup(
        dyofT("cfg.render.design", "Design"),
        coveredProduct ? "cover-selection" : (state.journey.refillType === "undated" ? "undated-layout" : "dated-layout"),
        designRows
      );
      this.appendReviewSummaryGroup(
        dyofT("cfg.render.layout", "Layout"),
        state.journey.refillType === "undated" ? "undated-layout" : "dated-layout",
        layoutRows
      );
      if (personalRows.length) {
        this.appendReviewSummaryGroup(dyofT("cfg.render.personalise", "Personalise"), "planner-details", personalRows);
      }
    }

    updateReviewCheckoutAvailability(state) {
      var validation = this.reviewValidation || this.stateApi.validateState(state, holidayValidationMessages(this));
      var confirmed = this.reviewConfirmations.details && this.reviewConfirmations.policy;
      if (this.elements.reviewAddToCart) {
        this.elements.reviewAddToCart.disabled = Boolean(this.addToCartInFlight) || !validation.valid || !confirmed;
        this.elements.reviewAddToCart.title = !validation.valid
          ? (validation.errors[0] || dyofT("cfg.render.review_errors", "Review the configuration errors before continuing."))
          : !confirmed
            ? dyofT("cfg.render.confirm_cart", "Confirm both statements before adding this product to cart.")
            : "";
      }
    }

    renderReview(state) {
      if (!this.elements.review) {
        return;
      }
      if (this.elements.reviewScene) {
        this.elements.reviewScene.dataset.paper = effectivePaperColour(state);
      }
      if (this.reviewConfirmationRevision !== state.revision) {
        this.reviewConfirmationRevision = state.revision;
        this.reviewConfirmations = { details: false, policy: false };
      }

      var validation = this.stateApi.validateState(state, holidayValidationMessages(this));
      var productionError = this.undatedProductionError(state);
      var offer = this.resolvePriceOffer(state);
      var purchase = offer ? null : this.resolveCartVariant(state);
      // A preview-only fill has no offer by design; validateState already
      // gives the one reason it can't be bought.
      var previewOnly = state.journey.refillType === "undated"
        && this.undatedPurchase(state).status === "preview-only";
      var contentGate;
      if (productionError) {
        validation = {
          valid: false,
          errors: validation.errors.concat([productionError]),
          warnings: validation.warnings
        };
      }
      if (previewOnly) {
        validation = validation.valid
          ? { valid: false, errors: [dyofT("cfg.cart.undated_fill_unavailable", "This undated fill is not available to purchase yet.")], warnings: validation.warnings }
          : validation;
      } else if (offer && (offer.status !== "ready" || !offer.items.length)) {
        validation = {
          valid: false,
          errors: validation.errors.concat([
            offer.message || dyofT("cfg.preview.product_combination_unavailable", "This product combination is not available to purchase.")
          ]),
          warnings: validation.warnings
        };
      } else if (purchase && purchase.status !== "ready") {
        validation = {
          valid: false,
          errors: validation.errors.concat([
            purchase.message || dyofT("cfg.preview.configuration_unavailable", "This configuration is not available to purchase.")
          ]),
          warnings: validation.warnings
        };
      }
      contentGate = this.contentCheckGate(state);
      if (!contentGate.valid) {
        validation = {
          valid: false,
          errors: validation.errors.concat([contentGate.message]),
          warnings: validation.warnings
        };
      }
      this.reviewValidation = validation;

      if (this.elements.reviewPrice) {
        this.elements.reviewPrice.textContent = this.reviewPriceText(state);
      }
      (this.elements.reviewConfirmations || []).forEach(function(input) {
        input.checked = Boolean(this.reviewConfirmations[input.dataset.dyofReviewConfirm]);
      }, this);

      if (this.elements.reviewErrors) {
        clearChildren(this.elements.reviewErrors);
        validation.errors.forEach(function(message) {
          var item = document.createElement("li");
          item.textContent = message;
          this.elements.reviewErrors.appendChild(item);
        }, this);
        this.elements.reviewErrors.hidden = validation.valid;
      }
      if (this.elements.reviewAlert && this.elements.reviewAlert.textContent
        && validation.errors.indexOf(this.elements.reviewAlert.textContent) === -1) {
        this.clearReviewStop();
      }

      this.renderReviewSummary(state);
      this.updateReviewCheckoutAvailability(state);
    }

    reviewPagePayload(state, pageNumbers) {
      if (state.journey.refillType === "none") {
        return null;
      }
      if (state.journey.refillType === "undated") {
        var fill = this.contract && this.contract.getUndatedFill
          ? this.contract.getUndatedFill(state.journey.undatedFill)
          : null;
        var undatedPurchase = fill ? this.undatedPurchase(state) : null;
        // The preview service holds only the A5 Journal sources. An Everyday
        // stock fill (A5 or Personal) has no production pages, so Review
        // shows its static sample spread instead (undatedReviewSampleSpread).
        if (
          !fill
          || state.selection.size !== "a5"
          || undatedPurchase.status !== "ready"
          || undatedPurchase.stockFill === true
          || !undatedPurchase.pageCount
        ) {
          return null;
        }
        return {
          engine: "undated",
          renderMode: "preview",
          version: state.contractVersion,
          selection: {
            fillKey: state.journey.undatedFill,
            size: state.selection.size,
            sku: undatedPurchase.sku
          },
          pageRequest: {
            requestedPages: Array.from(new Set(pageNumbers.map(Number))),
            documentOrder: "final"
          }
        };
      }
      var payload = this.stateApi.getPreviewRequest(state, {
        requestedPages: pageNumbers,
        documentOrder: "final"
      });
      if (payload && payload.engine === "modern") {
        payload.imageEncoding = "svg";
      }
      return payload;
    }

    cartRefillPreviewPayload(state) {
      if (!state || !state.journey) { return null; }
      if (state.journey.refillType === "undated") {
        return this.reviewPagePayload(state, [1, 2]);
      }
      return this.stateApi.getPreviewRequest(state, { type: "week", index: 1 });
    }

    composeRefillCartThumbnail(renderedPages, state, optionsInput) {
      var options = optionsInput || {};
      var pages = (Array.isArray(renderedPages) ? renderedPages : []).slice(0, 2);
      if (!pages.length) {
        throw dyofCustomerError(dyofT("cfg.preview.cart_no_pages", "The exact refill preview returned no pages for cart capture."));
      }
      var dimensions = pages.map(function(content) {
        var width = Number(content && (content.naturalWidth || content.width));
        var height = Number(content && (content.naturalHeight || content.height));
        if (!(width > 0) || !(height > 0)) {
          throw dyofCustomerError(dyofT("cfg.preview.cart_invalid_dimensions", "An exact refill preview page has no renderable dimensions."));
        }
        return { width: width, height: height };
      });
      var maxEdge = Math.min(
        Number(root.DYOFCoverEditor && root.DYOFCoverEditor.CART_THUMBNAIL_MAX_EDGE) || 640,
        Math.max(96, Math.round(Number(options.maxEdge) || 640))
      );
      var rawGap = pages.length > 1 ? 8 : 0;
      var rawWidth = dimensions.reduce(function(total, item) { return total + item.width; }, 0) + rawGap;
      var rawHeight = dimensions.reduce(function(maximum, item) { return Math.max(maximum, item.height); }, 0);
      var scale = Math.min(1, maxEdge / Math.max(rawWidth, rawHeight));
      var gap = pages.length > 1 ? Math.max(2, Math.round(rawGap * scale)) : 0;
      var targetDimensions = dimensions.map(function(item) {
        return {
          width: Math.max(1, Math.round(item.width * scale)),
          height: Math.max(1, Math.round(item.height * scale))
        };
      });
      var canvasWidth = targetDimensions.reduce(function(total, item) { return total + item.width; }, 0) + gap;
      var canvasHeight = targetDimensions.reduce(function(maximum, item) { return Math.max(maximum, item.height); }, 0);
      var canvas = options.createCanvas
        ? options.createCanvas()
        : document.createElement("canvas");
      canvas.width = Math.max(1, canvasWidth);
      canvas.height = Math.max(1, canvasHeight);
      var context = canvas.getContext && canvas.getContext("2d");
      if (!context) {
        throw dyofCustomerError(dyofT("cfg.preview.cart_no_context", "The exact refill thumbnail could not create a drawing context."));
      }
      context.fillStyle = "#FFFFFF";
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      var cursorX = 0;
      var creamPaper = effectivePaperColour(state) === "cream";
      pages.forEach(function(content, index) {
        var target = targetDimensions[index];
        var y = Math.round((canvas.height - target.height) / 2);
        context.globalCompositeOperation = "source-over";
        context.drawImage(content, cursorX, y, target.width, target.height);
        if (creamPaper) {
          context.globalCompositeOperation = "multiply";
          context.fillStyle = "rgba(247, 240, 223, 0.68)";
          context.fillRect(cursorX, y, target.width, target.height);
        }
        cursorX += target.width + gap;
      });
      context.globalCompositeOperation = "source-over";
      return canvas;
    }

    // Reuse decoded Layout/Refill pixels, or the exact first Review page when
    // personalisation invalidated Layout. Share Review's existing request.
    async captureStockFillCartThumbnail(state, optionsInput) {
      return this.captureExistingRefillCartThumbnail(state, optionsInput);
    }

    async captureRefillCartThumbnail(state, optionsInput) {
      return this.isStockFill(state)
        ? this.captureStockFillCartThumbnail(state, optionsInput)
        : this.captureExistingRefillCartThumbnail(state, optionsInput);
    }

    async captureExistingRefillCartThumbnail(state, optionsInput) {
      var options = optionsInput || {};
      var diagnostics = root.DYOFCoverEditor
        && typeof root.DYOFCoverEditor.createCartThumbnailDiagnostics === "function"
        ? root.DYOFCoverEditor.createCartThumbnailDiagnostics("refill")
        : null;
      var runStage = diagnostics
        ? function(stage, work) { return diagnostics.run(stage, work, options.signal); }
        : async function(stage, work) {
          throwIfPreviewAborted(options.signal);
          var result = await work();
          throwIfPreviewAborted(options.signal);
          return result;
        };
      var captureError = null;
      try {
        var key = this.cartThumbnailKey("refill", state);
        if (!this.cartRefillPreview || this.cartRefillPreview.key !== key) {
          var staticPreview = this.cartRefillPreviewReady;
          var preload = staticPreview && staticPreview.key === key ? null : this.ensureReviewPreload(state);
          var pending = staticPreview && staticPreview.key === key ? staticPreview.promise : preload && preload.promise;
          if (pending) { await withTimeout(pending, 15000); }
          throwIfPreviewAborted(options.signal);
          if (preload && preload.result) {
            this.rememberRefillCartPreview(state, preload.result.renderedPages.map(function(page) { return page.content; }));
          }
        }
        var canvas = await runStage("scene", function() {
          var preview = this.cartRefillPreview;
          if (!preview || preview.key !== this.cartThumbnailKey("refill", state)) {
            throw dyofCustomerError(dyofT("cfg.preview.cart_no_preview", "The selected refill has no exact cart preview."));
          }
          return this.composeRefillCartThumbnail(preview.pages, state, options);
        }.bind(this));
        var asset = await runStage("encode", function() {
          if (!root.DYOFCoverEditor || typeof root.DYOFCoverEditor.encodeCartThumbnail !== "function") {
            throw dyofCustomerError(dyofT("cfg.preview.cart_encoding_unavailable", "Cart thumbnail encoding support is unavailable."));
          }
          return root.DYOFCoverEditor.encodeCartThumbnail(canvas, "refill", options);
        });
        throwIfPreviewAborted(options.signal);
        return asset;
      } catch (error) {
        captureError = error;
        throw error;
      } finally {
        if (diagnostics) { diagnostics.finish(captureError, options.signal); }
      }
    }

    reviewIdentityForState(state) {
      if (!state) {
        return "";
      }
      var payload = this.reviewPagePayload(state, this.reviewPreloadPages(state));
      var reviewState = Object.assign({}, state, { screen: "review" });
      var coveredProduct = state.journey.productType === "clipbook"
        || state.journey.productType === "planner";
      var pageIdentity = payload
        ? previewRequestKey(reviewState, payload)
        : JSON.stringify(stablePreviewValue({
            contractVersion: state.contractVersion,
            journey: state.journey,
            selection: state.selection,
            firstPage: state.firstPage,
            features: state.features
          }));
      return JSON.stringify(stablePreviewValue({
        pageIdentity: pageIdentity,
        coverIdentity: coveredProduct ? this.reviewCoverKey(state) : null
      }));
    }

    reviewCoverKey(state) {
      if (!state) {
        return "";
      }
      var journey = state.journey || {};
      var selection = state.selection || {};
      return JSON.stringify([
        journey.productType,
        journey.lifestyle,
        selection.size,
        state.cover || null
      ]);
    }

    discardReviewCoverPreload() {
      var entry = this.reviewCoverPreload;
      this.reviewCoverGeneration = Number(this.reviewCoverGeneration || 0) + 1;
      if (!entry) {
        return;
      }
      if (entry.controller) {
        entry.controller.abort();
      }
      entry.images = [];
      entry.immediateWrapper = null;
      entry.hydratedWrapper = null;
      this.reviewCoverPreload = null;
    }

    async warmReviewCoverUrls(entry, urls) {
      var pending = [];
      (Array.isArray(urls) ? urls : []).forEach(function(source) {
        source = String(source || "");
        if (!source || entry.sources.has(source)) {
          return;
        }
        entry.sources.add(source);
        var image = document.createElement("img");
        image.decoding = "async";
        entry.images.push(image);
        pending.push(loadImageSource(image, source, entry.controller.signal).catch(function(error) {
          entry.sources.delete(source);
          entry.images = entry.images.filter(function(candidate) {
            return candidate !== image;
          });
          throw error;
        }));
      }, this);
      await Promise.all(pending);
    }

    ensureReviewCoverPreload(state) {
      if (
        !state
        || !this.coverEditor
        || typeof this.coverEditor.buildReviewScenesImmediate !== "function"
        || typeof this.coverEditor.getReviewAssetUrls !== "function"
        || (state.journey.productType !== "clipbook" && state.journey.productType !== "planner")
      ) {
        return null;
      }
      var key = this.reviewCoverKey(state);
      if (
        this.reviewCoverPreload
        && this.reviewCoverPreload.key === key
        && this.reviewCoverPreload.status !== "error"
        && this.reviewCoverPreload.status !== "aborted"
      ) {
        return this.reviewCoverPreload;
      }
      this.discardReviewCoverPreload();
      var generation = Number(this.reviewCoverGeneration || 0) + 1;
      this.reviewCoverGeneration = generation;
      var immediate = this.coverEditor.buildReviewScenesImmediate(state);
      var hydrationRequired = immediate.dataset.hydrationRequired === "true";
      var entry = {
        key: key,
        generation: generation,
        controller: new AbortController(),
        sources: new Set(),
        images: [],
        immediateWrapper: immediate,
        hydratedWrapper: null,
        status: "loading",
        error: null,
        promise: null
      };
      this.reviewCoverPreload = entry;
      entry.promise = (async function() {
        try {
          var hydrationPromise = hydrationRequired
            ? this.coverEditor.buildReviewScenes(state)
            : null;
          var initialWarmError = null;
          try {
            await this.warmReviewCoverUrls(entry, this.coverEditor.getReviewAssetUrls(state));
          } catch (error) {
            if (error && error.name === "AbortError") {
              throw error;
            }
            initialWarmError = error;
          }
          if (hydrationRequired) {
            var hydrated = await hydrationPromise;
            if (this.reviewCoverPreload !== entry || entry.controller.signal.aborted) {
              return null;
            }
            await this.warmReviewCoverUrls(entry, this.coverEditor.getReviewAssetUrls(state));
            var exact = this.coverEditor.buildReviewScenesImmediate(state);
            entry.hydratedWrapper = exact.dataset.hydrationRequired === "false"
              ? exact
              : hydrated;
            initialWarmError = null;
          }
          if (initialWarmError) {
            throw initialWarmError;
          }
          if (this.reviewCoverPreload !== entry || entry.controller.signal.aborted) {
            return null;
          }
          entry.status = "ready";
          return entry;
        } catch (error) {
          entry.error = error;
          entry.status = error && error.name === "AbortError" ? "aborted" : "error";
          return null;
        }
      }.bind(this))();
      return entry;
    }

    prepareReviewCoverFigures(wrapper, state) {
      var coverFigures = wrapper
        ? Array.from(wrapper.querySelectorAll("figure"))
        : [];
      coverFigures.forEach(function(figure) {
        figure.classList.add("dyof__review-item--" + state.journey.productType);
        figure.querySelectorAll("[data-cover-preview-object]").forEach(function(object) {
          object.removeAttribute("tabindex");
          object.removeAttribute("role");
          object.removeAttribute("aria-label");
        });
      });
      if (coverFigures[0]) {
        coverFigures[0].dataset.dyofReviewItem = "front-cover";
        coverFigures[0].classList.add("dyof__review-item", "dyof__review-item--cover");
      }
      if (coverFigures[1]) {
        coverFigures[1].dataset.dyofReviewItem = "back-cover";
        coverFigures[1].classList.add("dyof__review-item", "dyof__review-item--cover");
      }
      return coverFigures;
    }

    mountInitialReviewCovers(wrapper, state) {
      var figures = this.prepareReviewCoverFigures(wrapper, state);
      if (figures[0]) {
        this.elements.reviewScene.appendChild(figures[0]);
        this.recordWp2PreviewCommit("review-cover-shell", this.reviewCoverKey(state), state);
      }
      this.reviewPendingBackCover = figures[1] || null;
      return Boolean(figures[0]);
    }

    hydrateMountedReviewCovers(entry, state) {
      if (!entry || !entry.promise) {
        return;
      }
      entry.promise.then(function() {
        var current = this.store && this.store.getState();
        if (
          this.reviewCoverPreload !== entry
          || this.reviewCoverGeneration !== entry.generation
          || !current
          || current.screen !== "review"
          || this.reviewCoverKey(current) !== entry.key
          || !entry.hydratedWrapper
        ) {
          return;
        }
        var figures = this.prepareReviewCoverFigures(entry.hydratedWrapper, current);
        var front = this.reviewItems().find(function(item) {
          return item.dataset.dyofReviewItem === "front-cover";
        });
        if (front && figures[0] && front.parentNode) {
          figures[0].hidden = front.hidden;
          front.parentNode.replaceChild(figures[0], front);
        }
        if (figures[1]) {
          if (this.reviewPendingBackCover) {
            this.reviewPendingBackCover = figures[1];
          } else {
            var back = this.reviewItems().find(function(item) {
              return item.dataset.dyofReviewItem === "back-cover";
            });
            if (back && back.parentNode) {
              figures[1].hidden = back.hidden;
              back.parentNode.replaceChild(figures[1], back);
            }
          }
        }
        entry.hydratedWrapper = null;
        this.updateReviewCarousel();
        this.recordWp2PreviewCommit("review-cover-assets", entry.key, current);
      }.bind(this));
    }

    reviewPreloadPages(state) {
      return [1];
    }

    reviewPreloadKey(state) {
      var payload = this.reviewPagePayload(state, this.reviewPreloadPages(state));
      if (!payload) {
        return "";
      }
      var reviewState = Object.assign({}, state, { screen: "review" });
      return previewRequestKey(reviewState, payload);
    }

    isCurrentReviewWork(state, generation, expectedKey) {
      var current = this.store && this.store.getState();
      var key = expectedKey == null ? this.reviewKey : expectedKey;
      return Boolean(
        current
        && current.screen === "review"
        && this.reviewRevision === state.revision
        && this.reviewKey === key
        && this.reviewPreloadKey(current) === key
        && (generation == null || generation === this.reviewNavigationGeneration)
      );
    }

    ensureReviewPreload(state) {
      if (!state) {
        return null;
      }
      var payload = this.reviewPagePayload(state, this.reviewPreloadPages(state));
      if (!payload) {
        return null;
      }
      var key = this.reviewPreloadKey(state);
      if (
        this.reviewPreload
        && this.reviewPreload.key === key
        && !this.reviewPreload.error
      ) {
        return this.reviewPreload;
      }

      this.discardReviewPreload();
      var entry = {
        key: key,
        controller: new AbortController(),
        urls: [],
        result: null,
        error: null,
        promise: null
      };
      this.reviewPreload = entry;
      entry.promise = (async function() {
        try {
          var body = await this.fetchPreview(payload, entry.controller.signal);
          if (this.reviewPreload !== entry) {
            return null;
          }
          var pages = Array.isArray(body.pages) ? body.pages : [];
          var rendered = await Promise.all(pages.map(async function(page) {
            var content = await this.renderPageContent(
              page,
              dyofT("cfg.preview.refill_page", "Refill page {page}", { page: String(page.pageNumber) }),
              { signal: entry.controller.signal, objectUrls: entry.urls }
            );
            return content ? { page: page, content: content } : null;
          }, this));
          if (this.reviewPreload !== entry) {
            return null;
          }
          rendered = rendered.filter(Boolean);
          if (!rendered.length) {
            throw dyofCustomerError(dyofT("cfg.preview.first_review_failed", "The first review page could not be generated."));
          }
          entry.result = { body: body, renderedPages: rendered };
          this.rememberRefillCartPreview(state, rendered.map(function(page) { return page.content; }));
          return entry.result;
        } catch (error) {
          entry.error = error;
          if (this.reviewPreload === entry && (!error || error.name !== "AbortError")) {
            entry.urls.forEach(function(url) { URL.revokeObjectURL(url); });
            entry.urls = [];
          }
          return null;
        }
      }.bind(this))();
      return entry;
    }

    consumeReviewPreload(state) {
      var entry = this.reviewPreload;
      if (
        !entry
        || !entry.result
        || entry.key !== this.reviewPreloadKey(state)
      ) {
        return false;
      }
      this.reviewUrls = this.reviewUrls.concat(entry.urls);
      entry.urls = [];
      this.reviewTotalPages = Number(entry.result.body.totalPages || 0);
      this.reviewRendererVersion = String(entry.result.body.rendererVersion || "");
      this.reviewPersonalDatePageNumbers = this.normalizeReviewPersonalDatePages(
        entry.result.body.personalDatePageNumbers
      );
      this.appendReviewPageViews(entry.result.renderedPages, state);
      this.reviewLoadedThrough = entry.result.renderedPages.reduce(function(maximum, rendered) {
        return Math.max(maximum, Number(rendered.page.pageNumber || 0));
      }, 0);
      this.reviewPreload = null;
      return this.reviewLoadedThrough > 0;
    }

    discardReviewPreload() {
      if (!this.reviewPreload) {
        return;
      }
      if (this.reviewPreload.controller) {
        this.reviewPreload.controller.abort();
      }
      (this.reviewPreload.urls || []).forEach(function(url) {
        URL.revokeObjectURL(url);
      });
      this.reviewPreload.urls = [];
      this.reviewPreload = null;
    }

    reviewNextSpreadKey(state, pageNumbers) {
      return JSON.stringify(stablePreviewValue({
        identity: this.reviewIdentityForState(state),
        pages: pageNumbers,
        totalPages: this.reviewTotalPages,
        rendererVersion: this.reviewRendererVersion
      }));
    }

    canBufferReviewNextSpread(state, foreground) {
      var connection = root.navigator && root.navigator.connection;
      return Boolean(
        state
        && state.screen === "review"
        && state.journey.refillType === "dated"
        && state.selection.engine === "modern"
        && this.reviewRendererVersion
        && (foreground || (!document.hidden
          && !(connection && (connection.saveData || /(^|-)2g$|^3g$/.test(connection.effectiveType || "")))))
        && Number.isInteger(this.reviewTotalPages)
        && this.reviewTotalPages > 0
        && this.isCurrentReviewWork(state, null, this.reviewKey)
      );
    }

    scheduleReviewNextSpread(state) {
      if (!this.canBufferReviewNextSpread(state, this.reviewNextSpread && this.reviewNextSpread.claimed)) {
        this.discardReviewNextSpread();
        return null;
      }
      if (this.reviewNavigationBusy || this.reviewAbortController || this.isReviewSceneLoading()) {
        return null;
      }
      var range = this.reviewItemPageRange(this.reviewItems()[this.reviewCurrentIndex]);
      var pages = range && range.end < this.reviewTotalPages
        ? this.reviewViewPagesForTarget(state, range.end + 1)
        : [];
      if (!pages.length || pages.length > 2 || pages.some(function(page) {
        return this.reviewLoadedPageNumbers.has(page);
      }, this)) {
        this.discardReviewNextSpread();
        return null;
      }
      var key = this.reviewNextSpreadKey(state, pages);
      if (this.reviewNextSpread && this.reviewNextSpread.key === key) {
        return this.reviewNextSpread;
      }
      this.discardReviewNextSpread();
      var payload = this.reviewPagePayload(state, pages);
      if (!payload) { return null; }
      var entry = {
        key: key,
        controller: new AbortController(),
        urls: [],
        result: null,
        started: false,
        claimed: false,
        totalPages: this.reviewTotalPages,
        rendererVersion: this.reviewRendererVersion
      };
      this.reviewNextSpread = entry;
      entry.promise = new Promise(function(resolve) { entry.resolve = resolve; });
      entry.start = function() {
        if (entry.started) { return; }
        entry.started = true;
        clearTimeout(entry.timer);
        (async function() {
          try {
            throwIfPreviewAborted(entry.controller.signal);
            if (
              this.reviewNextSpread !== entry
              || !this.canBufferReviewNextSpread(state, entry.claimed)
              || (!entry.claimed && (this.reviewNavigationBusy || this.reviewAbortController))
            ) { throw previewAbortError(); }
            entry.networkTimer = setTimeout(function() {
              if (this.reviewNextSpread === entry) { this.discardReviewNextSpread(); }
            }.bind(this), 15000);
            var body = await this.fetchPreview(payload, entry.controller.signal);
            clearTimeout(entry.networkTimer);
            entry.networkTimer = null;
            throwIfPreviewAborted(entry.controller.signal);
            if (this.reviewNextSpread !== entry || !this.canBufferReviewNextSpread(state, entry.claimed)) {
              throw previewAbortError();
            }
            var returned = Array.isArray(body.pages) ? body.pages : [];
            var returnedNumbers = returned.map(function(page) { return Number(page.pageNumber); });
            var sourceUtf16CodeUnits = returned.reduce(function(total, page) {
              return total + String(page.imageSvg || "").length
                + String(page.imageDataUrl || "").length + String(page.pdfBase64 || "").length;
            }, 0);
            var maxSourceUtf16CodeUnits = 8 * 1024 * 1024; // At most ~16 MiB of UTF-16 source text.
            if (
              body.rendererVersion !== entry.rendererVersion
              || Number(body.totalPages) !== entry.totalPages
              || returned.length !== pages.length
              || new Set(returnedNumbers).size !== pages.length
              || pages.some(function(page) { return returnedNumbers.indexOf(page) === -1; })
              || sourceUtf16CodeUnits > maxSourceUtf16CodeUnits
            ) { throw new Error("The buffered review spread did not match the requested pages."); }
            var renderedPages = await Promise.all(returned.map(async function(page) {
              var content = await this.renderPageContent(
                page,
                dyofT("cfg.preview.refill_page", "Refill page {page}", { page: String(page.pageNumber) }),
                { signal: entry.controller.signal, objectUrls: entry.urls }
              );
              if (!content) { throw new Error("The buffered review page could not be rendered."); }
              return { page: { pageNumber: Number(page.pageNumber), side: page.side }, content: content };
            }, this));
            throwIfPreviewAborted(entry.controller.signal);
            if (
              this.reviewNextSpread !== entry
              || !this.canBufferReviewNextSpread(state, entry.claimed)
              || entry.key !== this.reviewNextSpreadKey(state, pages)
            ) { throw previewAbortError(); }
            entry.result = {
              renderedPages: renderedPages,
              personalDatePageNumbers: this.normalizeReviewPersonalDatePages(body.personalDatePageNumbers)
            };
            entry.resolve(entry.result);
          } catch (error) {
            if (this.reviewNextSpread === entry) { this.discardReviewNextSpread(); }
            entry.resolve(null);
          } finally {
            clearTimeout(entry.networkTimer);
            entry.networkTimer = null;
          }
        }.bind(this))();
      }.bind(this);
      entry.timer = setTimeout(entry.start, 120);
      return entry;
    }

    discardReviewNextSpread() {
      var entry = this.reviewNextSpread;
      if (!entry) { return; }
      this.reviewNextSpread = null;
      clearTimeout(entry.timer);
      clearTimeout(entry.networkTimer);
      entry.networkTimer = null;
      entry.controller.abort();
      entry.urls.forEach(function(url) { URL.revokeObjectURL(url); });
      entry.urls = [];
      entry.result = null;
      entry.resolve(null);
    }

    setReviewStatus(message, status) {
      if (!this.elements.reviewStatus) {
        return;
      }
      this.elements.reviewStatus.textContent = message;
      this.elements.reviewStatus.dataset.status = status || "ready";
    }

    setReviewSceneLoading(mode, message) {
      if (!this.elements.reviewScene) {
        return;
      }
      if (mode) {
        this.elements.reviewScene.dataset.reviewLoading = mode;
        this.elements.reviewScene.setAttribute("aria-busy", "true");
        this.setReviewStatus(message || dyofT("cfg.preview.review_loading", "Loading review pages…"), "loading");
        return;
      }
      delete this.elements.reviewScene.dataset.reviewLoading;
      this.elements.reviewScene.setAttribute("aria-busy", "false");
    }

    suspendReviewSession() {
      this.discardReviewNextSpread();
      this.reviewNavigationGeneration = Number(this.reviewNavigationGeneration || 0) + 1;
      this.reviewNavigationBusy = false;
      this.reviewRevision = null;
      this.reviewKey = null;
      this.pendingReloadReviewDestination = null;
      this.reloadReviewDestinationRestoring = false;
      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
        this.reviewAbortController = null;
      }
      this.setReviewSceneLoading(null);
    }

    isReviewSceneLoading() {
      return Boolean(
        this.elements.reviewScene
        && this.elements.reviewScene.dataset.reviewLoading
      );
    }

    reviewItems() {
      return this.elements.reviewScene
        ? Array.from(this.elements.reviewScene.querySelectorAll("[data-dyof-review-item]"))
        : [];
    }

    isRestorableReviewItem(item) {
      if (!item) {
        return false;
      }
      if (this.reviewItemPageRange(item)) {
        return true;
      }
      return ["front-cover", "back-cover", "attached-pdf", "sample-spread"].indexOf(
        item.dataset.dyofReviewItem
      ) !== -1;
    }

    canResumeReview(state, identity) {
      if (
        !state
        || state.screen !== "review"
        || !identity
        || this.reviewMountedIdentity !== identity
      ) {
        return false;
      }
      var items = this.reviewItems();
      var index = Number(this.reviewCurrentIndex);
      return Number.isInteger(index)
        && index >= 0
        && index < items.length
        && this.isRestorableReviewItem(items[index]);
    }

    resumeMountedReview(state, key, identity) {
      this.reviewNavigationGeneration = Number(this.reviewNavigationGeneration || 0) + 1;
      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
        this.reviewAbortController = null;
      }
      this.reviewNavigationBusy = false;
      this.reviewRevision = state.revision;
      this.reviewKey = key;
      this.reviewMountedIdentity = identity;
      this.setReviewSceneLoading(null);
      this.updateReviewCarousel();
    }

    mountReviewRefillShell(state) {
      if (!this.elements.reviewScene) {
        return null;
      }
      var figure = document.createElement("figure");
      var papers = document.createElement("div");
      var caption = document.createElement("figcaption");
      figure.className = "dyof__review-item dyof__review-item--page dyof__review-item--single dyof__review-item--shell";
      figure.dataset.dyofReviewItem = "preview-shell";
      figure.dataset.dyofReviewPageSide = "right";
      papers.className = "dyof__review-papers";
      caption.textContent = dyofT("cfg.preview.first_review_preparing_caption", "Preparing your first review page");
      var productFrame = this.createReviewProductFrame(state, papers, { openingPage: true });
      if (productFrame) {
        figure.classList.add("dyof__review-item--bound");
      }
      figure.appendChild(productFrame || papers);
      figure.appendChild(caption);
      this.elements.reviewScene.appendChild(figure);
      this.recordWp2PreviewCommit("review-shell", this.reviewPreloadKey(state), state);
      return figure;
    }

    createReviewProductFrame(state, papers, options) {
      var product = state && state.journey && state.journey.productType;
      if (["clipbook", "planner", "refill"].indexOf(product) === -1 || !this.dataset
        || !state.selection || ["a5", "personal", "a4"].indexOf(state.selection.size) === -1) {
        return null;
      }
      var size = state.selection.size;
      var personal = size === "personal";
      if ((product === "planner" && size !== "a5") || (size === "a4" && product !== "refill")) {
        return null;
      }
      var scene = this.openSpreadScene(state);
      if (!scene.image || scene.id === "a5" || scene.width !== 1600 || scene.height !== 1600) {
        return null;
      }
      var geometry = personal
        ? { crop: [363, 425, 879, 742], left: 378, right: 834, top: 439, width: 396, height: 714,
          clip: "polygon(0 0, 48% 0, 48% 2.5%, 52% 2.5%, 52% 0, 100% 0, 100% 100%, 52% 100%, 52% 97.5%, 48% 97.5%, 48% 100%, 0 100%)" }
        : product === "planner"
          ? { crop: [224, 421, 1152, 752], left: 275, right: 812, top: 436, width: 513, height: 723,
            clip: "inset(0 round 1.6%)" }
          : { crop: [255, 426, 1093, 742], left: 267, right: 823, top: 435, width: 510, height: 719,
            clip: "polygon(0 0, 49.2% 0, 49.2% 2.5%, 50.6% 2.5%, 50.6% 0, 100% 0, 100% 100%, 50.6% 100%, 50.6% 97.5%, 49.2% 97.5%, 49.2% 100%, 0 100%)" };
      if (product === "refill") {
        var outline = REVIEW_ORGANISER_OUTLINES[size];
        if (personal) {
          var outlineStyle = scene.previewTemplate;
          var outlineSource = PERSONAL_ORGANISER_SCENES[outlineStyle];
          if (!outlineSource || !this.dataset[outlineSource.openDataset]) {
            outlineStyle = "classic";
          }
          outline = outline[outlineStyle];
          scene.id = "personal-organiser-" + outlineStyle;
        } else if (size === "a5") {
          outline = outline[scene.previewTemplate] || outline.classic;
        }
        var page = size === "a4" ? A4_ORGANISER_PAGE
          : personal ? { leftX: 378, rightX: 834, top: 439, width: 396, height: 714 }
            : { leftX: 426, rightX: 958, top: 440, width: 503, height: 713 };
        geometry = { crop: outline.crop, clip: outline.clip, left: page.leftX, right: page.rightX,
          top: page.top, width: page.width, height: page.height };
      }
      var frontSheet = options && options.openingPage ? this.firstPageProductScene(state) : null;
      if (frontSheet && frontSheet.frontSheet) {
        scene = frontSheet;
      }
      var frame = document.createElement("div");
      var layer = document.createElement("img");
      var crop = geometry.crop;
      var paperWidth = geometry.right - geometry.left + geometry.width;
      frame.className = "dyof__review-product";
      frame.dataset.dyofReviewProduct = size + "-" + (product === "refill" ? "organiser" : product);
      frame.dataset.dyofReviewProductSource = scene.id;
      if (frontSheet && frontSheet.frontSheet) {
        frame.dataset.dyofReviewFirstPage = "true";
      }
      frame.style.setProperty("--dyof-review-product-ratio", String(crop[2] / crop[3]));
      frame.style.setProperty("--dyof-review-paper-stock", effectivePaperColour(state) === "cream" ? REVIEW_CREAM_PAPER_STOCK : "#fff");
      frame.style.clipPath = geometry.clip;
      papers.style.left = (geometry.left - crop[0]) / crop[2] * 100 + "%";
      papers.style.top = (geometry.top - crop[1]) / crop[3] * 100 + "%";
      papers.style.width = paperWidth / crop[2] * 100 + "%";
      papers.style.height = geometry.height / crop[3] * 100 + "%";
      papers.style.setProperty("--dyof-review-product-gap-ratio", String(
        (geometry.right - geometry.left - geometry.width) / paperWidth
      ));
      layer.className = "dyof__review-product-layer";
      layer.alt = "";
      layer.setAttribute("aria-hidden", "true");
      layer.decoding = "async";
      layer.width = scene.width;
      layer.height = scene.height;
      layer.style.left = -crop[0] / crop[2] * 100 + "%";
      layer.style.top = -crop[1] / crop[3] * 100 + "%";
      layer.style.width = scene.width / crop[2] * 100 + "%";
      layer.style.height = scene.height / crop[3] * 100 + "%";
      layer.src = scene.image;
      frame.appendChild(papers);
      frame.appendChild(layer);
      return frame;
    }

    // An Everyday stock fill has no production pages (the printer prints the
    // standard fill), and a preview-only fill none yet, so Review shows the
    // two chooser pages between the covers, bound in the chosen product,
    // without a request. Null for every fill with served pages (Journals).
    undatedReviewSampleSpread(state) {
      if (
        !state
        || !state.journey
        || state.journey.refillType !== "undated"
        || (this.undatedPurchase(state).status !== "preview-only" && !this.isStockFill(state))
      ) {
        return null;
      }
      var preview = this.undatedSizedPreview(state, state.journey.undatedFill);
      if (!preview || !preview.left || !preview.right) {
        return null;
      }
      var fill = this.contract && this.contract.getUndatedFill
        ? this.contract.getUndatedFill(state.journey.undatedFill)
        : null;
      var fillLabel = fill ? dyofDisplayLabel(fill.label) : dyofT("cfg.preview.undated_refill", "Undated refill");
      var figure = document.createElement("figure");
      var papers = document.createElement("div");
      var caption = document.createElement("figcaption");
      figure.className = "dyof__review-item dyof__review-item--page dyof__review-item--spread";
      figure.dataset.dyofReviewItem = "sample-spread";
      figure.hidden = true;
      papers.className = "dyof__review-papers";
      var images = [preview.left, preview.right].map(function(source, index) {
        var image = document.createElement("img");
        image.alt = dyofT("cfg.preview.undated_page_alt", "{fill} preview page {page}", { fill: fillLabel, page: index + 1 });
        image.decoding = "async";
        image.width = preview.width || 840;
        image.height = preview.height || 1192;
        image.crossOrigin = "anonymous";
        this.prepareReviewPaper(image);
        papers.appendChild(image);
        return image;
      }, this);
      var key = this.cartThumbnailKey("refill", state);
      this.cartRefillPreviewReady = { key: key, promise: Promise.all(images.map(function(image, index) {
        return loadImageSource(image, index ? preview.right : preview.left);
      })).then(function() {
        this.rememberRefillCartPreview(state, images);
      }.bind(this)).catch(function(error) { this.warnCartMedia(error); }.bind(this)) };
      caption.textContent = dyofT("cfg.preview.sample_pages", "Sample pages");
      var productFrame = this.createReviewProductFrame(state, papers, { openingPage: false });
      if (productFrame) {
        figure.classList.add("dyof__review-item--bound");
      }
      figure.appendChild(productFrame || papers);
      figure.appendChild(caption);
      return figure;
    }

    appendReviewBackCover() {
      if (!this.reviewPendingBackCover || !this.elements.reviewScene) {
        return;
      }
      this.reviewPendingBackCover.dataset.dyofReviewItem = "back-cover";
      this.reviewPendingBackCover.classList.add("dyof__review-item", "dyof__review-item--cover");
      this.reviewPendingBackCover.hidden = true;
      this.elements.reviewScene.appendChild(this.reviewPendingBackCover);
      this.reviewPendingBackCover = null;
    }

    normalizeReviewPersonalDatePages(values) {
      return Array.from(new Set((Array.isArray(values) ? values : [])
        .map(Number)
        .filter(function(pageNumber) {
          return Number.isInteger(pageNumber) && pageNumber > 0;
        })))
        .sort(function(left, right) { return left - right; });
    }

    reviewItemPageRange(item) {
      if (!item) {
        return null;
      }
      var start = Number(item.dataset.dyofReviewPageStart);
      var end = Number(item.dataset.dyofReviewPageEnd);
      return Number.isInteger(start) && start > 0 && Number.isInteger(end) && end >= start
        ? { start: start, end: end }
        : null;
    }

    reviewPersonalDateTarget(direction) {
      var items = this.reviewItems();
      var current = items[this.reviewCurrentIndex];
      var range = this.reviewItemPageRange(current);
      var pages = this.reviewPersonalDatePageNumbers;
      if (!pages.length || !current) {
        return null;
      }
      if (direction < 0) {
        var before = range
          ? pages.filter(function(pageNumber) { return pageNumber < range.start; })
          : current.dataset.dyofReviewItem === "back-cover" ? pages : [];
        return before.length ? before[before.length - 1] : null;
      }
      var after = range
        ? pages.filter(function(pageNumber) { return pageNumber > range.end; })
        : current.dataset.dyofReviewItem === "front-cover" ? pages : [];
      return after.length ? after[0] : null;
    }

    reviewStartItem() {
      var items = this.reviewItems();
      return items.find(function(item) {
        return item.dataset.dyofReviewItem === "front-cover";
      }) || items.find(function(item) {
        var range = this.reviewItemPageRange(item);
        return range && range.start <= 1 && range.end >= 1;
      }, this) || null;
    }

    reviewPersonalDateDestination(direction) {
      if (!this.reviewPersonalDatePageNumbers.length) {
        return null;
      }
      var targetPage = this.reviewPersonalDateTarget(direction);
      if (targetPage !== null) {
        return { kind: "page", pageNumber: targetPage };
      }
      if (direction < 0) {
        var startItem = this.reviewStartItem();
        var currentItem = this.reviewItems()[this.reviewCurrentIndex];
        if (startItem && currentItem && startItem !== currentItem) {
          return { kind: "start" };
        }
      }
      return null;
    }

    reviewAdjacentDestination(state, direction) {
      var items = this.reviewItems();
      var current = items[this.reviewCurrentIndex];
      if (!current || !state) {
        return null;
      }
      var itemName = current.dataset.dyofReviewItem;
      if (state.journey.refillType === "none") {
        // A Clipbook cover on its own: Review moves between its two covers only.
        if (itemName === "front-cover" && direction > 0 && (this.reviewPendingBackCover || items.some(function(item) {
          return item.dataset.dyofReviewItem === "back-cover";
        }))) {
          return { kind: "back-cover" };
        }
        return itemName === "back-cover" && direction < 0 && items.some(function(item) {
          return item.dataset.dyofReviewItem === "front-cover";
        }) ? { kind: "front-cover" } : null;
      }
      if (items.some(function(item) { return item.dataset.dyofReviewItem === "sample-spread"; })) {
        // Preview-only Personal Everyday: front cover, sample pages, back cover.
        var sequence = ["front-cover", "sample-spread", "back-cover"].filter(function(name) {
          return (name === "back-cover" && this.reviewPendingBackCover) || items.some(function(item) {
            return item.dataset.dyofReviewItem === name;
          });
        }, this);
        var position = sequence.indexOf(itemName);
        var target = position === -1 ? null : sequence[position + direction];
        return target ? { kind: target } : null;
      }
      if (itemName === "front-cover") {
        return direction > 0 && (this.reviewTotalPages > 0 || this.reviewCanLoadPages)
          ? { kind: "page", pageNumber: 1 }
          : null;
      }
      if (itemName === "back-cover") {
        return direction < 0 && this.reviewTotalPages > 0
          ? { kind: "page", pageNumber: this.reviewTotalPages }
          : null;
      }
      var range = this.reviewItemPageRange(current);
      if (!range) {
        return null;
      }
      if (direction < 0) {
        if (range.start > 1) {
          return { kind: "page", pageNumber: range.start - 1 };
        }
        return state.journey.productType !== "refill"
          && this.reviewItems().some(function(item) {
            return item.dataset.dyofReviewItem === "front-cover";
          })
          ? { kind: "front-cover" }
          : null;
      }
      if (range.end < this.reviewTotalPages) {
        return { kind: "page", pageNumber: range.end + 1 };
      }
      return state.journey.productType !== "refill"
        && (this.reviewPendingBackCover || this.reviewItems().some(function(item) {
          return item.dataset.dyofReviewItem === "back-cover";
        }))
        ? { kind: "back-cover" }
        : null;
    }

    reviewItemForPage(pageNumber) {
      return this.reviewItems().find(function(item) {
        var range = this.reviewItemPageRange(item);
        return range && pageNumber >= range.start && pageNumber <= range.end;
      }, this) || null;
    }

    focusReviewSceneAfterUnavailableControl(control, wasFocused) {
      var hadFocus = wasFocused === undefined
        ? document.activeElement === control
        : Boolean(wasFocused);
      if (
        !control
        || !hadFocus
        || (!control.hidden && !control.disabled)
      ) {
        return;
      }
      this.elements.reviewScene.setAttribute("tabindex", "-1");
      this.focusElementWithoutScroll(this.elements.reviewScene);
    }

    restoreReviewNavigationFocus(control, shouldRestore) {
      if (!shouldRestore) {
        return;
      }
      if (
        control
        && !control.hidden
        && !control.disabled
        && this.elementIsVisibleForFocus(control)
      ) {
        this.focusElementWithoutScroll(control);
        return;
      }
      if (this.elements.reviewScene) {
        this.elements.reviewScene.setAttribute("tabindex", "-1");
        this.focusElementWithoutScroll(this.elements.reviewScene);
      }
    }

    updateReviewCarousel() {
      var items = this.reviewItems();
      if (!items.length) {
        if (this.elements.reviewPreviousControl) {
          this.elements.reviewPreviousControl.hidden = true;
        }
        if (this.elements.reviewNextControl) {
          this.elements.reviewNextControl.hidden = true;
        }
        if (this.elements.reviewPagePrevious) {
          this.elements.reviewPagePrevious.disabled = true;
        }
        if (this.elements.reviewPageNext) {
          this.elements.reviewPageNext.disabled = true;
        }
        if (this.elements.reviewPrevious) {
          this.elements.reviewPrevious.hidden = true;
          this.elements.reviewPrevious.disabled = true;
        }
        if (this.elements.reviewNext) {
          this.elements.reviewNext.hidden = true;
          this.elements.reviewNext.disabled = true;
        }
        return;
      }
      this.reviewCurrentIndex = Math.max(0, Math.min(items.length - 1, this.reviewCurrentIndex));
      items.forEach(function(item, index) {
        item.hidden = index !== this.reviewCurrentIndex;
        item.setAttribute("aria-hidden", String(index !== this.reviewCurrentIndex));
      }, this);
      if (this.elements.reviewPreviousControl) {
        this.elements.reviewPreviousControl.hidden = false;
      }
      if (this.elements.reviewNextControl) {
        this.elements.reviewNextControl.hidden = false;
      }
      var state = this.store ? this.store.getState() : null;
      var previousPageDestination = this.reviewAdjacentDestination(state, -1);
      var nextPageDestination = this.reviewAdjacentDestination(state, 1);
      if (this.elements.reviewPagePrevious) {
        var previousPageHadFocus = document.activeElement === this.elements.reviewPagePrevious;
        this.elements.reviewPagePrevious.disabled = previousPageDestination === null
          || this.reviewNavigationBusy;
        this.focusReviewSceneAfterUnavailableControl(
          this.elements.reviewPagePrevious,
          previousPageHadFocus
        );
      }
      if (this.elements.reviewPageNext) {
        var nextPageHadFocus = document.activeElement === this.elements.reviewPageNext;
        this.elements.reviewPageNext.disabled = nextPageDestination === null
          || this.reviewNavigationBusy;
        this.focusReviewSceneAfterUnavailableControl(
          this.elements.reviewPageNext,
          nextPageHadFocus
        );
      }
      if (this.elements.reviewPrevious) {
        var previousDestination = this.reviewPersonalDateDestination(-1);
        var previousIsStart = previousDestination && previousDestination.kind === "start";
        this.elements.reviewPrevious.hidden = previousDestination === null;
        this.elements.reviewPrevious.disabled = previousDestination === null
          || this.reviewNavigationBusy;
        this.elements.reviewPrevious.dataset.dyofReviewTargetPage = previousDestination
          && previousDestination.kind === "page"
          ? String(previousDestination.pageNumber)
          : "";
        this.elements.reviewPrevious.dataset.dyofReviewTarget = previousIsStart
          ? "start"
          : previousDestination ? "personal-date" : "";
        this.elements.reviewPrevious.textContent = previousIsStart
          ? dyofT("cfg.preview.back_to_start", "Back to start")
          : dyofT("cfg.preview.previous_personal_date", "Previous personal date");
        this.elements.reviewPrevious.setAttribute(
          "aria-label",
          previousIsStart ? dyofT("cfg.preview.back_to_start_aria", "Back to the start of the review") : dyofT("cfg.preview.previous_personal_date_aria", "Show the previous personal date")
        );
        this.focusReviewSceneAfterUnavailableControl(this.elements.reviewPrevious);
      }
      if (this.elements.reviewNext) {
        var nextDestination = this.reviewPersonalDateDestination(1);
        this.elements.reviewNext.hidden = nextDestination === null;
        this.elements.reviewNext.disabled = nextDestination === null || this.reviewNavigationBusy;
        this.elements.reviewNext.dataset.dyofReviewTargetPage = nextDestination
          ? String(nextDestination.pageNumber)
          : "";
        this.elements.reviewNext.textContent = dyofT("cfg.preview.next_personal_date", "Next personal date");
        this.elements.reviewNext.setAttribute("aria-label", dyofT("cfg.preview.next_personal_date_aria", "Show the next personal date"));
        this.focusReviewSceneAfterUnavailableControl(this.elements.reviewNext);
      }
      if (this.elements.reviewScene) {
        this.elements.reviewScene.setAttribute(
          "aria-busy",
          String(this.isReviewSceneLoading())
        );
      }
      if (!this.isReviewSceneLoading()) {
        // A Clipbook cover on its own: its front cover points to the back cover.
        var coverOnlyFront = Boolean(
          state
          && state.journey.refillType === "none"
          && items[this.reviewCurrentIndex].dataset.dyofReviewItem === "front-cover"
          && nextPageDestination
        );
        this.setReviewStatus(
          coverOnlyFront
            ? dyofT("cfg.preview.cover_only_ready", "Front cover ready. Use Next to see the back cover.")
            : dyofT("cfg.preview.review_view", "Showing review view {view} of {total} currently loaded.", {
              view: this.reviewCurrentIndex + 1, total: items.length
            }),
          "ready"
        );
      }
      this.restorePendingReloadReviewDestination(state);
      this.scheduleReviewNextSpread(state);
    }

    reviewViewPagesForTarget(state, pageNumber) {
      if (pageNumber === 1) {
        return [1];
      }
      var spreadStart = pageNumber % 2 === 0 ? pageNumber : pageNumber - 1;
      return [spreadStart, spreadStart + 1].filter(function(value) {
        return value > 0 && (!this.reviewTotalPages || value <= this.reviewTotalPages);
      }, this);
    }

    reviewSinglePageSide(_state, page) {
      var explicitSide = page && String(page.side || "").toLowerCase();
      if (explicitSide === "left" || explicitSide === "right") {
        return explicitSide;
      }
      var pageNumber = Number(page && page.pageNumber);
      var isOddPage = Number.isInteger(pageNumber) && pageNumber > 0
        ? pageNumber % 2 === 1
        : true;
      return isOddPage ? "right" : "left";
    }

    reviewDestinationItem(destination) {
      if (!destination) {
        return null;
      }
      if (destination.kind === "start") {
        return this.reviewStartItem();
      }
      if (destination.kind === "front-cover") {
        return this.reviewItems().find(function(item) {
          return item.dataset.dyofReviewItem === "front-cover";
        }) || null;
      }
      if (destination.kind === "back-cover") {
        this.appendReviewBackCover();
        return this.reviewItems().find(function(item) {
          return item.dataset.dyofReviewItem === "back-cover";
        }) || null;
      }
      if (destination.kind === "sample-spread") {
        return this.reviewItems().find(function(item) {
          return item.dataset.dyofReviewItem === "sample-spread";
        }) || null;
      }
      return destination.kind === "page"
        ? this.reviewItemForPage(destination.pageNumber)
        : null;
    }

    async activateReviewDestination(destination, loadingMessage, initiatingControl) {
      if (this.reviewNavigationBusy) {
        return false;
      }
      var shouldRestoreInitiatingFocus = Boolean(
        initiatingControl
        && document.activeElement === initiatingControl
      );
      if (!destination) {
        this.updateReviewCarousel();
        this.restoreReviewNavigationFocus(
          initiatingControl,
          shouldRestoreInitiatingFocus
        );
        return false;
      }
      if (this.reviewNextSpread && (
        destination.kind !== "page"
        || this.reviewNextSpread.key !== this.reviewNextSpreadKey(
          this.store.getState(),
          this.reviewViewPagesForTarget(this.store.getState(), destination.pageNumber)
        )
      )) {
        this.discardReviewNextSpread();
      }
      var targetItem = this.reviewDestinationItem(destination);
      if (targetItem) {
        this.reviewCurrentIndex = this.reviewItems().indexOf(targetItem);
        this.updateReviewCarousel();
        if (this.store && this.store.getState) {
          this.persistReloadResumeState(this.store.getState());
        }
        this.restoreReviewNavigationFocus(
          initiatingControl,
          shouldRestoreInitiatingFocus
        );
        return true;
      }
      if (destination.kind !== "page") {
        this.updateReviewCarousel();
        this.restoreReviewNavigationFocus(
          initiatingControl,
          shouldRestoreInitiatingFocus
        );
        return false;
      }
      var navigationGeneration = Number(this.reviewNavigationGeneration || 0) + 1;
      this.reviewNavigationGeneration = navigationGeneration;
      this.reviewNavigationBusy = true;
      this.setReviewSceneLoading("navigation", loadingMessage);
      this.updateReviewCarousel();
      var navigationError = null;
      try {
        await this.loadReviewTargetPage(
          this.store.getState(),
          destination.pageNumber,
          navigationGeneration
        );
        if (this.reviewNavigationGeneration !== navigationGeneration) {
          return false;
        }
        targetItem = this.reviewDestinationItem(destination);
        if (!targetItem) {
          throw dyofCustomerError(dyofT("cfg.preview.requested_review_unloaded", "The requested review pages could not be loaded. Please try again."));
        }
        this.reviewCurrentIndex = this.reviewItems().indexOf(targetItem);
      } catch (error) {
        if (!error || error.name !== "AbortError") {
          navigationError = dyofErrorMessage(error, dyofT("cfg.preview.review_pages_unloaded", "Those review pages could not be loaded."));
        }
      } finally {
        if (this.reviewNavigationGeneration !== navigationGeneration) {
          return;
        }
        this.reviewNavigationBusy = false;
        this.setReviewSceneLoading(null);
        this.updateReviewCarousel();
        if (navigationError) {
          this.setReviewStatus(navigationError, "error");
        }
        if (this.store && this.store.getState) {
          this.persistReloadResumeState(this.store.getState());
        }
        this.restoreReviewNavigationFocus(
          initiatingControl,
          shouldRestoreInitiatingFocus
        );
      }
      return Boolean(targetItem && !navigationError);
    }

    moveReviewPage(direction, initiatingControl) {
      var state = this.store ? this.store.getState() : null;
      var destination = this.reviewAdjacentDestination(state, direction);
      return this.activateReviewDestination(
        destination,
        direction < 0 ? dyofT("cfg.preview.previous_review_loading", "Loading the previous review pages…") : dyofT("cfg.preview.next_review_loading", "Loading the next review pages…"),
        initiatingControl
      );
    }

    moveReviewPersonalDate(direction, initiatingControl) {
      var destination = this.reviewPersonalDateDestination(direction);
      return this.activateReviewDestination(
        destination,
        direction < 0 ? dyofT("cfg.preview.previous_personal_date_loading", "Loading the previous personal date…") : dyofT("cfg.preview.next_personal_date_loading", "Loading the next personal date…"),
        initiatingControl
      );
    }

    async loadReviewTargetPage(state, targetPage, navigationGeneration) {
      var pageNumbers = this.reviewViewPagesForTarget(state, targetPage);
      var payload = this.reviewPagePayload(state, pageNumbers);
      var expectedReviewKey = this.reviewKey;
      if (!payload) {
        return;
      }
      var buffered = this.reviewNextSpread;
      if (buffered && buffered.key === this.reviewNextSpreadKey(state, pageNumbers)) {
        buffered.claimed = true;
        this.reviewAbortController = buffered.controller;
        buffered.start();
        try {
          await buffered.promise;
          if (!this.isCurrentReviewWork(state, navigationGeneration, expectedReviewKey)) {
            return;
          }
          if (this.reviewNextSpread === buffered && buffered.result) {
            this.reviewUrls = this.reviewUrls.concat(buffered.urls);
            buffered.urls = [];
            this.reviewPersonalDatePageNumbers = buffered.result.personalDatePageNumbers;
            this.appendReviewPageViews(buffered.result.renderedPages, state);
            while (this.reviewLoadedPageNumbers.has(this.reviewLoadedThrough + 1)) {
              this.reviewLoadedThrough += 1;
            }
            if (this.reviewLoadedThrough >= this.reviewTotalPages) { this.appendReviewBackCover(); }
            this.discardReviewNextSpread();
            return;
          }
        } finally {
          if (this.reviewAbortController === buffered.controller) { this.reviewAbortController = null; }
        }
      }
      this.discardReviewNextSpread();
      if (
        JSON.stringify(pageNumbers) === JSON.stringify(this.reviewPreloadPages(state))
      ) {
        var preload = this.ensureReviewPreload(state);
        if (preload && preload.promise) {
          await preload.promise;
          if (!this.isCurrentReviewWork(state, navigationGeneration, expectedReviewKey)) {
            return;
          }
          if (this.consumeReviewPreload(state)) {
            return;
          }
        }
      }
      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
      }
      var controller = new AbortController();
      this.reviewAbortController = controller;
      try {
        var body = await this.fetchPreview(payload, controller.signal);
        if (
          this.reviewAbortController !== controller
          || !this.isCurrentReviewWork(state, navigationGeneration, expectedReviewKey)
        ) {
          return;
        }
        this.reviewTotalPages = Number(body.totalPages || this.reviewTotalPages || 0);
        this.reviewRendererVersion = String(body.rendererVersion || "");
        this.reviewPersonalDatePageNumbers = this.normalizeReviewPersonalDatePages(
          body.personalDatePageNumbers
        );
        var pages = Array.isArray(body.pages) ? body.pages : [];
        var renderedPages = (await Promise.all(pages.map(async function(page) {
          var content = await this.renderPageContent(
            page,
            dyofT("cfg.preview.refill_page", "Refill page {page}", { page: String(page.pageNumber) }),
            { signal: controller.signal, objectUrls: this.reviewUrls }
          );
          return content ? { page: page, content: content } : null;
        }, this))).filter(Boolean);
        if (
          this.reviewAbortController !== controller
          || !this.isCurrentReviewWork(state, navigationGeneration, expectedReviewKey)
        ) {
          return;
        }
        this.appendReviewPageViews(renderedPages, state);
        while (this.reviewLoadedPageNumbers.has(this.reviewLoadedThrough + 1)) {
          this.reviewLoadedThrough += 1;
        }
        if (this.reviewTotalPages && this.reviewLoadedThrough >= this.reviewTotalPages) {
          this.appendReviewBackCover();
        }
      } finally {
        if (this.reviewAbortController === controller) {
          this.reviewAbortController = null;
        }
      }
    }

    prepareReviewPaper(content) {
      content.classList.add("dyof__review-paper");
      var source = this.pdfPreviewSources && this.pdfPreviewSources.get(content);
      var width = Number(source ? source.baseWidth : content.naturalWidth || content.width);
      var height = Number(source ? source.baseHeight : content.naturalHeight || content.height);
      if (width > 0 && height > 0 && Number.isFinite(width / height) && content.style) {
        // Keep CSS geometry independent of the adaptive canvas backing bitmap.
        content.style.setProperty("--dyof-review-paper-ratio", String(width / height));
        content.classList.add("dyof__review-paper--sized");
      }
    }

    appendReviewPageViews(renderedPages, state) {
      var pendingPages = renderedPages.filter(function(rendered) {
        return !this.reviewLoadedPageNumbers.has(Number(rendered.page.pageNumber));
      }, this).sort(function(left, right) {
        return Number(left.page.pageNumber) - Number(right.page.pageNumber);
      });
      for (var index = 0; index < pendingPages.length; index += 1) {
        var first = pendingPages[index];
        var isOpeningPage = Number(first.page.pageNumber) === 1;
        var second = !isOpeningPage && pendingPages[index + 1]
          ? pendingPages[index + 1]
          : null;
        if (second) {
          var orderedPages = orderTwoPageSpreadBySide([first.page, second.page]);
          if (orderedPages[0] === second.page) {
            var originalFirst = first;
            first = second;
            second = originalFirst;
          }
        }
        var logicalPageStart = Number(first.page.pageNumber);
        var logicalPageEnd = second
          ? Number(second.page.pageNumber)
          : logicalPageStart;
        if (logicalPageEnd < logicalPageStart) {
          var originalLogicalPageStart = logicalPageStart;
          logicalPageStart = logicalPageEnd;
          logicalPageEnd = originalLogicalPageStart;
        }
        var figure = document.createElement("figure");
        var papers = document.createElement("div");
        var caption = document.createElement("figcaption");
        figure.className = "dyof__review-item dyof__review-item--page" +
          (second ? " dyof__review-item--spread" : " dyof__review-item--single");
        figure.dataset.dyofReviewItem = second
          ? "pages-" + logicalPageStart + "-" + logicalPageEnd
          : "page-" + logicalPageStart;
        figure.dataset.dyofReviewPageStart = String(logicalPageStart);
        figure.dataset.dyofReviewPageEnd = String(logicalPageEnd);
        if (!second) {
          figure.dataset.dyofReviewPageSide = this.reviewSinglePageSide(state, first.page);
        }
        figure.dataset.dyofReviewHasPersonalDate = String(
          this.reviewPersonalDatePageNumbers.indexOf(Number(first.page.pageNumber)) !== -1
          || Boolean(
            second
            && this.reviewPersonalDatePageNumbers.indexOf(Number(second.page.pageNumber)) !== -1
          )
        );
        figure.hidden = true;
        papers.className = "dyof__review-papers";
        this.prepareReviewPaper(first.content);
        papers.appendChild(first.content);
        if (second) {
          this.prepareReviewPaper(second.content);
          papers.appendChild(second.content);
          caption.textContent = dyofT("cfg.preview.page_range", "Pages {start}–{end}", { start: logicalPageStart, end: logicalPageEnd });
          index += 1;
        } else {
          caption.textContent = dyofT("cfg.preview.page", "Page {page}", { page: logicalPageStart });
        }
        this.rememberRefillCartPreview(state, second ? [first.content, second.content] : [first.content]);
        var productFrame = this.createReviewProductFrame(state, papers, { openingPage: isOpeningPage });
        if (productFrame) {
          figure.classList.add("dyof__review-item--bound");
        }
        figure.appendChild(productFrame || papers);
        figure.appendChild(caption);
        var followingPageItem = this.reviewItems().find(function(item) {
          var range = this.reviewItemPageRange(item);
          return range && range.start > logicalPageStart;
        }, this);
        if (followingPageItem) {
          this.elements.reviewScene.insertBefore(figure, followingPageItem);
        } else if (this.reviewPendingBackCover && this.reviewPendingBackCover.parentNode === this.elements.reviewScene) {
          this.elements.reviewScene.insertBefore(figure, this.reviewPendingBackCover);
        } else {
          this.elements.reviewScene.appendChild(figure);
        }
        this.reviewLoadedPageNumbers.add(Number(first.page.pageNumber));
        if (second) {
          this.reviewLoadedPageNumbers.add(Number(second.page.pageNumber));
        }
      }
      if (pendingPages.length) {
        this.recordWp2PreviewCommit("review-pages", this.reviewPreloadKey(state), state);
      }
    }

    async loadReviewPages(state, reset) {
      var reviewController;
      var consumedPreload = false;
      var standalonePreload = null;
      var reviewLoadGeneration;
      var expectedReviewKey;
      var coveredProduct = state.journey.productType === "clipbook"
        || state.journey.productType === "planner";
      if (!this.elements.reviewScene) {
        return;
      }
      if (reset) {
        this.reviewNavigationGeneration = Number(this.reviewNavigationGeneration || 0) + 1;
        if (this.reviewAbortController) {
          this.reviewAbortController.abort();
          this.reviewAbortController = null;
        }
        this.reviewRevision = state.revision;
        this.reviewKey = this.reviewPreloadKey(state);
        this.reviewMountedIdentity = this.reviewIdentityForState(state);
        this.reviewLoadedThrough = 0;
        this.reviewTotalPages = 0;
        this.reviewCanLoadPages = Boolean(this.reviewPagePayload(state, [1]));
        this.reviewCurrentIndex = 0;
        this.reviewPendingBackCover = null;
        this.reviewLoadedPageNumbers = new Set();
        this.reviewPersonalDatePageNumbers = [];
        this.reviewNavigationBusy = false;
        clearChildren(this.elements.reviewScene);
        this.releaseReviewUrls();
        this.setReviewSceneLoading(null);
        this.setReviewStatus(dyofT("cfg.preview.personalised_preparing", "Preparing your personalised pages…"), "loading");
        standalonePreload = !coveredProduct ? this.ensureReviewPreload(state) : null;
        consumedPreload = !coveredProduct && this.consumeReviewPreload(state);
        if (consumedPreload) {
          this.setReviewSceneLoading(null);
          this.setReviewStatus(dyofT("cfg.preview.first_review_ready", "The first review page is ready."), "ready");
          this.updateReviewCarousel();
          return;
        }
        if (standalonePreload && standalonePreload.promise && !coveredProduct) {
          var shell = this.mountReviewRefillShell(state);
          var preloadGeneration = this.reviewNavigationGeneration;
          var preloadKey = this.reviewKey;
          this.setReviewSceneLoading("initial", dyofT("cfg.preview.first_review_preparing", "Preparing your first review page…"));
          this.updateReviewCarousel();
          standalonePreload.promise.then(function() {
            var current = this.store && this.store.getState();
            if (
              !current
              || !this.isCurrentReviewWork(current, preloadGeneration, preloadKey)
            ) {
              return;
            }
            if (standalonePreload.result) {
              if (shell && shell.parentNode) {
                shell.parentNode.removeChild(shell);
              }
              if (this.consumeReviewPreload(current)) {
                this.setReviewSceneLoading(null);
                this.setReviewStatus(dyofT("cfg.preview.first_review_ready", "The first review page is ready."), "ready");
                this.updateReviewCarousel();
                return;
              }
            }
            if (shell && shell.parentNode) {
              shell.parentNode.removeChild(shell);
            }
            var retry = document.createElement("button");
            retry.type = "button";
            retry.className = "dyof__review-item dyof__review-item--message";
            retry.dataset.dyofReviewItem = "error";
            retry.dataset.dyofReviewRetry = "";
            retry.textContent = dyofT("cfg.preview.review_retry", "The preview could not be generated. Retry");
            this.elements.reviewScene.appendChild(retry);
            this.setReviewSceneLoading(null);
            this.setReviewStatus(
              dyofErrorMessage(standalonePreload.error, dyofT("cfg.preview.review_unloaded", "Review pages could not be loaded.")),
              "error"
            );
            this.updateReviewCarousel();
          }.bind(this));
          return;
        }
        if (this.coverEditor && coveredProduct) {
          var coverPreload = this.ensureReviewCoverPreload(state);
          var covers = coverPreload && coverPreload.hydratedWrapper
            ? coverPreload.hydratedWrapper
            : coverPreload && coverPreload.immediateWrapper
              ? coverPreload.immediateWrapper
              : this.coverEditor.buildReviewScenesImmediate(state);
          if (coverPreload) {
            if (covers === coverPreload.hydratedWrapper) {
              coverPreload.hydratedWrapper = null;
            }
            if (covers === coverPreload.immediateWrapper) {
              coverPreload.immediateWrapper = null;
            }
          }
          this.mountInitialReviewCovers(covers, state);
          this.updateReviewCarousel();
          this.hydrateMountedReviewCovers(coverPreload, state);
          if (state.journey.refillType === "none") {
            // A Clipbook cover on its own: both covers are the whole Review. The
            // carousel's status then reads "Use Next to see the back cover".
            this.appendReviewBackCover();
            this.setReviewSceneLoading(null);
            this.updateReviewCarousel();
            return;
          }
          if (
            this.reviewCanLoadPages
            && this.reviewItems().some(function(item) {
              return item.dataset.dyofReviewItem === "front-cover";
            })
          ) {
            this.setReviewSceneLoading(null);
            this.setReviewStatus(
              dyofT("cfg.preview.front_cover_ready", "Front cover ready. Use Next to review the first refill page."),
              "ready"
            );
            var startPagePreload = function() {
              var current = this.store && this.store.getState();
              if (
                current
                && current.screen === "review"
                && this.reviewRevision === state.revision
                && this.reviewPreloadKey(current) === this.reviewKey
              ) {
                this.ensureReviewPreload(current);
              }
            }.bind(this);
            if (typeof root.requestAnimationFrame === "function") {
              root.requestAnimationFrame(startPagePreload);
            } else {
              setTimeout(startPagePreload, 0);
            }
            return;
          }
          if (this.reviewItems().length) {
            var coveredSampleSpread = this.undatedReviewSampleSpread(state);
            if (coveredSampleSpread) {
              this.elements.reviewScene.appendChild(coveredSampleSpread);
            }
            this.appendReviewBackCover();
            this.setReviewSceneLoading(null);
            this.setReviewStatus(
              coveredSampleSpread
                ? dyofT("cfg.preview.front_cover_ready", "Front cover ready. Use Next to review the first refill page.")
                : dyofT("cfg.preview.front_cover_pdf_ready", "Front cover ready. The selected refill PDF is attached to this order."),
              "ready"
            );
            this.updateReviewCarousel();
            return;
          }
        }
        if (!consumedPreload && !this.reviewItems().length) {
          var preparing = document.createElement("div");
          preparing.className = "dyof__review-item dyof__review-item--message";
          preparing.dataset.dyofReviewItem = "preparing";
          preparing.textContent = dyofT("cfg.preview.first_review_preparing", "Preparing your first review page…");
          this.elements.reviewScene.appendChild(preparing);
          this.setReviewSceneLoading("initial", dyofT("cfg.preview.first_review_preparing", "Preparing your first review page…"));
          this.updateReviewCarousel();
        }
      }

      if (state.journey.refillType === "none") {
        return;
      }
      reviewLoadGeneration = this.reviewNavigationGeneration;
      expectedReviewKey = this.reviewKey || this.reviewPreloadKey(state);

      var requestCount = this.reviewLoadedThrough === 0 ? 13 : 12;
      var payload = this.reviewPagePayload(
        state,
        Array.from({ length: requestCount }, function(_, index) {
          return this.reviewLoadedThrough + index + 1;
        }, this)
      );
      if (!payload) {
        this.setReviewSceneLoading(null);
        var preparingItem = this.elements.reviewScene.querySelector("[data-dyof-review-item='preparing']");
        if (preparingItem) { preparingItem.remove(); }
        var sampleSpread = this.reviewItems().some(function(item) {
          return item.dataset.dyofReviewItem === "sample-spread";
        }) ? null : this.undatedReviewSampleSpread(state);
        if (sampleSpread) {
          this.elements.reviewScene.appendChild(sampleSpread);
          this.appendReviewBackCover();
          this.updateReviewCarousel();
          return;
        }
        this.appendReviewBackCover();
        if (!this.reviewItems().length) {
          var unavailable = document.createElement("div");
          unavailable.className = "dyof__review-item dyof__review-item--message";
          unavailable.dataset.dyofReviewItem = "attached-pdf";
          unavailable.textContent = state.journey.refillType === "undated"
            ? dyofT("cfg.preview.predefined_pdf_attached", "The selected predefined refill PDF will be attached to this order.")
            : dyofT("cfg.preview.legacy_pages_production", "The retained legacy renderer will provide these refill pages at production.");
          this.elements.reviewScene.appendChild(unavailable);
        }
        this.setReviewStatus(dyofT("cfg.preview.retained_pdf_attached", "The retained refill PDF is attached to this order."), "ready");
        this.updateReviewCarousel();
        return;
      }

      if (this.reviewAbortController) {
        this.reviewAbortController.abort();
      }
      reviewController = new AbortController();
      this.reviewAbortController = reviewController;
      this.setReviewStatus(dyofT("cfg.preview.personalised_loading", "Loading your personalised pages…"), "loading");
      try {
        var body = await this.fetchPreview(payload, reviewController.signal);
        if (
          this.reviewAbortController !== reviewController
          || !this.isCurrentReviewWork(state, reviewLoadGeneration, expectedReviewKey)
        ) { return; }
        this.reviewTotalPages = Number(body.totalPages || 0);
        this.reviewRendererVersion = String(body.rendererVersion || "");
        this.reviewPersonalDatePageNumbers = this.normalizeReviewPersonalDatePages(
          body.personalDatePageNumbers
        );
        var pages = Array.isArray(body.pages) ? body.pages : [];
        var renderedPages = (await Promise.all(pages.map(async function(page) {
          var content = await this.renderPageContent(
            page,
            dyofT("cfg.preview.refill_page", "Refill page {page}", { page: String(page.pageNumber) }),
            { signal: reviewController.signal, objectUrls: this.reviewUrls }
          );
          return content ? { page: page, content: content } : null;
        }, this))).filter(Boolean);
        if (
          this.reviewAbortController !== reviewController
          || !this.isCurrentReviewWork(state, reviewLoadGeneration, expectedReviewKey)
        ) { return; }
        var loadingItem = this.elements.reviewScene.querySelector("[data-dyof-review-item='preparing']");
        if (loadingItem) { loadingItem.remove(); }
        this.appendReviewPageViews(renderedPages, state);
        this.reviewLoadedThrough = Math.min(this.reviewTotalPages, pages.reduce(function(maximum, page) {
          return Math.max(maximum, Number(page.pageNumber || 0));
        }, this.reviewLoadedThrough));
        if (this.reviewLoadedThrough >= this.reviewTotalPages) {
          this.appendReviewBackCover();
        }
        this.setReviewSceneLoading(null);
        this.updateReviewCarousel();
      } catch (error) {
        if (
          this.reviewAbortController !== reviewController
          || !this.isCurrentReviewWork(state, reviewLoadGeneration, expectedReviewKey)
        ) { return; }
        if (error && error.name === "AbortError") { return; }
        this.setReviewSceneLoading(null);
        var failedPreparingItem = this.elements.reviewScene.querySelector(
          "[data-dyof-review-item='preparing']"
        );
        if (failedPreparingItem) { failedPreparingItem.remove(); }
        if (!this.reviewItems().length) {
          var retry = document.createElement("button");
          retry.type = "button";
          retry.className = "dyof__review-item dyof__review-item--message";
          retry.dataset.dyofReviewItem = "error";
          retry.dataset.dyofReviewRetry = "";
          retry.textContent = dyofT("cfg.preview.review_retry", "The preview could not be generated. Retry");
          this.elements.reviewScene.appendChild(retry);
        }
        this.updateReviewCarousel();
        this.setReviewStatus(
          dyofErrorMessage(error, dyofT("cfg.preview.review_unloaded", "Review pages could not be loaded.")),
          "error"
        );
      } finally {
        if (this.reviewAbortController === reviewController) {
          this.reviewAbortController = null;
        }
      }
    }

    layoutPreviewCacheState(state, selectionOverrides) {
      var candidate = Object.assign({}, state, {
        selection: Object.assign({}, state.selection, selectionOverrides || {})
      });
      return this.stateApi.createInitialState(candidate);
    }

    datedEntryPreviewState(state) {
      if (!state) {
        return null;
      }
      return this.stateApi.createInitialState(Object.assign({}, state, {
        screen: "dated-layout",
        journey: Object.assign({}, state.journey, { refillType: "dated" })
      }));
    }

    hasExplicitDatedStyle(state) {
      return Boolean(
        state
        && state.screen === "dated-layout"
        && state.journey
        && state.journey.refillType === "dated"
        && this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has("style:style")
      );
    }

    shouldRequestPreview(state) {
      if (!state || this.stateApi.getPreviewDescriptor(state).renderer !== "server") {
        return false;
      }
      return state.screen !== "dated-layout" || this.hasExplicitDatedStyle(state);
    }

    prewarmPreviewPaths(state) {
      if (!state) {
        return null;
      }
      // Keep the one exact Dated entry hot, but do not let manifests, alternate
      // layouts, or every Undated WebP compete before the customer chooses a
      // Size/Refill Type. Selecting Undated must also cancel the implicit Dated
      // warm path immediately.
      var choseUndated = Boolean(
        this.didChooseRefillType
        && state.journey
        && state.journey.refillType === "undated"
      );
      // Cover only has no refill to warm.
      var datedEntry = choseUndated || state.journey && state.journey.refillType === "none"
        ? null
        : this.preloadDatedEntryPreview(state);
      var hasExplicitStandaloneSize = Boolean(
        state.journey
        && state.journey.productType === "refill"
        && this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has("size:size")
      );
      var maySpeculate = Boolean(
        hasExplicitStandaloneSize
        || this.didChooseRefillType
        || this.hasExplicitCoveredPreviewSize(state)
      );
      if (datedEntry && maySpeculate && this.layoutPreviewCacheEnabled()) {
        var datedState = this.datedEntryPreviewState(state);
        if (datedState) {
          this.scheduleLayoutPreviewSpeculation(datedState, datedEntry);
        }
      }
      return datedEntry;
    }

    hasExplicitCoveredPreviewSize(state) {
      var coveredProduct = state
        && state.journey
        && (state.journey.productType === "clipbook" || state.journey.productType === "planner");
      return Boolean(
        coveredProduct
        && this.coverEditor
        && typeof this.coverEditor.hasExplicitSizeChoice === "function"
        && this.coverEditor.hasExplicitSizeChoice()
      );
    }

    preloadDatedEntryPreview(state) {
      if (!state || !this.layoutPreviewCacheEnabled()) {
        return null;
      }
      var hasExplicitCoveredSize = this.hasExplicitCoveredPreviewSize(state);
      var isStandaloneDatedEntry = state.screen === "dated-layout"
        && state.journey
        && state.journey.productType === "refill";
      var hasExplicitStandaloneSize = Boolean(
        isStandaloneDatedEntry
        && this.datedFlowExplicitFields
        && this.datedFlowExplicitFields.has("size:size")
      );
      if (state.screen !== "refill-type" && !hasExplicitCoveredSize && !isStandaloneDatedEntry) {
        return null;
      }
      var candidate = this.datedEntryPreviewState(state);
      // Before an explicit branch/size choice, the tiny exact bootstrap is the
      // only allowed source. If it is absent or stale, wait for the click rather
      // than falling through to a full manifest download during startup.
      if (
        candidate
        && this.store
        && !this.didChooseRefillType
        && !hasExplicitCoveredSize
        && !hasExplicitStandaloneSize
      ) {
        var bootstrapPayload = this.layoutPreviewCachePayload(candidate);
        if (!bootstrapPayload || !this.lookupDatedEntryPreview(bootstrapPayload)) {
          return null;
        }
      }
      return candidate ? this.ensureLayoutPreviewCache(candidate, null, true) : null;
    }

    schedulePreviewSpeculationAfter(entry, callback) {
      var generation = Number(this.previewSpeculationGeneration || 0) + 1;
      this.previewSpeculationGeneration = generation;
      var scheduleIdle = function() {
        if (generation !== this.previewSpeculationGeneration) {
          return;
        }
        var run = function() {
          if (
            generation !== this.previewSpeculationGeneration
            || this.isConnected === false
          ) {
            return;
          }
          callback();
        }.bind(this);
        if (typeof root.requestIdleCallback === "function") {
          root.requestIdleCallback(run, { timeout: 800 });
        } else {
          setTimeout(run, 0);
        }
      }.bind(this);

      if (entry && entry.promise && typeof entry.promise.then === "function") {
        entry.promise.then(scheduleIdle, scheduleIdle);
        return;
      }
      scheduleIdle();
    }

    scheduleLayoutPreviewSpeculation(state, entry) {
      var payload = this.layoutPreviewCachePayload(state);
      var expectedKey = this.layoutPreviewCacheKey(payload);
      if (!payload || !expectedKey) {
        return;
      }
      this.schedulePreviewSpeculationAfter(entry, function() {
        if (!this.store || typeof this.store.getState !== "function") {
          return;
        }
        var current = this.store.getState();
        var candidate = null;
        // A Clipbook cover on its own has no refill to warm, even when this
        // was queued before the customer turned Cover only on.
        if (current && current.journey && current.journey.refillType === "none") {
          return;
        }
        if (
          current
          && current.screen === "dated-layout"
          && current.journey
          && current.journey.refillType === "dated"
        ) {
          candidate = current;
        } else if (
          current
          && current.screen === "refill-type"
          && this.didChooseRefillType
          && current.journey
          && current.journey.refillType === "dated"
        ) {
          candidate = this.datedEntryPreviewState(current);
        } else if (this.hasExplicitCoveredPreviewSize(current)) {
          candidate = this.datedEntryPreviewState(current);
        }
        var currentPayload = candidate ? this.layoutPreviewCachePayload(candidate) : null;
        if (
          !currentPayload
          || this.layoutPreviewCacheKey(currentPayload) !== expectedKey
        ) {
          return;
        }
        this.prefetchA5ShellBytes(candidate);
        this.preloadLayoutPreviewCandidatesNow(candidate, 2, expectedKey);
      }.bind(this));
    }

    prefetchUndatedPreviewBytesAfter(entry, state) {
      var previewKey = state && state.journey ? state.journey.undatedFill : "";
      if (entry && entry.promise && typeof entry.promise.then === "function") {
        var beginPrefetch = function() {
          if (!this.store || this.store.getState().selection.size !== state.selection.size) {
            return;
          }
          this.scheduleUndatedPreviewPrefetch(this.store.getState(), previewKey);
        }.bind(this);
        entry.promise.then(beginPrefetch, beginPrefetch);
        return;
      }
      this.scheduleUndatedPreviewPrefetch(state, previewKey);
    }

    prefetchA5ShellBytesAfter(entry, state) {
      if (entry && entry.promise && typeof entry.promise.then === "function") {
        var beginPrefetch = function() {
          if (!this.store || this.store.getState().selection.size !== state.selection.size) {
            return;
          }
          this.prefetchA5ShellBytes(this.store.getState());
        }.bind(this);
        entry.promise.then(beginPrefetch, beginPrefetch);
        return;
      }
      this.prefetchA5ShellBytes(state);
    }

    prefetchA5ShellBytes(state) {
      if (
        !state
        || state.selection.size !== "a5"
        || (this.a5ShellPrefetchLinks && this.a5ShellPrefetchLinks.length)
      ) {
        return;
      }
      var connection = root.navigator && root.navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) {
        return;
      }
      if (!document.head) {
        return;
      }
      this.a5ShellPrefetchLinks = this.a5ShellPrefetchLinks || [];
      [
        this.dataset && this.dataset.refillBlankScene,
        this.dataset && this.dataset.refillOpenSpreadLayer
      ].filter(Boolean).forEach(function(source) {
        var link = document.createElement("link");
        link.rel = "prefetch";
        link.as = "image";
        link.href = source;
        link.setAttribute("fetchpriority", "low");
        document.head.appendChild(link);
        this.a5ShellPrefetchLinks.push(link);
      }, this);
    }

    scheduleUndatedPreviewPrefetch(state, selectedKey) {
      if (!state || !selectedKey) {
        return;
      }
      var expectedIdentity = this.undatedPreviewRequestKey(state, selectedKey);
      this.schedulePreviewSpeculationAfter(null, function() {
        if (!this.store || typeof this.store.getState !== "function") {
          return;
        }
        var current = this.store.getState();
        var currentKey = current && current.journey ? current.journey.undatedFill : "";
        if (
          !this.didChooseUndatedFill
          || !current
          || current.screen !== "undated-layout"
          || currentKey !== selectedKey
          || this.undatedPreviewKey !== selectedKey
          || this.undatedPreviewIdentity !== expectedIdentity
          || this.undatedPreviewRequestKey(current, currentKey) !== expectedIdentity
        ) {
          return;
        }
        this.prefetchUndatedPreviewBytes(current, selectedKey, 2);
      }.bind(this));
    }

    prefetchUndatedPreviewBytes(state, selectedKey, fillLimit) {
      selectedKey = selectedKey || (state && state.journey && state.journey.undatedFill);
      if (!state || !selectedKey || !this.didChooseUndatedFill) {
        return;
      }
      var connection = root.navigator && root.navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) {
        return;
      }
      if (!document.head || !this.undatedPreviews) {
        return;
      }
      // Only this size's own artwork: Personal warms Personal pages and skips
      // fills it does not offer.
      var keys = Object.keys(this.undatedPreviews).filter(function(key) {
        return Boolean(this.undatedSizedPreview(state, key));
      }, this);
      var selectedIndex = keys.indexOf(selectedKey);
      if (selectedIndex === -1 || keys.length < 2) {
        return;
      }
      var maximumFills = Math.min(2, Math.max(0, Number(fillLimit) || 2));
      var maximumSources = maximumFills * 2;
      var sources = [];
      var warmed = this.undatedPreviewPrefetchedSources || new Set();
      this.undatedPreviewPrefetchedSources = warmed;
      var selectedPreview = this.undatedSizedPreview(state, selectedKey) || {};
      [selectedPreview.left, selectedPreview.right, selectedPreview.scene].forEach(function(source) {
        source = String(source || "");
        if (source) {
          warmed.add(source);
        }
      });
      for (var offset = 1; offset < keys.length && maximumFills > 0; offset += 1) {
        var key = keys[(selectedIndex + offset) % keys.length];
        var preview = this.undatedSizedPreview(state, key) || {};
        [preview.left, preview.right, preview.scene].forEach(function(source) {
          source = String(source || "");
          if (!source || warmed.has(source) || sources.length >= maximumSources) {
            return;
          }
          warmed.add(source);
          sources.push(source);
        });
        maximumFills -= 1;
      }
      this.undatedPreviewPrefetchLinks = this.undatedPreviewPrefetchLinks || [];
      sources.forEach(function(source) {
        var link = document.createElement("link");
        link.rel = "prefetch";
        link.as = "image";
        link.href = source;
        link.setAttribute("fetchpriority", "low");
        document.head.appendChild(link);
        this.undatedPreviewPrefetchLinks.push(link);
      }, this);
    }

    layoutPreviewManifestEnabled() {
      var hostname = root.location ? root.location.hostname : "";
      var local = hostname === "127.0.0.1" || hostname === "localhost";
      var dataset = this.dataset || {};
      return local
        ? dataset.devLayoutPreviewManifestEnabled === "true"
        : dataset.layoutPreviewManifestEnabled === "true";
    }

    directLayoutPreviewManifestState(engine) {
      var normalizedEngine = engine === "modern" ? "modern" : "legacy";
      if (!this.layoutPreviewDirectManifestStateByEngine) {
        this.layoutPreviewDirectManifestStateByEngine = {};
      }
      if (!this.layoutPreviewDirectManifestStateByEngine[normalizedEngine]) {
        this.layoutPreviewDirectManifestStateByEngine[normalizedEngine] = {
          index: null,
          promise: null,
          controller: null,
          retryAt: 0
        };
      }
      return this.layoutPreviewDirectManifestStateByEngine[normalizedEngine];
    }

    directLayoutPreviewManifestConfig(engine) {
      var normalizedEngine = engine === "modern" ? "modern" : "legacy";
      var hostname = root.location ? root.location.hostname : "";
      var local = hostname === "127.0.0.1" || hostname === "localhost";
      var dataset = this.dataset || {};
      var modern = normalizedEngine === "modern";
      var url = local
        ? modern
          ? dataset.devLayoutPreviewModernManifestUrl
          : dataset.devLayoutPreviewManifestUrl
        : modern
          ? dataset.layoutPreviewModernManifestUrl
          : dataset.layoutPreviewManifestUrl;
      var sha256 = local
        ? modern
          ? dataset.devLayoutPreviewModernManifestSha256
          : dataset.devLayoutPreviewManifestSha256
        : modern
          ? dataset.layoutPreviewModernManifestSha256
          : dataset.layoutPreviewManifestSha256;
      if (
        !this.layoutPreviewManifestEnabled()
        || typeof url !== "string"
        || (local ? !/^https?:\/\//.test(url) : url.indexOf("https://") !== 0)
        || !/^[a-f0-9]{64}$/.test(String(sha256 || ""))
      ) {
        return null;
      }
      return { engine: normalizedEngine, url: url, sha256: sha256 };
    }

    layoutPreviewManifestSelectionKey(selection, expectedEngine) {
      var engine = expectedEngine || (selection && selection.engine) || "legacy";
      if (!selection || ["legacy", "modern"].indexOf(engine) === -1) {
        return "";
      }
      if (engine === "modern") {
        if (
          (selection.engine && selection.engine !== "modern")
          || typeof selection.variant !== "string"
          || typeof selection.fallbackVariant !== "string"
          || typeof selection.style !== "string"
          || typeof selection.colourMode !== "string"
          || (
            selection.singleColour !== null
            && selection.singleColour !== undefined
            && typeof selection.singleColour !== "string"
          )
          || typeof selection.datePosition !== "string"
          || typeof selection.headerTheme !== "string"
          || typeof selection.size !== "string"
          || typeof selection.language !== "string"
          || typeof selection.startMonth !== "string"
          || typeof selection.startDay !== "string"
          || !Number.isFinite(Number(selection.documentLengthMonths))
        ) {
          return "";
        }
        return JSON.stringify([
          selection.variant,
          selection.fallbackVariant,
          selection.style,
          selection.colourMode,
          selection.singleColour || null,
          selection.datePosition,
          selection.headerTheme,
          selection.size.toLowerCase(),
          selection.language,
          selection.startMonth,
          selection.startDay,
          Number(selection.documentLengthMonths)
        ]);
      }
      if (
        (selection.engine && selection.engine !== "legacy")
        || ["a4", "a5", "personal"].indexOf(selection.size) === -1
        || ["minimal", "classic", "luxury"].indexOf(selection.style) === -1
      ) {
        return "";
      }
      return JSON.stringify([
        selection.size,
        selection.style,
        selection.layout,
        selection.lineStyle,
        Boolean(selection.calendar),
        Boolean(selection.notes),
        Boolean(selection.appointmentTimes),
        selection.language,
        selection.startMonth,
        selection.startDay,
        Number(selection.documentLengthMonths)
      ]);
    }

    async verifyDirectLayoutPreviewManifestBytes(config, bytes) {
      var value = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
      if (
        value.byteLength < 2
        || value.byteLength > 4 * 1024 * 1024
        || !root.crypto
        || !root.crypto.subtle
        || typeof root.crypto.subtle.digest !== "function"
      ) {
        throw new Error("The Layout preview manifest failed integrity verification.");
      }
      var digest = new Uint8Array(await root.crypto.subtle.digest("SHA-256", value));
      var digestHex = Array.from(digest).map(function(byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
      if (digestHex !== config.sha256) {
        throw new Error("The Layout preview manifest failed SHA-256 verification.");
      }
      return value;
    }

    parseDirectLayoutPreviewManifest(input, expectedEngine) {
      var engine = expectedEngine === "modern" ? "modern" : "legacy";
      var entries = new Map();
      var rawEntries;
      if (
        !input
        || input.schemaVersion !== "layout-preview-shopify-v1"
        || input.sourceSchemaVersion !== "layout-preview-v1"
        || input.engine !== engine
        || !/^\d{4}-(0[1-9]|1[0-2])$/.test(String(input.month || ""))
        || typeof input.language !== "string"
        || typeof input.startDay !== "string"
        || !input.entries
        || typeof input.entries !== "object"
        || Array.isArray(input.entries)
      ) {
        throw new Error("The Layout preview manifest is invalid.");
      }
      rawEntries = Object.entries(input.entries);
      if (
        rawEntries.length !== Number(input.entryCount)
        || rawEntries.length !== Number(input.assetCount)
        || rawEntries.length < 1
        || rawEntries.length > 10000
      ) {
        throw new Error("The Layout preview manifest has an invalid entry count.");
      }
      rawEntries.forEach(function(pair) {
        var cacheKey = pair[0];
        var entry = pair[1];
        var selectionKey;
        if (
          !(new RegExp("^layout-preview-v1/" + engine + "/[a-f0-9]{64}$")).test(cacheKey)
          || !entry
          || entry.cacheKey !== cacheKey
          || !entry.selection
        ) {
          throw new Error("The Layout preview manifest has an invalid entry.");
        }
        selectionKey = this.layoutPreviewManifestSelectionKey(entry.selection, engine);
        if (!selectionKey || entries.has(selectionKey)) {
          throw new Error("The Layout preview manifest has an invalid selection index.");
        }
        entries.set(selectionKey, {
          schemaVersion: "layout-preview-shopify-v1",
          cacheStatus: "asset-hit",
          release: input.release,
          month: input.month,
          language: input.language,
          startDay: input.startDay,
          cacheKey: cacheKey,
          asset: this.layoutPreviewManifestAsset(entry.asset)
        });
      }, this);
      return entries;
    }

    loadDirectLayoutPreviewManifest(engine) {
      var normalizedEngine = engine === "modern" ? "modern" : "legacy";
      var config = this.directLayoutPreviewManifestConfig(normalizedEngine);
      var manifestState = this.directLayoutPreviewManifestState(normalizedEngine);
      var controller;
      if (!config) {
        return Promise.resolve(null);
      }
      if (manifestState.index) {
        return Promise.resolve(manifestState.index);
      }
      if (manifestState.promise) {
        return manifestState.promise;
      }
      if (manifestState.retryAt > Date.now()) {
        return Promise.resolve(null);
      }
      controller = new AbortController();
      manifestState.controller = controller;
      manifestState.promise = root.fetch(config.url, {
        method: "GET",
        headers: { "Accept": "application/json" },
        credentials: "omit",
        cache: "force-cache",
        signal: controller.signal
      }).then(async function(response) {
        if (!response.ok) {
          throw new Error("The Layout preview manifest could not be downloaded.");
        }
        var bytes = await this.verifyDirectLayoutPreviewManifestBytes(
          config,
          new Uint8Array(await response.arrayBuffer())
        );
        var decoder = root.TextDecoder ? new root.TextDecoder("utf-8") : null;
        if (!decoder) {
          throw new Error("The Layout preview manifest cannot be decoded.");
        }
        var index = this.parseDirectLayoutPreviewManifest(
          JSON.parse(decoder.decode(bytes)),
          normalizedEngine
        );
        manifestState.index = index;
        manifestState.retryAt = 0;
        return index;
      }.bind(this)).catch(function(error) {
        if (!error || error.name !== "AbortError") {
          manifestState.retryAt = Date.now() + 5000;
        }
        return null;
      }.bind(this)).finally(function() {
        manifestState.promise = null;
        if (manifestState.controller === controller) {
          manifestState.controller = null;
        }
      }.bind(this));
      return manifestState.promise;
    }

    preloadDirectLayoutPreviewManifest(engine) {
      var engines = ["legacy", "modern"];
      if (["legacy", "modern"].indexOf(engine) !== -1) {
        engines = [engine];
      } else if (this.store && typeof this.store.getState === "function") {
        var state = this.store.getState();
        var selectedEngine = state && state.selection ? state.selection.engine : "";
        if (["legacy", "modern"].indexOf(selectedEngine) !== -1) {
          engines = [selectedEngine];
        }
      }
      engines.forEach(function(selectedEngine) {
        if (this.directLayoutPreviewManifestConfig(selectedEngine)) {
          this.loadDirectLayoutPreviewManifest(selectedEngine);
        }
      }, this);
    }

    async lookupDirectLayoutPreviewManifest(payload, signal) {
      var engine = payload && payload.engine;
      var config;
      var index;
      var selectionKey;
      if (["legacy", "modern"].indexOf(engine) === -1) {
        return null;
      }
      config = this.directLayoutPreviewManifestConfig(engine);
      if (!config) {
        return null;
      }
      index = await this.loadDirectLayoutPreviewManifest(engine);
      throwIfPreviewAborted(signal);
      if (!index) {
        return null;
      }
      selectionKey = this.layoutPreviewManifestSelectionKey(payload.selection, engine);
      return index.get(selectionKey) || {
        schemaVersion: "layout-preview-shopify-v1",
        cacheStatus: "miss"
      };
    }

    lookupDatedEntryPreview(payload) {
      var entry = this.datedEntryPreview;
      var engine = payload && payload.engine;
      var requestedSelectionKey;
      var entrySelectionKey;
      if (
        !entry
        || engine !== "modern"
        || entry.engine !== engine
        || !(new RegExp("^layout-preview-v1/" + engine + "/[a-f0-9]{64}$")).test(
          String(entry.cacheKey || "")
        )
      ) {
        return null;
      }
      requestedSelectionKey = this.layoutPreviewManifestSelectionKey(payload.selection, engine);
      entrySelectionKey = this.layoutPreviewManifestSelectionKey(entry.selection, engine);
      if (!requestedSelectionKey || requestedSelectionKey !== entrySelectionKey) {
        return null;
      }
      try {
        return {
          schemaVersion: "layout-preview-shopify-v1",
          cacheStatus: "asset-hit",
          release: "dated-entry-bootstrap",
          cacheKey: entry.cacheKey,
          asset: this.layoutPreviewManifestAsset(entry.asset)
        };
      } catch (error) {
        return null;
      }
    }

    /**
     * The stored-Layout pin for this store's refill language: "en" for the UK
     * (no store profile), otherwise the profile's content language. Null while
     * that language has no reviewed pack.
     */
    predefinedLayoutPin() {
      var language = this.storeProfile ? String(this.storeProfile.contentLanguage || "") : "en";
      var pin = Object.prototype.hasOwnProperty.call(PREDEFINED_LAYOUT_PINS, language) ? PREDEFINED_LAYOUT_PINS[language] : null;
      if (!pin || !pin.rendererVersion || !/^[a-f0-9]{64}$/.test(pin.sourceIdentity)) { return null; }
      return { language: language, rendererVersion: pin.rendererVersion, sourceIdentity: pin.sourceIdentity,
        activeFileName: pin.activeFileName, storedMonthly: pin.storedMonthly };
    }

    predefinedLayoutConfig() {
      // A store with a profile names its own index and never falls back to the
      // UK index in the shared section.
      var source = this.storeProfile ? this.storeProfile.layoutPreviewActiveUrl : (this.dataset || {}).layoutPreviewActiveUrl;
      var pin = this.predefinedLayoutPin();
      if (!pin || typeof source !== "string" || !source) { return null; }
      try {
        var url = new URL(source);
        if (!/^https:\/\/cdn\.shopify\.com\//.test(source) || url.protocol !== "https:"
          || url.hostname !== "cdn.shopify.com" || url.port || url.username || url.password || url.hash
          || !/^\/s\/files\/(?:\d+\/){2,6}files\/dyof-layout-preview-active(?:-cs)?\.json$/.test(url.pathname)
          || url.pathname.slice(url.pathname.lastIndexOf("/") + 1) !== pin.activeFileName
          || (url.search && !/^\?v=\d+$/.test(url.search)) || url.href !== source) { return null; }
        return { url: url.href, base: new URL("./", url).href, language: pin.language,
          rendererVersion: pin.rendererVersion, sourceIdentity: pin.sourceIdentity, storedMonthly: pin.storedMonthly };
      } catch (_error) { return null; }
    }

    predefinedLayoutAssetUrl(source, extension) {
      var config = this.predefinedLayoutConfig();
      if (!config || typeof source !== "string" || source.length > 1024) {
        throw new Error("Invalid predefined Layout Files URL.");
      }
      var url = new URL(source);
      var fileName = url.pathname.slice(url.pathname.lastIndexOf("/") + 1);
      if (url.href !== source || new URL("./", url).href !== config.base
        || url.username || url.password || url.port || url.hash
        || (url.search && !/^\?v=\d+$/.test(url.search))
        || !/^dyof-layout-preview-[a-z0-9.-]+$/.test(fileName)
        || !fileName.endsWith(extension) || fileName.indexOf("..") !== -1) {
        throw new Error("Invalid predefined Layout Files URL.");
      }
      return url.href;
    }

    predefinedLayoutMonths() {
      var now = new Date();
      return [0, 1].map(function(offset) {
        var date = new Date(now.getFullYear(), now.getMonth() + offset, 1);
        return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0");
      });
    }

    predefinedLayoutSelectionKey(selection) {
      var pin = this.predefinedLayoutPin();
      if (!pin || !selection || (selection.engine && selection.engine !== "modern")
        || !/^(weekly|weekly-vertical|daily|monthly)\.[a-z.-]+\.a5$/.test(String(selection.variant || ""))
        || selection.fallbackVariant !== "weekly.standard.ruled.a5"
        || PREDEFINED_LAYOUT_STYLES.indexOf(selection.style) === -1
        || selection.size !== "a5" || selection.language !== pin.language
        || selection.colourMode !== "signature-multicolour" || selection.singleColour != null
        || selection.paperColour !== "white" || selection.datePosition !== "left-aligned"
        || selection.headerTheme !== "productivity" || selection.startDay !== "monday"
        || selection.documentLengthMonths !== 12
        || !/^\d{4}-(0[1-9]|1[0-2])$/.test(String(selection.startMonth || ""))
        || ["visualYearLabel", "visualMiniMonthKey", "visualMiniMonthMode", "visualMiniActiveRowIndex"].some(function(key) {
          return selection[key] !== undefined && selection[key] !== null;
        })) { return ""; }
      return JSON.stringify([selection.variant, selection.fallbackVariant, selection.style,
        selection.size, selection.language, selection.colourMode, null, selection.paperColour,
        selection.datePosition, selection.headerTheme, selection.startMonth, selection.startDay, 12]);
    }

    predefinedLayoutPayload(state) {
      var config = this.predefinedLayoutConfig();
      if (!config || !state || state.screen !== "dated-layout"
        || !state.journey || state.journey.refillType !== "dated"
        || !state.selection || state.selection.engine !== "modern") { return null; }
      var payload = this.stateApi.getPreviewRequest(state, { type: "week", index: 1 });
      // Monthly date numbers became bold on 2026-09-29 and the stored Monthly
      // previews still show the old light digits, so Monthly renders live
      // until those previews are re-made. Weekly and Daily keep theirs.
      // A pack rendered after that change (the Czech one) keeps its Monthly.
      if (config.storedMonthly) {
        if (!payload) { return null; }
      } else if (!payload || /^monthly\./.test(String(payload.selection && payload.selection.variant || ""))) { return null; }
      if (this.layoutPreviewCacheHasVisualFeatures(payload.features)
        || !this.predefinedLayoutSelectionKey(payload.selection)
        || this.predefinedLayoutMonths().indexOf(payload.selection.startMonth) === -1
        || payload.selection.frameKeys !== undefined
        || JSON.stringify(stablePreviewValue(payload.pageRequest)) !== '{"original":{"index":1,"type":"week"}}') { return null; }
      // Never project a custom raw visual override into a default public key.
      if (["frameKeys", "visualYearLabel", "visualMiniMonthKey", "visualMiniMonthMode", "visualMiniActiveRowIndex"].some(function(key) {
        return state.selection[key] !== undefined && state.selection[key] !== null;
      })) { return null; }
      return payload;
    }

    predefinedLayoutKey(state) {
      var payload = this.predefinedLayoutPayload(state);
      return payload ? this.layoutPreviewCacheKey(payload) + "|" + this.layoutPreviewVisualKey(state) : "";
    }

    async predefinedLayoutSha256(bytes) {
      if (!root.crypto || !root.crypto.subtle) { throw dyofCustomerError(dyofT("cfg.preview.integrity_unavailable", "Preview integrity is unavailable.")); }
      var value = typeof bytes === "string" ? new TextEncoder().encode(bytes) : bytes;
      var hash = new Uint8Array(await root.crypto.subtle.digest("SHA-256", value));
      return Array.from(hash).map(function(byte) { return byte.toString(16).padStart(2, "0"); }).join("");
    }

    async readPredefinedLayoutBytes(response, limit, signal) {
      if (!response.ok || Number(response.headers.get("content-length")) > limit) {
        throw new Error("Predefined Layout download unavailable or too large.");
      }
      if (!response.body || typeof response.body.getReader !== "function") {
        var whole = new Uint8Array(await response.arrayBuffer());
        if (whole.byteLength > limit) { throw new Error("Predefined Layout download is too large."); }
        throwIfPreviewAborted(signal);
        return whole;
      }
      var reader = response.body.getReader();
      var chunks = [];
      var length = 0;
      try {
        for (;;) {
          var chunk = await reader.read();
          throwIfPreviewAborted(signal);
          if (chunk.done) { break; }
          length += chunk.value.byteLength;
          if (length > limit) { throw new Error("Predefined Layout download is too large."); }
          chunks.push(chunk.value);
        }
        var result = new Uint8Array(length);
        var offset = 0;
        chunks.forEach(function(chunk) { result.set(chunk, offset); offset += chunk.byteLength; });
        return result;
      } finally { await reader.cancel().catch(function() {}); reader.releaseLock(); }
    }

    parsePredefinedLayoutBootstrap(input) {
      var config = this.predefinedLayoutConfig();
      // The UK index carries no language; every other language's index names its own.
      if (!config || !input || input.schemaVersion !== "dyof-layout-preview-active-v1"
        || input.rendererVersion !== config.rendererVersion
        || input.sourceIdentity !== config.sourceIdentity
        || ((config.language !== "en" || input.language !== undefined) && input.language !== config.language)
        || !Array.isArray(input.manifests) || input.manifests.length !== 2) {
        throw new Error("Predefined Layout source version mismatch.");
      }
      var months = new Set();
      input.manifests.forEach(function(record) {
        if (!record || !/^\d{4}-(0[1-9]|1[0-2])$/.test(String(record.month || ""))
          || months.has(record.month) || !/^[a-f0-9]{64}$/.test(String(record.sha256 || ""))
          || !Number.isInteger(record.bytes) || record.bytes < 2 || record.bytes > 4 * 1024 * 1024) {
          throw new Error("Invalid predefined Layout month record.");
        }
        this.predefinedLayoutAssetUrl(record.cdnUrl, ".json");
        months.add(record.month);
      }, this);
      var sorted = Array.from(months).sort();
      var first = sorted[0].split("-").map(Number);
      var next = new Date(first[0], first[1], 1);
      if (sorted[1] !== next.getFullYear() + "-" + String(next.getMonth() + 1).padStart(2, "0")) {
        throw new Error("Predefined Layout months must be consecutive.");
      }
      return input.manifests;
    }

    loadPredefinedLayoutBootstrap() {
      var config = this.predefinedLayoutConfig();
      if (!config) { return Promise.resolve(null); }
      var existing = this.predefinedLayoutBootstrap;
      if (existing && (existing.promise || existing.expiresAt > Date.now())) {
        return existing.promise || Promise.resolve(existing.records);
      }
      var entry = { controller: new AbortController(), records: null, promise: null, expiresAt: 0 };
      this.predefinedLayoutBootstrap = entry;
      var timeout = setTimeout(function() { entry.controller.abort(); }, 8000);
      entry.promise = root.fetch(config.url, { method: "GET", credentials: "omit", redirect: "error",
        cache: "no-cache", headers: { Accept: "application/json" }, signal: entry.controller.signal
      }).then(async function(response) {
        var bytes = await this.readPredefinedLayoutBytes(response, 512 * 1024, entry.controller.signal);
        var records = this.parsePredefinedLayoutBootstrap(JSON.parse(new TextDecoder().decode(bytes)));
        if (this.predefinedLayoutBootstrap !== entry) { throw previewAbortError(); }
        entry.records = records;
        return records;
      }.bind(this)).catch(function() { return null; }).finally(function() {
        clearTimeout(timeout); entry.promise = null; entry.expiresAt = Date.now() + 60000;
      });
      return entry.promise;
    }

    async parsePredefinedLayoutManifest(input, record) {
      var config = this.predefinedLayoutConfig();
      if (!config || !input || input.schemaVersion !== "layout-preview-shopify-v1" || input.sourceSchemaVersion !== "layout-preview-v1"
        || input.engine !== "modern" || input.rendererVersion !== config.rendererVersion
        || input.sourceIdentity !== config.sourceIdentity || input.month !== record.month
        || input.language !== config.language || input.startDay !== "monday"
        || !input.renderProfile || input.renderProfile.id !== PREDEFINED_LAYOUT_PROFILE
        || input.entryCount !== 186 || input.assetCount !== 186
        || !input.entries || Array.isArray(input.entries) || Object.keys(input.entries).length !== 186) {
        throw new Error("Invalid current-source predefined Layout manifest.");
      }
      var index = new Map();
      for (var pair of Object.entries(input.entries)) {
        var entry = pair[1];
        var canonical = entry && entry.canonicalRequest;
        var selection = entry && entry.selection;
        var key = this.predefinedLayoutSelectionKey(selection);
        if (!entry || entry.cacheKey !== pair[0] || !/^layout-preview-v1\/modern\/[a-f0-9]{64}$/.test(pair[0])
          || !key || index.has(key) || selection.startMonth !== record.month
          || !canonical || canonical.schemaVersion !== "layout-preview-v1" || canonical.engine !== "modern"
          || !canonical.versions || canonical.versions.renderer !== config.rendererVersion
          || canonical.versions.catalog !== input.catalogVersion || !canonical.selection
          || !Array.isArray(canonical.selection.frameKeys) || canonical.selection.frameKeys.length !== 12
          || !canonical.pageRequest || canonical.pageRequest.scope !== "body"
          || JSON.stringify(canonical.pageRequest.requestedPages) !== "[8,9]"
          || JSON.stringify(stablePreviewValue(selection)) !== JSON.stringify(stablePreviewValue(Object.assign({}, canonical.selection, { paperColour: "white" })))
          || await this.predefinedLayoutSha256(JSON.stringify(stablePreviewValue(canonical))) !== pair[0].split("/").pop()) {
          throw new Error("Predefined Layout canonical request mismatch.");
        }
        var asset = this.layoutPreviewManifestAsset(Object.assign({}, entry.asset, {
          cdnUrl: this.predefinedLayoutAssetUrl(entry.asset && entry.asset.cdnUrl, ".webp")
        }));
        if (!entry.asset.screenRules || entry.asset.screenRules.schemaVersion !== "dyof-screen-rules-v1"
          || !/^[a-f0-9]{64}$/.test(String(entry.asset.pixelSha256 || ""))
          || asset.bytes > 1024 * 1024 || asset.width * asset.height > 4 * 1024 * 1024
          || JSON.stringify(asset.pageNumbers) !== "[8,9]") {
          throw new Error("Predefined Layout artwork or rule metadata is missing.");
        }
        for (var side of ["left", "right"]) {
          var sheet = entry.asset.screenRules[side];
          if (!sheet || typeof sheet.svg !== "string" || sheet.svg.length > 128 * 1024
            || !Number.isInteger(sheet.ruleCount) || sheet.ruleCount < 0 || sheet.ruleCount > 2000
            || !/^[a-f0-9]{64}$/.test(String(sheet.sha256 || ""))
            || await this.predefinedLayoutSha256(sheet.svg) !== sheet.sha256) {
            throw new Error("Predefined Layout rule integrity mismatch.");
          }
        }
        asset.screenRules = entry.asset.screenRules;
        asset.pixelSha256 = entry.asset.pixelSha256;
        index.set(key, asset);
      }
      return index;
    }

    loadPredefinedLayoutManifest(month) {
      this.predefinedLayoutManifests = this.predefinedLayoutManifests || new Map();
      var existing = this.predefinedLayoutManifests.get(month);
      if (existing && (existing.promise || existing.expiresAt > Date.now())) {
        return existing.promise || Promise.resolve(existing.index);
      }
      var entry = { controller: new AbortController(), promise: null, index: null, expiresAt: 0 };
      this.predefinedLayoutManifests.set(month, entry);
      var timeout = setTimeout(function() { entry.controller.abort(); }, 10000);
      entry.promise = this.loadPredefinedLayoutBootstrap().then(async function(records) {
        var record = records && records.find(function(candidate) { return candidate.month === month; });
        if (!record || this.predefinedLayoutMonths().indexOf(month) === -1) { return null; }
        var response = await root.fetch(this.predefinedLayoutAssetUrl(record.cdnUrl, ".json"), {
          method: "GET", credentials: "omit", redirect: "error", cache: "force-cache",
          headers: { Accept: "application/json" }, signal: entry.controller.signal
        });
        var bytes = await this.readPredefinedLayoutBytes(response, record.bytes, entry.controller.signal);
        if (bytes.byteLength !== record.bytes || await this.predefinedLayoutSha256(bytes) !== record.sha256) {
          throw new Error("Predefined Layout manifest integrity mismatch.");
        }
        var index = await this.parsePredefinedLayoutManifest(JSON.parse(new TextDecoder().decode(bytes)), record);
        throwIfPreviewAborted(entry.controller.signal);
        if (this.predefinedLayoutManifests.get(month) !== entry) { throw previewAbortError(); }
        entry.index = index;
        return index;
      }.bind(this)).catch(function() { return null; }).finally(function() {
        clearTimeout(timeout); entry.promise = null; entry.expiresAt = Date.now() + (entry.index ? 86400000 : 60000);
      });
      this.predefinedLayoutManifests.forEach(function(old, key) {
        if (key !== month && this.predefinedLayoutMonths().indexOf(key) === -1) {
          old.controller.abort(); this.predefinedLayoutManifests.delete(key);
        }
      }, this);
      return entry.promise;
    }

    renderPredefinedLayoutPage(source, altText, pixelWidth) {
      var width = this.pdfPreviewPixelWidth(source.base.width, source.base.height, null, pixelWidth);
      var height = Math.ceil(width * source.base.height / source.base.width);
      var prepared = root.DYOFPreviewRules.prepareSvg(source.rules.svg, {
        width: width, height: height, density: Math.min(3, Math.max(1, Number(root.devicePixelRatio) || 1)),
        legacySolidOpacityScale: PREDEFINED_LAYOUT_RENDERER_VERSION === "modern-layout-preview-2026-09-06.2"
          && PREDEFINED_LAYOUT_SOURCE_IDENTITY === "b9e449d996d74b4c8945375d28551f25abc3a840449265d09c811008fb511c28"
          ? 0.65 : undefined
      });
      if (prepared.skippedCount || prepared.markedCount !== source.rules.ruleCount
        || prepared.rules.length !== source.rules.ruleCount) { throw new Error("Incomplete predefined screen rules."); }
      var canvas = document.createElement("canvas");
      canvas.width = width; canvas.height = height;
      canvas.setAttribute("role", "img"); canvas.setAttribute("aria-label", altText);
      var context = canvas.getContext("2d");
      if (!context) { throw new Error("Predefined Layout canvas unavailable."); }
      context.drawImage(source.base, 0, 0, width, height);
      root.DYOFPreviewRules.drawRules(context, prepared.rules);
      this.pdfPreviewSources = this.pdfPreviewSources || new WeakMap();
      this.pdfPreviewSources.set(canvas, { predefinedArtwork: source,
        baseWidth: source.base.width, baseHeight: source.base.height, width: width });
      return canvas;
    }

    async preparePredefinedLayoutAsset(asset, state, signal) {
      if (!root.DYOFPreviewRules) { throw new Error("Predefined Layout rules unavailable."); }
      var response = await root.fetch(asset.cdnUrl, { method: "GET", credentials: "omit", redirect: "error",
        cache: "force-cache", headers: { Accept: "image/webp" }, signal: signal });
      var bytes = await this.readPredefinedLayoutBytes(response, Math.min(1024 * 1024, asset.bytes + 65536), signal);
      if (bytes.length < 12 || String.fromCharCode.apply(null, bytes.slice(0, 4)) !== "RIFF"
        || String.fromCharCode.apply(null, bytes.slice(8, 12)) !== "WEBP") { throw new Error("Invalid predefined WebP."); }
      var url = URL.createObjectURL(new Blob([bytes], { type: "image/webp" }));
      try {
        var image = document.createElement("img");
        await loadImageSource(image, url, signal);
        if (image.naturalWidth !== asset.width || image.naturalHeight !== asset.height) {
          throw new Error("Predefined Layout dimensions changed.");
        }
        var decoded = document.createElement("canvas");
        decoded.width = asset.width; decoded.height = asset.height;
        var context = decoded.getContext("2d");
        if (!context) { throw new Error("Predefined Layout canvas unavailable."); }
        context.drawImage(image, 0, 0);
        // Shopify may add metadata. Only exact decoded source pixels are accepted;
        // lossy or colour-converted delivery cannot silently replace the source.
        if (await this.predefinedLayoutSha256(context.getImageData(0, 0, asset.width, asset.height).data) !== asset.pixelSha256) {
          throw new Error("Predefined Layout source pixels changed.");
        }
        var stageWidth = this.elements && this.elements.previewStage && this.elements.previewStage.getBoundingClientRect
          ? this.elements.previewStage.getBoundingClientRect().width : Number(root.innerWidth) || 711;
        var children = ["left", "right"].map(function(side, pageIndex) {
          var rect = asset.pageRects[side];
          var base = document.createElement("canvas");
          base.width = rect.width; base.height = rect.height;
          base.getContext("2d").drawImage(decoded, rect.x, rect.y, rect.width, rect.height, 0, 0, rect.width, rect.height);
          var content = this.renderPredefinedLayoutPage({ base: base, rules: asset.screenRules[side] },
            dyofT("cfg.preview.refill_preview_page", "Refill preview page {page}", { page: asset.pageNumbers[pageIndex] }),
            Math.max(1, stageWidth * 0.32 * Math.min(3, Math.max(1, Number(root.devicePixelRatio) || 1))));
          var wrapper = document.createElement("div");
          wrapper.className = "dyof__preview-page";
          wrapper.appendChild(content);
          return wrapper;
        }, this);
        var scene = this.openSpreadScene(state);
        if (scene.id !== "a5" && scene.image) {
          var sceneImage = document.createElement("img");
          sceneImage.decoding = "async";
          await loadImageSource(sceneImage, scene.image, signal);
          sceneImage.className = "dyof__open-spread-top-layer";
          sceneImage.alt = ""; sceneImage.setAttribute("aria-hidden", "true");
          sceneImage.width = scene.width; sceneImage.height = scene.height;
          children.push(sceneImage);
        }
        throwIfPreviewAborted(signal);
        return { children: children, pageCount: 2, scene: scene, paper: "white", urls: [] };
      } finally { URL.revokeObjectURL(url); }
    }

    ensurePredefinedLayoutPreview(state, overrides, priority) {
      if (["frameKeys", "visualYearLabel", "visualMiniMonthKey", "visualMiniMonthMode", "visualMiniActiveRowIndex"].some(function(key) {
        return (state && state.selection && state.selection[key] != null) || (overrides && overrides[key] != null);
      })) { return null; }
      var candidate = this.layoutPreviewCacheState(state, overrides);
      var payload = this.predefinedLayoutPayload(candidate);
      var key = payload && this.predefinedLayoutKey(candidate);
      if (!key) { return null; }
      this.predefinedLayoutEntries = this.predefinedLayoutEntries || new Map();
      this.predefinedLayoutQueue = this.predefinedLayoutQueue || [];
      var existing = this.predefinedLayoutEntries.get(key);
      if (priority) { this.predefinedLayoutEntries.forEach(function(value) { value.priority = false; }); }
      if (existing && existing.expiresAt && existing.expiresAt <= Date.now()) {
        this.releasePredefinedLayoutEntry(existing); existing = null;
      }
      if (existing) {
        existing.priority = existing.priority || Boolean(priority);
        if (existing.status === "ready") {
          this.predefinedLayoutEntries.delete(key); this.predefinedLayoutEntries.set(key, existing);
        }
        if (priority && existing.status === "queued") {
          this.predefinedLayoutQueue = [existing].concat(this.predefinedLayoutQueue.filter(function(value) { return value !== existing; }));
          this.prioritizePredefinedLayoutEntry(existing);
        }
        return existing;
      }
      var limit = (Number(root.innerWidth) || 1024) <= 767 ? 6 : 9;
      if (!priority && this.predefinedLayoutEntries.size >= limit) { return null; }
      var entry = { key: key, payload: payload, state: candidate, priority: Boolean(priority),
        status: "queued", controller: new AbortController(), prepared: null, released: false, promise: null };
      entry.promise = new Promise(function(resolve) { entry.resolve = resolve; });
      this.predefinedLayoutEntries.set(key, entry);
      if (priority) { this.predefinedLayoutQueue.unshift(entry); } else { this.predefinedLayoutQueue.push(entry); }
      while (this.predefinedLayoutEntries.size > limit) {
        var old = Array.from(this.predefinedLayoutEntries.values()).find(function(value) { return value !== entry && !value.priority; })
          || Array.from(this.predefinedLayoutEntries.values()).find(function(value) { return value !== entry; });
        this.releasePredefinedLayoutEntry(old);
      }
      if (priority) { this.prioritizePredefinedLayoutEntry(entry); }
      this.pumpPredefinedLayoutQueue();
      return entry;
    }

    prioritizePredefinedLayoutEntry(entry) {
      if (this.predefinedLayoutActive < 2) { return; }
      var obsolete = Array.from(this.predefinedLayoutEntries.values()).find(function(value) {
        return value !== entry && value.status === "loading" && !value.priority;
      });
      if (obsolete) { this.releasePredefinedLayoutEntry(obsolete); }
    }

    releasePredefinedLayoutEntry(entry) {
      if (!entry) { return; }
      entry.released = true; entry.controller.abort(); entry.prepared = null;
      this.predefinedLayoutEntries.delete(entry.key);
      this.predefinedLayoutQueue = this.predefinedLayoutQueue.filter(function(value) { return value !== entry; });
      if (entry.status === "queued") { entry.status = "aborted"; entry.resolve(entry); }
    }

    pumpPredefinedLayoutQueue() {
      this.predefinedLayoutActive = this.predefinedLayoutActive || 0;
      while (this.predefinedLayoutActive < 2 && this.predefinedLayoutQueue.length) {
        var entry = this.predefinedLayoutQueue.shift();
        if (entry.released) { continue; }
        entry.status = "loading"; this.predefinedLayoutActive += 1;
        this.runPredefinedLayoutEntry(entry);
      }
    }

    async runPredefinedLayoutEntry(entry) {
      var timeout = setTimeout(function() { entry.controller.abort(); }, 12000);
      try {
        var index = await this.loadPredefinedLayoutManifest(entry.payload.selection.startMonth);
        throwIfPreviewAborted(entry.controller.signal);
        var asset = index && index.get(this.predefinedLayoutSelectionKey(entry.payload.selection));
        if (!asset) { throw new Error("No exact predefined Layout match."); }
        var prepared = await this.preparePredefinedLayoutAsset(asset, entry.state, entry.controller.signal);
        throwIfPreviewAborted(entry.controller.signal);
        if (entry.released || this.predefinedLayoutEntries.get(entry.key) !== entry) { throw previewAbortError(); }
        entry.prepared = prepared; entry.status = "ready";
      } catch (_error) {
        entry.status = entry.controller.signal.aborted ? "aborted" : "miss";
        entry.expiresAt = Date.now() + 60000;
      }
      finally {
        clearTimeout(timeout);
        if (entry.released) { entry.prepared = null; }
        this.predefinedLayoutActive = Math.max(0, this.predefinedLayoutActive - 1);
        entry.resolve(entry); this.pumpPredefinedLayoutQueue();
      }
    }

    hasCurrentPredefinedLayoutPreview(state) {
      return Boolean(state && state.preview && state.preview.status !== "error"
        && this.elements && this.elements.previewPages
        && this.elements.previewPages.dataset.dyofPreviewSource === "predefined-layout"
        && this.currentPredefinedLayoutKey && this.currentPredefinedLayoutKey === this.predefinedLayoutKey(state));
    }

    commitPredefinedLayoutPreview(entry) {
      var state = this.store && this.store.getState();
      if (!state || !this.hasExplicitDatedStyle(state) || ["idle", "loading"].indexOf(state.preview.status) === -1
        || !entry || entry.released || entry.status !== "ready" || !entry.prepared
        || this.predefinedLayoutEntries.get(entry.key) !== entry || this.predefinedLayoutKey(state) !== entry.key
        || this.hasCurrentLayoutPreviewCacheVisual(state) || this.hasCurrentRetainedLayoutVisual(state)) { return false; }
      if (this.hasCurrentPredefinedLayoutPreview(state)) { return true; }
      var mounted = this.clonePreparedLayoutPreview(entry.prepared);
      if (!mounted) { return false; }
      var pages = this.elements.previewPages;
      this.releasePreviewUrls(); this.clearPreviewContentIdentity();
      pages.dataset.mode = "open-spread"; pages.dataset.dyofPreviewSource = "predefined-layout";
      if (mounted.scene.id === "a5") { delete pages.dataset.dyofOpenScene; }
      else { pages.dataset.dyofOpenScene = mounted.scene.id; }
      pages.dataset.dyofPreviewTemplate = mounted.scene.previewTemplate;
      pages.classList.remove("dyof__preview-pages--single");
      this.elements.previewStage.dataset.paper = "white";
      pages.replaceChildren.apply(pages, mounted.children);
      this.rememberRefillCartPreview(state, mounted.children);
      this.currentPredefinedLayoutKey = entry.key;
      this.currentLayoutVisualKey = this.layoutPreviewVisualKey(state);
      entry.priority = false;
      this.predefinedLayoutEntries.delete(entry.key); this.predefinedLayoutEntries.set(entry.key, entry);
      // A visual-only hit may reveal the next choice, but never confirms the
      // configuration. The exact existing request alone controls Next.
      this.datedFlowWaiting = false;
      this.advanceDatedFlowPendingChoice(state);
      this.render(state);
      this.recordWp2PreviewCommit("predefined-layout", entry.payload.selection.variant, state);
      return true;
    }

    showPredefinedLayoutPreview(state) {
      if (!this.hasExplicitDatedStyle(state) || this.hasCurrentLayoutPreviewCacheVisual(state)
        || this.hasCurrentRetainedLayoutVisual(state)) { return; }
      var entry = this.ensurePredefinedLayoutPreview(state, null, true);
      if (!entry) { return; }
      if (entry.status === "ready") { this.commitPredefinedLayoutPreview(entry); return; }
      entry.promise.then(function(resolved) { this.commitPredefinedLayoutPreview(resolved); }.bind(this)).catch(function() {});
    }

    preloadPredefinedLayoutChoices(state) {
      if (!this.predefinedLayoutConfig() || !state || state.screen !== "dated-layout"
        || !state.journey || state.journey.refillType !== "dated"
        || (state.preview && state.preview.status === "error")) { return; }
      var connection = root.navigator && root.navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) { return; }
      var overrides = this.layoutPreviewCandidateOverrides(state).concat(PREDEFINED_LAYOUT_STYLES.map(function(style) { return { style: style }; }));
      if (this.hasExplicitDatedStyle(state)) { overrides.unshift({}); }
      var wanted = new Map();
      overrides.some(function(patch) {
        var key = this.predefinedLayoutKey(this.layoutPreviewCacheState(state, patch));
        if (key && !wanted.has(key)) { wanted.set(key, patch); }
        return wanted.size >= 6;
      }, this);
      if (this.predefinedLayoutEntries) {
        Array.from(this.predefinedLayoutEntries.values()).forEach(function(entry) {
          if (!wanted.has(entry.key) && entry.key !== this.currentPredefinedLayoutKey && !entry.priority) {
            this.releasePredefinedLayoutEntry(entry);
          }
        }, this);
      }
      wanted.forEach(function(patch) { this.ensurePredefinedLayoutPreview(state, patch, false); }, this);
    }

    releasePredefinedLayoutPreviews() {
      if (this.predefinedLayoutEntries) {
        Array.from(this.predefinedLayoutEntries.values()).forEach(this.releasePredefinedLayoutEntry, this);
      }
      if (this.predefinedLayoutBootstrap) { this.predefinedLayoutBootstrap.controller.abort(); }
      this.predefinedLayoutBootstrap = null;
      if (this.predefinedLayoutManifests) {
        this.predefinedLayoutManifests.forEach(function(entry) { entry.controller.abort(); });
        this.predefinedLayoutManifests.clear();
      }
    }

    layoutPreviewPayloadCacheEnabled() {
      var hostname = root.location ? root.location.hostname : "";
      var local = hostname === "127.0.0.1" || hostname === "localhost";
      var dataset = this.dataset || {};
      return local
        ? dataset.devLayoutPreviewCacheEnabled === "true"
        : dataset.layoutPreviewCacheEnabled === "true";
    }

    layoutPreviewCacheEnabled() {
      return (this.dataset || {}).layoutPreviewMemoryCacheEnabled === "true"
        || this.layoutPreviewManifestEnabled() || this.layoutPreviewPayloadCacheEnabled();
    }

    layoutPreviewMemoryOnly() {
      return (this.dataset || {}).layoutPreviewMemoryCacheEnabled === "true"
        && !this.layoutPreviewManifestEnabled() && !this.layoutPreviewPayloadCacheEnabled();
    }

    layoutPreviewTransportPayload(payload) {
      // SVG is the same renderer output without its duplicate base64 copy.
      // Keep identity keys independent of this transport-only optimisation.
      return payload && payload.engine === "modern"
        ? Object.assign({}, payload, { imageEncoding: "svg" })
        : payload;
    }

    layoutPreviewCacheHasVisualFeatures(features) {
      function isEmptyFeatureValue(value) {
        if (value === undefined || value === null || value === false || value === "") {
          return true;
        }
        if (Array.isArray(value)) {
          return value.length === 0;
        }
        if (typeof value !== "object") {
          return false;
        }
        return Object.keys(value).every(function(key) {
          return isEmptyFeatureValue(value[key]);
        });
      }

      return Object.keys(features || {}).some(function(key) {
        var value = features[key];
        if (key === "moonPhases") {
          return value === true || Boolean(value && value.enabled === true);
        }
        return !isEmptyFeatureValue(value);
      });
    }

    layoutPreviewCachePayload(state, selectionOverrides) {
      var candidate = this.layoutPreviewCacheState(state, selectionOverrides);
      var exactPayload;
      if (
        !candidate
        || candidate.screen !== "dated-layout"
        || candidate.journey.refillType !== "dated"
        || this.stateApi.getPreviewDescriptor(candidate).renderer !== "server"
      ) {
        return null;
      }
      exactPayload = this.layoutFacingPreviewPayload(candidate);
      if (
        !exactPayload
        || this.layoutPreviewCacheHasVisualFeatures(exactPayload.features)
      ) {
        return null;
      }
      if (this.layoutPreviewMemoryOnly()) {
        // Foreground completion must be tied to the complete original payload,
        // not the deliberately reduced public sprite-manifest selection key.
        return exactPayload;
      }
      var selection = exactPayload.selection.engine === "legacy"
        ? {
            engine: exactPayload.selection.engine,
            style: exactPayload.selection.style,
            size: exactPayload.selection.size,
            layout: exactPayload.selection.layout,
            lineStyle: exactPayload.selection.lineStyle,
            calendar: exactPayload.selection.calendar,
            notes: exactPayload.selection.notes,
            appointmentTimes: exactPayload.selection.appointmentTimes,
            language: exactPayload.selection.language,
            startMonth: exactPayload.selection.startMonth,
            startDay: exactPayload.selection.startDay,
            documentLengthMonths: exactPayload.selection.documentLengthMonths
          }
        : {
            engine: exactPayload.selection.engine,
            language: exactPayload.selection.language,
            variant: exactPayload.selection.variant,
            fallbackVariant: exactPayload.selection.fallbackVariant,
            style: exactPayload.selection.style,
            colourMode: exactPayload.selection.colourMode,
            singleColour: exactPayload.selection.singleColour,
            paperColour: exactPayload.selection.paperColour,
            datePosition: exactPayload.selection.datePosition,
            headerTheme: exactPayload.selection.headerTheme,
            size: exactPayload.selection.size,
            startMonth: exactPayload.selection.startMonth,
            startDay: exactPayload.selection.startDay,
            documentLengthMonths: exactPayload.selection.documentLengthMonths
          };
      return {
        engine: exactPayload.engine,
        renderMode: exactPayload.renderMode,
        version: exactPayload.version,
        selection: selection,
        features: {},
        pageRequest: exactPayload.pageRequest
      };
    }

    layoutPreviewCacheKey(payload) {
      return payload ? JSON.stringify(stablePreviewValue({
        screen: "dated-layout",
        payload: payload
      })) : "";
    }

    layoutPreviewCandidateOverridesForStage(state, stageName) {
      var candidates = [];
      var controls;
      var groups;
      var explicitFields = this.datedFlowExplicitFields || new Set();
      var currentCacheVisual = this.hasCurrentLayoutPreviewCacheVisual(state);
      if (!stageName) {
        return candidates;
      }
      if (state.selection.engine === "legacy" && stageName === "legacy-design") {
        controls = this.legacyControlsFor(state);
        if (controls.indexOf("lineStyle") !== -1) {
          if (!explicitFields.has("legacy-design:lineStyle") && !currentCacheVisual) {
            candidates.push({ lineStyle: state.selection.lineStyle });
          }
          candidates.push({ lineStyle: state.selection.lineStyle === "ruled" ? "blank" : "ruled" });
        }
        if (controls.indexOf("calendar") !== -1) {
          if (!explicitFields.has("legacy-design:calendar") && !currentCacheVisual) {
            candidates.push({ calendar: Boolean(state.selection.calendar) });
          }
          candidates.push({ calendar: !state.selection.calendar });
        }
        if (controls.indexOf("notes") !== -1 && state.selection.lineStyle === "blank") {
          if (!explicitFields.has("legacy-design:notes") && !currentCacheVisual) {
            candidates.push({ notes: Boolean(state.selection.notes) });
          }
          candidates.push({ notes: !state.selection.notes });
        }
        if (controls.indexOf("appointmentTimes") !== -1 && state.selection.lineStyle === "ruled") {
          if (!explicitFields.has("legacy-design:appointmentTimes") && !currentCacheVisual) {
            candidates.push({ appointmentTimes: Boolean(state.selection.appointmentTimes) });
          }
          candidates.push({ appointmentTimes: !state.selection.appointmentTimes });
        }
        return candidates;
      }

      groups = Array.from(this.querySelectorAll("[data-dyof-dated-stage]")).filter(function(group) {
        return group.dataset.dyofDatedStage === stageName
          && this.isDatedStageGroupApplicable(group, state);
      }, this);
      groups.forEach(function(group) {
        group.querySelectorAll("button[data-dyof-field]").forEach(function(control) {
          var field = control.dataset.dyofField;
          var value = control.dataset.dyofValue;
          var selected = state.selection[field];
          var temporaryDisabled = control.dataset.dyofFlowDisabled === "true";
          var explicitChoice = explicitFields.has(stageName + ":" + field);
          var patch;
          if (
            (control.disabled && !temporaryDisabled)
            || (
              String(selected) === String(value)
              && (explicitChoice || currentCacheVisual)
            )
          ) {
            return;
          }
          patch = {};
          patch[field] = ["calendar", "notes", "appointmentTimes"].indexOf(field) !== -1
            ? value === "true"
            : value;
          if (field === "singleColour") {
            patch.colourMode = "single-colour";
          }
          if (field === "colourMode" && value === "single-colour") {
            var singleColours = this.contract.getSingleColours(state.selection.style) || [];
            if (!singleColours.some(function(option) {
              return option.value === state.selection.singleColour;
            })) {
              patch.singleColour = singleColours.length ? singleColours[0].value : "colour-01";
            }
          }
          candidates.push(patch);
        }, this);
      }, this);
      return candidates;
    }

    layoutPreviewCandidateOverrides(state) {
      var sequence = this.getDatedFlowSequence(state);
      var stageIndex = this.datedFlowWaiting && this.datedFlowPendingIndex !== null
        ? Math.min(this.datedFlowPendingIndex, Math.max(0, sequence.length - 1))
        : this.datedFlowVisibleThrough;
      var stageName = sequence[stageIndex];
      var candidates;
      if (!stageName) {
        return [];
      }

      // A5 is the internal default, so users can confirm Size before any Style
      // request would normally begin. Warm Style in its DOM order now; legacy
      // choices intentionally lead the list and are never queued behind Waves.
      if (!this.datedFlowWaiting && stageName === "size" && sequence[stageIndex + 1] === "style") {
        candidates = this.layoutPreviewCandidateOverridesForStage(state, "style");
        var legacyStyles = candidates.filter(function(candidate) {
          var style = candidate.style ? this.contract.getStyle(candidate.style) : null;
          return style && style.engine === "legacy";
        }, this);
        var modernStyles = candidates.filter(function(candidate) {
          var style = candidate.style ? this.contract.getStyle(candidate.style) : null;
          return !style || style.engine !== "legacy";
        }, this);
        return legacyStyles
          .concat(this.layoutPreviewCandidateOverridesForStage(state, stageName))
          .concat(modernStyles);
      }
      return this.layoutPreviewCandidateOverridesForStage(state, stageName);
    }

    preloadLayoutPreviewCandidates(state) {
      this.preloadPredefinedLayoutChoices(state);
      if (!this.store || typeof this.store.getState !== "function") {
        this.preloadLayoutPreviewCandidatesNow(state);
        return;
      }
      if (!state || (state.preview && state.preview.status === "error") || !this.layoutPreviewCacheEnabled()) {
        return;
      }
      var payload = this.layoutPreviewCachePayload(state);
      if (!payload) {
        return;
      }
      // After standalone Size there is no customer-selected Style to protect.
      // Start the first two real Style candidates immediately instead of
      // warming the normalized hidden default and making Classic wait behind
      // it. ensureLayoutPreviewCache deduplicates the shared manifest fetch.
      if (!this.hasExplicitDatedStyle(state)) {
        this.preloadLayoutPreviewCandidatesNow(state, 2, "");
        return;
      }
      var selectedVisible = Boolean(
        (state.preview && state.preview.status === "ready")
        || this.hasCurrentLayoutPreviewVisual(state)
      );
      var entry = selectedVisible
        ? null
        : this.ensureLayoutPreviewCache(state, null, true);
      this.scheduleLayoutPreviewSpeculation(state, entry);
    }

    preloadLayoutPreviewCandidatesNow(state, limit, excludedKey) {
      var seen = new Set();
      var requested = 0;
      var maximum = Number.isFinite(Number(limit)) ? Math.max(0, Number(limit)) : Infinity;
      if (!this.layoutPreviewCacheEnabled()) {
        return;
      }
      if (
        root.navigator
        && root.navigator.connection
        && root.navigator.connection.saveData
      ) {
        return;
      }
      // Drop completed-stage work before the pending stage claims the bounded
      // pool. The current selection is retained separately by the pruner.
      this.retainLayoutPreviewCacheEntriesForState(state);
      this.layoutPreviewCandidateOverrides(state).forEach(function(overrides) {
        var payload = this.layoutPreviewCachePayload(state, overrides);
        var key = this.layoutPreviewCacheKey(payload);
        if (
          !payload
          || key === excludedKey
          || seen.has(key)
          || requested >= maximum
        ) {
          return;
        }
        seen.add(key);
        if (this.ensureLayoutPreviewCache(state, overrides, false)) {
          requested += 1;
        }
      }, this);
    }

    async fetchLayoutPreviewCache(payload, signal) {
      var endpoints = [];
      var hostname = root.location ? root.location.hostname : "";
      var local = hostname === "127.0.0.1" || hostname === "localhost";
      var dataset = this.dataset || {};
      var useManifest = this.layoutPreviewManifestEnabled();
      var lastResult = { cacheStatus: "unavailable" };

      if (useManifest) {
        var entryResult = this.lookupDatedEntryPreview(payload);
        if (entryResult) {
          return entryResult;
        }
        var directResult = await this.lookupDirectLayoutPreviewManifest(payload, signal);
        if (directResult && directResult.cacheStatus !== "miss") {
          return directResult;
        }
        if (directResult) {
          lastResult = directResult;
        }
        if (local && dataset.devLayoutPreviewManifestEndpoint) {
          endpoints.push(dataset.devLayoutPreviewManifestEndpoint);
        } else if (!local && dataset.layoutPreviewManifestEndpoint) {
          endpoints.push(dataset.layoutPreviewManifestEndpoint);
        }
      } else {
        if (local && dataset.devLayoutPreviewCacheEnabled === "true") {
          if (dataset.devLayoutPreviewCacheEndpoint) {
            endpoints.push(dataset.devLayoutPreviewCacheEndpoint);
          }
        } else if (!local && dataset.layoutPreviewCacheEnabled === "true") {
          if (dataset.layoutPreviewCacheEndpoint) {
            endpoints.push(dataset.layoutPreviewCacheEndpoint);
          }
        }
      }

      for (var index = 0; index < endpoints.length; index += 1) {
        try {
          var response = await root.fetch(endpoints[index], {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload),
            signal: signal
          });
          var body = await response.json().catch(function() { return {}; });
          if (
            response.ok
            && (
              (
                body.schemaVersion === "layout-preview-v1"
                && (body.cacheStatus === "hit" || body.cacheStatus === "bypass")
              )
              || (
                body.schemaVersion === "layout-preview-shopify-v1"
                && (body.cacheStatus === "asset-hit" || body.cacheStatus === "bypass")
              )
            )
          ) {
            return body;
          }
          if (response.status === 404 && body.cacheStatus === "miss") {
            lastResult = body;
            continue;
          }
          lastResult = { cacheStatus: "unavailable" };
        } catch (error) {
          if (error && error.name === "AbortError") {
            throw error;
          }
          lastResult = { cacheStatus: "unavailable" };
        }
      }
      return lastResult;
    }

    layoutPreviewManifestAsset(asset) {
      function positiveInteger(value) {
        return Number.isInteger(value) && value > 0;
      }
      function normalizedRect(value, width, height) {
        if (
          !value
          || !Number.isInteger(value.x)
          || !Number.isInteger(value.y)
          || !positiveInteger(value.width)
          || !positiveInteger(value.height)
          || value.x < 0
          || value.y < 0
          || value.x + value.width > width
          || value.y + value.height > height
        ) {
          throw dyofCustomerError(dyofT("cfg.preview.cached_invalid_geometry", "The cached Layout sprite has invalid page geometry."));
        }
        return {
          x: value.x,
          y: value.y,
          width: value.width,
          height: value.height
        };
      }

      if (
        !asset
        || asset.mimeType !== "image/webp"
        || typeof asset.cdnUrl !== "string"
        || asset.cdnUrl.indexOf("https://") !== 0
        || !/^[a-f0-9]{64}$/.test(String(asset.sha256 || ""))
        || !positiveInteger(asset.bytes)
        || asset.bytes > 20 * 1024 * 1024
        || !positiveInteger(asset.width)
        || !positiveInteger(asset.height)
        || asset.width > 8192
        || asset.height > 8192
        || !Array.isArray(asset.pageNumbers)
        || asset.pageNumbers.length !== 2
        || !asset.pageRects
      ) {
        throw dyofCustomerError(dyofT("cfg.preview.cached_invalid_metadata", "The cached Layout sprite metadata is invalid."));
      }
      return {
        mimeType: "image/webp",
        cdnUrl: asset.cdnUrl,
        sha256: asset.sha256,
        bytes: asset.bytes,
        width: asset.width,
        height: asset.height,
        pageNumbers: [Number(asset.pageNumbers[0]), Number(asset.pageNumbers[1])],
        pageRects: {
          left: normalizedRect(asset.pageRects.left, asset.width, asset.height),
          right: normalizedRect(asset.pageRects.right, asset.width, asset.height)
        }
      };
    }

    async verifyLayoutPreviewManifestBytes(asset, bytes) {
      var value = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
      if (
        value.byteLength !== asset.bytes
        || value.byteLength < 12
        || String.fromCharCode.apply(null, value.slice(0, 4)) !== "RIFF"
        || String.fromCharCode.apply(null, value.slice(8, 12)) !== "WEBP"
        || !root.crypto
        || !root.crypto.subtle
        || typeof root.crypto.subtle.digest !== "function"
      ) {
        throw dyofCustomerError(dyofT("cfg.preview.cached_integrity_failed", "The cached Layout sprite failed integrity verification."));
      }
      var digest = new Uint8Array(await root.crypto.subtle.digest("SHA-256", value));
      var digestHex = Array.from(digest).map(function(byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
      if (digestHex !== asset.sha256) {
        throw dyofCustomerError(dyofT("cfg.preview.cached_hash_failed", "The cached Layout sprite failed SHA-256 verification."));
      }
      return value;
    }

    async prepareLayoutPreviewManifestHit(assetInput, state, signal) {
      var asset = this.layoutPreviewManifestAsset(assetInput);
      var response = await root.fetch(asset.cdnUrl, {
        method: "GET",
        headers: { "Accept": "image/webp" },
        credentials: "omit",
        cache: "force-cache",
        signal: signal
      });
      if (!response.ok) {
        throw dyofCustomerError(dyofT("cfg.preview.cached_download_failed", "The cached Layout sprite could not be downloaded."));
      }
      var bytes = await this.verifyLayoutPreviewManifestBytes(
        asset,
        new Uint8Array(await response.arrayBuffer())
      );
      throwIfPreviewAborted(signal);

      var spriteUrl = URL.createObjectURL(new Blob([bytes], { type: "image/webp" }));
      try {
        var sprite = document.createElement("img");
        sprite.decoding = "async";
        await loadImageSource(sprite, spriteUrl, signal);
        if (sprite.naturalWidth !== asset.width || sprite.naturalHeight !== asset.height) {
          throw dyofCustomerError(dyofT("cfg.preview.cached_dimensions_mismatch", "The cached Layout sprite dimensions do not match its manifest."));
        }

        var scene = this.openSpreadScene(state);
        var sceneImage = null;
        var sceneReadiness = [];
        if (scene.id !== "a5" && scene.image) {
          sceneImage = document.createElement("img");
          sceneImage.decoding = "async";
          sceneReadiness.push(loadImageSource(sceneImage, scene.image, signal));
        }

        var children = ["left", "right"].map(function(side, index) {
          var rect = asset.pageRects[side];
          var canvas = document.createElement("canvas");
          var context = canvas.getContext("2d");
          if (!context) {
            throw dyofCustomerError(dyofT("cfg.preview.cached_canvas_failed", "The cached Layout sprite could not create a page canvas."));
          }
          canvas.width = rect.width;
          canvas.height = rect.height;
          canvas.setAttribute("role", "img");
          canvas.setAttribute(
            "aria-label",
            dyofT("cfg.preview.cached_page", "Cached refill preview page {page}", { page: asset.pageNumbers[index] || index + 1 })
          );
          context.drawImage(
            sprite,
            rect.x,
            rect.y,
            rect.width,
            rect.height,
            0,
            0,
            rect.width,
            rect.height
          );
          var wrapper = document.createElement("div");
          wrapper.className = "dyof__preview-page";
          wrapper.appendChild(canvas);
          return wrapper;
        });
        await Promise.all(sceneReadiness);
        if (sceneImage && scene.id !== "a5") {
          sceneImage.className = "dyof__open-spread-top-layer";
          sceneImage.alt = "";
          sceneImage.setAttribute("aria-hidden", "true");
          sceneImage.width = scene.width;
          sceneImage.height = scene.height;
          children.push(sceneImage);
        }
        throwIfPreviewAborted(signal);
        return {
          children: children,
          pageCount: 2,
          scene: scene,
          paper: effectivePaperColour(state),
          urls: []
        };
      } finally {
        URL.revokeObjectURL(spriteUrl);
      }
    }

    async prepareLayoutPreviewCacheHit(preview, state, signal) {
      var stagedUrls = [];
      var scene = this.openSpreadScene(state);
      var pages = orderTwoPageSpreadBySide(
        Array.isArray(preview && preview.pages) ? preview.pages.slice(0, 2) : []
      );
      var sceneImage = null;
      var sceneReadiness = [];
      try {
        if (!pages.length) {
          throw dyofCustomerError(dyofT("cfg.preview.cached_no_pages", "The cached preview has no pages."));
        }
        if (scene.id !== "a5" && scene.image) {
          sceneImage = document.createElement("img");
          sceneImage.decoding = "async";
          sceneReadiness.push(loadImageSource(sceneImage, scene.image, signal));
        }

        var prepared = await Promise.all([
          Promise.all(pages.map(async function(page, index) {
            var content = await this.renderPageContent(
              page,
              dyofT("cfg.preview.cached_page", "Cached refill preview page {page}", { page: page.pageNumber || index + 1 }),
              { signal: signal, objectUrls: stagedUrls }
            );
            if (!content) {
              return null;
            }
            var wrapper = document.createElement("div");
            wrapper.className = "dyof__preview-page";
            wrapper.appendChild(content);
            return wrapper;
          }, this)),
          Promise.all(sceneReadiness)
        ]);
        var children = prepared[0].filter(Boolean);
        if (!children.length) {
          throw dyofCustomerError(dyofT("cfg.preview.cached_no_visible_pages", "The cached preview has no visible pages."));
        }
        if (sceneImage && scene.id !== "a5") {
          sceneImage.className = "dyof__open-spread-top-layer";
          sceneImage.alt = "";
          sceneImage.setAttribute("aria-hidden", "true");
          sceneImage.width = scene.width;
          sceneImage.height = scene.height;
          children.push(sceneImage);
        }
        throwIfPreviewAborted(signal);
        return {
          children: children,
          pageCount: prepared[0].filter(Boolean).length,
          scene: scene,
          paper: effectivePaperColour(state),
          urls: stagedUrls
        };
      } catch (error) {
        stagedUrls.forEach(function(url) { URL.revokeObjectURL(url); });
        throw error;
      }
    }

    ensureLayoutPreviewCache(state, selectionOverrides, priority) {
      var candidateState = this.layoutPreviewCacheState(state, selectionOverrides);
      var payload = this.layoutPreviewCachePayload(candidateState);
      var key = this.layoutPreviewCacheKey(payload);
      var existing = this.layoutPreviewCacheEntries.get(key);
      var controller;
      var entry;

      if (!this.layoutPreviewCacheEnabled() || !payload) {
        return null;
      }
      if (this.layoutPreviewMemoryOnly() && !this.hasExplicitDatedStyle(candidateState)) {
        return null;
      }
      // An in-memory cache is not a licence to generate full previews for
      // every unclicked option. Only a selected choice starts a live request;
      // exact predefined assets have their own bounded read-only warm path.
      if (!existing && !priority && this.layoutPreviewMemoryOnly()) {
        return null;
      }
      if (priority) {
        this.layoutPreviewCacheEntries.forEach(function(candidate) {
          candidate.priority = false;
        });
      }
      if (existing) {
        if ((existing.expiresAt && existing.expiresAt <= Date.now())
          || (priority && this.layoutPreviewMemoryOnly()
            && ["queued", "loading", "ready"].indexOf(existing.status) === -1)) {
          this.layoutPreviewCacheEntries.delete(key);
        } else {
          if (priority) {
            existing.priority = true;
            existing.selectedByCustomer = existing.selectedByCustomer
              || this.hasExplicitDatedStyle(candidateState);
            if (existing.status === "queued") {
              this.layoutPreviewCacheQueue = [existing].concat(
                this.layoutPreviewCacheQueue.filter(function(candidate) {
                  return candidate !== existing;
                })
              );
              this.makeRoomForSelectedLayoutPreview();
            }
          }
          return existing;
        }
      }
      if (
        !priority
        && this.layoutPreviewCacheEntries.size >= this.layoutPreviewCacheEntryLimit()
      ) {
        return null;
      }

      controller = new AbortController();
      entry = {
        key: key,
        status: "queued",
        controller: controller,
        prepared: null,
        payload: payload,
        candidateState: candidateState,
        priority: Boolean(priority),
        selectedByCustomer: Boolean(
          priority && this.hasExplicitDatedStyle(candidateState)
        ),
        resolve: null,
        promise: null
      };
      entry.promise = new Promise(function(resolve) {
        entry.resolve = resolve;
      });
      this.layoutPreviewCacheEntries.set(key, entry);
      if (priority) {
        this.layoutPreviewCacheQueue.unshift(entry);
        this.makeRoomForSelectedLayoutPreview();
      } else {
        this.layoutPreviewCacheQueue.push(entry);
      }
      this.pruneLayoutPreviewCacheEntries();
      this.pumpLayoutPreviewCacheQueue();
      return entry;
    }

    makeRoomForSelectedLayoutPreview() {
      if (!this.layoutPreviewMemoryOnly() || this.layoutPreviewCacheActive < 4) {
        return;
      }
      // A fifth click must not wait behind four obsolete downloads. Keep ready
      // comparisons, but give the new selection the oldest occupied live slot.
      var obsolete = Array.from(this.layoutPreviewCacheEntries.values()).find(function(entry) {
        return entry.status === "loading" && !entry.priority && !entry.released;
      });
      if (obsolete) {
        obsolete.released = true;
        this.layoutPreviewCacheEntries.delete(obsolete.key);
        obsolete.controller.abort();
      }
    }

    layoutPreviewCacheEntryLimit() {
      var viewportWidth = Number(root.innerWidth) || 1024;
      return viewportWidth <= 767 ? 4 : 9;
    }

    pumpLayoutPreviewCacheQueue() {
      while (this.layoutPreviewCacheActive < 4 && this.layoutPreviewCacheQueue.length) {
        var entry = this.layoutPreviewCacheQueue.shift();
        if (!entry || entry.status !== "queued") {
          continue;
        }
        this.layoutPreviewCacheActive += 1;
        entry.status = "loading";
        this.runLayoutPreviewCacheEntry(entry);
      }
    }

    runLayoutPreviewCacheEntry(entry) {
      var memoryOnly = this.layoutPreviewMemoryOnly();
      var timeout = memoryOnly ? setTimeout(function() {
        entry.timedOut = true;
        entry.controller.abort();
      }, 20000) : null;
      var request = memoryOnly
        ? this.fetchPreview(this.layoutPreviewTransportPayload(entry.payload), entry.controller.signal)
          .then(function(preview) { return { cacheStatus: "hit", preview: preview }; })
        : this.fetchLayoutPreviewCache(entry.payload, entry.controller.signal);
      request
        .then(async function(result) {
          if (
            result
            && result.cacheStatus === "asset-hit"
            && result.asset
          ) {
            entry.prepared = await this.prepareLayoutPreviewManifestHit(
              result.asset,
              entry.candidateState,
              entry.controller.signal
            );
            entry.status = "ready";
            return entry;
          }
          if (
            !result
            || result.cacheStatus !== "hit"
            || !result.preview
          ) {
            entry.status = result && result.cacheStatus ? result.cacheStatus : "unavailable";
            return entry;
          }
          entry.prepared = await this.prepareLayoutPreviewCacheHit(
            result.preview,
            entry.candidateState,
            entry.controller.signal
          );
          entry.pages = result.preview.pages.map(function(page) {
            return {
              pageNumber: page.pageNumber,
              side: page.side,
              kind: page.kind,
              imageType: page.imageType
            };
          });
          entry.status = "ready";
          return entry;
        }.bind(this))
        .catch(function(error) {
          entry.status = error && error.name === "AbortError" && !entry.timedOut ? "aborted" : "unavailable";
          entry.lastError = entry.timedOut
            ? dyofT("cfg.preview.download_timeout", "The preview download timed out. Please retry.")
            : root.DYOFI18n
              ? dyofErrorMessage(error, dyofT("cfg.preview.failed", "Preview failed."))
              : error && error.message ? error.message : String(error || "");
          return entry;
        })
        .then(function(resolved) {
          clearTimeout(timeout);
          this.layoutPreviewCacheActive = Math.max(0, this.layoutPreviewCacheActive - 1);
          if (resolved.released && resolved.prepared) {
            resolved.prepared.urls.forEach(function(url) { URL.revokeObjectURL(url); });
            resolved.prepared = null;
          }
          if (
            resolved.status !== "ready"
          ) {
            resolved.expiresAt = Date.now() + 5000;
          }
          if (resolved.resolve) {
            resolved.resolve(resolved);
            resolved.resolve = null;
          }
          this.recordWp2CacheTrace(resolved);
          this.pumpLayoutPreviewCacheQueue();
        }.bind(this));
    }

    hasCurrentLayoutPreviewCacheVisual(state) {
      var payload;
      var previewPages = this.elements && this.elements.previewPages;
      if (
        !state
        || !state.preview
        || state.preview.status === "error"
        || !previewPages
        || previewPages.dataset.dyofPreviewSource !== "layout-cache"
        || !this.lastCommittedLayoutPreviewCacheKey
      ) {
        return false;
      }
      payload = this.layoutPreviewCachePayload(state);
      return Boolean(
        payload
        && this.lastCommittedLayoutPreviewCacheKey === this.layoutPreviewCacheKey(payload)
      );
    }

    hasCurrentRetainedLayoutVisual(state) {
      var previewPages = this.elements && this.elements.previewPages;
      return Boolean(
        state
        && state.screen === "dated-layout"
        && state.preview
        && state.preview.status !== "error"
        && previewPages
        && previewPages.dataset.dyofPreviewSource === "retained-layout"
        && this.hasMountedLayoutPreview()
        && this.currentLayoutVisualKey
        && this.currentLayoutVisualKey === this.layoutPreviewVisualKey(state)
      );
    }

    hasCurrentLayoutPreviewVisual(state) {
      return this.hasCurrentLayoutPreviewCacheVisual(state)
        || this.hasCurrentRetainedLayoutVisual(state)
        || this.hasCurrentPredefinedLayoutPreview(state);
    }

    hasAuthoritativeRetainedLayoutPreview(state) {
      return Boolean(
        this.hasCurrentRetainedLayoutVisual(state)
        && state.preview.status === "ready"
        && state.preview.pages
        && state.preview.pages.length
      );
    }

    isCurrentLayoutPreviewCacheKey(key) {
      var current = this.store.getState();
      return current.screen === "dated-layout"
        && (current.preview.status === "idle" || current.preview.status === "loading")
        && this.layoutPreviewCacheKey(this.layoutPreviewCachePayload(current)) === key;
    }

    clonePreparedLayoutPreview(prepared) {
      if (!prepared || !Array.isArray(prepared.children)) {
        return null;
      }
      var children = prepared.children.map(function(sourceChild) {
        var clonedChild = typeof sourceChild.cloneNode === "function"
          ? sourceChild.cloneNode(true)
          : sourceChild;
        var sourceCanvases = [];
        var clonedCanvases = [];
        if (sourceChild.tagName === "CANVAS") {
          sourceCanvases.push(sourceChild);
        }
        if (clonedChild.tagName === "CANVAS") {
          clonedCanvases.push(clonedChild);
        }
        if (typeof sourceChild.querySelectorAll === "function") {
          sourceCanvases = sourceCanvases.concat(
            Array.from(sourceChild.querySelectorAll("canvas"))
          );
        }
        if (typeof clonedChild.querySelectorAll === "function") {
          clonedCanvases = clonedCanvases.concat(
            Array.from(clonedChild.querySelectorAll("canvas"))
          );
        }
        sourceCanvases.forEach(function(sourceCanvas, index) {
          var clonedCanvas = clonedCanvases[index];
          var context;
          if (!clonedCanvas || typeof clonedCanvas.getContext !== "function") {
            return;
          }
          clonedCanvas.width = sourceCanvas.width;
          clonedCanvas.height = sourceCanvas.height;
          context = clonedCanvas.getContext("2d");
          if (context) {
            context.drawImage(sourceCanvas, 0, 0);
          }
          this.copyPdfPreviewSource(sourceCanvas, clonedCanvas);
        }, this);
        return clonedChild;
      }, this);
      return {
        children: children,
        pageCount: prepared.pageCount,
        scene: prepared.scene,
        paper: prepared.paper
      };
    }

    commitLayoutPreviewCacheEntry(entry) {
      var prepared = entry && entry.prepared;
      var mounted;
      if (
        !prepared
        || entry.released
        || this.layoutPreviewCacheEntries.get(entry.key) !== entry
        || !this.isCurrentLayoutPreviewCacheKey(entry.key)
      ) {
        return false;
      }

      mounted = this.clonePreparedLayoutPreview(prepared);
      if (!mounted) {
        return false;
      }

      var current = this.store.getState();
      var previousUrls = this.previewUrls.slice();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "open-spread";
      this.elements.previewPages.dataset.dyofPreviewSource = "layout-cache";
      delete this.elements.previewPages.dataset.dyofPreviewRequest;
      this.elements.previewPages.classList.toggle(
        "dyof__preview-pages--single",
        mounted.pageCount === 1
      );
      if (mounted.scene.id === "a5") {
        delete this.elements.previewPages.dataset.dyofOpenScene;
      } else {
        this.elements.previewPages.dataset.dyofOpenScene = mounted.scene.id;
      }
      this.elements.previewPages.dataset.dyofPreviewTemplate = mounted.scene.previewTemplate;
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.paper = mounted.paper;
      }
      this.elements.previewPages.replaceChildren.apply(
        this.elements.previewPages,
        mounted.children
      );
      this.rememberRefillCartPreview(current, mounted.children);
      // The mounted nodes share already-decoded sources with the bounded cache
      // entry. Keep the prepared template alive so returning to a real prior
      // choice can paint synchronously instead of starting another resolver
      // request. Object URLs remain owned by the entry and are revoked only
      // when that entry is released or evicted.
      this.previewUrls = [];
      entry.status = "ready";
      entry.priority = false;
      entry.lastUsedAt = Date.now();
      this.lastCommittedLayoutPreviewCacheKey = entry.key;
      this.currentLayoutVisualKey = this.layoutPreviewVisualKey(current);
      this.layoutPreviewCacheEntries.delete(entry.key);
      this.layoutPreviewCacheEntries.set(entry.key, entry);
      previousUrls.forEach(function(url) { URL.revokeObjectURL(url); });
      this.acceptCurrentLayoutPreviewCacheVisual(current);
      this.recordWp2PreviewCommit(
        "layout-cache", this.layoutPreviewMemoryOnly() ? "memory-layout" : entry.key, current
      );
      return true;
    }

    commitLayoutPreviewCacheEntryAfterSelectionPaint(entry) {
      // The selected control's aria state is updated before state dispatch.
      // Mount a ready cached preview immediately as well: waiting for another
      // animation frame is actively harmful in backgrounded/mobile WebViews,
      // where requestAnimationFrame can be heavily throttled.
      this.commitLayoutPreviewCacheEntry(entry);
    }

    showCachedLayoutPreview(state) {
      var entry;
      if (!this.layoutPreviewCacheEnabled()
        || state.preview.status === "ready" || state.preview.status === "error") {
        return;
      }
      // An internal normalized Style is not a customer choice. Its bytes must
      // not occupy the priority lane ahead of the first two visible choices.
      if (!this.hasExplicitDatedStyle(state)) {
        return;
      }
      if (
        this.lastCommittedLayoutPreviewCacheKey
        && this.lastCommittedLayoutPreviewCacheKey
          === this.layoutPreviewCacheKey(this.layoutPreviewCachePayload(state))
        && this.elements.previewPages.dataset.dyofPreviewSource === "layout-cache"
      ) {
        return;
      }
      entry = this.ensureLayoutPreviewCache(state, null, true);
      if (!entry) {
        return;
      }
      if (entry.status === "ready") {
        this.commitLayoutPreviewCacheEntryAfterSelectionPaint(entry);
        return;
      }
      entry.promise.then(function(resolved) {
        if (resolved.status === "ready"
          && !this.hasCurrentLayoutPreviewCacheVisual(this.store.getState())) {
          this.commitLayoutPreviewCacheEntryAfterSelectionPaint(resolved);
        }
      }.bind(this));
    }

    pruneLayoutPreviewCacheEntries() {
      while (this.layoutPreviewCacheEntries.size > this.layoutPreviewCacheEntryLimit()) {
        var oldestKey;
        this.layoutPreviewCacheEntries.forEach(function(entry, key) {
          if (oldestKey === undefined && !entry.priority) {
            oldestKey = key;
          }
        });
        if (oldestKey === undefined) {
          oldestKey = this.layoutPreviewCacheEntries.keys().next().value;
        }
        var oldest = this.layoutPreviewCacheEntries.get(oldestKey);
        if (oldest) {
          oldest.released = true;
        }
        if (oldest && oldest.controller) {
          oldest.controller.abort();
        }
        if (oldest && oldest.prepared) {
          oldest.prepared.urls.forEach(function(url) { URL.revokeObjectURL(url); });
          oldest.prepared = null;
        }
        this.layoutPreviewCacheQueue = this.layoutPreviewCacheQueue.filter(function(entry) {
          return entry !== oldest;
        });
        if (oldest && oldest.status === "queued" && oldest.resolve) {
          oldest.status = "aborted";
          oldest.resolve(oldest);
          oldest.resolve = null;
        }
        this.layoutPreviewCacheEntries.delete(oldestKey);
      }
    }

    retainLayoutPreviewCacheEntriesForState(state) {
      if (!this.layoutPreviewCacheEntries || !state || state.screen !== "dated-layout") {
        return;
      }
      var currentPayload = this.layoutPreviewCachePayload(state);
      var retainedKeys = new Set(this.layoutPreviewCandidateOverrides(state).map(function(overrides) {
        return this.layoutPreviewCacheKey(this.layoutPreviewCachePayload(state, overrides));
      }, this));
      if (currentPayload) {
        retainedKeys.add(this.layoutPreviewCacheKey(currentPayload));
      }
      this.layoutPreviewCacheEntries.forEach(function(entry, key) {
        if (retainedKeys.has(key)) {
          return;
        }
        // Ready entries are a small, bounded LRU of genuinely decoded visuals.
        // Preserve them across comparisons and Back/Edit returns; pruning still
        // applies the viewport memory cap and screen/size resets release it.
        if (
          (entry.status === "ready" && entry.prepared)
          || (
            entry.selectedByCustomer
            && (entry.status === "queued" || entry.status === "loading")
          )
        ) {
          entry.priority = false;
          return;
        }
        entry.released = true;
        if (entry.controller) {
          entry.controller.abort();
        }
        if (entry.prepared) {
          entry.prepared.urls.forEach(function(url) { URL.revokeObjectURL(url); });
          entry.prepared = null;
        }
        this.layoutPreviewCacheQueue = this.layoutPreviewCacheQueue.filter(function(candidate) {
          return candidate !== entry;
        });
        if (entry.status === "queued" && entry.resolve) {
          entry.status = "aborted";
          entry.resolve(entry);
          entry.resolve = null;
        }
        this.layoutPreviewCacheEntries.delete(key);
      }, this);
    }

    releaseLayoutPreviewCacheEntries() {
      this.releasePredefinedLayoutPreviews();
      if (!this.layoutPreviewCacheEntries) {
        return;
      }
      this.layoutPreviewCacheEntries.forEach(function(entry) {
        entry.released = true;
        if (entry.controller) {
          entry.controller.abort();
        }
        if (entry.prepared) {
          entry.prepared.urls.forEach(function(url) { URL.revokeObjectURL(url); });
          entry.prepared = null;
        }
        if (entry.status === "queued" && entry.resolve) {
          entry.status = "aborted";
          entry.resolve(entry);
          entry.resolve = null;
        }
      });
      this.layoutPreviewCacheQueue = [];
      this.layoutPreviewCacheEntries.clear();
    }

    schedulePreview(state, immediate) {
      clearTimeout(this.previewTimer);
      this.previewTimer = setTimeout(function() {
        this.loadPreview(state);
      }.bind(this), immediate || state.screen === "dated-layout" ? 0 : 180);
    }

    layoutFacingPreviewPayload(state) {
      var pageRequest = { type: "week", index: 1 };
      var selection = state && state.selection;
      if (state && state.screen === "dated-layout"
        && state.journey && state.journey.refillType === "dated"
        && selection && selection.engine === "legacy" && selection.layout === "daily"
        && /^\d{4}-(0[1-9]|1[0-2])$/.test(String(selection.startMonth || ""))) {
        // Legacy Daily's diary1 (Mon/Wed/Fri) is LEFT artwork; diary2 and
        // the weekend diary3 are RIGHT. Like the old builder, the renderer
        // opens every start month on a diary1 page (a Tue/Thu start on the
        // previous Mon/Wed, a Sat/Sun start on the previous Friday), so body
        // pages 1 and 2 are always the first LEFT→RIGHT facing pair.
        // This is Layout-only: never reorder Review or the final document.
        pageRequest = { requestedPages: [1, 2] };
      }
      return this.stateApi.getPreviewRequest(state, pageRequest);
    }

    isCurrentPreviewRequest(key, controller) {
      var current = this.store.getState();
      var payload = this.layoutFacingPreviewPayload(current);
      return this.abortController === controller
        && current.preview.requestKey === key
        && this.shouldRequestPreview(current)
        && previewRequestKey(current, payload) === key;
    }

    async loadPreview(state) {
      var purchase;
      var controller;
      var directTimeout = null;
      var directTimedOut = false;
      if (
        state.journey.productType === "refill"
        && state.journey.refillType === "dated"
        && state.selection.engine === "legacy"
      ) {
        purchase = this.resolveCartVariant(state);
        if (purchase.status !== "ready") {
          if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
          }
          this.setPreviewStatus(
            purchase.message || dyofT("cfg.preview.choose_available_combination", "Select an available size, style and layout combination."),
            "error"
          );
          return;
        }
      }

      var payload = this.layoutFacingPreviewPayload(state);

      if (!payload) {
        if (state.journey.refillType === "undated") {
          this.renderUndatedPreview(state);
        } else {
          this.renderPreviewPlaceholder(
            dyofT("cfg.preview.retained_adapter", "The retained {style} preview will be connected through its legacy adapter.", {
              style: dyofDisplayLabel(this.contract.getStyle(state.selection.style).label)
            })
          );
        }
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }
      controller = new AbortController();
      this.abortController = controller;

      var key = previewRequestKey(state, payload);
      this.store.dispatch({ type: "PREVIEW_REQUESTED", payload: { requestKey: key } });
      this.setPreviewStatus(dyofT("cfg.preview.generating_page", "Generating a real page preview…"), "loading");

      try {
        // Claim the selected entry already started by showCachedLayoutPreview.
        // The same promise owns both its pixels and authoritative completion:
        // do not issue a second POST or decode the same spread twice.
        var cacheEntry = state.screen === "dated-layout" && this.layoutPreviewMemoryOnly()
          && this.layoutPreviewCacheEntries
          ? this.ensureLayoutPreviewCache(state, null, true)
          : null;
        if (cacheEntry) {
          var resolvedEntry = await cacheEntry.promise;
          if (!this.isCurrentPreviewRequest(key, controller)) {
            throw previewAbortError();
          }
          if (resolvedEntry.released || resolvedEntry.status === "aborted") {
            throw previewAbortError();
          }
          if (resolvedEntry.status !== "ready" || !resolvedEntry.pages || !resolvedEntry.pages.length) {
            throw dyofCustomerError(resolvedEntry.lastError || dyofT("cfg.preview.layout_unloaded", "The selected layout preview could not be loaded. Please retry."));
          }
          if (!this.hasCurrentLayoutPreviewCacheVisual(this.store.getState())
            && !this.commitLayoutPreviewCacheEntry(resolvedEntry)) {
            throw previewAbortError();
          }
          this.store.dispatch({
            type: "PREVIEW_SUCCEEDED",
            payload: { requestKey: key, pages: resolvedEntry.pages }
          });
          this.setPreviewStatus(dyofT("cfg.preview.matches_configuration", "Preview matches the current configuration."), "ready");
          return;
        }
        // Personal dates/moon phases bypass the generic memory cache, but their
        // Layout download still needs a deadline rather than an endless loader.
        if (state.screen === "dated-layout") {
          directTimeout = setTimeout(function() {
            directTimedOut = true;
            controller.abort();
          }, 20000);
        }
        var body = await this.fetchPreview(this.layoutPreviewTransportPayload(payload), controller.signal);
        if (!this.isCurrentPreviewRequest(key, controller)) {
          throw previewAbortError();
        }

        var pages = Array.isArray(body.pages) ? body.pages : [];
        if (!pages.length) {
          throw dyofCustomerError(dyofT("cfg.preview.no_pages", "No preview pages were returned."));
        }
        await this.renderPreviewPages(pages, state, {
          requestKey: key,
          controller: controller,
          signal: controller.signal
        });
        if (!this.isCurrentPreviewRequest(key, controller)) {
          throw previewAbortError();
        }
        this.store.dispatch({
          type: "PREVIEW_SUCCEEDED",
          payload: { requestKey: key, pages: pages.map(function(page) {
            return {
              pageNumber: page.pageNumber,
              side: page.side,
              kind: page.kind,
              imageType: page.imageType
            };
          }) }
        });
        this.setPreviewStatus(dyofT("cfg.preview.matches_configuration", "Preview matches the current configuration."), "ready");
      } catch (error) {
        if (error && error.name === "AbortError" && !directTimedOut) {
          return;
        }
        if (directTimedOut) {
          error = dyofCustomerError(dyofT("cfg.preview.download_timeout", "The preview download timed out. Please retry."));
        }
        if (!this.isCurrentPreviewRequest(key, controller)) {
          return;
        }
        this.store.dispatch({
          type: "PREVIEW_FAILED",
          payload: {
            requestKey: key,
            error: root.DYOFI18n
              ? dyofErrorMessage(error, dyofT("cfg.preview.failed", "Preview failed."))
              : error && error.message ? error.message : String(error)
          }
        });
        this.setPreviewStatus(
          dyofErrorMessage(error, dyofT("cfg.preview.failed", "Preview failed.")),
          "error"
        );
      } finally {
        clearTimeout(directTimeout);
        if (this.abortController === controller) {
          this.abortController = null;
        }
      }
    }

    previewFontTransportRequest(payload, endpoint) {
      if (!payload || payload.imageEncoding !== "svg"
        || (payload.engine !== undefined && payload.engine !== "modern")
        || !payload.selection || payload.selection.engine !== "modern"
        || !root.crypto || !root.crypto.subtle || typeof TextEncoder === "undefined"
        || this.previewFontTransportDisabledEndpoint === endpoint) { return null; }
      var request = payload.pageRequest || {};
      var original = request.original;
      var originalObject = original && typeof original === "object" && !Array.isArray(original);
      var review = request.documentOrder === "final" || (originalObject && original.documentOrder === "final");
      var layout = !request.documentOrder && !request.requestedPages && originalObject
        && original.type === "week" && original.index === 1
        && Object.keys(original).every(function(key) { return key === "type" || key === "index"; });
      if (!review && !layout) { return null; }
      var cache = this.previewFontCache;
      if (!cache || cache.endpoint !== endpoint) {
        cache = { endpoint: endpoint, fonts: new Map(), bytes: 0 };
        this.previewFontCache = cache;
      }
      var fonts = new Map(cache.fonts);
      return {
        cache: cache,
        fonts: fonts,
        payload: Object.assign({}, payload, { fontTransport: { version: 1, knownFonts: Array.from(fonts.keys()) } })
      };
    }

    async restorePreviewFontTransport(body, transport, signal) {
      throwIfPreviewAborted(signal);
      if (!body || !Object.prototype.hasOwnProperty.call(body, "fontTransport")) { return body; }
      function invalid() { throw dyofCustomerError(dyofT("cfg.preview.font_verification_failed", "Preview fonts could not be verified.")); }
      var wire = body.fontTransport;
      if (!transport || !wire || wire.version !== 1 || body.engine !== "modern" || body.renderMode !== "preview"
        || !Array.isArray(body.pages) || body.pages.length > 32
        || !Array.isArray(wire.fonts) || wire.fonts.length > PREVIEW_FONT_MAX_ENTRIES
        || !Array.isArray(wire.pages) || !wire.pages.length || wire.pages.length !== body.pages.length) { invalid(); }
      var fonts = new Map(transport.fonts);
      var supplied = new Set();
      var suppliedBytes = 0;
      for (var font of wire.fonts) {
        if (!font || typeof font.id !== "string" || !PREVIEW_FONT_ID.test(font.id)
          || supplied.has(font.id) || typeof font.css !== "string"
          || font.css.length > PREVIEW_FONT_MAX_FACE_BYTES || /[^\x00-\x7f]/.test(font.css)
          || !PREVIEW_FONT_FACE.test(font.css)) { invalid(); }
        suppliedBytes += new TextEncoder().encode(font.css).byteLength;
        if (suppliedBytes > PREVIEW_FONT_MAX_CACHE_BYTES
          || await this.predefinedLayoutSha256(font.css) !== font.id) { invalid(); }
        throwIfPreviewAborted(signal);
        supplied.add(font.id);
        fonts.set(font.id, font.css);
      }
      var pages = body.pages.slice();
      var seenPages = new Set();
      var used = new Set();
      var usedCssBytes = 0;
      var totalPageBytes = 0;
      for (var entry of wire.pages) {
        if (!entry || !Number.isSafeInteger(entry.index) || entry.index < 0 || entry.index >= pages.length
          || seenPages.has(entry.index) || typeof entry.svgSha256 !== "string" || !PREVIEW_FONT_ID.test(entry.svgSha256)
          || !Array.isArray(entry.refs) || entry.refs.length > 64) { invalid(); }
        var page = pages[entry.index];
        if (!page || page.imageType !== "image/svg+xml" || Object.prototype.hasOwnProperty.call(page, "imageDataUrl")
          || typeof page.imageSvg !== "string" || page.imageSvg.length > PREVIEW_FONT_MAX_PAGE_BYTES) { invalid(); }
        seenPages.add(entry.index);
        var cursor = 0;
        var restoredLength = page.imageSvg.length;
        var parts = [];
        for (var ref of entry.refs) {
          if (!ref || !Number.isSafeInteger(ref.offset) || ref.offset < cursor || ref.offset > page.imageSvg.length
            || typeof ref.id !== "string" || !PREVIEW_FONT_ID.test(ref.id) || !fonts.has(ref.id)) { invalid(); }
          var css = fonts.get(ref.id);
          if (typeof css !== "string" || css.length > PREVIEW_FONT_MAX_FACE_BYTES) { invalid(); }
          if (!used.has(ref.id)) {
            usedCssBytes += css.length;
            if (usedCssBytes > PREVIEW_FONT_MAX_CACHE_BYTES) { invalid(); }
          }
          restoredLength += css.length;
          if (restoredLength > PREVIEW_FONT_MAX_PAGE_BYTES) { invalid(); }
          parts.push(page.imageSvg.slice(cursor, ref.offset), css);
          cursor = ref.offset;
          used.add(ref.id);
        }
        parts.push(page.imageSvg.slice(cursor));
        var svg = parts.join("");
        var bytes = new TextEncoder().encode(svg);
        totalPageBytes += bytes.byteLength;
        if (bytes.byteLength > PREVIEW_FONT_MAX_PAGE_BYTES || totalPageBytes > PREVIEW_FONT_MAX_TOTAL_PAGE_BYTES
          || await this.predefinedLayoutSha256(bytes) !== entry.svgSha256) { invalid(); }
        throwIfPreviewAborted(signal);
        pages[entry.index] = Object.assign({}, page, { imageSvg: svg });
      }
      for (var suppliedId of supplied) { if (!used.has(suppliedId)) { invalid(); } }
      if (used.size > PREVIEW_FONT_MAX_ENTRIES) { invalid(); }
      // All pages must verify before caching anything or returning renderable data.
      if (this.previewFontCache === transport.cache) {
        var cache = transport.cache;
        for (var id of used) {
          var value = fonts.get(id);
          if (cache.fonts.has(id)) { cache.bytes -= cache.fonts.get(id).length; cache.fonts.delete(id); }
          cache.fonts.set(id, value);
          cache.bytes += value.length;
        }
        while (cache.fonts.size > PREVIEW_FONT_MAX_ENTRIES || cache.bytes > PREVIEW_FONT_MAX_CACHE_BYTES) {
          var oldest = cache.fonts.keys().next().value;
          cache.bytes -= cache.fonts.get(oldest).length;
          cache.fonts.delete(oldest);
        }
      }
      var restored = Object.assign({}, body, { pages: pages });
      delete restored.fontTransport;
      return restored;
    }

    async fetchPreviewResponse(endpoint, payload, signal) {
      throwIfPreviewAborted(signal);
      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: signal
      });
      var responseText = await response.text();
      throwIfPreviewAborted(signal);
      var body = {};
      if (responseText) {
        try { body = JSON.parse(responseText); }
        catch (parseError) {
          if (response.ok) { throw dyofCustomerError(dyofT("cfg.preview.unreadable_response", "Preview service returned an unreadable response.")); }
        }
      }
      if (!response.ok) {
        if (root.DYOFI18n) {
          throw this.serviceFailure(response, body, dyofT("cfg.interaction.service_preview", "preview service"));
        }
        throw new Error(body.reason || body.error || dyofT("cfg.preview.service_http", "Preview service returned HTTP {status}.", { status: String(response.status) }));
      }
      return body;
    }

    async fetchPreview(payload, signal) {
      var endpoints = [this.dataset.previewEndpoint];
      var isLocal = location.hostname === "127.0.0.1" || location.hostname === "localhost";

      if (isLocal && this.dataset.devPreviewEndpoint) {
        endpoints.push(this.dataset.devPreviewEndpoint);
      }

      var lastError = null;
      for (var index = 0; index < endpoints.length; index += 1) {
        try {
          var endpoint = endpoints[index];
          var transport = this.previewFontTransportRequest(payload, endpoint);
          var body = await this.fetchPreviewResponse(endpoint, transport ? transport.payload : payload, signal);
          try {
            return await this.restorePreviewFontTransport(body, transport, signal);
          } catch (fontError) {
            throwIfPreviewAborted(signal);
            if (!transport || (fontError && fontError.name === "AbortError")) { throw fontError; }
            this.previewFontTransportDisabledEndpoint = endpoint;
            if (this.previewFontCache === transport.cache) { this.previewFontCache = null; }
            var compatiblePayload = Object.assign({}, payload);
            delete compatiblePayload.fontTransport;
            var compatible = await this.fetchPreviewResponse(endpoint, compatiblePayload, signal);
            return await this.restorePreviewFontTransport(compatible, null, signal);
          }
        } catch (error) {
          if (error && error.name === "AbortError") {
            throw error;
          }
          lastError = error;
        }
      }

      throw lastError || dyofCustomerError(dyofT("cfg.preview.service_unavailable", "Preview service is unavailable."));
    }

    async renderSizedSvgPreview(svg, altText, options) {
      var rootTag = String(svg).match(/<svg\b[^>]*>/i);
      var viewBox = rootTag && rootTag[0].match(/\bviewBox="([^"]+)"/);
      var box = viewBox && viewBox[1].trim().split(/[\s,]+/).map(Number);
      if (!box || box.length !== 4 || !box.every(Number.isFinite)) {
        throw dyofCustomerError(dyofT("cfg.preview.vector_invalid_dimensions", "The vector preview has invalid page dimensions."));
      }
      var requestedWidth = options.pixelWidth;
      if (options.pixelBounds) {
        requestedWidth = Math.min(options.pixelBounds.width, options.pixelBounds.height * box[2] / box[3]);
      }
      var width = this.pdfPreviewPixelWidth(box[2], box[3], options.displayWidth, requestedWidth);
      var height = Math.ceil(width * box[3] / box[2]);
      var prepared = root.DYOFPreviewRules.prepareSvg(svg, {
        width: width,
        height: height,
        density: options.pixelBounds ? 1 : Math.min(3, Math.max(1, Number(root.devicePixelRatio) || 1))
      });
      var temporaryUrl = URL.createObjectURL(new Blob([prepared.svg], { type: "image/svg+xml" }));
      try {
        var image = document.createElement("img");
        await loadImageSource(image, temporaryUrl, options.signal);
        throwIfPreviewAborted(options.signal);
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        canvas.setAttribute("role", "img");
        canvas.setAttribute("aria-label", altText);
        var context = canvas.getContext("2d");
        if (!context) { throw dyofCustomerError(dyofT("cfg.preview.vector_no_context", "The vector preview could not create a drawing context.")); }
        context.drawImage(image, 0, 0, width, height);
        root.DYOFPreviewRules.drawRules(context, prepared.rules);
        if (options.adaptive !== false) {
          this.pdfPreviewSources = this.pdfPreviewSources || new WeakMap();
          this.pdfPreviewSources.set(canvas, {
            imageSvg: svg, baseWidth: box[2], baseHeight: box[3], width: width
          });
        }
        return canvas;
      } finally {
        URL.revokeObjectURL(temporaryUrl);
      }
    }

    async renderPageContent(page, altText, renderOptions) {
      var options = renderOptions || {};
      var signal = options.signal;
      var objectUrls = options.objectUrls || this.previewUrls;
      throwIfPreviewAborted(signal);

      if (page.imageDataUrl) {
        var completeImage = document.createElement("img");
        completeImage.alt = altText;
        completeImage.decoding = "async";
        await loadImageSource(completeImage, page.imageDataUrl, signal);
        return completeImage;
      }

      if (
        page.imageSvg && (page.imageSvg.includes("data-source-stroke-width=") || options.pixelBounds)
        && root.DYOFPreviewRules
      ) {
        return this.renderSizedSvgPreview(page.imageSvg, altText, options);
      }

      if (page.imageSvg) {
        var image = document.createElement("img");
        var url = URL.createObjectURL(new Blob([page.imageSvg], { type: "image/svg+xml" }));
        objectUrls.push(url);
        image.alt = altText;
        image.decoding = "async";
        try {
          await loadImageSource(image, url, signal);
        } catch (error) {
          objectUrls.splice(objectUrls.indexOf(url), 1);
          URL.revokeObjectURL(url);
          throw error;
        }
        return image;
      }

      if (page.pdfBase64) {
        if (!root.pdfjsLib) {
          throw dyofCustomerError(dyofT("cfg.preview.pdf_library_unavailable", "The PDF preview library is unavailable."));
        }
        var task = root.pdfjsLib.getDocument({ data: decodeBase64(page.pdfBase64) });
        var documentProxy = null;
        var renderTask = null;
        var destroyPromise = null;
        var renderFailure = null;
        var destroyPdfWork = function() {
          if (!destroyPromise) {
            destroyPromise = Promise.resolve().then(function() {
              // The loading task owns the worker even when loading failed before
              // a PDFDocumentProxy was returned. Share one cleanup across abort
              // and finally so a cancelled resize cannot destroy it twice.
              if (task && typeof task.destroy === "function") {
                return task.destroy();
              }
              if (documentProxy && typeof documentProxy.destroy === "function") {
                return documentProxy.destroy();
              }
            });
          }
          return destroyPromise;
        };
        var cancelPdfWork = function() {
          if (renderTask && typeof renderTask.cancel === "function") {
            try { renderTask.cancel(); } catch (error) { /* already settled */ }
          }
          // Abort events cannot await promises. Consume the rejection here;
          // finally still awaits this same cleanup and handles its outcome.
          destroyPdfWork().catch(function() {});
        };
        if (signal) {
          signal.addEventListener("abort", cancelPdfWork, { once: true });
        }
        try {
          documentProxy = await task.promise;
          throwIfPreviewAborted(signal);
          var pdfPage = await documentProxy.getPage(1);
          throwIfPreviewAborted(signal);
          var baseViewport = pdfPage.getViewport({ scale: 1 });
          // Cart PDFs render directly into their final allotted pixel box. A
          // second browser downsample would reintroduce uneven hairline weight.
          var requestedPixelWidth = options.pixelWidth;
          if (options.pixelBounds) {
            requestedPixelWidth = Math.min(
              options.pixelBounds.width,
              options.pixelBounds.height * baseViewport.width / baseViewport.height
            );
          }
          var pixelWidth = this.pdfPreviewPixelWidth(
            baseViewport.width, baseViewport.height, options.displayWidth, requestedPixelWidth
          );
          var viewport = pdfPage.getViewport({ scale: pixelWidth / baseViewport.width });
          var canvas = document.createElement("canvas");
          canvas.width = pixelWidth;
          canvas.height = Math.ceil(viewport.height);
          canvas.setAttribute("role", "img");
          canvas.setAttribute("aria-label", altText);
          renderTask = pdfPage.render({
            canvasContext: canvas.getContext("2d"),
            viewport: viewport
          });
          try {
            await renderTask.promise;
          } catch (error) {
            if (signal && signal.aborted) {
              throw previewAbortError();
            }
            throw error;
          }
          throwIfPreviewAborted(signal);
          if (options.adaptive !== false) {
            this.pdfPreviewSources = this.pdfPreviewSources || new WeakMap();
            this.pdfPreviewSources.set(canvas, {
              pdfBase64: page.pdfBase64,
              baseWidth: baseViewport.width,
              baseHeight: baseViewport.height,
              width: canvas.width
            });
          }
          return canvas;
        } catch (error) {
          renderFailure = signal && signal.aborted ? previewAbortError() : error;
          throw renderFailure;
        } finally {
          if (signal) {
            signal.removeEventListener("abort", cancelPdfWork);
          }
          try {
            await destroyPdfWork();
          } catch (cleanupError) {
            // Do not replace a useful load/render failure (or AbortError) with
            // a secondary worker-cleanup failure.
            if (!renderFailure) {
              if (signal && signal.aborted) { throw previewAbortError(); }
              throw cleanupError;
            }
          }
        }
      }

      return null;
    }

    openSpreadScene(state) {
      var previewTemplate = refillPreviewTemplate(state, this.merchandising);
      if (
        state
        && state.journey.productType === "refill"
        && state.selection.size === "a4"
      ) {
        var lifestyle = a4OrganiserLifestyle(state, this.merchandising);
        var sceneConfig = A4_ORGANISER_SCENES[lifestyle];
        return {
          id: "a4-organiser-" + lifestyle,
          image: this.dataset[sceneConfig.openDataset]
            || this.dataset.a4OrganiserOpenClassic,
          alt: dyofT("cfg.preview.a4_open_alt", "Open A4 leather Organiser with two blank refill pages"),
          width: 1600,
          height: 1600,
          previewTemplate: lifestyle
        };
      }

      if (
        state
        && state.selection.size === "personal"
      ) {
        var organiser = state.journey.productType === "refill";
        var personalLifestyle = organiser
          ? refillPreviewTemplate(state, this.merchandising)
          : personalClipbookLifestyle(state, this.merchandising);
        var personalSceneConfig = (organiser ? PERSONAL_ORGANISER_SCENES : PERSONAL_CLIPBOOK_SCENES)[personalLifestyle];
        return {
          id: (organiser ? "personal-organiser-" : "personal-clipbook-") + personalLifestyle,
          image: this.dataset[personalSceneConfig.openDataset]
            || this.dataset[organiser ? "personalOrganiserOpenClassic" : "personalClipbookOpenClassic"],
          alt: dyofT("cfg.preview.personal_open_alt", "Open Personal {product} with two blank refill pages", {
            product: organiser ? dyofT("cfg.preview.organiser", "Organiser") : dyofT("cfg.preview.clipbook", "Clipbook")
          }),
          width: 1600,
          height: 1600,
          previewTemplate: personalLifestyle
        };
      }

      var a5Product = state && state.journey && state.journey.productType;
      a5Product = A5_OPEN_SCENES[a5Product] ? a5Product : "refill";
      var a5Dataset = A5_OPEN_SCENES[a5Product][previewTemplate];
      var a5Image = this.dataset[a5Dataset];
      if (a5Image) {
        return {
          id: "a5-" + a5Product + "-" + previewTemplate,
          image: a5Image,
          alt: dyofT("cfg.preview.a5_open_alt", "Open A5 {product} with two refill pages", {
            product: a5Product === "planner" ? dyofT("cfg.preview.notebook", "notebook")
              : a5Product === "clipbook" ? dyofT("cfg.preview.clipbook_lower", "clipbook")
                : dyofT("cfg.preview.refill_lower", "refill")
          }),
          width: 1600,
          height: 1600,
          previewTemplate: previewTemplate
        };
      }

      return {
        id: "a5",
        image: this.dataset.refillBlankScene,
        alt: dyofT("cfg.preview.a5_blank_open_alt", "Open A5 diary with two blank refill pages"),
        width: 2756,
        height: 2756,
        previewTemplate: previewTemplate
      };
    }

    applyOpenSpreadScene(state) {
      var scene = this.openSpreadScene(state || this.store.getState());
      if (scene.id === "a5") {
        delete this.elements.previewPages.dataset.dyofOpenScene;
      } else {
        this.elements.previewPages.dataset.dyofOpenScene = scene.id;
      }
      this.elements.previewPages.dataset.dyofPreviewTemplate = scene.previewTemplate;
      return scene;
    }

    async renderPreviewPages(pages, state, request) {
      var requestOptions = request || {};
      var stagedUrls = [];
      var committed = false;
      var scene = this.openSpreadScene(state);
      var visiblePages = orderTwoPageSpreadBySide(pages.slice(0, 2));
      try {
        // Keep the committed spread mounted while every replacement layer is prepared.
        var sceneImage = null;
        var sceneReadiness = [];
        if (scene.id !== "a5" && scene.image) {
          sceneImage = document.createElement("img");
          sceneImage.decoding = "async";
          sceneReadiness.push(
            loadImageSource(sceneImage, scene.image, requestOptions.signal)
          );
        }

        var prepared = await Promise.all([
          Promise.all(visiblePages.map(async function(page, index) {
            var content = await this.renderPageContent(
              page,
              dyofT("cfg.preview.generated_page", "Generated refill preview page {page}", { page: page.pageNumber || index + 1 }),
              { signal: requestOptions.signal, objectUrls: stagedUrls }
            );
            if (!content) {
              return null;
            }
            var wrapper = document.createElement("div");
            wrapper.className = "dyof__preview-page";
            wrapper.appendChild(content);
            return wrapper;
          }, this)),
          Promise.all(sceneReadiness)
        ]);
        var stagedPages = prepared[0];
        stagedPages = stagedPages.filter(Boolean);

        if (!stagedPages.length) {
          throw dyofCustomerError(dyofT("cfg.preview.no_pages", "No preview pages were returned."));
        }

        var nextChildren = stagedPages.slice();
        if (sceneImage && scene.id !== "a5") {
          sceneImage.className = "dyof__open-spread-top-layer";
          sceneImage.alt = "";
          sceneImage.setAttribute("aria-hidden", "true");
          sceneImage.width = scene.width;
          sceneImage.height = scene.height;
          nextChildren.push(sceneImage);
        }

        throwIfPreviewAborted(requestOptions.signal);
        if (
          requestOptions.requestKey
          && !this.isCurrentPreviewRequest(
            requestOptions.requestKey,
            requestOptions.controller
          )
        ) {
          throw previewAbortError();
        }

        var previousUrls = this.previewUrls.slice();
        this.clearPreviewContentIdentity();
        this.elements.previewPages.dataset.mode = "open-spread";
        this.elements.previewPages.classList.toggle(
          "dyof__preview-pages--single",
          stagedPages.length === 1
        );
        if (scene.id === "a5") {
          delete this.elements.previewPages.dataset.dyofOpenScene;
        } else {
          this.elements.previewPages.dataset.dyofOpenScene = scene.id;
        }
        this.elements.previewPages.dataset.dyofPreviewTemplate = scene.previewTemplate;
        if (requestOptions.requestKey) {
          this.elements.previewPages.dataset.dyofPreviewRequest = requestOptions.requestKey;
        }
        this.elements.previewPages.dataset.dyofPreviewSource = "server";
        if (this.elements.previewStage) {
          this.elements.previewStage.dataset.paper = effectivePaperColour(state);
        }
        this.elements.previewPages.replaceChildren.apply(
          this.elements.previewPages,
          nextChildren
        );
        this.rememberRefillCartPreview(state, stagedPages);
        this.previewUrls = stagedUrls;
        this.lastCommittedLayoutPreviewCacheKey = null;
        this.currentLayoutVisualKey = this.layoutPreviewVisualKey(state);
        this.retainLayoutPreviewCacheEntriesForState(state);
        this.recordWp2PreviewCommit(
          "server",
          requestOptions.requestKey || this.layoutPreviewVisualKey(state),
          state
        );
        committed = true;
        previousUrls.forEach(function(url) {
          URL.revokeObjectURL(url);
        });
      } finally {
        if (!committed) {
          stagedUrls.forEach(function(url) {
            URL.revokeObjectURL(url);
          });
        }
      }
    }

    async renderUndatedPreview(state) {
      if (!this.didChooseUndatedFill) {
        return;
      }
      var previewKey = state.journey.undatedFill;
      var requestIdentity = this.undatedPreviewRequestKey(state, previewKey);
      var preview = this.undatedChooserPreview(state, previewKey);
      var fill = this.contract.getUndatedFill(previewKey);
      var fillLabel = fill ? dyofDisplayLabel(fill.label) : dyofT("cfg.preview.undated_refill", "Undated refill");
      var journalSceneIdentity = root.DYOFCoverEditor
        && typeof root.DYOFCoverEditor.resolveJournalPreviewScene === "function"
        ? root.DYOFCoverEditor.resolveJournalPreviewScene(this.merchandising, previewKey)
        : null;
      var controller;
      var scene;
      var sceneImage;
      var children;

      if (!preview) {
        this.setPreviewStatus(dyofT("cfg.preview.undated_unavailable", "This Undated preview is not available yet."), "error");
        return;
      }
      if (
        this.undatedPreviewAbortController
        && this.undatedPreviewPendingIdentity !== requestIdentity
      ) {
        this.undatedPreviewAbortController.abort();
        this.undatedPreviewAbortController = null;
        this.undatedPreviewPendingKey = null;
        this.undatedPreviewPendingIdentity = null;
        if (this.elements.previewStage) {
          delete this.elements.previewStage.dataset.previewLoading;
        }
      }
      if (
        this.undatedPreviewKey === previewKey
        && this.undatedPreviewIdentity === requestIdentity
        && this.elements.previewPages.dataset.dyofUndatedPreview === previewKey
      ) {
        this.setPreviewStatus(dyofT("cfg.preview.undated_ready", "{fill} preview", { fill: fillLabel }), "ready");
        return;
      }
      if (this.undatedPreviewPendingIdentity === requestIdentity) {
        return;
      }

      if (this.undatedPreviewAbortController) {
        this.undatedPreviewAbortController.abort();
      }
      controller = new AbortController();
      this.undatedPreviewAbortController = controller;
      this.undatedPreviewPendingKey = previewKey;
      this.undatedPreviewPendingIdentity = requestIdentity;
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.previewLoading = "undated";
      }
      this.setPreviewStatus(
        dyofT("cfg.preview.undated_loading", "Loading {fill} preview…", { fill: fillLabel }),
        "loading"
      );
      try {
        if (preview.kind === "scene") {
          var fullScene = document.createElement("img");
          fullScene.className = "dyof__undated-scene-image";
          fullScene.alt = preview.illustrativeScene
            ? dyofT("cfg.preview.baby_journal_illustration", "Illustrative Baby Journal interior pages: First month and Watching you grow")
            : dyofT("cfg.preview.undated_open_alt", "{fill} open refill preview", { fill: fillLabel });
          if (preview.illustrativeScene) {
            fullScene.width = 713;
            fullScene.height = 659;
          }
          fullScene.decoding = "async";
          await loadImageSource(fullScene, preview.scene, controller.signal);
          children = [fullScene];
        } else {
          scene = preview.journalScene || this.openSpreadScene(state);
          var pageImages = [preview.left, preview.right].map(function(source, index) {
            var image = document.createElement("img");
            // Decode the public preview once with CORS so its existing pixels
            // can also be encoded for optional cart media without a refetch.
            image.crossOrigin = "anonymous";
            var wrapper = document.createElement("div");
            image.alt = dyofT("cfg.preview.undated_page_alt", "{fill} preview page {page}", { fill: fillLabel, page: index + 1 });
            image.decoding = "async";
            image.width = preview.width || 840;
            image.height = preview.height || 1192;
            wrapper.className = "dyof__preview-page";
            if (scene.pageRects) {
              var rect = scene.pageRects[index];
              wrapper.style.left = (rect.x * 100) + "%";
              wrapper.style.top = (rect.y * 100) + "%";
              wrapper.style.width = (rect.width * 100) + "%";
              wrapper.style.height = (rect.height * 100) + "%";
              wrapper.dataset.dyofPhysicalPage = String(preview.physicalPages[index]);
              image.alt = dyofT("cfg.preview.journal_page_alt", "{fill} {side} page", {
                fill: fill ? dyofDisplayLabel(fill.label) : dyofT("cfg.preview.journal", "Journal"),
                side: index ? dyofT("cfg.preview.right", "right") : dyofT("cfg.preview.left", "left")
              });
            }
            wrapper.appendChild(image);
            return { image: image, wrapper: wrapper, source: source };
          });
          var pageReadiness = pageImages.map(function(page) {
            return loadImageSource(page.image, page.source, controller.signal);
          });
          if (scene.id !== "a5" && scene.image) {
            sceneImage = document.createElement("img");
            sceneImage.decoding = "async";
            pageReadiness.push(loadImageSource(sceneImage, scene.image, controller.signal));
          }
          await Promise.all(pageReadiness);
          children = pageImages.map(function(page) { return page.wrapper; });
          if (scene.id !== "a5" && scene.image) {
            sceneImage.className = "dyof__open-spread-top-layer";
            sceneImage.alt = "";
            sceneImage.setAttribute("aria-hidden", "true");
            sceneImage.width = scene.width;
            sceneImage.height = scene.height;
            children.push(sceneImage);
          }
        }

        throwIfPreviewAborted(controller.signal);
        var current = this.store.getState();
        var currentKey = current.journey.undatedFill;
        var currentIdentity = this.undatedPreviewRequestKey(current, currentKey);
        if (
          this.undatedPreviewAbortController !== controller
          || current.screen !== "undated-layout"
          || currentKey !== previewKey
          || currentIdentity !== requestIdentity
        ) {
          throw previewAbortError();
        }

        this.releasePreviewUrls();
        this.clearPreviewContentIdentity();
        this.elements.previewPages.classList.remove("dyof__preview-pages--single");
        this.elements.previewPages.dataset.dyofUndatedPreview = previewKey;
        if (preview.illustrativeScene) {
          this.elements.previewPages.dataset.dyofUndatedIllustration = preview.illustrativeScene;
        } else {
          delete this.elements.previewPages.dataset.dyofUndatedIllustration;
        }
        if (journalSceneIdentity) {
          this.elements.previewPages.dataset.dyofPreviewScene =
            "journal:" + journalSceneIdentity.scene;
        }
        if (preview.kind === "scene") {
          this.elements.previewPages.dataset.mode = "undated-scene";
          delete this.elements.previewPages.dataset.dyofOpenScene;
        } else {
          this.elements.previewPages.dataset.mode = "open-spread";
          if (scene.id === "a5") {
            delete this.elements.previewPages.dataset.dyofOpenScene;
          } else {
            this.elements.previewPages.dataset.dyofOpenScene = scene.id;
          }
          this.elements.previewPages.dataset.dyofPreviewTemplate = scene.previewTemplate;
        }
        if (this.elements.previewStage) {
          this.elements.previewStage.dataset.paper = "white";
        }
        this.elements.previewPages.replaceChildren.apply(this.elements.previewPages, children);
        this.rememberRefillCartPreview(state, children);
        this.undatedPreviewKey = previewKey;
        this.undatedPreviewIdentity = requestIdentity;
        this.recordWp2PreviewCommit("undated-asset", requestIdentity, current);
        this.setPreviewStatus(dyofT("cfg.preview.undated_ready", "{fill} preview", { fill: fillLabel }), "ready");
        this.renderStep(current);
        // Let the visible spread win the network/decode race. Review warming is
        // useful only after the selected Undated artwork is on screen.
        this.ensureReviewPreload(current);
        this.scheduleUndatedPreviewPrefetch(current, previewKey);
      } catch (error) {
        if (!error || error.name !== "AbortError") {
          this.setPreviewStatus(
            dyofErrorMessage(error, dyofT("cfg.preview.undated_unloaded", "The Undated refill preview could not be loaded.")),
            "error"
          );
          this.renderStep(this.store.getState());
        }
      } finally {
        if (this.undatedPreviewAbortController === controller) {
          this.undatedPreviewAbortController = null;
          this.undatedPreviewPendingKey = null;
          this.undatedPreviewPendingIdentity = null;
          if (this.elements.previewStage) {
            delete this.elements.previewStage.dataset.previewLoading;
          }
        }
      }
    }

    renderBlankOpenScene(message, state) {
      clearChildren(this.elements.previewPages);
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.dataset.mode = "blank-open";
      this.elements.previewPages.classList.remove("dyof__preview-pages--single");
      var scene = this.applyOpenSpreadScene(state);
      if (this.elements.previewStage) {
        this.elements.previewStage.dataset.paper = effectivePaperColour(state);
      }
      var image = document.createElement("img");
      image.className = "dyof__blank-refill-scene";
      image.src = scene.image;
      // The same empty open Clipbook, described without refill pages for Cover only.
      image.alt = state && state.journey.refillType === "none"
        ? dyofT("cfg.preview.cover_only_open_alt", "Open {size} Clipbook with no refill", {
          size: dyofDisplayLabel(sizeLabel(state.selection.size))
        })
        : scene.alt;
      image.width = scene.width;
      image.height = scene.height;
      this.elements.previewPages.appendChild(image);
      this.setPreviewStatus(message, "idle");
    }

    renderPreviewPlaceholder(message, badgeText, mode) {
      clearChildren(this.elements.previewPages);
      this.releasePreviewUrls();
      this.clearPreviewContentIdentity();
      this.elements.previewPages.classList.remove("dyof__preview-pages--single");
      this.elements.previewPages.dataset.mode = mode || "placeholder";
      var placeholder = document.createElement("div");
      var badge = document.createElement("span");
      var paragraph = document.createElement("p");
      placeholder.className = "dyof__preview-placeholder";
      badge.textContent = dyofDisplayLabel(badgeText || "A5");
      paragraph.textContent = message;
      placeholder.appendChild(badge);
      placeholder.appendChild(paragraph);
      this.elements.previewPages.appendChild(placeholder);
      this.setPreviewStatus(message, "idle");
    }

    // Retry re-runs the Layout or Undated preview. A refusal the customer
    // fixes (another photo, file or selection) keeps its message but offers
    // no Retry: { retry: false }.
    setPreviewStatus(message, status, options) {
      if (this.elements.previewExpand) {
        this.elements.previewExpand.hidden = this.hasStaticPhotoPreview();
      }
      var datedLayout = this.elements.previewStage
        && this.elements.previewStage.dataset.screen === "dated-layout";
      var pages = this.elements.previewPages;
      if (datedLayout && pages && pages.dataset && pages.dataset.dyofPreviewStale === "true"
        && (status === "loading" || status === "error")) {
        message = dyofT("cfg.preview.previous_visible", "The previous preview remains visible. {message}", { message: String(message) });
      } else if (datedLayout && status === "error" && this.hasMountedLayoutPreview()) {
        message = dyofT("cfg.preview.layout_unconfirmed", "The displayed layout preview is not yet confirmed. {message}", { message: String(message) });
      }
      if (this.elements.previewStatus) {
        this.elements.previewStatus.textContent = message;
        this.elements.previewStatus.dataset.status = status;
      }
      if (this.elements.previewRetry) {
        this.elements.previewRetry.hidden = status !== "error"
          || Boolean(options && options.retry === false);
      }
      if (this.elements.previewStage) {
        var layoutLoading = datedLayout && status === "loading";
        this.elements.previewStage.dataset.layoutLoading = String(layoutLoading);
        if (typeof this.elements.previewStage.setAttribute === "function") {
          this.elements.previewStage.setAttribute("aria-busy", String(layoutLoading));
        }
      }
    }

    releasePreviewUrls() {
      this.previewUrls.forEach(function(url) {
        URL.revokeObjectURL(url);
      });
      this.previewUrls = [];
    }

    releaseReviewUrls() {
      this.discardReviewNextSpread();
      this.reviewRendererVersion = "";
      this.reviewUrls.forEach(function(url) {
        URL.revokeObjectURL(url);
      });
      this.reviewUrls = [];
    }
  }

  root.customElements.define("dyof-configurator", DYOFConfigurator);
})(typeof window !== "undefined" ? window : null);
